/* tslint:disable */
/* eslint-disable */
/**
 * Concular API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AWSLocationOUT {
    'region': string;
    'street': string;
    'house_number': string;
    'latitude': number;
    'longitude': number;
    'postal_code': string;
    'country_code': string;
}
export interface AdditionalProcessing {
    'indicator_zero__material_flow'?: boolean;
}

export const AssignAction = {
    Assign: 'assign',
    Unassign: 'unassign'
} as const;

export type AssignAction = typeof AssignAction[keyof typeof AssignAction];


export interface AuditIN {
    'id': string;
    'blueprint_set': Array<BlueprintOUT>;
    'limit_to'?: Array<string | null>;
}
export interface AuditInvitationDetailsOUT {
    'id': string;
    'role': number;
    'audit_id': string;
    'status': number;
    'email': string;
    'modified': string;
}
export interface AuditInvitationIN {
    'audit_id': string;
    'email': string;
    'role': RoleEnum;
}


export interface AuditInvitationOUT {
    'invitation_details'?: AuditInvitationDetailsOUT | null;
}
export interface AuditMemberOUT {
    'user': AuditUserOUT;
    'role': number;
}
export interface AuditOUT {
    'id': string;
    'title': string;
    'building_id': string;
    'created': string;
    'modified': string;
    'created_by': UserProfileOUT;
    'blueprint_set': Array<BlueprintOUT>;
    'floor_set': Array<FloorOUT>;
    'room_set': Array<RoomOUT>;
}
export interface AuditUserOUT {
    'username': string;
    'email': string;
    'first_name': string;
    'last_name': string;
    'id': number;
}
export interface AvailableColumnsOUT {
    'property_name': string;
    'friendly_name_en'?: string | null;
    'friendly_name_de'?: string | null;
    'is_available': boolean;
    'in_default_view': boolean;
    'in_debug': boolean;
    'group_key'?: string | null;
    'filter_function': string;
    'ui_element': string;
    'order'?: number | null;
    'tooltip_active': boolean;
}
export interface BenchmarkData {
    'used_area'?: number | null;
    'gwp_plus_per_m2a'?: number | null;
    'gwp_premium_per_m2a'?: number | null;
    'penrt_plus_per_m2a'?: number | null;
    'penrt_premium_per_m2a'?: number | null;
}
export interface BlueprintIN {
    'name': string;
    'name_de'?: string | null;
    'extra_info'?: string | null;
    'audit_id': string;
    'product_group_id': string;
    'blueprintproperty_set': Array<PropertyFieldsSchema>;
    'components'?: Array<BlueprintIN>;
    'manufacturer_id'?: string | null;
    'as_component_amount': number;
}

export const BlueprintListSortBy = {
    Name: 'name',
    Created: 'created'
} as const;

export type BlueprintListSortBy = typeof BlueprintListSortBy[keyof typeof BlueprintListSortBy];


export interface BlueprintOUT {
    'id': string;
    'name': string;
    'name_de'?: string | null;
    'extra_info'?: string | null;
    'audit_id': string;
    'product_group_id': string;
    'created': string;
    'modified': string;
    'created_by': UserProfileOUT | null;
    'blueprintproperty_set': Array<BlueprintPropertyOUT>;
    'instance_set': Array<InstanceOUT>;
    'components'?: Array<BlueprintOUT | null>;
    'as_component_amount': number;
    'manufacturer'?: ManufacturerOUT | null;
    'albums': Array<ImageAlbumOUT>;
}
export interface BlueprintPropertyIN {
    'field_id': string;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
    'blueprint_id': string;
}
export interface BlueprintPropertyOUT {
    'field_id': string;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
    'id': string;
    'blueprint_id': string;
    'created': string;
    'modified': string;
}
export interface BlueprintPropertyUpdateIN {
    'blueprint_id'?: string | null;
    'field_id'?: string | null;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
}
export interface BlueprintUpdateIN {
    'name': string;
    'name_de': string;
    'extra_info': string;
    'audit_id': string;
    'product_group_id': string;
    'blueprintproperty_set': Array<PropertyFieldsSchema>;
    'components': Array<BlueprintUpdateIN>;
    'manufacturer_id': string;
    'as_component_amount': number;
}
export interface BreadcrumbItem {
    'node_id': string;
    'name': string;
    'name_de': string;
}
export interface BrokenRulesOUT {
    'has_broken_rules': boolean;
    'rules_info': Array<RulesInfo>;
}
export interface BuildingBenchmarkData {
    'qng'?: BenchmarkData | null;
    'dgnb23'?: BenchmarkData | null;
    'dgnb18'?: BenchmarkData | null;
    'bnb'?: BenchmarkData | null;
    'levels'?: BenchmarkData | null;
}

export const BuildingCalculationEngine = {
    Matrices: 'MATRICES',
    ImportedMass: 'IMPORTED_MASS'
} as const;

export type BuildingCalculationEngine = typeof BuildingCalculationEngine[keyof typeof BuildingCalculationEngine];


export interface BuildingCalculationOptions {
    'use_imported_mass'?: boolean | null;
}
export interface BuildingCertificationSettings {
    'dgnb18'?: ExportCertificationOptions | null;
    'dgnb23'?: ExportCertificationOptions | null;
    'qng'?: ExportCertificationOptions | null;
    'bnb'?: ExportCertificationOptions | null;
    'levels'?: ExportCertificationOptions | null;
}
export interface BuildingIN {
    'organisation_id': string;
    'name': string;
    'construction_year'?: number | null;
    'building_type_id'?: string | null;
    'address'?: object | null;
    'gross_floor_area'?: number | null;
    'net_floor_area'?: number | null;
    'current_state'?: number | null;
    'upcoming_operation'?: string | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'images'?: Array<string> | null;
    'certification_id'?: string | null;
    'conformity_id'?: string | null;
    'auto_premap'?: boolean | null;
    'premapping_enabled'?: boolean | null;
    'ifc_parser_split_objects_enabled'?: boolean | null;
    'ifc_parser_split_objects_list'?: string | null;
    'ifc_parser'?: IFCParserChoices | null;
    'b6_kwh_m2a_input'?: number | null;
    'b6_energy_source_main_input'?: number | null;
    'heated_area'?: number | null;
    'is_existing'?: boolean | null;
    'rule_based_mapping_enabled'?: boolean | null;
    'certification_export_settings'?: BuildingCertificationSettings | null;
    'calculation_option'?: BuildingCalculationOptions | null;
    'ingestion_options'?: IngestionOptionsSchema | null;
}


export interface BuildingImageAddRemoveIN {
    'images': Array<string>;
}
export interface BuildingImageOUT {
    'id': string;
    'image': string;
}
export interface BuildingInviteeIN {
    'building_id': string;
    'email': string;
    'role': number;
}
export interface BuildingInviteeOUT {
    'id': string;
    'role': number;
    'building_id': string;
    'status': number;
    'user'?: UserProfileOUT | null;
    'email'?: string | null;
    'modified': string;
}
export interface BuildingMappingStatus {
    'building_id': string;
    'has_mapped_objects': boolean;
    'has_compliant_matches': boolean;
}
export interface BuildingMemberOUT {
    'id': string;
    'user': UserProfileOUT;
    'role': number;
}
export interface BuildingOUT {
    'id': string;
    'name': string;
    'life_span'?: number | null;
    'calculation_status'?: string | null;
    'construction_year'?: number | null;
    'building_type': BuildingTypeOUT | null;
    'address'?: object | null;
    'postal_code'?: string | null;
    'region'?: string | null;
    'gross_floor_area'?: number | null;
    'net_floor_area'?: number | null;
    'current_state'?: number | null;
    'upcoming_operation'?: string | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'images': Array<BuildingImageOUT>;
    'organisation_id'?: string | null;
    'default_ifc_file'?: string | null;
    'active_ifc_files'?: Array<string>;
    'certification_id'?: string | null;
    'conformity_id'?: string | null;
    'auto_premap': boolean;
    'exports_available': boolean;
    'premapping_enabled': boolean;
    'ifc_parser_split_objects_enabled': boolean;
    'ifc_parser_split_objects_list': string;
    'ifc_parser': IFCParserChoices;
    'uploads_allowed': boolean;
    'is_demo': boolean;
    'available_features'?: Array<string>;
    'license'?: LicenseMinimal | null;
    'heated_area'?: number | null;
    'is_existing'?: boolean | null;
    'rule_based_mapping_enabled'?: boolean | null;
    'certification_export_settings'?: BuildingCertificationSettings | null;
    'calculation_option'?: BuildingCalculationOptions | null;
    'b6_benchmark_data'?: BuildingBenchmarkData | null;
    'outdated_area_warnings'?: { [key: string]: OutdatedB6AreaData; };
    'ingestion_options'?: IngestionOptionsSchema | null;
    'calculation_mode'?: BuildingCalculationEngine | null;
}


export interface BuildingReportOUT {
    'id': string;
    'filename'?: string | null;
    'download_url'?: string | null;
    'type'?: string;
    'creation_date'?: string;
    'created_by'?: UserProfileOUT | null;
    'status': ExportStatusEnum;
}


export interface BuildingTypeOUT {
    'id': string;
    'name': string;
    'name_de': string;
}
export interface BuildingUpdateIN {
    'organisation_id'?: string | null;
    'name'?: string | null;
    'construction_year'?: number | null;
    'building_type_id'?: string | null;
    'address'?: object | null;
    'gross_floor_area'?: number | null;
    'life_span'?: number | null;
    'net_floor_area'?: number | null;
    'current_state'?: number | null;
    'upcoming_operation'?: string | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'certification_id'?: string | null;
    'conformity_id'?: string | null;
    'auto_premap'?: boolean | null;
    'premapping_enabled'?: boolean | null;
    'ifc_parser_split_objects_enabled'?: boolean | null;
    'ifc_parser_split_objects_list'?: string | null;
    'ifc_parser'?: IFCParserChoices | null;
    'b6_kwh_m2a_input'?: number | null;
    'b6_energy_source_main_input'?: number | null;
    'heated_area'?: number | null;
    'is_existing'?: boolean | null;
    'rule_based_mapping_enabled'?: boolean | null;
    'certification_export_settings'?: BuildingCertificationSettings | null;
    'calculation_mode'?: BuildingCalculationEngine | null;
    'calculation_option'?: BuildingCalculationOptions | null;
    'ingestion_options'?: IngestionOptionsSchema | null;
}


export interface CPXValueOUT {
    'id': string;
    'category'?: string | null;
    'name'?: string | null;
    'numeric_value'?: number | null;
    'qualification'?: string | null;
}
export interface CSVUploadOptionsIN {
    /**
     * Create as many distinct objects as the quantity
     */
    'split_quantity_into_objects'?: boolean;
}

export const CalculationResult = {
    Mass: 'Mass',
    IndicatorScaling: 'Indicator Scaling'
} as const;

export type CalculationResult = typeof CalculationResult[keyof typeof CalculationResult];


export interface CalculationStatusOUT {
    'status': string;
    'file_operations'?: Array<FileOperationOUT>;
}

export const CalculationStatusTypeEnum = {
    File: 'file',
    Building: 'building'
} as const;

export type CalculationStatusTypeEnum = typeof CalculationStatusTypeEnum[keyof typeof CalculationStatusTypeEnum];


export interface CalculationTrace {
    'trace_type': TraceType;
    'label'?: string | null;
    'value'?: Value1 | null;
    'unit'?: CalculationUnit | null;
}


export interface CalculationTransparency {
    'mass': Array<SingleCalculationResult>;
    'indicators': Array<SingleCalculationResult>;
}

export const CalculationUnit = {
    Kg: 'kg',
    M3: 'm3',
    M2: 'm2',
    M: 'm',
    Pcs: 'pcs',
    M3M3: 'm3/m3',
    M3M2: 'm3/m2',
    M3M: 'm3/m',
    M3Pcs: 'm3/pcs',
    M3Kg: 'm3/kg',
    M2M3: 'm2/m3',
    M2M2: 'm2/m2',
    M2M: 'm2/m',
    M2Pcs: 'm2/pcs',
    M2Kg: 'm2/kg',
    MM3: 'm/m3',
    MM2: 'm/m2',
    MM: 'm/m',
    MPcs: 'm/pcs',
    MKg: 'm/kg',
    PcsM3: 'pcs/m3',
    PcsM2: 'pcs/m2',
    PcsM: 'pcs/m',
    PcsPcs: 'pcs/pcs',
    PcsKg: 'pcs/kg',
    KgM3: 'kg/m3',
    KgM2: 'kg/m2',
    KgM: 'kg/m',
    KgPcs: 'kg/pcs',
    KgKg: 'kg/kg',
    Empty: ''
} as const;

export type CalculationUnit = typeof CalculationUnit[keyof typeof CalculationUnit];


export interface Category {
    'id': string;
    'name': string;
}
export interface CategoryFullOut {
    'id': string;
    'name': string;
    'name_de': string | null;
    'category_system': string;
    'category_number'?: string | null;
}
export interface CategoryOUT {
    'id': string;
    'name': string;
    'name_de': string | null;
}

export const CertificationName = {
    Dgnb2023: 'DGNB 2023',
    Qng: 'QNG',
    Bnb: 'BNB',
    LevelS: 'Level(s)',
    Dgnb2018: 'DGNB 2018',
    Keine: 'Keine'
} as const;

export type CertificationName = typeof CertificationName[keyof typeof CertificationName];


export interface CertificationOUT {
    'id': string;
    'name': string;
}
export interface CertificationOut {
    'id': string;
    'name': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'conformities': Array<EPDConformityOut>;
}
export interface CertificationsValue {
    'modified'?: string;
    'complete'?: boolean;
    'has_data'?: boolean;
    'table_data': { [key: string]: OperationalEnergyTableRow; };
    'area'?: number;
    'life_span'?: number;
}
export interface CheckOperationalEnergy {
    'has_data': boolean;
    'building_id': string;
    'certification_name': CertificationName;
}


export interface Circularity {
    'singular_values'?: Array<SingularCircularityValue> | null;
}

export const ColumnConfiguration = {
    All: 'all',
    Default: 'default'
} as const;

export type ColumnConfiguration = typeof ColumnConfiguration[keyof typeof ColumnConfiguration];


export interface ColumnKeyIN {
    'column_key': string;
    'column_source': ColumnSourceEnum;
}



export const ColumnSourceEnum = {
    PhysicalObject: 'PhysicalObject',
    SummaryTable: 'SummaryTable',
    IfcProperties: 'IFCProperties',
    ProductProperties: 'ProductProperties',
    TemplateVariable: 'TemplateVariable',
    Literal: 'Literal'
} as const;

export type ColumnSourceEnum = typeof ColumnSourceEnum[keyof typeof ColumnSourceEnum];


export interface ColumnSuggestionsIN {
    'column_key': string;
    'column_source': ColumnSourceEnum;
}


export interface ColumnSuggestionsOUT {
    'value': Value3 | null;
    'value_count': number | null;
}
export interface ColumnToDisplay {
    'column_key': string;
    'column_source': ColumnSourceEnum;
}


export interface ColumnValueSchemaIN {
    'columns': Array<string>;
    'building_id': string;
}
export interface ComplianceOUT {
    'conformities'?: Array<string> | null;
    'certifications'?: Array<string> | null;
    'dataset_sources'?: Array<string> | null;
}
export interface CompliantCertification {
    'name': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
}
export interface ComponentChildIN {
    'product_id': string;
    'unit_conversion'?: number;
    'comment'?: string | null;
    'thickness'?: number | null;
    'life_span'?: number | null;
    'component_order'?: number | null;
}
export interface ComponentComplianceIN {
    'product_ids': Array<string>;
}
export interface ComponentComplianceOUT {
    'dataset_sources'?: Array<string> | null;
    'conformities'?: Array<string> | null;
    'compliant_certifications'?: Array<string> | null;
    'health_checked_status'?: ProductHealthCheckedStatusEnum;
}


export interface ComponentCreateIN {
    'name': string;
    'tags_automapper'?: Array<string>;
    'ifc_is_external'?: boolean;
    'ifc_is_loadbearing'?: boolean;
    'reference_unit': ComponentReferenceUnitEnum;
    'children'?: Array<ComponentChildIN>;
    'building'?: string | null;
    'organisation_id'?: string | null;
    'din_category_id'?: string | null;
    'org_properties'?: { [key: string]: ProductProperty; };
    'file_ids'?: Array<string>;
}


export interface ComponentCreateOUT {
    'id': string;
    'organisation_id': string;
    'name'?: string | null;
    'type': string;
    'comment'?: string | null;
    'component_order'?: number | null;
    'health_checked': ProductHealthCheckedStatusEnum;
    'thickness'?: number | null;
    'lifespan'?: number | null;
    'children'?: Array<ComponentCreateOUT>;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
}


export interface ComponentDINCategoryIN {
    'product_ids': Array<string>;
}
export interface ComponentDINCategoryOUT {
    'din_category'?: string | null;
}
export interface ComponentDetailsByFileOut {
    'id': string;
    'name'?: string | null;
    'organisation_id'?: string | null;
    'organisation_name'?: string | null;
    'din_category_level_1'?: string | null;
    'din_category_level_1_number'?: string | null;
    'is_compliant_by_file'?: boolean;
    'selected_epd_group_id'?: string | null;
    'life_span': number;
    'life_span_overwritten'?: boolean;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'epd_groups'?: Array<ComponentDetailsEPDGroupOUT>;
    'compliance'?: ComplianceOUT | null;
    'automapping_tags'?: Array<string> | null;
    'reference_unit': string;
    'type': string;
    'is_health_checked'?: boolean | null;
    'health_checked'?: ProductHealthCheckedStatusEnum;
    'unit_conversion'?: number | null;
    'comment'?: string | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'has_outdated_children'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'component_order'?: number | null;
    'children'?: Array<ComponentDetailsByFileOut> | null;
    'is_part_of_a_component'?: boolean;
    'dataset_source'?: string | null;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'files_info'?: FilesInfoOut | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'thickness'?: number | null;
    'permissions'?: ProductPermissionsOUT | null;
    'created_by_email'?: string | null;
}


export interface ComponentDetailsEPDGroupOUT {
    'id': string;
    'name': string;
    'conformity'?: string | null;
    'certifications'?: Array<InventoryCertificationOUT> | null;
    'epds'?: Array<InventoryProductEPDForProductDetailsByFileOUT>;
    'health_checked'?: ProductHealthCheckedStatusEnum;
}


export interface ComponentEditIN {
    'name': string;
    'tags_automapper'?: Array<string>;
    'ifc_is_external'?: boolean;
    'ifc_is_loadbearing'?: boolean;
    'reference_unit': ComponentReferenceUnitEnum;
    'children'?: Array<ComponentChildIN>;
    'building'?: string | null;
    'organisation_id'?: string | null;
    'din_category_id'?: string | null;
    'org_properties'?: { [key: string]: ProductProperty; };
    'file_ids'?: Array<string>;
}


export interface ComponentEditOUT {
    'component': ComponentCreateOUT;
    'is_recalculation_triggered': boolean;
    /**
     * unpublished original component and created a copy if true
     */
    'created_duplicate'?: boolean;
}
export interface ComponentGraphicData {
    'graphic_parts'?: Array<ComponentGraphicLayer>;
    'thickness'?: number | null;
    'percentage'?: number | null;
    'orientation'?: GraphicOrientation;
}


export interface ComponentGraphicLayer {
    'epd_id': string;
    'epd_name': string;
    'percentage'?: number | null;
    'fill_pattern'?: MaterialPatternName;
    'fill_color'?: string;
    'orientation'?: GraphicOrientation;
}


export interface ComponentInsightsIN {
    'reference_unit': ReferenceUnitChoices;
    'parts'?: Array<ComponentPartIN>;
    'orientation'?: GraphicOrientation;
}


export interface ComponentInsightsOUT {
    'component_graphic': Array<ComponentGraphicData>;
    'total_thickness'?: number | null;
}
export interface ComponentPartIN {
    'product_id': string;
    'thickness'?: number | null;
    'factor'?: number | null;
}

export const ComponentReferenceUnitEnum = {
    M: 'M',
    M2: 'M2',
    M3: 'M3',
    Kg: 'KG',
    Pcs: 'PCS'
} as const;

export type ComponentReferenceUnitEnum = typeof ComponentReferenceUnitEnum[keyof typeof ComponentReferenceUnitEnum];


export interface ConcularProperty {
    'field_name': string;
    'value'?: string | null;
}
export interface CustomBuildingProductEditIN {
    'name': string;
    'din_category': string;
    'life_span': number;
    'ifc_is_external'?: boolean | null;
    'ifc_is_loadbearing'?: boolean | null;
    'automapping_tags'?: Array<string> | null;
    'cpx_values': ProductCreationCPXValues;
    'epd_groups': Array<ProductCreationEPDGroup>;
    'building'?: string | null;
    'organisation_id': string;
    'reference_unit': CustomBuildingProductReferenceUnitEnum;
    'file_ids'?: Array<string>;
    'org_properties'?: { [key: string]: ProductProperty; };
}


export interface CustomBuildingProductEditOUT {
    'created_by_email'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
    'groups'?: Array<EPDGroupOUT> | null;
    'files_info'?: FilesInfoOut | null;
    'is_recalculation_triggered': boolean;
    /**
     * unpublished original product and created a copy if true
     */
    'created_new_version'?: boolean;
}


export interface CustomBuildingProductIN {
    'name': string;
    'din_category': string;
    'life_span': number;
    'ifc_is_external'?: boolean | null;
    'ifc_is_loadbearing'?: boolean | null;
    'automapping_tags'?: Array<string> | null;
    'cpx_values': ProductCreationCPXValues;
    'epd_groups': Array<ProductCreationEPDGroup>;
    'building'?: string | null;
    'organisation_id': string;
    'reference_unit': CustomBuildingProductReferenceUnitEnum;
    'file_ids'?: Array<string>;
    'org_properties'?: { [key: string]: ProductProperty; };
}


export interface CustomBuildingProductOUT {
    'created_by_email'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
    'groups'?: Array<EPDGroupOUT> | null;
    'files_info'?: FilesInfoOut | null;
}



export const CustomBuildingProductReferenceUnitEnum = {
    M: 'M',
    M2: 'M2',
    M3: 'M3',
    Kg: 'KG',
    Pcs: 'PCS'
} as const;

export type CustomBuildingProductReferenceUnitEnum = typeof CustomBuildingProductReferenceUnitEnum[keyof typeof CustomBuildingProductReferenceUnitEnum];


export interface CustomEPDSubmissionIN {
    'epd_link': string;
    'organisation_id': string;
}
export interface DGNBPassportFileOUT {
    'id': string;
    'download_url'?: string | null;
    'created': string;
    'input_data': object;
}
export interface DGNBPassportIN {
    'project_certification_bool'?: boolean | null;
    'project_certification_description'?: string | null;
    'address'?: string | null;
    'date_of_construction'?: string | null;
    'permit_of_construction'?: string | null;
    'type_of_construction'?: string | null;
    'type_of_operation'?: string | null;
    'building_category'?: string | null;
    'description'?: string | null;
    'special_features'?: string | null;
    'gross_floor_area'?: string | null;
    'net_room_area'?: string | null;
    'utility_unit'?: string | null;
    'deconstruction_type'?: string | null;
    'deconstruction_type_method'?: string | null;
    'building_type_pollution_measure'?: string | null;
    'building_type_pollution_measure_explanation'?: string | null;
    'building_type_pollution'?: string | null;
    'building_type_pollution_explanation'?: string | null;
    'building_type_pollution_quality'?: string | null;
    'lvl_pollution'?: string | null;
    'lvl_pollution_quality'?: string | null;
    'pollution_usage'?: string | null;
    'report_pollution'?: string | null;
    'date_report_pollution'?: string | null;
    'result_report_pollution'?: string | null;
    'penrt_b6'?: number | null;
    'gwp_b6'?: number | null;
    'multiple_use_areas'?: string | null;
    'repurposing_capability_area'?: string | null;
    'area_division_possible'?: string | null;
    'area_division_possible_source'?: string | null;
    'area_utilization_ratio'?: string | null;
    'area_utility_need'?: string | null;
    'area_expandable'?: string | null;
    'area_expandable_source'?: string | null;
    'area_concept_description'?: string | null;
    'area_concept_description_explanation'?: string | null;
    'state_of_building'?: string | null;
    'date_of_issue'?: string | null;
    'operation_result'?: string | null;
    'energy_consumption'?: string | null;
}
export interface DINCategoryFilter {
    'use_simplified_version_lca'?: boolean | null;
}

export const DINCategoryLevelEnum = {
    Level1: 'level_1',
    Level2: 'level_2',
    Level3: 'level_3'
} as const;

export type DINCategoryLevelEnum = typeof DINCategoryLevelEnum[keyof typeof DINCategoryLevelEnum];


export interface DashboardBuildingBasic {
    'building_id': string;
    'gwp_nominal'?: number | null;
    'gwp_per_m2'?: number | null;
    'gwp_per_m2_and_year'?: number | null;
    'mass_total'?: number | null;
}
export interface DashboardBuildingCPX {
    'building_id': string;
    'cpx_total'?: number | null;
    'cpx_preuse_score'?: number | null;
    'cpx_recyclability_score'?: number | null;
    'cpx_separability_score'?: number | null;
    'cpx_reusability_score'?: number | null;
    'cpx_deconstructability_score'?: number | null;
}
export interface DashboardBuildingEnvironmental {
    'building_id': string;
    'gwp_nominal'?: number | null;
    'gwp_per_m2'?: number | null;
    'gwp_per_m2_and_year'?: number | null;
    'traces'?: Array<PlotlyTrace>;
}
export interface DashboardBuildingEnvironmentalIN {
    'category_system': string;
    'unit': string;
}
export interface DashboardBuildingGeneralEmissions {
    'building_id': string;
    'grand_total'?: number | null;
    'gwp_total'?: number | null;
    'gwp_traces'?: Array<PlotlyTrace>;
    'gwp_modules'?: Array<string>;
    'operational_energy_total'?: number | null;
    'operational_energy_traces'?: Array<PlotlyTrace>;
    'operational_energy_modules'?: Array<string>;
    'all_modules'?: Array<string>;
}
export interface DashboardBuildingHotspotIN {
    /**
     * SummaryTable numeric indicator column key to rank EPDs by (summed per EPD).
     */
    'value'?: string;
    /**
     * Number of top EPDs to return.
     */
    'top_n'?: number;
}
export interface DashboardBuildingHotspotOUT {
    'building_id': string;
    'value': string;
    'total'?: number | null;
    'traces'?: Array<PlotlyTrace>;
}
export interface DashboardBuildingMass {
    'building_id': string;
    'total_mass'?: number | null;
    'traces'?: Array<PlotlyTrace>;
}
export interface DashboardBuildingMaterialValue {
    'building_id': string;
    'object_count_with_match'?: number | null;
    'object_count_with_match_and_material_price'?: number | null;
    'total_mass'?: number | null;
    'total_mass_with_material_price'?: number | null;
    'total_material_value'?: number | null;
    'traces'?: Array<PlotlyTrace>;
}
export interface DashboardBuildingMaterialValueIN {
    'category_system': string;
}
export interface DashboardBuildingOperationalEmissions {
    'building_id': string;
    'certification_id': string;
    'gwp_total'?: number | null;
    'gwp_traces'?: Array<PlotlyTrace>;
    'gwp_modules'?: Array<string>;
    'penrt_total'?: number | null;
    'penrt_traces'?: Array<PlotlyTrace>;
    'penrt_modules'?: Array<string>;
}
export interface DashboardBuildingOperationalEnergy {
    'building_id': string;
    'gwp_b6_1'?: number | null;
    'gwp_b6_2'?: number | null;
    'gwp_b6_3'?: number | null;
    'gwp_summe_b6'?: number | null;
    'gwp_summe_b1'?: number | null;
    'gwp_self_generated'?: number | null;
    'gwp_d2'?: number | null;
    'gwp_total'?: number | null;
    'penrt_b6_1'?: number | null;
    'penrt_b6_2'?: number | null;
    'penrt_b6_3'?: number | null;
    'penrt_summe_b6'?: number | null;
    'penrt_self_generated'?: number | null;
    'penrt_d2'?: number | null;
    'penrt_total'?: number | null;
}
export interface DashboardDynamicChart {
    'traces'?: Array<PlotlyTrace>;
}
export interface DashboardDynamicChartInput {
    'x_axis': string;
    'y_axis'?: string | null;
}
export interface DatasetCheckerIN {
    'building_id': string;
    'certification_id': string;
    'conformity_id': string;
    'din_category_filter'?: DINCategoryFilter | null;
}
export interface DatasetCheckerOUT {
    'total_objects': number;
    'compliant_objects': number;
}
export interface DefaultMaterial {
    'id': string;
    'name': string;
    'codename': string;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
}
export interface DetailViewMappingIN {
    'operation_type': OperationType;
    'columns_to_display': Array<ColumnToDisplay>;
    'product_uuid'?: string | null;
    'detail_view_report_keys': FetchReportTileReportKeys;
}


export interface DetailViewMappingOUT {
    'row_data': SingleItem;
    'object_details': FetchReportTileOUT;
}
export interface Dimensions {
    'field_name'?: string | null;
    'field_name_de'?: string | null;
    'value'?: number | null;
    'unit': string;
}
export interface DinCategoryOUT {
    'id': string;
    'name'?: string | null;
    'category_number'?: string | null;
    'level1_number'?: string | null;
    'level1_name'?: string | null;
    'level2_number'?: string | null;
    'level2_name'?: string | null;
    'level3_number'?: string | null;
    'level3_name'?: string | null;
}
export interface DynamicColumnOUT {
    'id': Id;
    'key_name': string;
    'group_name': string;
    'group_name_de': string;
    'classification': string;
    'classification_de': string;
    'source': string;
    'friendly_name': string;
    'friendly_name_de': string;
    /**
     * Shortest name with unit available
     */
    'short_with_unit': string;
    /**
     * Shortest german name with unit available
     */
    'short_with_unit_de': string;
    'default'?: boolean;
    'short_name'?: string | null;
    'short_name_de'?: string | null;
    'unit'?: string | null;
    'type'?: string | null;
    'subtitle'?: string | null;
    'subtitle_de'?: string | null;
    'tooltip'?: string | null;
    'tooltip_de'?: string | null;
    'match_dependant'?: boolean | null;
    'mask_duplicates'?: boolean | null;
}
export interface EPDConformityOut {
    'id': string;
    'name': string;
}

export const EPDDataType = {
    Specific: 'specific',
    Average: 'average',
    Generic: 'generic',
    Template: 'template',
    Representative: 'representative'
} as const;

export type EPDDataType = typeof EPDDataType[keyof typeof EPDDataType];


export interface EPDDetailExternalLinks {
    'materials_2050_source'?: string | null;
    'epd_source'?: string | null;
    'user_document'?: UserDocument | null;
}
export interface EPDDetailIN {
    'name_de'?: string | null;
    'name_en'?: string | null;
    'publishing_date'?: string | null;
    'expiry_year'?: number | null;
    'data_type'?: EPDDataType | null;
    'url'?: string | null;
    'is_public'?: boolean | null;
    'registration_number'?: string | null;
    'version'?: string | null;
    'manufacturer'?: string | null;
    'source_uuid'?: string | null;
    'source'?: string | null;
    'database'?: string | null;
    'country'?: string | null;
    'concular_material_name_de'?: string | null;
    'concular_material_category_name_de'?: string | null;
    'reference_unit'?: ReferenceUnit | null;
    'reference_factor'?: number | null;
    'conformity_name'?: string | null;
    'mass_conversion_factor'?: number | null;
    'mass_value_m'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m3'?: number | null;
    'thickness'?: number | null;
    'indicators': Array<EPDDetailIndicator>;
    'file_ids'?: Array<string> | null;
}


export interface EPDDetailIndicator {
    'indicator_name'?: string | null;
    'module_values': Array<EPDDetailModuleValue>;
    'unit'?: string | null;
}
export interface EPDDetailModuleValue {
    'module_name'?: string | null;
    'value'?: number | null;
}
export interface EPDDetailOUT {
    'name_de'?: string | null;
    'name_en'?: string | null;
    'publishing_date'?: string | null;
    'expiry_year'?: number | null;
    'data_type'?: EPDDataType | null;
    'url'?: string | null;
    'is_public'?: boolean | null;
    'registration_number'?: string | null;
    'version'?: string | null;
    'manufacturer'?: string | null;
    'source_uuid'?: string | null;
    'source'?: string | null;
    'database'?: string | null;
    'country'?: string | null;
    'concular_material_name_de'?: string | null;
    'concular_material_category_name_de'?: string | null;
    'reference_unit'?: ReferenceUnit | null;
    'reference_factor'?: number | null;
    'conformity_name'?: string | null;
    'mass_conversion_factor'?: number | null;
    'mass_value_m'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m3'?: number | null;
    'thickness'?: number | null;
    'indicators': Array<EPDDetailIndicator>;
    'file_ids'?: Array<string> | null;
    'id'?: string | null;
    'dataset_source'?: string | null;
    'conformities'?: Array<string> | null;
    'compliant_certifications'?: Array<string>;
    'documents'?: Array<EPDDocumentOUT> | null;
    'external_links'?: EPDDetailExternalLinks | null;
    'is_health_checked'?: boolean;
    'concular_material_id'?: string | null;
    'concular_material_name_en'?: string | null;
    'concular_material_category_name_en'?: string | null;
}


export interface EPDDocument {
    'provider'?: string | null;
    'link'?: string | null;
    'title'?: string | null;
}
export interface EPDDocumentOUT {
    'provider'?: string | null;
    'link'?: string | null;
    'title'?: string | null;
}

export const EPDFieldNameEnum = {
    Database: 'database',
    ReferenceUnit: 'reference_unit',
    ConformityName: 'conformity__name',
    DataType: 'data_type'
} as const;

export type EPDFieldNameEnum = typeof EPDFieldNameEnum[keyof typeof EPDFieldNameEnum];


export interface EPDGroupDataIN {
    'epd_id': string;
    'material_id': string;
    'conversion_factor': number;
}
export interface EPDGroupDataOUT {
    'epd_id': string;
    'material_id': string;
    'conversion_factor': number;
    'calculated_ratio'?: number | null;
    'calculation_error'?: string | null;
}
export interface EPDGroupGraphic {
    'orientation'?: GraphicOrientation;
    'layers'?: Array<GraphicLayerData> | null;
}


export interface EPDGroupInsightsIN {
    'product_reference_unit': ReferenceUnitChoices;
    'layers': Array<EPDGroupDataIN>;
}


export interface EPDGroupInsightsOUT {
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'compliant_certifications'?: Array<CompliantCertification>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked_status'?: ProductHealthCheckedStatus | null;
    'graphic'?: EPDGroupGraphic | null;
    'epd_group'?: Array<EPDGroupDataOUT> | null;
    'error'?: string | null;
}


export interface EPDGroupOUT {
    'epds'?: Array<EPDSOUT> | null;
    'conformity'?: string | null;
    'certifications'?: Array<CertificationOUT> | null;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked'?: ProductHealthCheckedStatusEnum;
    'generate_graphic'?: boolean;
}


export interface EPDGroupOUTRaw {
    'epds'?: Array<EPDSOUT> | null;
    'conformity'?: string | null;
    'certifications'?: Array<CertificationOUT> | null;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked'?: ProductHealthCheckedStatusEnum;
    'generate_graphic'?: boolean;
}


export interface EPDGroupsCheckIN {
    'epd_groups': Array<Array<string>>;
}
export interface EPDGroupsCheckOUT {
    'dataset_sources'?: Array<string>;
    'conformities'?: Array<string>;
    'compliant_certifications'?: Array<string>;
    'health_checked_status'?: ProductHealthCheckedStatus | null;
}


export interface EPDIndicatorOUT {
    'name': string;
    'unit': string;
    'description_de'?: string | null;
    'description_en'?: string | null;
}
export interface EPDOUT {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'reference_unit'?: string | null;
    'reference_size': number;
    'version'?: string | null;
    'url'?: string | null;
    'database'?: string | null;
    'manufacturer'?: string | null;
    'category'?: SearchEngineCategoryOUT | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'mass_value_m'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m3'?: number | null;
    'documents'?: Array<EPDDocument>;
}
export interface EPDSOUT {
    'epd': EPDOUT;
    'material': MaterialOUT | null;
    'factor'?: number | null;
}
export interface EPDSearchFilter {
    'field': EPDFieldNameEnum;
    /**
     * List of values which can be of any type: string, number, boolean etc.
     */
    'values': Array<any>;
}


export interface EPDSearchIN {
    'term': string;
    'conformity'?: Array<string> | null;
    'manufacturer'?: Array<string> | null;
    'database'?: Array<string> | null;
    'data_type'?: Array<string> | null;
    'is_sentinel'?: boolean | null;
    'filtering'?: Array<EPDSearchFilter> | null;
    'organisation_id'?: string | null;
    'only_from_organisation'?: boolean | null;
}
export interface EPDSearchOUT {
    'id': string;
    'is_sentinel': boolean;
    'source': string;
    'source_uuid': string;
    'version': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'url'?: string | null;
    'category'?: string | null;
    'manufacturer'?: string | null;
    'reference_size': number;
    'reference_unit': string;
    'mass_conversion_factor'?: number | null;
    'mass_value_m3'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m'?: number | null;
    'conformity__name'?: string | null;
    'database'?: string | null;
    'default_material'?: DefaultMaterial | null;
    'data_type'?: string | null;
    'documents'?: Array<EPDDocument> | null;
    'compliant_certifications'?: Array<string>;
    'is_editable'?: boolean;
}

export const EPDSearchSortBy = {
    NameEn: 'name_en',
    NameDe: 'name_de',
    Database: 'database',
    ReferenceUnit: 'reference_unit',
    ConformityName: 'conformity__name',
    DataType: 'data_type'
} as const;

export type EPDSearchSortBy = typeof EPDSearchSortBy[keyof typeof EPDSearchSortBy];


export interface EPDSpecificationCheckIN {
    'epds': Array<string>;
}
export interface EmbedConfig {
    'tokenId'?: string | null;
    'token'?: string | null;
    'tokenExpiry'?: string | null;
    'reportConfig'?: Array<ReportConfig> | null;
}
export interface EpdSpecificationCheckOUT {
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'compliant_certifications'?: Array<CompliantCertification>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked_status'?: ProductHealthCheckedStatus | null;
}


export interface ErrorOUT {
    'success': boolean;
    'status_code': number;
    'message': string;
    'error_code': string;
    'details': object;
}
export interface ExceptionSchemaIN {
    'msg': string;
    'status_code'?: number | null;
}
export interface ExportCertificationIN {
    'certification_id': string;
    'conformity_id': string;
    'options'?: ExportCertificationOptions | null;
    'save_settings'?: boolean | null;
}
export interface ExportCertificationOptions {
    'is_active'?: boolean | null;
    'use_simplified_version_lca'?: boolean | null;
    'reduce_tga_factor_to_1_1'?: boolean | null;
    'base_amounts_matrix_key'?: string | null;
    'level_of_requirements'?: LevelOfRequirementsEnum | null;
    'lca_class'?: LCAClassEnum | null;
    'building_type'?: string | null;
    'energetic_standard'?: string | null;
    'relevant_area'?: number | null;
    'net_floor_area'?: number | null;
}


export interface ExportResultOUT {
    'export_id': string;
}

export const ExportStatusEnum = {
    New: 'NEW',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    Failed: 'FAILED'
} as const;

export type ExportStatusEnum = typeof ExportStatusEnum[keyof typeof ExportStatusEnum];


export interface FetchReportTileIN {
    'object_id': string;
    'report_keys': FetchReportTileReportKeys;
}
export interface FetchReportTileOUT {
    'info'?: ReportTileInfo | null;
    'reports'?: ReportTileReport | null;
    'ifc_properties'?: IFCProperties | null;
}
export interface FetchReportTileReportKeys {
    'info'?: boolean | null;
    'reports'?: boolean | null;
    'ifc_properties'?: boolean | null;
}
export interface FieldIN {
    'name'?: string | null;
    'name_de'?: string | null;
    'field_type'?: string | null;
    'order_of_appearance': number;
}
export interface FieldOUT {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'field_type'?: string | null;
    'field_options': Array<FieldOptionOUT>;
    'order_of_appearance': number;
}
export interface FieldOptionOUT {
    'id': string;
    'name': string;
    'name_de'?: string | null;
    'value': string;
}

export const FileCategoryType = {
    Image: 'image',
    Document: 'document',
    Diagram: 'diagram'
} as const;

export type FileCategoryType = typeof FileCategoryType[keyof typeof FileCategoryType];


export interface FileOperationIN {
    'filtering'?: Filtering | null;
    'operation_type': OperationType;
    'product_uuid'?: string | null;
    'columns_to_display': Array<ColumnToDisplay>;
    'sorting'?: Array<Sorting> | null;
    'object_update_data'?: ObjectUpdateData | null;
    'confirm_all'?: boolean | null;
}


export interface FileOperationOUT {
    'ifc_file_id': string;
    'ifc_file_name'?: string | null;
    'ifc_file_reporting_status'?: string;
    'status': string;
    'completed_chunks': number;
    'total_chunks': number;
}
export interface FileProcessingReport {
    'id': string;
    'content': string | null;
}
export interface FileUploadIN {
    'files'?: Array<FileUploadSchema>;
}
export interface FileUploadOUT {
    'id': string;
    'organisation_id': string;
    'uploaded_by_id': number;
    'original_filename': string;
    'content_type': string;
    'category': FileCategoryType;
    'created': string;
    'modified': string;
    'related_product_ids'?: Array<string> | null;
}


export interface FileUploadSchema {
    'file_name': string;
    'content_type': string;
    'category': FileCategoryType;
}


export interface FilesInfoOut {
    'images': Array<SingleFileInfoOUT>;
    'documents': Array<SingleFileInfoOUT>;
    'diagrams': Array<SingleFileInfoOUT>;
}
export interface FilterCategoryOUT {
    'id': string;
    'category_key': string;
    'category_name': string;
    'category_name_de'?: string | null;
}
export interface FilterOptionOUT {
    'option_id': number;
    'option_name': string;
    'option_name_de': string | null;
    'badge': string | null;
}
export interface Filtering {
    'logical_operator': LogicalOperatorENUM;
    'rules': Array<FilteringRule>;
}


export interface FilteringRule {
    'column_key': string | null;
    'column_source': ColumnSourceEnum | null;
    'operator': FilteringRuleENUM;
    'value': Value2 | null;
    'value_source'?: ColumnSourceEnum | null;
    'template_variable'?: ProcessingRuleVariable | null;
}



export const FilteringRuleENUM = {
    Is: 'IS',
    IsNot: 'IS_NOT',
    Contains: 'CONTAINS',
    DoesNotContain: 'DOES_NOT_CONTAIN',
    EndsWith: 'ENDS_WITH',
    IsEmpty: 'IS_EMPTY',
    IsNotEmpty: 'IS_NOT_EMPTY',
    GreaterThanOrEqual: 'GREATER_THAN_OR_EQUAL',
    LessThanOrEqual: 'LESS_THAN_OR_EQUAL',
    GreaterThan: 'GREATER_THAN',
    LessThan: 'LESS_THAN',
    EqualTemplate: 'EQUAL_TEMPLATE',
    ContainsTemplate: 'CONTAINS_TEMPLATE'
} as const;

export type FilteringRuleENUM = typeof FilteringRuleENUM[keyof typeof FilteringRuleENUM];


export interface Financial {
    'field_name': string;
    'field_name_de': string;
    'value'?: number | null;
}
export interface FloorCreateIN {
    'name': string;
    'level': number;
    'audit_id': string;
}
export interface FloorOUT {
    'id': string;
    'name': string;
    'level': number;
    'audit_id': string;
}
export interface FloorUpdateIN {
    'name'?: string | null;
    'level'?: number | null;
    'audit_id'?: string | null;
}
export interface FriendlyNameGroupOUT {
    'key': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'columns': Array<AvailableColumnsOUT>;
}
export interface GeneralInfo {
    'field_name'?: string | null;
    'field_name_de'?: string | null;
    'value'?: string | null;
}
export interface GenerateAPIKeyOut {
    'token': string;
}
export interface GermanSearchQuery {
    /**
     * The final German search string formatted for Postgres websearch.
     */
    'query_string': string;
}
export interface GetUserFileDownloadOUT {
    'file_id': string;
    'url': string;
}
export interface GlobalIFCIdsFromGroupsIN {
    'group_selection'?: Array<Filtering> | null;
    'filtering'?: Filtering | null;
}
export interface GraphicLayerData {
    'epd_id': string;
    'epd_name': string;
    'percentage': number;
    'fill_pattern'?: MaterialPatternName;
    'fill_color'?: string;
}



export const GraphicOrientation = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
} as const;

export type GraphicOrientation = typeof GraphicOrientation[keyof typeof GraphicOrientation];


export interface IFCFileOUT {
    'id': string;
    'building_id': string;
    'file'?: string | null;
    'file_name'?: string;
    'state': string;
    'created': string;
    'uploaded_by'?: UserProfileOUT | null;
    'file_type'?: string | null;
    'reporting_status'?: string | null;
    'has_processing_report'?: boolean;
}

export const IFCParserChoices = {
    V20231: 'v2023.1',
    V20240: 'v2024.0',
    V20250: 'v2025.0'
} as const;

export type IFCParserChoices = typeof IFCParserChoices[keyof typeof IFCParserChoices];


export interface IFCProperties {
    'all_properties'?: Array<PropertySet> | null;
    'concular_properties'?: Array<ConcularProperty> | null;
}
export interface IOERDetail {
    'gwp': IOERGwpDetailSchema | null;
    'material': IOERMaterialDetailSchema | null;
}
export interface IOERGroup {
    'gwp': IOERGwpGroupSchema | null;
    'material': IOERMaterialGroupSchema | null;
}
export interface IOERGwpDetailSchema {
    'fid'?: number | null;
    'bldg_gmlid'?: string | null;
    'ags_municipality_key'?: string | null;
    'building_area'?: number | null;
    'building_volume'?: number | null;
    'building_function'?: string | null;
    'btysetid'?: number | null;
    'btyid'?: string | null;
    'btysig'?: string | null;
    'total_gwp'?: number | null;
    'concrete_normal'?: number | null;
    'concrete_lightweight'?: number | null;
    'bricks_burnt'?: number | null;
    'bricks_insulation'?: number | null;
    'clay_roof_covering'?: number | null;
    'calcareous_plaster_mortar'?: number | null;
    'plaster_mortar_gypsum_anhydrite'?: number | null;
    'clay_loamy_plaster_mortar'?: number | null;
    'plasters_synthetic_components'?: number | null;
    'screeds_calcareous'?: number | null;
    'screeds_gypsum_anhydrite'?: number | null;
    'screeds_dry_gypsum_anhydrite'?: number | null;
    'screeds_synthetic_components'?: number | null;
    'bricks_sand_lime'?: number | null;
    'blocks_aerated_concrete'?: number | null;
    'blocks_concrete'?: number | null;
    'bricks_mud_adobe'?: number | null;
    'plasterboards_gypsum'?: number | null;
    'mineral_construction_boards'?: number | null;
    'mineral_thermal_insulation_materials'?: number | null;
    'concrete_roof_tile_covering'?: number | null;
    'fiber_cement_roofing'?: number | null;
    'slate_cover'?: number | null;
    'substrate_layer_green_roof'?: number | null;
    'mineral_fillings'?: number | null;
    'glass'?: number | null;
    'bricks_natural'?: number | null;
    'other_mineral_building_materials'?: number | null;
    'sawn_timber_lumber'?: number | null;
    'processed_wood'?: number | null;
    'renewable_thermal_insulation_materials'?: number | null;
    'straw_reed_cover'?: number | null;
    'other_materials_renewable_resources'?: number | null;
    'petroleum_based_thermal_insulation_materials'?: number | null;
    'plastic_roofing'?: number | null;
    'petroleum_based_coverings_geomembranes'?: number | null;
    'bitumen_roofing'?: number | null;
    'bituminous_coverings_waterproofing_membranes'?: number | null;
    'metal_roofing'?: number | null;
    'ferrous_metals'?: number | null;
    'coverings_containing_aluminum_sealing_membranes'?: number | null;
    'aluminium'?: number | null;
    'copper'?: number | null;
    'other_non_ferrous_metals'?: number | null;
}
export interface IOERGwpGroupSchema {
    'fid'?: number | null;
    'bldg_gmlid'?: string | null;
    'ags_municipality_key'?: string | null;
    'building_area'?: number | null;
    'building_volume'?: number | null;
    'building_function'?: string | null;
    'btysetid'?: number | null;
    'btyid'?: string | null;
    'btysig'?: string | null;
    'total_gwp'?: number | null;
    'concrete'?: number | null;
    'bricks_clay_roof_tiles'?: number | null;
    'other_minerals'?: number | null;
    'wood'?: number | null;
    'other_renewable_materials'?: number | null;
    'plastics'?: number | null;
    'bituminous_minerals'?: number | null;
    'ferrous_metals'?: number | null;
    'non_ferrous_metals'?: number | null;
    'sand_lime_bricks'?: number | null;
    'calcareous_mortar_screeds'?: number | null;
}
export interface IOERMaterialDetailSchema {
    'fid'?: number | null;
    'bldg_gmlid'?: string | null;
    'ags_municipality_key'?: string | null;
    'building_area'?: number | null;
    'building_volume'?: number | null;
    'building_function'?: string | null;
    'btysetid'?: number | null;
    'btyid'?: string | null;
    'btysig'?: string | null;
    'total_material'?: number | null;
    'concrete_normal'?: number | null;
    'concrete_lightweight'?: number | null;
    'bricks_burnt'?: number | null;
    'bricks_insulation'?: number | null;
    'clay_roof_covering'?: number | null;
    'calcareous_plaster_mortar'?: number | null;
    'plaster_mortar_gypsum_anhydrite'?: number | null;
    'clay_loamy_plaster_mortar'?: number | null;
    'plasters_synthetic_components'?: number | null;
    'screeds_calcareous'?: number | null;
    'screeds_gypsum_anhydrite'?: number | null;
    'screeds_dry_gypsum_anhydrite'?: number | null;
    'screeds_synthetic_components'?: number | null;
    'bricks_sand_lime'?: number | null;
    'blocks_aerated_concrete'?: number | null;
    'blocks_concrete'?: number | null;
    'bricks_mud_adobe'?: number | null;
    'plasterboards_gypsum'?: number | null;
    'mineral_construction_boards'?: number | null;
    'mineral_thermal_insulation_materials'?: number | null;
    'concrete_roof_tile_covering'?: number | null;
    'fiber_cement_roofing'?: number | null;
    'slate_cover'?: number | null;
    'substrate_layer_green_roof'?: number | null;
    'mineral_fillings'?: number | null;
    'glass'?: number | null;
    'bricks_natural'?: number | null;
    'other_mineral_building_materials'?: number | null;
    'sawn_timber_lumber'?: number | null;
    'processed_wood'?: number | null;
    'renewable_thermal_insulation_materials'?: number | null;
    'straw_reed_cover'?: number | null;
    'other_materials_renewable_resources'?: number | null;
    'petroleum_based_thermal_insulation_materials'?: number | null;
    'plastic_roofing'?: number | null;
    'petroleum_based_coverings_geomembranes'?: number | null;
    'bitumen_roofing'?: number | null;
    'bituminous_coverings_waterproofing_membranes'?: number | null;
    'metal_roofing'?: number | null;
    'ferrous_metals'?: number | null;
    'coverings_containing_aluminum_sealing_membranes'?: number | null;
    'aluminium'?: number | null;
    'copper'?: number | null;
    'other_non_ferrous_metals'?: number | null;
}
export interface IOERMaterialGroupSchema {
    'fid'?: number | null;
    'bldg_gmlid'?: string | null;
    'ags_municipality_key'?: string | null;
    'building_area'?: number | null;
    'building_volume'?: number | null;
    'building_function'?: string | null;
    'btysetid'?: number | null;
    'btyid'?: string | null;
    'btysig'?: string | null;
    'total_material'?: number | null;
    'concrete'?: number | null;
    'bricks_clay_roof_tiles'?: number | null;
    'other_minerals'?: number | null;
    'wood'?: number | null;
    'other_renewable_materials'?: number | null;
    'plastics'?: number | null;
    'bituminous_minerals'?: number | null;
    'ferrous_metals'?: number | null;
    'non_ferrous_metals'?: number | null;
    'sand_lime_bricks'?: number | null;
    'calcareous_mortar_screeds'?: number | null;
}
export interface Id {
}
export interface ImageAlbumOUT {
    'id': string;
    'images': Array<ImageOUT>;
}
export interface ImageOUT {
    'id': string;
    'order': number;
    'image'?: string | null;
}
export interface ImageUploadOUT {
    'id': string;
    'order': number;
    'image'?: string | null;
    'upload_url_config': S3PresignedPostOUT | null;
}
export interface IndicatorValues {
    'name': string;
    'value'?: number | null;
    'value_per_m2_year'?: number | null;
    'unit'?: string | null;
}
export interface IngestionOptionsSchema {
    'prepend_name_from_parent_in_parts'?: boolean | null;
    'import_parent'?: boolean | null;
    'import_children'?: boolean | null;
    'parent_is_assigned_children_materials'?: boolean | null;
    'merge_single_element_part_with_parent'?: boolean | null;
    'ifc_entities_with_splitting'?: Array<string> | null;
}
export interface IngestionReportSchema {
    'source_type'?: string | null;
    'total_objects': number;
    'discarded_objects': number;
    'details'?: object | null;
}
export interface Input {
    'limit'?: number;
    'offset'?: number;
}
export interface InstanceIN {
    'name': string;
    'name_de'?: string | null;
    'extra_info'?: string | null;
    'blueprint_id': string;
    'instanceproperty_set': Array<PropertyFieldsSchema>;
    'instance_amount': number;
    'room_id'?: string | null;
    'floor_ids'?: Array<string | null>;
    'album_ids'?: Array<string | null>;
}
export interface InstanceOUT {
    'id': string;
    'name': string;
    'name_de'?: string | null;
    'extra_info'?: string | null;
    'blueprint_id': string;
    'created': string;
    'modified': string;
    'created_by': UserProfileOUT | null;
    'instanceproperty_set': Array<InstancePropertyOUT>;
    'instance_amount': number;
    'room_name'?: string | null;
    'floor_ids'?: Array<string | null>;
}
export interface InstancePropertyIN {
    'field_id': string;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
    'instance_record_id': string;
}
export interface InstancePropertyOUT {
    'field_id': string;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
    'id': string;
    'instance_record_id': string;
    'created': string;
    'modified': string;
}
export interface InstancePropertyUpdateIN {
    'instance_record_id'?: string | null;
    'field_id'?: string | null;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
}
export interface InstanceUpdateIN {
    'name': string;
    'name_de': string;
    'extra_info': string;
    'blueprint_id': string;
    'instanceproperty_set': Array<PropertyFieldsSchema>;
    'instance_amount': number;
    'room_id': string;
    'floor_ids': Array<string>;
    'album_ids': Array<string>;
}
export interface InternalNoEPDSProductSearchOutput {
    'organisation_id'?: string | null;
    'created_by_email'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
}


export interface InternalPaginatedProductSearchOutput {
    'items': Array<InternalNoEPDSProductSearchOutput>;
    'count': number;
    'total_count_without_compliance_filter': number;
}
export interface InternalProductSearchOutput {
    'organisation_id'?: string | null;
    'created_by_email'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
    'groups'?: Array<EPDGroupOUT> | null;
    'files_info'?: FilesInfoOut | null;
}


export interface InventoryAutomapperTagOUT {
    'id': string;
    'name': string;
}
export interface InventoryCertificationOUT {
    'id': string;
    'name': string;
}
export interface InventoryEPDForProductDetailsByFileOUT {
    'id': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'url'?: string | null;
    'reference_unit': string;
    'reference_size': number;
    'default_material'?: string | null;
    'dataset_source'?: string | null;
    'database'?: string | null;
    'mass_value_m'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m3'?: number | null;
    'documents'?: Array<EPDDocument> | null;
}
export interface InventoryEPDGroupOUT {
    'id': string;
    'name': string;
    'conformity'?: string | null;
    'certifications'?: Array<InventoryCertificationOUT>;
    'epds': Array<InventoryProductEPDForProductDetailsByFileOUT>;
    'health_checked'?: ProductHealthCheckedStatusEnum | null;
}


export interface InventoryEPDMatchOut {
    'id': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'reference_unit': string;
    'reference_size': number;
    'version': string;
    'url': string;
    'category'?: Category | null;
    'dataset_source'?: string | null;
    'database'?: string | null;
    'conformity'?: string | null;
}
export interface InventoryEPDOut {
    'id': string;
    'name_de'?: string | null;
    'name_en'?: string | null;
    'reference_unit': string;
    'reference_size': number;
    'version': string;
    'url'?: string | null;
    'source': string;
    'category': Category | null;
    'life_span'?: number;
    'manufacturer': Manufacturer | null;
    'documents'?: Array<EPDDocument> | null;
}
export interface InventoryFileOUT {
    'id': string;
    'building_id': string;
    'file'?: string | null;
    'file_processed_xkt'?: string | null;
    'file_name'?: string;
    'total_unique_material_names'?: number;
    'total_no_of_mapped_material_names'?: number;
    'state': string;
    'created': string;
    'uploaded_by'?: UserProfileOUT | null;
    'file_type'?: string | null;
    'reporting_status'?: string | null;
}
export interface InventoryPhysicalObjectDetailOut {
    'id': string;
    'quantity'?: number | null;
    'material'?: string | null;
    'component'?: string | null;
    'area'?: number | null;
    'volume'?: number | null;
    'length'?: number | null;
    'width'?: number | null;
    'height'?: number | null;
    'gwp'?: number | null;
    'mass'?: number | null;
    'ifc_entity'?: string | null;
    'product_match'?: InventoryProductOut | null;
    'product_match_type'?: string | null;
    'layer_position': string;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'extra_properties'?: object | null;
}
export interface InventoryProductDetailsByFileOut {
    'created_by_email'?: string | null;
    'id': string;
    'name'?: string | null;
    'organisation_id'?: string | null;
    'organisation_name'?: string | null;
    'din_category_level_1'?: string | null;
    'din_category_level_2'?: string | null;
    'din_category_level_3'?: string | null;
    'din_category_level_1_number'?: string | null;
    'din_category_level_2_number'?: string | null;
    'din_category_level_3_number'?: string | null;
    'is_compliant_by_file': boolean;
    'selected_epd_group_id'?: string | null;
    'life_span'?: number;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'epd_groups': Array<InventoryEPDGroupOUT>;
    'compliance'?: ComplianceOUT | null;
    'health_checked'?: ProductHealthCheckedStatusEnum | null;
    'is_health_checked'?: boolean | null;
    'automapping_tags'?: Array<string> | null;
    'reference_unit': string;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'product_disabled_status': ProductDisabledStatusEnum;
    'is_part_of_a_component'?: boolean;
    'dataset_source'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'files_info'?: FilesInfoOut | null;
    'permissions'?: ProductPermissionsOUT | null;
}


export interface InventoryProductEPDForProductDetailsByFileOUT {
    'id': string;
    'factor'?: number | null;
    'material': string;
    'epd': InventoryEPDForProductDetailsByFileOUT;
    'material_recyclability_score'?: number | null;
    'material_recyclability_qualification'?: string | null;
}
export interface InventoryProductEPDOut {
    'ratio': number;
    'epd': InventoryEPDMatchOut;
    'material'?: string | null;
    'material_id'?: string | null;
}
export interface InventoryProductOut {
    'id': string;
    'name': string | null;
    'epds': Array<InventoryProductEPDOut>;
    'din_category'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'separability_qualification'?: string | null;
    'separability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'preuse_qualification'?: string | null;
    'preuse_score'?: number | null;
    'reusability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'is_compliant_by_file'?: boolean | null;
    'selected_epd_group_id'?: string | null;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'type': string;
    'reference_unit': string;
    'health_checked': ProductHealthCheckedStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'files_info'?: FilesInfoOut | null;
}



export const LCAClassEnum = {
    K1: 'K1',
    K2: 'K2',
    K3: 'K3',
    K4: 'K4',
    K5: 'K5',
    K6: 'K6'
} as const;

export type LCAClassEnum = typeof LCAClassEnum[keyof typeof LCAClassEnum];


export interface LCAIndicatorValue {
    'indicator_name': string;
    'value'?: number | null;
    'unit'?: string | null;
    'modules'?: Array<LCAIndicatorValueModule> | null;
}
export interface LCAIndicatorValueModule {
    'module_name': string;
    'value'?: number | null;
    'unit'?: string | null;
}
/**
 * Request paginated LCC component list for a building.
 */
export interface LCCComponentListIN {
    /**
     * Convention to use: dgnb23, bnb, qng
     */
    'convention'?: LCCConvention;
    'product_type'?: string | null;
    /**
     * Page number
     */
    'page'?: number;
    /**
     * Items per page
     */
    'page_size'?: number;
    /**
     * Sort by: \'kg\' (cost group) or \'name\' (component name)
     */
    'sort_by'?: LCCOrderBy;
    'convention_override'?: LCCConventionInfo | null;
    /**
     * Sort direction: ASC or DESC
     */
    'sort_direction'?: LCCSortDirection;
}


/**
 * Paginated LCC component list response.
 */
export interface LCCComponentListOUT {
    /**
     * Building UUID
     */
    'building_id': string;
    /**
     * Building name
     */
    'building_name': string;
    /**
     * Bruttogrundfläche m²
     */
    'bgf_m2': number;
    /**
     * Applied convention
     */
    'convention': LCCConventionInfo;
    /**
     * Per-component LCC results (paginated)
     */
    'components'?: Array<LCCComponentResult>;
    /**
     * Total number of components (for pagination)
     */
    'components_total'?: number;
    /**
     * Current page number
     */
    'components_page'?: number;
    /**
     * Items per page
     */
    'components_page_size'?: number;
}
/**
 * Per-component (Bauteil) LCC result row. Corresponds to table rows in \"Lebenszykluskosten nach Kostengruppen\".
 */
export interface LCCComponentResult {
    /**
     * Product/component UUID
     */
    'component_id': string;
    /**
     * Bauteil name
     */
    'component_name': string;
    /**
     * DIN 276 cost group code (e.g., \'331\')
     */
    'kg_code': string;
    'kg_name'?: string | null;
    /**
     * Menge in Bezugseinheit
     */
    'amount': number;
    'amount_unit'?: string | null;
    /**
     * Herstellkosten (HK) in €
     */
    'installed_cost_eur': number;
    /**
     * Instandhaltung Barwert in €
     */
    'maintenance_pv_eur': number;
    /**
     * Ersatzinvestitionen Barwert in €
     */
    'replacement_pv_eur': number;
    /**
     * Gesamt Barwert in €
     */
    'total_pv_eur': number;
    /**
     * €/m² BGF (total / building BGF)
     */
    'total_eur_per_m2_bgf': number;
    'service_life_years'?: number | null;
    'service_life_governing_material'?: string | null;
    'product_type'?: string | null;
}

export const LCCConvention = {
    Dgnb23: 'dgnb23',
    Bnb: 'bnb',
    Qng: 'qng'
} as const;

export type LCCConvention = typeof LCCConvention[keyof typeof LCCConvention];


/**
 * Convention parameters used for LCC calculation.
 */
export interface LCCConventionInfo {
    'description'?: string | null;
    /**
     * Kalkulationszinssatz %
     */
    'discount_rate_pct': number;
    /**
     * Allg. Preissteigerung %/a
     */
    'price_increase_general_pct_pa': number;
    /**
     * Betrachtungszeitraum Jahre
     */
    'observation_period_years': number;
    /**
     * Instandhaltungssatz %/a der Herstellkosten
     */
    'maintenance_rate_pct_pa'?: number;
}
/**
 * Aggregated LCC summary per cost group (Kostengruppe). One row per KG code, summing all components of that group.
 */
export interface LCCKGSummary {
    /**
     * DIN 276 cost group code
     */
    'kg_code': string;
    'kg_name'?: string | null;
    /**
     * Number of components in this KG
     */
    'component_count': number;
    /**
     * Sum HK in €
     */
    'installed_cost_eur': number;
    /**
     * Sum Instandhaltung BW in €
     */
    'maintenance_pv_eur': number;
    /**
     * Sum Ersatz BW in €
     */
    'replacement_pv_eur': number;
    /**
     * Sum Gesamt BW in €
     */
    'total_pv_eur': number;
    /**
     * €/m² BGF
     */
    'total_eur_per_m2_bgf': number;
}

export const LCCOrderBy = {
    Kg: 'kg',
    Name: 'name'
} as const;

export type LCCOrderBy = typeof LCCOrderBy[keyof typeof LCCOrderBy];



export const LCCSortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type LCCSortDirection = typeof LCCSortDirection[keyof typeof LCCSortDirection];


/**
 * Request LCC summary (totals + KG summaries) for a building.
 */
export interface LCCSummaryIN {
    /**
     * Convention to use: dgnb23, bnb, qng
     */
    'convention'?: LCCConvention;
    'product_type'?: string | null;
    'convention_override'?: LCCConventionInfo | null;
    /**
     * Include KG summaries in response
     */
    'group_by_kg'?: boolean;
}


/**
 * LCC summary response — totals and KG summaries across the entire building.
 */
export interface LCCSummaryOUT {
    /**
     * Building UUID
     */
    'building_id': string;
    /**
     * Building name
     */
    'building_name': string;
    /**
     * Bruttogrundfläche m²
     */
    'bgf_m2': number;
    /**
     * Applied convention
     */
    'convention': LCCConventionInfo;
    /**
     * Grand totals across all KGs
     */
    'totals': LCCTotals;
    /**
     * Aggregated LCC per cost group
     */
    'kg_summaries'?: Array<LCCKGSummary>;
}
/**
 * Grand totals across all cost groups. Corresponds to the footer row in the report table.
 */
export interface LCCTotals {
    /**
     * Total Herstellkosten in €
     */
    'installed_cost_eur': number;
    /**
     * Total Instandhaltung BW in €
     */
    'maintenance_pv_eur': number;
    /**
     * Total Ersatz BW in €
     */
    'replacement_pv_eur': number;
    /**
     * Grand total Barwert in €
     */
    'total_pv_eur': number;
    /**
     * €/m² BGF
     */
    'total_eur_per_m2_bgf': number;
}
export interface LatestReportOUT {
    'report'?: ReportOUT | null;
}

export const LevelOfRequirementsEnum = {
    Plus: 'PLUS',
    Premium: 'PREMIUM'
} as const;

export type LevelOfRequirementsEnum = typeof LevelOfRequirementsEnum[keyof typeof LevelOfRequirementsEnum];



export const LicenseAppType = {
    Lca: 'LCA',
    Asset: 'ASSET',
    Manufacturer: 'MANUFACTURER'
} as const;

export type LicenseAppType = typeof LicenseAppType[keyof typeof LicenseAppType];



export const LicenseFeatureEnum = {
    AnalyticsDashboards: 'analytics-dashboards',
    ArchiveBuilding: 'archive-building',
    Audits: 'audits',
    B6Calculator: 'b6-calculator',
    PdfReportExports: 'pdf-report-exports',
    BuildingDataUploadIfcCsv: 'building-data-upload-ifc-csv',
    ExportEnvironmentalReport: 'export-environmental-report',
    ExportDgnbGebauderessourcenpass: 'export-dgnb-gebauderessourcenpass',
    ButtonLcaGrpExportsEnabled: 'button-lca-grp-exports-enabled',
    Integrations: 'integrations',
    Inventory: 'inventory',
    InventoryExports: 'inventory-exports',
    MainDashboardRetool: 'main-dashboard-retool',
    Mapping: 'mapping',
    MaterialSalesFlow: 'material-sales-flow',
    PotfolioScreener: 'potfolio-screener',
    ProductPublishing: 'product-publishing',
    VariantComparison: 'variant-comparison'
} as const;

export type LicenseFeatureEnum = typeof LicenseFeatureEnum[keyof typeof LicenseFeatureEnum];



export const LicenseKindType = {
    Regular: 'regular',
    Demo: 'demo',
    ReadOnly: 'read_only',
    Custom: 'custom'
} as const;

export type LicenseKindType = typeof LicenseKindType[keyof typeof LicenseKindType];


export interface LicenseMinimal {
    'type'?: string | null;
    'app'?: LicenseAppType | null;
    'kind'?: LicenseKindType | null;
    'is_demo'?: boolean | null;
    'max_building_count'?: number | null;
    'max_certification_count'?: number | null;
    'effective_max_building_count'?: number | null;
    'effective_max_certification_count'?: number | null;
    'selected_certification_ids'?: Array<string>;
}


export interface LicenseOUT {
    'id': string;
    'license_type': string;
    'app': LicenseAppType;
    'kind': LicenseKindType;
    'is_demo': boolean | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'organisation_id'?: string | null;
    'building_id'?: string | null;
    'max_building_count'?: number | null;
    'max_certification_count'?: number | null;
    'effective_max_building_count'?: number | null;
    'effective_max_certification_count'?: number | null;
    'selected_certification_ids'?: Array<string>;
}



export const LicenseOwnerType = {
    Building: 'BUILDING',
    Organisation: 'ORGANISATION'
} as const;

export type LicenseOwnerType = typeof LicenseOwnerType[keyof typeof LicenseOwnerType];


export interface LicenseUpdateIN {
    'organisation_id'?: string | null;
    'building_id'?: string | null;
}
export interface ListUserFilesOUT {
    'count': number;
    'items': Array<FileUploadOUT>;
}

export const LogicalOperatorENUM = {
    And: 'AND',
    Or: 'OR'
} as const;

export type LogicalOperatorENUM = typeof LogicalOperatorENUM[keyof typeof LogicalOperatorENUM];


export interface Manufacturer {
    'id': string;
    'name': string;
}
export interface ManufacturerIN {
    'name': string;
    'organisation_id'?: string | null;
}
export interface ManufacturerOUT {
    'id': string;
    'name': string;
}
export interface MappingOperationMetadata {
    'number_of_affected_objects'?: number;
    'outdated_components_names'?: Array<string> | null;
    'outdated_components_matches'?: number | null;
    'affected_ids'?: Array<number>;
}
export interface MasterToolExportIN {
    'certification_id': string;
    'conformity_id': string;
}

export const MatchCompliance = {
    Ok: 'OK',
    DoesNot: 'DOES_NOT',
    Error: 'ERROR'
} as const;

export type MatchCompliance = typeof MatchCompliance[keyof typeof MatchCompliance];



export const MatchType = {
    Manual: 'manual',
    Auto: 'auto',
    Pre: 'pre'
} as const;

export type MatchType = typeof MatchType[keyof typeof MatchType];


export interface Material2050SearchFilter {
    'category_key': string;
    'ids': Array<number>;
}
export interface Material2050SearchInput {
    'search_term': string;
    'filters'?: Array<Material2050SearchFilter>;
}
export interface Material2050SearchOUT {
    'id': string;
    'name': string;
    'company'?: string | null;
}

export const MaterialFlowStatusEnum = {
    Verbleibt: 'Verbleibt',
    Hinzugefgt: 'Hinzugefügt',
    Entfernt: 'Entfernt',
    TemporrHinzugefgt: 'Temporär hinzugefügt'
} as const;

export type MaterialFlowStatusEnum = typeof MaterialFlowStatusEnum[keyof typeof MaterialFlowStatusEnum];


export interface MaterialIN {
    'dgnb_category_name': string;
    'origin_category_name': string;
    'general_category_name': string;
    'name': string;
    'life_span': number;
    'code_name': string;
    'cpx_recyclability_id': string;
    'price_points'?: Array<PricePointIN>;
    'pattern_data'?: PatternData | null;
}
export interface MaterialOUT {
    'id': string;
    'name'?: string | null;
    'category_dgnb'?: string;
    'category_origin'?: string;
    'category_general'?: string;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
}

export const MaterialPatternName = {
    Default: 'default',
    Ga01: 'ga_01',
    Fl01: 'fl_01',
    Sc01: 'sc_01',
    Sc02: 'sc_02',
    Sc03: 'sc_03',
    Sc04: 'sc_04',
    Da01: 'da_01',
    Da02: 'da_02',
    Da03: 'da_03',
    Di01: 'di_01',
    Di02: 'di_02',
    Di03: 'di_03',
    Fe01: 'fe_01',
    Gl01: 'gl_01',
    Tb01: 'tb_01',
    Tb02: 'tb_02',
    Tb03: 'tb_03',
    Vh01: 'vh_01',
    Vh02: 'vh_02',
    Vh03: 'vh_03',
    Hw01: 'hw_01',
    Mw01: 'mw_01',
    Mw02: 'mw_02',
    Mw03: 'mw_03',
    Bt01: 'bt_01',
    Bt02: 'bt_02',
    Bt03: 'bt_03',
    Me01: 'me_01'
} as const;

export type MaterialPatternName = typeof MaterialPatternName[keyof typeof MaterialPatternName];


export interface MaterialResourceOUT {
    'id': string;
    'building_id': string;
    'file'?: string | null;
    'file_processed_xkt'?: string | null;
    'file_geometry'?: string | null;
    'name'?: string | null;
    'file_name'?: string;
    'total_unique_material_names'?: number;
    'total_no_of_mapped_material_names'?: number;
    'report'?: IngestionReportSchema | null;
    'state'?: string | null;
    'created': string;
    'uploaded_by'?: UserProfileOUT | null;
    'created_by'?: UserProfileOUT | null;
    'file_type'?: string | null;
    'title'?: string | null;
    'reporting_status'?: string | null;
    'xkt_status'?: string | null;
    'has_processing_report'?: boolean | null;
}
export interface MaterialSearchIN {
    'term'?: string | null;
    'category_general'?: Array<string> | null;
}
export interface MaterialSearchOUT {
    'id': string;
    'name': string;
    'codename': string;
    'category_dgnb'?: string | null;
    'category_origin'?: string | null;
    'category_general__name'?: string | null;
    'category_general__name_de'?: string | null;
    'life_span'?: number | null;
    'recyclability_score': number;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
}

export const MaterialSearchSortBy = {
    Name: 'name',
    CategoryGeneralName: 'category_general__name',
    CategoryGeneralNameDe: 'category_general__name_de',
    RecyclabilityScore: 'recyclability_score',
    RecyclabilityQualification: 'recyclability_qualification'
} as const;

export type MaterialSearchSortBy = typeof MaterialSearchSortBy[keyof typeof MaterialSearchSortBy];


export interface Materials2050EPDDetailOUT {
    'name_de'?: string | null;
    'name_en'?: string | null;
    'publishing_date'?: string | null;
    'expiry_year'?: number | null;
    'data_type'?: EPDDataType | null;
    'url'?: string | null;
    'is_public'?: boolean | null;
    'registration_number'?: string | null;
    'version'?: string | null;
    'manufacturer'?: string | null;
    'source_uuid'?: string | null;
    'source'?: string | null;
    'database'?: string | null;
    'country'?: string | null;
    'concular_material_name_de'?: string | null;
    'concular_material_category_name_de'?: string | null;
    'reference_unit'?: ReferenceUnit | null;
    'reference_factor'?: number | null;
    'conformity_name'?: string | null;
    'mass_conversion_factor'?: number | null;
    'mass_value_m'?: number | null;
    'mass_value_m2'?: number | null;
    'mass_value_m3'?: number | null;
    'thickness'?: number | null;
    'indicators': Array<EPDDetailIndicator>;
    'file_ids'?: Array<string> | null;
    'id'?: string | null;
    'dataset_source'?: string | null;
    'conformities'?: Array<string> | null;
    'compliant_certifications'?: Array<string>;
    'documents'?: Array<EPDDocumentOUT> | null;
    'external_links'?: EPDDetailExternalLinks | null;
    'is_health_checked'?: boolean;
    'concular_material_id'?: string | null;
    'concular_material_name_en'?: string | null;
    'concular_material_category_name_en'?: string | null;
    'materials_2050_uuid': string;
    'materials_2050_material'?: string | null;
    'materials_2050_material_category'?: string | null;
    'is_good_quality'?: boolean | null;
}


export interface ObjectListIN {
    'filtering'?: Filtering | null;
    'retrieve_ids'?: boolean;
    'columns_to_display': Array<ColumnToDisplay>;
    'sorting'?: Array<Sorting> | null;
    'grouping'?: Array<ColumnToDisplay> | null;
    'include_matches'?: boolean | null;
    'one_row_per_object'?: boolean | null;
    'apply_masking'?: boolean | null;
    'include_ifc_id'?: boolean | null;
}
export interface ObjectListNoPaginationIN {
    'filtering'?: Filtering | null;
}
export interface ObjectListNoPaginationOUT {
    'id': string;
    'ifc_global_id'?: string | null;
}
export interface ObjectListOUT {
    'items': Array<SingleItem>;
    'count': number;
    'metadata'?: MappingOperationMetadata | null;
}
export interface ObjectOperationIN {
    'filtering'?: Filtering | null;
    'retrieve_ids'?: boolean;
    'columns_to_display': Array<ColumnToDisplay>;
    'sorting'?: Array<Sorting> | null;
    'grouping'?: Array<ColumnToDisplay> | null;
    'include_matches'?: boolean | null;
    'one_row_per_object'?: boolean | null;
    'apply_masking'?: boolean | null;
    'include_ifc_id'?: boolean | null;
    'operation_type': OperationType;
    'product_uuid'?: string | null;
    'object_ids'?: Array<string> | null;
    'group_selection'?: Array<Filtering> | null;
    'object_update_data'?: ObjectUpdateData | null;
}


export interface ObjectProductMatch {
    'id'?: string | null;
    'name'?: string | null;
    'match_type'?: MatchType | null;
    'compliance'?: MatchCompliance | null;
    'product_type'?: ProductType | null;
    'multiple_matches'?: boolean | null;
    'product_outdated'?: boolean | null;
}


export interface ObjectUpdateData {
    'material_flow_status'?: MaterialFlowStatusEnum | null;
    'cpx_preuse_id'?: string | null;
    'cpx_reusability_id'?: string | null;
    'cpx_separability_id'?: string | null;
    'cpx_deconstructability_id'?: string | null;
    'ifc_entity'?: string | null;
    'ifc_is_external'?: boolean | null;
    'component_name'?: string | null;
    'material'?: string | null;
    'length'?: number | null;
    'height'?: number | null;
    'width'?: number | null;
    'area'?: number | null;
    'volume'?: number | null;
    'quantity'?: number | null;
    'object_mass'?: number | null;
}


export interface ObjectsFilterIN {
    'filtering'?: Filtering | null;
    'retrieve_ids'?: boolean;
}
export interface ObjectsFilterOUT {
    'result_count': number;
    'serial_ids'?: Array<number>;
}

export const OperationType = {
    ManualMatch: 'manual_match',
    AutoMapMatch: 'auto_map_match',
    UndoMatch: 'undo_match',
    UpdateObjects: 'update_objects',
    RuleBasedMapping: 'rule_based_mapping',
    UpdateOutdatedMappings: 'update_outdated_mappings',
    IgnoreObjects: 'ignore_objects',
    UnignoreObjects: 'unignore_objects'
} as const;

export type OperationType = typeof OperationType[keyof typeof OperationType];


export interface OperationalEnergyCertification {
    'modified'?: string | null;
    'complete'?: boolean;
    'has_data'?: boolean;
    'table_data': { [key: string]: OperationalEnergyTableRow; };
    'area'?: number | null;
    'life_span'?: number | null;
}
export interface OperationalEnergyReportSubmitOUT {
    'report_id': string;
}
export interface OperationalEnergyTable {
    'has_data': boolean;
    'certifications'?: { [key: string]: CertificationsValue; };
}
export interface OperationalEnergyTableRow {
    'friendly_name': string;
    'description': string;
    'indicator_values': Array<IndicatorValues>;
}
export interface OrderedProperties {
    'slug': string;
    'position': number;
}
export interface OrganisationAccessRequestOUT {
    'status'?: number | null;
    'organisation_id': string;
    'modified': string;
}
export interface OrganisationDomainIN {
    'organisation_id': string;
    'domain': string;
}
export interface OrganisationDomainOUT {
    'id': string;
    'domain': string;
    'organisation': OrganisationOUT;
}
export interface OrganisationIN {
    'name': string;
    'organisation_type_id': string;
    'add_demo_building'?: boolean | null;
    'domains'?: Array<string>;
}
export interface OrganisationInviteeIN {
    'email': string;
    'role'?: number;
}
export interface OrganisationInviteeOUT {
    'id': string;
    'role': number;
    'organisation_id': string;
}
export interface OrganisationOUT {
    'id': string;
    'name': string;
    'organisation_type': OrganisationTypeOUT;
    'legal_name'?: string | null;
    'address'?: string | null;
    'phone'?: string | null;
    'zip_code'?: number | null;
    'city'?: string | null;
    'logo'?: string | null;
    'role'?: number | null;
    'can_create_buildings'?: boolean | null;
    'max_building_entry'?: number | null;
    'available_features'?: Array<string> | null;
    'license'?: LicenseMinimal | null;
}
export interface OrganisationRequestAcceptIN {
    'id': string;
}
export interface OrganisationRequestAllOUT {
    'id': string;
    'email'?: string | null;
    'role': number;
    'status'?: number | null;
    'modified': string;
    'organisation_id': string;
    'user'?: UserProfileOUT | null;
    'invited_by'?: UserProfileOUT | null;
}
export interface OrganisationTypeOUT {
    'id': string;
    'name': string;
    'name_de': string;
}
export interface OrganisationUpdateIN {
    'name'?: string | null;
    'organisation_type_id'?: string | null;
    'legal_name'?: string | null;
    'phone'?: string | null;
    'address'?: string | null;
    'zip_code'?: string | null;
    'city'?: string | null;
}
export interface OutdatedB6AreaData {
    'b6_area'?: number | null;
    'configured_area'?: number | null;
}
export interface PagedAWSLocationOUT {
    'items': Array<AWSLocationOUT>;
    'count': number;
}
export interface PagedBlueprintPropertyOUT {
    'items': Array<BlueprintPropertyOUT>;
    'count': number;
}
export interface PagedBuildingMemberOUT {
    'items': Array<BuildingMemberOUT>;
    'count': number;
}
export interface PagedBuildingOUT {
    'items': Array<BuildingOUT>;
    'count': number;
}
export interface PagedBuildingTypeOUT {
    'items': Array<BuildingTypeOUT>;
    'count': number;
}
export interface PagedEPDSearchOUT {
    'items': Array<EPDSearchOUT>;
    'count': number;
}
export interface PagedFieldOUT {
    'items': Array<FieldOUT>;
    'count': number;
}
export interface PagedFloorOUT {
    'items': Array<FloorOUT>;
    'count': number;
}
export interface PagedIFCFileOUT {
    'items': Array<IFCFileOUT>;
    'count': number;
}
export interface PagedInstanceOUT {
    'items': Array<InstanceOUT>;
    'count': number;
}
export interface PagedInstancePropertyOUT {
    'items': Array<InstancePropertyOUT>;
    'count': number;
}
export interface PagedInventoryEPDOut {
    'items': Array<InventoryEPDOut>;
    'count': number;
}
export interface PagedManufacturerOUT {
    'items': Array<ManufacturerOUT>;
    'count': number;
}
export interface PagedMaterialSearchOUT {
    'items': Array<MaterialSearchOUT>;
    'count': number;
}
export interface PagedOrganisationDomainOUT {
    'items': Array<OrganisationDomainOUT>;
    'count': number;
}
export interface PagedOrganisationOUT {
    'items': Array<OrganisationOUT>;
    'count': number;
}
export interface PagedOrganisationRequestAllOUT {
    'items': Array<OrganisationRequestAllOUT>;
    'count': number;
}
export interface PagedOrganisationTypeOUT {
    'items': Array<OrganisationTypeOUT>;
    'count': number;
}
export interface PagedProductGroupOUT {
    'items': Array<ProductGroupOUT>;
    'count': number;
}
export interface PagedProductUsageBuildingItemOUT {
    'items': Array<ProductUsageBuildingItemOUT>;
    'count': number;
}
export interface PagedProductUsageComponentItemOUT {
    'items': Array<ProductUsageComponentItemOUT>;
    'count': number;
}
export interface PagedRoomOUT {
    'items': Array<RoomOUT>;
    'count': number;
}
export interface PagedSlimAuditOut {
    'items': Array<SlimAuditOut>;
    'count': number;
}
export interface PagedSlimBlueprintOUT {
    'items': Array<SlimBlueprintOUT>;
    'count': number;
}
export interface PagedSlimUserAuditOUT {
    'items': Array<SlimUserAuditOUT>;
    'count': number;
}
export interface PagedSuggestOUT {
    'items': Array<SuggestOUT>;
    'count': number;
}
export interface PagedUserOrganisationMemberOUT {
    'items': Array<UserOrganisationMemberOUT>;
    'count': number;
}
export interface Pageddict {
    'items': Array<object>;
    'count': number;
}
export interface PaginatedEPDFilterOptionsOUT {
    /**
     * List of distinct values which can be of any type: string, number, boolean etc.
     */
    'items': Array<any>;
    'count': number;
}
export interface PaginatedFilterOptionsOUT {
    'items'?: Array<FilterOptionOUT>;
    'count': number;
}
export interface PaginatedMaterial2050SearchOUT {
    'items'?: Array<Material2050SearchOUT>;
    'count': number;
}
export interface ParsedIndicators {
    'indicators'?: Array<EPDDetailIndicator>;
    /**
     * Number of values parsed
     */
    'count'?: number;
}
export interface PatternData {
    'name'?: MaterialPatternName;
    'color_hex'?: string;
}


export interface PlaceDetailsOUT {
    'street': string;
    'latitude': number;
    'longitude': number;
    'country_code': string;
    'house_number': string;
    'postal_code': string;
    'region': string;
    'place_id': string;
}
export interface PlotlyTrace {
    'x': Array<PlotlyTraceXInner>;
    'y': Array<PlotlyTraceXInner>;
    'name': string;
}
export interface PlotlyTraceXInner {
}

export const PrefillTooltip = {
    Default: 'default',
    FromEpd: 'from_epd',
    FromObject: 'from_object',
    CpxWorst: 'cpx_worst',
    CpxFromObject: 'cpx_from_object'
} as const;

export type PrefillTooltip = typeof PrefillTooltip[keyof typeof PrefillTooltip];


export interface PrefilledProductCreationIN {
    'organisation_id'?: string | null;
    'epd_ids'?: Array<string>;
    'materials2050_epd_ids'?: Array<string>;
    'object_ids'?: Array<string>;
}
export interface PrefilledProductOUT {
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
    'groups'?: Array<EPDGroupOUTRaw> | null;
    'files_info'?: FilesInfoOut | null;
    'tooltips'?: TooltipMapOUT;
}


export interface PresignedUrlIn {
    'file_name': string;
    'category': string;
    'metadata'?: object | null;
}
export interface PricePointIN {
    'name': string;
    'price': number;
    'date': string;
    'source': string;
    'vat_included'?: boolean;
    'unit'?: string;
}

export const ProblemTypeEnum = {
    DeletedProperty: 'deleted_property'
} as const;

export type ProblemTypeEnum = typeof ProblemTypeEnum[keyof typeof ProblemTypeEnum];



export const ProcessingOperationEnum = {
    ManualMatch: 'manual_match'
} as const;

export type ProcessingOperationEnum = typeof ProcessingOperationEnum[keyof typeof ProcessingOperationEnum];


export interface ProcessingRuleCreateSchema {
    'name': string;
    'filter': Filtering;
    'action': ProcessingOperationEnum;
}


export interface ProcessingRuleOUT {
    'id': number;
    'name': string;
    'organisation_id': string;
    'filter': Filtering;
    'action': ProcessingOperationEnum;
    'order': number;
    'simple_rule_object_update_data'?: object | null;
    'simple_rule_product_uuid'?: string | null;
    'active': boolean;
    'validation_errors'?: string | null;
}


export interface ProcessingRuleUpdateIN {
    'name': string;
    'filter': Filtering;
    'action': ProcessingOperationEnum;
}



export const ProcessingRuleVariable = {
    ProductName: '@product.name',
    ProductType: '@product.type',
    ProductId: '@product.id',
    ProductReferenceUnit: '@product.reference_unit',
    ProductDin276Name: '@product.din276_name',
    ProductDin276Number: '@product.din276_number',
    ProductTags: '@product.tags',
    ProductEpdName: '@product.epd_name',
    ProductMaterialName: '@product.material_name'
} as const;

export type ProcessingRuleVariable = typeof ProcessingRuleVariable[keyof typeof ProcessingRuleVariable];


export interface ProcessingRulesCreateIN {
    'organisation_id': string;
    'processing_rule': ProcessingRuleCreateSchema;
}
export interface ProcessingRulesUpdateOrdersIN {
    'processing_rule_id': number;
    'order': number;
}
export interface ProductClassSummaryOUT {
    'id': string;
    'name': string;
}
export interface ProductClassWithConfigsOUT {
    'id': string;
    'name': string;
    'property_configurations': Array<PropertyConfigurationForClassOUT>;
}
/**
 * Org-scoped capabilities that don\'t belong to a single product.
 */
export interface ProductCollectionPermissionsOUT {
    'can_create': boolean;
}
export interface ProductComplianceOUT {
    'dataset_sources'?: Array<string> | null;
    'conformities'?: Array<string> | null;
    'compliant_certifications'?: Array<string> | null;
}
export interface ProductCreationCPXValues {
    'separability_id'?: string | null;
    'deconstructability_id'?: string | null;
    'reusability_id'?: string | null;
    'preuse_id'?: string | null;
}
export interface ProductCreationEPD {
    'material': string;
    'epd': string;
    'factor': number;
}
export interface ProductCreationEPDGroup {
    'epds': Array<ProductCreationEPD>;
    'generate_graphic'?: boolean;
}
export interface ProductDinCategoryByLevelOUT {
    'level_1': Array<SearchEngineCategoryBase>;
    'level_2': Array<SearchEngineCategoryBase>;
    'level_3': Array<SearchEngineCategoryBase>;
}

export const ProductDisabledStatusEnum = {
    UpToDate: 'UP_TO_DATE',
    Disabled: 'DISABLED',
    UpdateAvailable: 'UPDATE_AVAILABLE'
} as const;

export type ProductDisabledStatusEnum = typeof ProductDisabledStatusEnum[keyof typeof ProductDisabledStatusEnum];


/**
 * Schema for a Product Group
 */
export interface ProductGroupOUT {
    'id': string;
    'name': string;
    'name_de': string;
    'categories': Array<CategoryOUT>;
    'blueprint_field_set'?: Array<SlimProductGroupFieldSetOUT>;
    'required_fields': Array<FieldOUT>;
    'optional_fields': Array<FieldOUT>;
    'required_components'?: Array<ProductGroupOUT | null>;
    'optional_components'?: Array<ProductGroupOUT | null>;
    'unit': string;
}

export const ProductHealthCheckedStatus = {
    None: 'NONE',
    Partial: 'PARTIAL',
    Full: 'FULL'
} as const;

export type ProductHealthCheckedStatus = typeof ProductHealthCheckedStatus[keyof typeof ProductHealthCheckedStatus];



export const ProductHealthCheckedStatusEnum = {
    None: 'NONE',
    Partial: 'PARTIAL',
    Full: 'FULL'
} as const;

export type ProductHealthCheckedStatusEnum = typeof ProductHealthCheckedStatusEnum[keyof typeof ProductHealthCheckedStatusEnum];


export interface ProductListOUT {
    'created_by_email'?: string | null;
    'id': string;
    'name'?: string | null;
    'type': string;
    'reference_unit': string;
    'disabled': boolean;
    'is_public': boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'dataset_source'?: string | null;
    'din_category'?: DinCategoryOUT | null;
    'product_class'?: ProductClassSummaryOUT | null;
    'permissions'?: ProductPermissionsOUT | null;
}


export interface ProductListPaginatedOUT {
    'items': Array<ProductListOUT>;
    'count': number;
    'permissions'?: ProductCollectionPermissionsOUT | null;
}
/**
 * Per-product button states for the current user.  Computed by ``building_products.permissions`` — the same policy that enforces access on write — so the frontend never re-derives the rules. ``None`` when the endpoint did not attach capabilities (treat as \"no role restriction\").  These reflect role/ownership only; object-state preconditions (e.g. a component must have outdated children to upgrade) are surfaced as their own fields and still enforced server-side.
 */
export interface ProductPermissionsOUT {
    'can_edit': boolean;
    'can_delete': boolean;
    'can_duplicate': boolean;
    'can_upgrade': boolean;
}
export interface ProductProperty {
    'name': string;
    'property_type': PropertyTypeChoices;
    'value': Value | null;
}


export interface ProductSearchInput {
    'building_id'?: string | null;
    'organisation_id'?: string | null;
    'query'?: string | null;
    'mode'?: SearchMode;
    'source'?: Array<string> | null;
    'din_category'?: Array<string> | null;
    'din_category_numbers'?: Array<string> | null;
    'material_name'?: Array<string> | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'epd_conformity'?: Array<string> | null;
    'certifications'?: Array<string> | null;
    'product_source'?: ProductSourceEnum | null;
    'building_compliance'?: boolean | null;
    'type'?: ProductTypeChoicesEnum | null;
    'is_sentinel'?: boolean | null;
    'publication_status'?: Array<PublicationStatus>;
    'reference_units'?: Array<ReferenceUnitChoices>;
}



export const ProductSourceEnum = {
    Custom: 'custom',
    Manufacturer: 'manufacturer',
    Concular: 'concular'
} as const;

export type ProductSourceEnum = typeof ProductSourceEnum[keyof typeof ProductSourceEnum];



export const ProductType = {
    Product: 'PRODUCT',
    Component: 'COMPONENT'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];



export const ProductTypeChoicesEnum = {
    Product: 'PRODUCT',
    Component: 'COMPONENT'
} as const;

export type ProductTypeChoicesEnum = typeof ProductTypeChoicesEnum[keyof typeof ProductTypeChoicesEnum];


export interface ProductUsageBuildingItemOUT {
    'id': string;
    'name': string;
    'match_count': number;
    'affected_calculations': number;
}
export interface ProductUsageComponentItemOUT {
    'id': string;
    'name': string;
    'match_count': number;
}
export interface ProductUsageSummaryOUT {
    'component_count': number;
    'direct_parent_count': number;
    'building_count': number;
    'total_matches': number;
    'total_calculations': number;
}
export interface PropertyBrowserNodeOUT {
    'node_id': string;
    'parent_node_id'?: string | null;
    'has_children': boolean;
    'column_key': string;
    'column_source': string;
    'name': string;
    'name_de': string;
    'default'?: boolean;
    'is_numeric'?: boolean;
    'property_type'?: PropertyTypeChoices;
    'match_dependant'?: boolean | null;
    'mask_duplicates'?: boolean;
    'breadcrumb'?: Array<BreadcrumbItem>;
}


export interface PropertyBrowserNodesPage {
    'items': Array<PropertyBrowserNodeOUT>;
    'total_count': number;
    'page': number;
    'page_size': number;
    'has_more': boolean;
}
export interface PropertyBrowserTreeNode {
    'id': string;
    'column_key': string;
    'column_source': string;
    'name': string;
    'name_de': string;
    'group_name': string;
    'group_name_de': string;
    'classification': string;
    'classification_de': string;
    'default': boolean;
    'is_numeric': boolean;
    'property_type': PropertyTypeChoices;
    'match_dependant'?: boolean | null;
    'description_key'?: string | null;
    'children'?: Array<PropertyBrowserTreeNode>;
    'mask_duplicates'?: boolean;
}


export interface PropertyConfigurationForClassOUT {
    'id': number;
    'slug': string;
    'name': string;
    'property_type': PropertyTypeChoices;
    'options'?: object;
}


export interface PropertyConfigurationIN {
    'name': string;
    'organisation_id'?: string | null;
    'property_type': PropertyTypeChoices;
    'options': PropertyConfigurationOptions;
}


export interface PropertyConfigurationOUT {
    'name': string;
    'organisation_id'?: string | null;
    'property_type': PropertyTypeChoices;
    'options': PropertyConfigurationOptions;
    'slug': string;
}


export interface PropertyConfigurationOptions {
    'choices'?: Array<string>;
}
export interface PropertyFieldsSchema {
    'field_id': string;
    'value_string'?: string | null;
    'value_numeric'?: number | null;
    'value_datetime'?: string | null;
    'value_field_option_ids'?: Array<string | null>;
}
export interface PropertyOrderingIN {
    'ordered_slugs': Array<OrderedProperties>;
}
export interface PropertySet {
    'property_set_name': string;
    'properties'?: Array<PropertySetProperty> | null;
}
export interface PropertySetProperty {
    'property_name': string;
    'property_value'?: PropertyValue | null;
}

export const PropertyTypeChoices = {
    Text: 'text',
    Number: 'number',
    Boolean: 'boolean',
    Select: 'select',
    Multiselect: 'multiselect',
    NumberRange: 'number_range'
} as const;

export type PropertyTypeChoices = typeof PropertyTypeChoices[keyof typeof PropertyTypeChoices];


export interface PropertyValue {
}

export const PublicationAction = {
    Publish: 'publish',
    Unpublish: 'unpublish'
} as const;

export type PublicationAction = typeof PublicationAction[keyof typeof PublicationAction];



export const PublicationStatus = {
    Unpublished: 'unpublished',
    Published: 'published'
} as const;

export type PublicationStatus = typeof PublicationStatus[keyof typeof PublicationStatus];


/**
 * Constant definitions for reference units
 */

export const ReferenceUnit = {
    M: 'M',
    M2: 'M2',
    M3: 'M3',
    Kg: 'KG',
    Pcs: 'PCS',
    Kwh: 'KWh',
    Empty: ''
} as const;

export type ReferenceUnit = typeof ReferenceUnit[keyof typeof ReferenceUnit];



export const ReferenceUnitChoices = {
    M: 'M',
    M2: 'M2',
    M3: 'M3',
    Kg: 'KG',
    Pcs: 'PCS',
    Empty: ''
} as const;

export type ReferenceUnitChoices = typeof ReferenceUnitChoices[keyof typeof ReferenceUnitChoices];


export interface ReportConfig {
    'reportId'?: string | null;
    'reportName'?: string | null;
    'embedUrl'?: string | null;
    'datasetId'?: string | null;
}
export interface ReportOUT {
    'id': string;
    'building_id': string;
    'input_file'?: string | null;
    'download_url'?: string | null;
    'status': string;
    'raw_values'?: Array<object> | null;
    'multiplied_values'?: Array<object> | null;
    'calculation_reason'?: string | null;
    'calculation_date'?: string | null;
    'created': string;
    'modified': string;
}
export interface ReportTileInfo {
    'component_name'?: string | null;
    'general_information'?: Array<GeneralInfo> | null;
    'dimensions'?: Array<Dimensions> | null;
}
export interface ReportTileReport {
    'mass'?: ReportTileReportMass | null;
    'lca_indicator_values'?: Array<LCAIndicatorValue>;
    'circularity'?: Circularity | null;
    'financial'?: Financial | null;
}
export interface ReportTileReportMass {
    'value'?: number | null;
    'unit'?: string | null;
}
export interface ResolveNodesIN {
    'column_keys': Array<ColumnKeyIN>;
}
/**
 * Output types
 */

export const ResourcePassportOutputType = {
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Txt: 'TXT',
    None: 'NONE'
} as const;

export type ResourcePassportOutputType = typeof ResourcePassportOutputType[keyof typeof ResourcePassportOutputType];


export interface ResultOUT {
    'success': boolean;
    'message': object;
}
export interface RetoolBuildingProductCPXValues {
    'separability_qualification': string;
    'deconstructability_qualification': string;
    'reusability_qualification': string;
    'preuse_qualification': string;
}
export interface RetoolBuildingProductUpsertIN {
    'product_id'?: string | null;
    'name': string;
    'din_category_number': string;
    'life_span': number;
    'ifc_is_external'?: boolean | null;
    'ifc_is_loadbearing'?: boolean | null;
    'automapping_tags'?: Array<string> | null;
    'cpx_values': RetoolBuildingProductCPXValues;
    'epd_groups': Array<ProductCreationEPDGroup>;
    'reference_unit': CustomBuildingProductReferenceUnitEnum;
    'end_of_life_qualification'?: string | null;
    'ifc_entity'?: string | null;
    'disabled'?: boolean | null;
    'ifc_alternatives'?: string | null;
    'automap_material'?: string | null;
    'automap_name'?: string | null;
    'tags_general'?: Array<string> | null;
    'is_public'?: boolean;
}


export interface RetoolBuildingProductUpsertOUT {
    'created_by_email'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'organisation_name'?: string | null;
    'din_category'?: string | null;
    'din_category_number'?: string | null;
    'is_external'?: boolean | null;
    'is_load_bearing'?: boolean | null;
    'preuse_score'?: number | null;
    'preuse_qualification'?: string | null;
    'deconstructability_score'?: number | null;
    'deconstructability_qualification'?: string | null;
    'reusability_score'?: number | null;
    'reusability_qualification'?: string | null;
    'separability_score'?: number | null;
    'separability_qualification'?: string | null;
    'recyclability_score'?: number | null;
    'recyclability_qualification'?: string | null;
    'dataset_source'?: string | null;
    'conformity'?: string | null;
    'building'?: string | null;
    'life_span'?: number;
    'tags_automapper'?: Array<InventoryAutomapperTagOUT>;
    'reference_unit': string;
    'compliant_certifications_names'?: Array<string>;
    'compliant_conformities_names'?: Array<string>;
    'compliant_dataset_sources_names'?: Array<string>;
    /**
     * @deprecated
     */
    'is_health_checked'?: boolean;
    'health_checked': ProductHealthCheckedStatusEnum;
    'type': string;
    'epd_providers'?: Array<string>;
    'is_part_of_a_component'?: boolean;
    'product_disabled_status': ProductDisabledStatusEnum;
    'thumbnail_url'?: string | null;
    'diagram_url'?: string | null;
    'global_properties'?: { [key: string]: ProductProperty; };
    'org_properties'?: { [key: string]: ProductProperty; };
    'product_class_id'?: string | null;
    'product_class_name'?: string | null;
    'is_public'?: boolean;
    'has_outdated_children'?: boolean;
    'permissions'?: ProductPermissionsOUT | null;
    'groups'?: Array<EPDGroupOUT> | null;
    'files_info'?: FilesInfoOut | null;
    'is_recalculation_triggered': boolean;
}


export interface RetoolEmbedIN {
    'app_id': string;
    'environment': string | null;
    'release_version': string | null;
}
export interface RetoolEmbedOUT {
    'embedUrl': string;
}

export const RoleEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


export interface RoomCreateIN {
    'name': string;
    'audit_id': string;
}
export interface RoomOUT {
    'id': string;
    'name': string;
    'audit_id': string;
}
export interface RoomUpdateIN {
    'name'?: string | null;
    'audit_id'?: string | null;
}
export interface RulesInfo {
    'rule_id': number;
    'rule_name': string;
    'problem_type': ProblemTypeEnum;
    'problem_data': string;
}


export interface S3PostData {
    'url': string;
    'fields': { [key: string]: string; };
    'file_id': string;
    'file_name': string;
}
export interface S3PresignedPostOUT {
    'url': string;
    'fields': object;
}
export interface SaveUserDynamicColumnsIN {
    'view_name': ViewChoices;
    'id_list': Array<string>;
}


export interface SearchEngineCategoryBase {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'category_number'?: string | null;
    'category_system'?: string | null;
}
export interface SearchEngineCategoryOUT {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'category_number'?: string | null;
    'category_system'?: string | null;
    'children'?: Array<SearchEngineCategoryOUT> | null;
}

export const SearchMode = {
    Websearch: 'websearch',
    Raw: 'raw'
} as const;

export type SearchMode = typeof SearchMode[keyof typeof SearchMode];


export interface SimpleMaterialOut {
    'id': string | null;
    'name'?: string | null;
}
export interface SingleCalculationResult {
    'epd_name': string;
    'result_type': CalculationResult;
    'formula_name': string;
    'result_value': number;
    'result_unit': CalculationUnit;
    'trace': Array<CalculationTrace>;
    'additional_processing': AdditionalProcessing;
}


export interface SingleFileInfoOUT {
    'file_id': string;
    'file_name': string;
    'url': string;
    'content_type': string;
    'category': FileCategoryType;
    'thumbnail_url'?: string | null;
    'created': string;
}


export interface SingleItem {
    'id'?: string | null;
    'ifc_global_id'?: string | null;
    'product_match'?: ObjectProductMatch | null;
    'object_count'?: number;
    'calculation_count'?: number;
    'values': object;
}
export interface SingularCircularityValue {
    'field_name'?: string | null;
    'field_name_de'?: string | null;
    'value'?: string | null;
}
export interface SlimAuditOut {
    'id': string;
    'title': string;
    'building_id': string;
    'created': string;
    'modified': string;
    'created_by': UserProfileOUT;
}
export interface SlimBlueprintOUT {
    'id': string;
    'name': string;
    'name_de': string | null;
    'extra_info'?: string | null;
    'audit_id': string;
    'product_group_id': string;
    'created': string;
    'modified': string;
    'created_by': UserProfileOUT | null;
    'blueprintproperty_set'?: Array<BlueprintPropertyOUT>;
    'instance_set': Array<InstanceOUT>;
    'components': Array<SlimBlueprintOUT>;
    'as_component_amount': number | null;
    'manufacturer': ManufacturerOUT | null;
    'albums': Array<ImageAlbumOUT>;
    'total_instance_amount'?: number | null;
}
export interface SlimBuildingOUT {
    'id': string;
    'name': string;
    'address'?: object | null;
    'postal_code'?: string | null;
}
export interface SlimFieldOUT {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'field_type'?: string | null;
    'order_of_appearance': number;
}
/**
 * Fieldset without the field options
 */
export interface SlimFieldSetOUT {
    'id': string;
    'name'?: string | null;
    'name_de'?: string | null;
    'order_of_appearance': number;
    'required_fields'?: Array<SlimFieldOUT | null>;
    'optional_fields'?: Array<SlimFieldOUT | null>;
}
export interface SlimProductGroupFieldSetOUT {
    'id': string;
    'name': string | null;
    'name_de': string | null;
    'order_of_appearance': number;
    'required_fields'?: Array<SlimFieldOUT | null>;
    'optional_fields'?: Array<SlimFieldOUT | null>;
}
/**
 * Schema for a Product Group
 */
export interface SlimProductGroupOUT {
    'id': string;
    'name': string;
    'name_de': string;
    'categories': Array<CategoryOUT>;
    'blueprint_field_set'?: Array<SlimProductGroupFieldSetOUT>;
    'required_fields': Array<FieldOUT>;
    'optional_fields': Array<FieldOUT>;
    'required_components'?: Array<SlimProductGroupOUT | null>;
    'optional_components'?: Array<SlimProductGroupOUT | null>;
    'unit': string;
}
export interface SlimUserAuditOUT {
    'audit_id': string;
    'audit_title'?: string | null;
    'member_count': number;
    'role': number;
    'building': SlimBuildingOUT;
    'created': string;
    'modified': string;
}

export const SnapshotCategory = {
    Mapping: 'mapping',
    Full: 'full',
    All: 'all'
} as const;

export type SnapshotCategory = typeof SnapshotCategory[keyof typeof SnapshotCategory];


export interface SnapshotListOUT {
    'snapshots': Array<SnapshotOUT>;
    'file_id': string;
    'file_name': string;
    'total_count': number;
    'total_pages': number;
    'current_page': number;
}
export interface SnapshotOUT {
    'id': number;
    'name': string;
    'created_by'?: string;
    'number_matches': number;
    'restored': boolean;
    'snapshot_type'?: SnapshotType | null;
    'created_at': string;
}



export const SnapshotType = {
    Full: 'FULL',
    Mapping: 'MAPPING',
    Unmapping: 'UNMAPPING',
    Admin: 'ADMIN',
    Nightly: 'NIGHTLY'
} as const;

export type SnapshotType = typeof SnapshotType[keyof typeof SnapshotType];



export const SortDirectionENUM = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionENUM = typeof SortDirectionENUM[keyof typeof SortDirectionENUM];



export const SortOrder = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];


export interface Sorting {
    'column_key': string;
    'column_source': ColumnSourceEnum;
    'direction': SortDirectionENUM;
}


export interface StructuredMaterialOut {
    'category_name': string;
    'children'?: Array<MaterialOUT>;
}
export interface SuggestOUT {
    'place_id': string;
    'structured_formatting': object;
    'description': string;
}
export interface SummaryTableDataFilterSchema {
    'input_file_id'?: string | null;
    'input_id'?: string | null;
    'match_id'?: string | null;
    'building_id'?: string | null;
    'object_id'?: string | null;
    'object_name'?: string | null;
    'object_material'?: string | null;
    'object_material_flow_status'?: string | null;
    'object_area__from'?: number | null;
    'object_area__until'?: number | null;
    'object_volume__from'?: number | null;
    'object_volume__until'?: number | null;
    'component_name'?: string | null;
    'product_name'?: string | null;
    'product_lca_data_obd_name_de'?: string | null;
    'product_din_category_name'?: string | null;
    'product_material_category_general_name'?: string | null;
    'product_material'?: string | null;
    'product_reusability_score__from'?: number | null;
    'product_reusability_score__until'?: number | null;
    'product_separability_score__from'?: number | null;
    'product_separability_score__until'?: number | null;
    'product_recyclability_score__from'?: number | null;
    'product_recyclability_score__until'?: number | null;
    'product_deconstructability_score__from'?: number | null;
    'product_deconstructability_score__until'?: number | null;
    'product_reusability_qualification'?: string | null;
    'gwp_total__from'?: number | null;
    'gwp_total__until'?: number | null;
    'mass__from'?: number | null;
    'mass__until'?: number | null;
    'object_height__from'?: number | null;
    'object_height__until'?: number | null;
    'object_width__from'?: number | null;
    'object_width__until'?: number | null;
    'object_length__from'?: number | null;
    'object_length__until'?: number | null;
    'mass'?: number | null;
    'epd_name_de'?: string | null;
    'epd_name_en'?: string | null;
    'epd_url'?: string | null;
    'epd_contains_shi_documents'?: boolean | null;
    'epd_group_id'?: string | null;
    'epd_ratio__from'?: number | null;
    'epd_ratio__until'?: number | null;
    'epd_reference_size'?: string | null;
    'epd_reference_unit'?: string | null;
    'epd_mass_value_m__from'?: number | null;
    'epd_mass_value_m__until'?: number | null;
    'epd_mass_value_m2__from'?: number | null;
    'epd_mass_value_m2__until'?: number | null;
    'epd_mass_value_m3__from'?: number | null;
    'epd_mass_value_m3__until'?: number | null;
    'material'?: string | null;
    'material_category_origin_id'?: string | null;
    'material_category_origin_name'?: string | null;
    'material_category_general_name'?: string | null;
    'material_category_general_id'?: string | null;
    'material_category_dgnb_id'?: string | null;
    'material_recyclability_score__from'?: number | null;
    'material_recyclability_score__until'?: number | null;
    'cpx_preuse_score__from'?: number | null;
    'cpx_preuse_score__until'?: number | null;
    'cpx_recyclability_score__from'?: number | null;
    'cpx_recyclability_score__until'?: number | null;
    'cpx_score__from'?: number | null;
    'cpx_score__until'?: number | null;
    'cpx_separability_qualification'?: string | null;
    'cpx_separability_score__from'?: number | null;
    'cpx_separability_score__until'?: number | null;
    'cpx_deconstructability_score__from'?: number | null;
    'cpx_deconstructability_score__until'?: number | null;
    'cpx_preuse_qualification'?: string | null;
    'cpx_recyclability_qualification'?: string | null;
    'cpx_deconstructability_qualification'?: string | null;
    'cpx_reusability_qualification'?: string | null;
    'cpx_reuse_potential_score__from'?: number | null;
    'cpx_reuse_potential_score__until'?: number | null;
    'mass_material_value__from'?: number | null;
    'mass_material_value__until'?: number | null;
    'is_compliant'?: boolean | null;
    'object_ifc_entity'?: string | null;
    'product_din_category_id'?: string | null;
    'product_din_category_name_level_2'?: string | null;
    'product_din_category_name_level_3'?: string | null;
    'product_match_type'?: string | null;
    'product_epd_id'?: string | null;
    'product_id'?: string | null;
    'material_recyclability_qualification'?: string | null;
    'product_match_confidence__from'?: number | null;
    'product_match_confidence__until'?: number | null;
    'product_deconstructability_qualification'?: string | null;
    'object_deconstructability_qualification'?: string | null;
    'product_deconstructability_dgnb_wording'?: string | null;
    'object_recyclability_qualification'?: string | null;
    'penrt_total__from'?: number | null;
    'penrt_total__until'?: number | null;
    'pert_total__from'?: number | null;
    'pert_total__until'?: number | null;
    'pe_total__from'?: number | null;
    'pe_total__until'?: number | null;
    'pocp_total__from'?: number | null;
    'pocp_total__until'?: number | null;
    'ap_total__from'?: number | null;
    'ap_total__until'?: number | null;
    'ep_total__from'?: number | null;
    'ep_total__until'?: number | null;
    'fw_total__from'?: number | null;
    'fw_total__until'?: number | null;
    'hwd_total__from'?: number | null;
    'hwd_total__until'?: number | null;
    'mer_total__from'?: number | null;
    'mer_total__until'?: number | null;
    'mfr_total__from'?: number | null;
    'mfr_total__until'?: number | null;
    'nhwd_total__from'?: number | null;
    'nhwd_total__until'?: number | null;
    'adpe_total__from'?: number | null;
    'adpe_total__until'?: number | null;
    'adpf_total__from'?: number | null;
    'adpf_total__until'?: number | null;
    'gwpfossil_total__from'?: number | null;
    'gwpfossil_total__until'?: number | null;
    'gwp_a1_a3__from'?: number | null;
    'gwp_a1_a3__until'?: number | null;
    'gwp_a4__from'?: number | null;
    'gwp_a4__until'?: number | null;
    'gwp_a5__from'?: number | null;
    'gwp_a5__until'?: number | null;
    'gwp_b4__from'?: number | null;
    'gwp_b4__until'?: number | null;
    'gwp_c1__from'?: number | null;
    'gwp_c1__until'?: number | null;
    'gwp_c2__from'?: number | null;
    'gwp_c2__until'?: number | null;
    'gwp_c3__from'?: number | null;
    'gwp_c3__until'?: number | null;
    'gwp_c4__from'?: number | null;
    'gwp_c4__until'?: number | null;
    'gwp_d__from'?: number | null;
    'gwp_d__until'?: number | null;
    'savings_potential__from'?: number | null;
    'savings_potential__until'?: number | null;
    'saved_emissions__from'?: number | null;
    'saved_emissions__until'?: number | null;
    'component_order__from'?: number | null;
    'component_order__until'?: number | null;
}
export interface SummaryTableDataSchemaIn {
    'columns'?: Array<string>;
    'sort_by'?: string | null;
    'sort_direction'?: string | null;
    'filters': SummaryTableDataFilterSchema;
}
export interface TooltipMapOUT {
    'name'?: PrefillTooltip;
    'reference_unit'?: PrefillTooltip;
    'cpx_preuse'?: PrefillTooltip;
    'cpx_deconstructability'?: PrefillTooltip;
    'cpx_reusability'?: PrefillTooltip;
    'cpx_separability'?: PrefillTooltip;
    'cpx_recyclability'?: PrefillTooltip;
    'din_category'?: PrefillTooltip | null;
    'life_span'?: PrefillTooltip;
}



export const TraceType = {
    Value: 'value',
    Operator: 'operator'
} as const;

export type TraceType = typeof TraceType[keyof typeof TraceType];


export interface UsedPropertiesOUT {
    'slug': string;
    'value': string;
    'count'?: number;
}
export interface UserAuditRoleOUT {
    'role_type': string;
    'role_name': string;
}
export interface UserAuditUpdateIN {
    'role': RoleEnum;
}


export interface UserBackTokenOUT {
    'sso_jwt': string;
}
export interface UserBuildingOUT {
    'id': string;
    'building': BuildingOUT;
    'organisation_name': string;
    'user': UserProfileOUT;
    'role': number;
}
export interface UserDocument {
    'url': string;
    'file_name': string;
}
export interface UserOrganisationMemberOUT {
    'user': UserProfileOUT;
    'role': number;
}
export interface UserOrganisationOUT {
    'id': string;
    'organisation': OrganisationOUT;
    'role': number;
}
export interface UserOrganisationRoleIN {
    'username': string;
    'role': number;
}
export interface UserProfileIN {
    'first_name': string;
    'last_name': string;
    'terms_accepted'?: boolean | null;
}
export interface UserProfileOUT {
    'username': string;
    'email': string;
    'first_name': string;
    'last_name': string;
}
export interface UserRoleOUT {
    'role_type': string;
    'role_name': string;
}
export interface Value {
}
export interface Value1 {
}
export interface Value2 {
}
export interface Value3 {
}

export const ViewChoices = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;

export type ViewChoices = typeof ViewChoices[keyof typeof ViewChoices];


export interface WorkflowResponseSchema {
    'result': object;
}
export interface WorkflowTriggerInput {
    'endpoint': string;
    'payload': object;
}

/**
 * APIKeyApi - axios parameter creator
 */
export const APIKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate API key for user
         * @summary Generate Api Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersApiKeyGenerateApiKey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/api_key/generate_api_key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate if the API key belongs to the user
         * @summary Validate Api Key
         * @param {string} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersApiKeyValidateApiKey: async (apiKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKey' is not null or undefined
            assertParamExists('concularApiV1RoutersApiKeyValidateApiKey', 'apiKey', apiKey)
            const localVarPath = `/api/v1/concular/api_key/validate_api_key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (apiKey !== undefined) {
                localVarQueryParameter['api_key'] = apiKey;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIKeyApi - functional programming interface
 */
export const APIKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate API key for user
         * @summary Generate Api Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersApiKeyGenerateApiKey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAPIKeyOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersApiKeyGenerateApiKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.concularApiV1RoutersApiKeyGenerateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate if the API key belongs to the user
         * @summary Validate Api Key
         * @param {string} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersApiKeyValidateApiKey(apiKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersApiKeyValidateApiKey(apiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeyApi.concularApiV1RoutersApiKeyValidateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APIKeyApi - factory interface
 */
export const APIKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIKeyApiFp(configuration)
    return {
        /**
         * Generate API key for user
         * @summary Generate Api Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersApiKeyGenerateApiKey(options?: RawAxiosRequestConfig): AxiosPromise<GenerateAPIKeyOut> {
            return localVarFp.concularApiV1RoutersApiKeyGenerateApiKey(options).then((request) => request(axios, basePath));
        },
        /**
         * Validate if the API key belongs to the user
         * @summary Validate Api Key
         * @param {string} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersApiKeyValidateApiKey(apiKey: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersApiKeyValidateApiKey(apiKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIKeyApi - object-oriented interface
 */
export class APIKeyApi extends BaseAPI {
    /**
     * Generate API key for user
     * @summary Generate Api Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersApiKeyGenerateApiKey(options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).concularApiV1RoutersApiKeyGenerateApiKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate if the API key belongs to the user
     * @summary Validate Api Key
     * @param {string} apiKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersApiKeyValidateApiKey(apiKey: string, options?: RawAxiosRequestConfig) {
        return APIKeyApiFp(this.configuration).concularApiV1RoutersApiKeyValidateApiKey(apiKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditInvitationsApi - axios parameter creator
 */
export const AuditInvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an audit invitation.
         * @summary Delete Audit Invitation
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationDeleteAuditInvitation: async (invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('caApiV1RoutersAuditInvitationDeleteAuditInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/v1/ca/audit_invitations/{invitation_id}`
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a user to join an audit. Audit manager can invite the user to join an audit.
         * @summary Invite User For Audit
         * @param {AuditInvitationIN} auditInvitationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationInviteUserForAudit: async (auditInvitationIN: AuditInvitationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditInvitationIN' is not null or undefined
            assertParamExists('caApiV1RoutersAuditInvitationInviteUserForAudit', 'auditInvitationIN', auditInvitationIN)
            const localVarPath = `/api/v1/ca/audit_invitations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditInvitationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all the audit invitations for a specific audit.
         * @summary List Audit Invitations
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationListAuditInvitations: async (auditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersAuditInvitationListAuditInvitations', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/audit_invitations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (auditId !== undefined) {
                localVarQueryParameter['audit_id'] = auditId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditInvitationsApi - functional programming interface
 */
export const AuditInvitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditInvitationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an audit invitation.
         * @summary Delete Audit Invitation
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditInvitationsApi.caApiV1RoutersAuditInvitationDeleteAuditInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite a user to join an audit. Audit manager can invite the user to join an audit.
         * @summary Invite User For Audit
         * @param {AuditInvitationIN} auditInvitationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN: AuditInvitationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditInvitationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditInvitationsApi.caApiV1RoutersAuditInvitationInviteUserForAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all the audit invitations for a specific audit.
         * @summary List Audit Invitations
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditInvitationListAuditInvitations(auditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditInvitationDetailsOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditInvitationListAuditInvitations(auditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditInvitationsApi.caApiV1RoutersAuditInvitationListAuditInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditInvitationsApi - factory interface
 */
export const AuditInvitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditInvitationsApiFp(configuration)
    return {
        /**
         * Delete an audit invitation.
         * @summary Delete Audit Invitation
         * @param {string} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite a user to join an audit. Audit manager can invite the user to join an audit.
         * @summary Invite User For Audit
         * @param {AuditInvitationIN} auditInvitationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN: AuditInvitationIN, options?: RawAxiosRequestConfig): AxiosPromise<AuditInvitationOUT> {
            return localVarFp.caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN, options).then((request) => request(axios, basePath));
        },
        /**
         * List all the audit invitations for a specific audit.
         * @summary List Audit Invitations
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditInvitationListAuditInvitations(auditId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditInvitationDetailsOUT>> {
            return localVarFp.caApiV1RoutersAuditInvitationListAuditInvitations(auditId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditInvitationsApi - object-oriented interface
 */
export class AuditInvitationsApi extends BaseAPI {
    /**
     * Delete an audit invitation.
     * @summary Delete Audit Invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId: string, options?: RawAxiosRequestConfig) {
        return AuditInvitationsApiFp(this.configuration).caApiV1RoutersAuditInvitationDeleteAuditInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite a user to join an audit. Audit manager can invite the user to join an audit.
     * @summary Invite User For Audit
     * @param {AuditInvitationIN} auditInvitationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN: AuditInvitationIN, options?: RawAxiosRequestConfig) {
        return AuditInvitationsApiFp(this.configuration).caApiV1RoutersAuditInvitationInviteUserForAudit(auditInvitationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all the audit invitations for a specific audit.
     * @summary List Audit Invitations
     * @param {string} auditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditInvitationListAuditInvitations(auditId: string, options?: RawAxiosRequestConfig) {
        return AuditInvitationsApiFp(this.configuration).caApiV1RoutersAuditInvitationListAuditInvitations(auditId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditsApi - axios parameter creator
 */
export const AuditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete blueprint by id.
         * @summary Delete Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditDeleteBlueprint: async (blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersAuditDeleteBlueprint', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/audits/blueprint/{blueprint_id}`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete instance by id.
         * @summary Delete Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditDeleteInstance: async (instanceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersAuditDeleteInstance', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/audits/instance/{instance_id}`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get audit by id.
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditGetAudit: async (auditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersAuditGetAudit', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/audits/{audit_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditUpdateAudit: async (auditIN: AuditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditIN' is not null or undefined
            assertParamExists('caApiV1RoutersAuditUpdateAudit', 'auditIN', auditIN)
            const localVarPath = `/api/v1/ca/audits/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditsApi - functional programming interface
 */
export const AuditsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete blueprint by id.
         * @summary Delete Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditDeleteBlueprint(blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditDeleteBlueprint(blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditsApi.caApiV1RoutersAuditDeleteBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete instance by id.
         * @summary Delete Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditDeleteInstance(instanceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditDeleteInstance(instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditsApi.caApiV1RoutersAuditDeleteInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get audit by id.
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditGetAudit(auditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditsApi.caApiV1RoutersAuditGetAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersAuditUpdateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersAuditUpdateAudit(auditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditsApi.caApiV1RoutersAuditUpdateAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditsApi - factory interface
 */
export const AuditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditsApiFp(configuration)
    return {
        /**
         * Delete blueprint by id.
         * @summary Delete Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditDeleteBlueprint(blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersAuditDeleteBlueprint(blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete instance by id.
         * @summary Delete Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditDeleteInstance(instanceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersAuditDeleteInstance(instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audit by id.
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig): AxiosPromise<AuditOUT> {
            return localVarFp.caApiV1RoutersAuditGetAudit(auditId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersAuditUpdateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.caApiV1RoutersAuditUpdateAudit(auditIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditsApi - object-oriented interface
 */
export class AuditsApi extends BaseAPI {
    /**
     * Delete blueprint by id.
     * @summary Delete Blueprint
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditDeleteBlueprint(blueprintId: string, options?: RawAxiosRequestConfig) {
        return AuditsApiFp(this.configuration).caApiV1RoutersAuditDeleteBlueprint(blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete instance by id.
     * @summary Delete Instance
     * @param {string} instanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditDeleteInstance(instanceId: string, options?: RawAxiosRequestConfig) {
        return AuditsApiFp(this.configuration).caApiV1RoutersAuditDeleteInstance(instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get audit by id.
     * @summary Get Audit
     * @param {string} auditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig) {
        return AuditsApiFp(this.configuration).caApiV1RoutersAuditGetAudit(auditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Audit
     * @param {AuditIN} auditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersAuditUpdateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig) {
        return AuditsApiFp(this.configuration).caApiV1RoutersAuditUpdateAudit(auditIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BProductsAndComponentsApi - axios parameter creator
 */
export const BProductsAndComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckComponentCompliance: async (componentComplianceIN: ComponentComplianceIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentComplianceIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsCheckComponentCompliance', 'componentComplianceIN', componentComplianceIN)
            const localVarPath = `/api/v1/building_products/components/compliance/component_compliance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentComplianceIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckComponentDinCategory: async (componentDINCategoryIN: ComponentDINCategoryIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDINCategoryIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsCheckComponentDinCategory', 'componentDINCategoryIN', componentDINCategoryIN)
            const localVarPath = `/api/v1/building_products/components/categories/din_category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentDINCategoryIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckProductCompliance: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsCheckProductCompliance', 'productId', productId)
            const localVarPath = `/api/v1/building_products/components/compliance/product_compliance/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCreateComponent: async (componentCreateIN: ComponentCreateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentCreateIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsCreateComponent', 'componentCreateIN', componentCreateIN)
            const localVarPath = `/api/v1/building_products/components/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentCreateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsDeleteComponent: async (componentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsDeleteComponent', 'componentId', componentId)
            const localVarPath = `/api/v1/building_products/components/{component_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsDetailsByFile: async (componentId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsDetailsByFile', 'componentId', componentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsDetailsByFile', 'fileId', fileId)
            const localVarPath = `/api/v1/building_products/components/details_by_file/{component_id}/{file_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsEditComponent: async (componentId: string, componentEditIN: ComponentEditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsEditComponent', 'componentId', componentId)
            // verify required parameter 'componentEditIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentsEditComponent', 'componentEditIN', componentEditIN)
            const localVarPath = `/api/v1/building_products/components/{component_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentEditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BProductsAndComponentsApi - functional programming interface
 */
export const BProductsAndComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BProductsAndComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentComplianceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsCheckComponentCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDINCategoryOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsCheckComponentDinCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductComplianceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsCheckProductCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentCreateOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsCreateComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsDeleteComponent(componentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsDeleteComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDetailsByFileOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsDetailsByFile(componentId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsDetailsByFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentEditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BProductsAndComponentsApi.buildingProductsApiV1RoutersComponentsEditComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BProductsAndComponentsApi - factory interface
 */
export const BProductsAndComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BProductsAndComponentsApiFp(configuration)
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentComplianceOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDINCategoryOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductComplianceOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentCreateOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsDeleteComponent(componentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDetailsByFileOut> {
            return localVarFp.buildingProductsApiV1RoutersComponentsDetailsByFile(componentId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentEditOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BProductsAndComponentsApi - object-oriented interface
 */
export class BProductsAndComponentsApi extends BaseAPI {
    /**
     *
     * @summary Check Component Compliance
     * @param {ComponentComplianceIN} componentComplianceIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check Component Din Category
     * @param {ComponentDINCategoryIN} componentDINCategoryIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check Product Compliance
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsCheckProductCompliance(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new component :param request: :param payload: :return:
     * @summary Create Component
     * @param {ComponentCreateIN} componentCreateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsCreateComponent(componentCreateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Component
     * @param {string} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsDeleteComponent(componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Details By File
     * @param {string} componentId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsDetailsByFile(componentId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit Component
     * @param {string} componentId
     * @param {ComponentEditIN} componentEditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig) {
        return BProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuildingInviteesApi - axios parameter creator
 */
export const BuildingInviteesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Once the organisation admin sent the invites to user for joining building. User can accept invite to join a building
         * @summary Accept Invite
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesAcceptInvite: async (buildingInviteeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingInviteeId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesAcceptInvite', 'buildingInviteeId', buildingInviteeId)
            const localVarPath = `/api/v1/concular/building_invitees/{building_invitee_id}`
                .replace(`{${"building_invitee_id"}}`, encodeURIComponent(String(buildingInviteeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the latest status of user building request. If it\'s invited then user hasn\'t join building yet.
         * @summary Check Invite Status
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesCheckInviteStatus: async (buildingInviteeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingInviteeId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesCheckInviteStatus', 'buildingInviteeId', buildingInviteeId)
            const localVarPath = `/api/v1/concular/building_invitees/{building_invitee_id}/status`
                .replace(`{${"building_invitee_id"}}`, encodeURIComponent(String(buildingInviteeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation member can see all the pending invites (user who didn\'t sign up yet) for the building.
         * @summary Get All Invites For Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/building_invitees/all/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a user to join a building. Organisation admin can invite to the user to join a building. Building will be shared with that user even if user is not part for organisation
         * @summary Invite User For Building
         * @param {BuildingInviteeIN} buildingInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesInviteUserForBuilding: async (buildingInviteeIN: BuildingInviteeIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingInviteeIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesInviteUserForBuilding', 'buildingInviteeIN', buildingInviteeIN)
            const localVarPath = `/api/v1/concular/building_invitees/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingInviteeIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove user from invitee list. In future if we implement decline request by user that will also work.
         * @summary Remove User From Invitee List
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList: async (buildingInviteeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingInviteeId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList', 'buildingInviteeId', buildingInviteeId)
            const localVarPath = `/api/v1/concular/building_invitees/{building_invitee_id}`
                .replace(`{${"building_invitee_id"}}`, encodeURIComponent(String(buildingInviteeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation member can resend the invites to the user
         * @summary Resend Invitation Email
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesResendInvitationEmail: async (buildingInviteeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingInviteeId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingInviteesResendInvitationEmail', 'buildingInviteeId', buildingInviteeId)
            const localVarPath = `/api/v1/concular/building_invitees/{building_invitee_id}/resend`
                .replace(`{${"building_invitee_id"}}`, encodeURIComponent(String(buildingInviteeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildingInviteesApi - functional programming interface
 */
export const BuildingInviteesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuildingInviteesApiAxiosParamCreator(configuration)
    return {
        /**
         * Once the organisation admin sent the invites to user for joining building. User can accept invite to join a building
         * @summary Accept Invite
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserBuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesAcceptInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the latest status of user building request. If it\'s invited then user hasn\'t join building yet.
         * @summary Check Invite Status
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingInviteeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesCheckInviteStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation member can see all the pending invites (user who didn\'t sign up yet) for the building.
         * @summary Get All Invites For Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingInviteeOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite a user to join a building. Organisation admin can invite to the user to join a building. Building will be shared with that user even if user is not part for organisation
         * @summary Invite User For Building
         * @param {BuildingInviteeIN} buildingInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN: BuildingInviteeIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingInviteeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesInviteUserForBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove user from invitee list. In future if we implement decline request by user that will also work.
         * @summary Remove User From Invitee List
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation member can resend the invites to the user
         * @summary Resend Invitation Email
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingInviteeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingInviteesApi.concularApiV1RoutersBuildingInviteesResendInvitationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuildingInviteesApi - factory interface
 */
export const BuildingInviteesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuildingInviteesApiFp(configuration)
    return {
        /**
         * Once the organisation admin sent the invites to user for joining building. User can accept invite to join a building
         * @summary Accept Invite
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserBuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the latest status of user building request. If it\'s invited then user hasn\'t join building yet.
         * @summary Check Invite Status
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingInviteeOUT> {
            return localVarFp.concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation member can see all the pending invites (user who didn\'t sign up yet) for the building.
         * @summary Get All Invites For Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildingInviteeOUT>> {
            return localVarFp.concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite a user to join a building. Organisation admin can invite to the user to join a building. Building will be shared with that user even if user is not part for organisation
         * @summary Invite User For Building
         * @param {BuildingInviteeIN} buildingInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN: BuildingInviteeIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingInviteeOUT> {
            return localVarFp.concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove user from invitee list. In future if we implement decline request by user that will also work.
         * @summary Remove User From Invitee List
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation member can resend the invites to the user
         * @summary Resend Invitation Email
         * @param {string} buildingInviteeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingInviteeOUT> {
            return localVarFp.concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuildingInviteesApi - object-oriented interface
 */
export class BuildingInviteesApi extends BaseAPI {
    /**
     * Once the organisation admin sent the invites to user for joining building. User can accept invite to join a building
     * @summary Accept Invite
     * @param {string} buildingInviteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId: string, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesAcceptInvite(buildingInviteeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the latest status of user building request. If it\'s invited then user hasn\'t join building yet.
     * @summary Check Invite Status
     * @param {string} buildingInviteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId: string, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesCheckInviteStatus(buildingInviteeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation member can see all the pending invites (user who didn\'t sign up yet) for the building.
     * @summary Get All Invites For Building
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId: string, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesGetAllInvitesForBuilding(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite a user to join a building. Organisation admin can invite to the user to join a building. Building will be shared with that user even if user is not part for organisation
     * @summary Invite User For Building
     * @param {BuildingInviteeIN} buildingInviteeIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN: BuildingInviteeIN, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesInviteUserForBuilding(buildingInviteeIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove user from invitee list. In future if we implement decline request by user that will also work.
     * @summary Remove User From Invitee List
     * @param {string} buildingInviteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId: string, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesRemoveUserFromInviteeList(buildingInviteeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation member can resend the invites to the user
     * @summary Resend Invitation Email
     * @param {string} buildingInviteeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId: string, options?: RawAxiosRequestConfig) {
        return BuildingInviteesApiFp(this.configuration).concularApiV1RoutersBuildingInviteesResendInvitationEmail(buildingInviteeId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuildingProductEditorApi - axios parameter creator
 */
export const BuildingProductEditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorCheckEpdGroups: async (ePDGroupsCheckIN: EPDGroupsCheckIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDGroupsCheckIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorCheckEpdGroups', 'ePDGroupsCheckIN', ePDGroupsCheckIN)
            const localVarPath = `/api/v1/building_products/product_editor/check_epd_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDGroupsCheckIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications: async (ePDSpecificationCheckIN: EPDSpecificationCheckIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDSpecificationCheckIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications', 'ePDSpecificationCheckIN', ePDSpecificationCheckIN)
            const localVarPath = `/api/v1/building_products/product_editor/check_epd_specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDSpecificationCheckIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct', 'productId', productId)
            const localVarPath = `/api/v1/building_products/product_editor/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct: async (productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct', 'productId', productId)
            // verify required parameter 'customBuildingProductEditIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct', 'customBuildingProductEditIN', customBuildingProductEditIN)
            const localVarPath = `/api/v1/building_products/product_editor/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customBuildingProductEditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetCategories: async (categorySystem?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/product_editor/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (categorySystem !== undefined) {
                localVarQueryParameter['category_system'] = categorySystem;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetCpxValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/product_editor/cpx_values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates data in the shape of editing an existing product with data prefilled based on the provided EPDs.
         * @summary Get Prefilled Product Data
         * @param {PrefilledProductCreationIN} prefilledProductCreationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetPrefilledProductData: async (prefilledProductCreationIN: PrefilledProductCreationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefilledProductCreationIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorGetPrefilledProductData', 'prefilledProductCreationIN', prefilledProductCreationIN)
            const localVarPath = `/api/v1/building_products/product_editor/building_products/create_from_epds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prefilledProductCreationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Usage Buildings
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings: async (productId: string, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings', 'productId', productId)
            const localVarPath = `/api/v1/building_products/product_editor/{product_id}/product_usage/buildings`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Usage Components
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageComponents: async (productId: string, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorGetProductUsageComponents', 'productId', productId)
            const localVarPath = `/api/v1/building_products/product_editor/{product_id}/product_usage/components`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Usage Summary
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageSummary: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorGetProductUsageSummary', 'productId', productId)
            const localVarPath = `/api/v1/building_products/product_editor/{product_id}/product_usage`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct: async (customBuildingProductIN: CustomBuildingProductIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customBuildingProductIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct', 'customBuildingProductIN', customBuildingProductIN)
            const localVarPath = `/api/v1/building_products/product_editor/building_products/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customBuildingProductIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorSearchMaterials: async (materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialSearchIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorSearchMaterials', 'materialSearchIN', materialSearchIN)
            const localVarPath = `/api/v1/building_products/product_editor/search/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(materialSearchIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct: async (retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retoolBuildingProductUpsertIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct', 'retoolBuildingProductUpsertIN', retoolBuildingProductUpsertIN)
            const localVarPath = `/api/v1/building_products/product_editor/retool/upsert_building_product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retoolBuildingProductUpsertIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildingProductEditorApi - functional programming interface
 */
export const BuildingProductEditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuildingProductEditorApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDGroupsCheckOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorCheckEpdGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpdSpecificationCheckOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomBuildingProductEditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CPXValueOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetCpxValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetCpxValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates data in the shape of editing an existing product with data prefilled based on the provided EPDs.
         * @summary Get Prefilled Product Data
         * @param {PrefilledProductCreationIN} prefilledProductCreationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN: PrefilledProductCreationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefilledProductOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetPrefilledProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Usage Buildings
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProductUsageBuildingItemOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Usage Components
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProductUsageComponentItemOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetProductUsageComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Usage Summary
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUsageSummaryOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorGetProductUsageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomBuildingProductOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMaterialSearchOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorSearchMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetoolBuildingProductUpsertOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingProductEditorApi.buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuildingProductEditorApi - factory interface
 */
export const BuildingProductEditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuildingProductEditorApiFp(configuration)
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig): AxiosPromise<EPDGroupsCheckOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig): AxiosPromise<EpdSpecificationCheckOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig): AxiosPromise<CustomBuildingProductEditOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryOUT>> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<CPXValueOUT>> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetCpxValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Generates data in the shape of editing an existing product with data prefilled based on the provided EPDs.
         * @summary Get Prefilled Product Data
         * @param {PrefilledProductCreationIN} prefilledProductCreationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN: PrefilledProductCreationIN, options?: RawAxiosRequestConfig): AxiosPromise<PrefilledProductOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Usage Buildings
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedProductUsageBuildingItemOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Usage Components
         * @param {string} productId
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedProductUsageComponentItemOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Usage Summary
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductUsageSummaryOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig): AxiosPromise<CustomBuildingProductOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedMaterialSearchOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig): AxiosPromise<RetoolBuildingProductUpsertOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuildingProductEditorApi - object-oriented interface
 */
export class BuildingProductEditorApi extends BaseAPI {
    /**
     * This endpoint checks the combination of the compliance of multiple epd groups.
     * @summary Check Epd Groups
     * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
     * @summary Check Epd Specifications
     * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Custom Building Product
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit Custom Building Product
     * @param {string} productId
     * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Categories
     * @param {string | null} [categorySystem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetCategories(categorySystem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Cpx Values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetCpxValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates data in the shape of editing an existing product with data prefilled based on the provided EPDs.
     * @summary Get Prefilled Product Data
     * @param {PrefilledProductCreationIN} prefilledProductCreationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN: PrefilledProductCreationIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetPrefilledProductData(prefilledProductCreationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Usage Buildings
     * @param {string} productId
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetProductUsageBuildings(productId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Usage Components
     * @param {string} productId
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId: string, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetProductUsageComponents(productId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Usage Summary
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId: string, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorGetProductUsageSummary(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint registers a custom building product to the database.
     * @summary Register Custom Building Product
     * @param {CustomBuildingProductIN} customBuildingProductIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Materials
     * @param {MaterialSearchIN} materialSearchIN
     * @param {SortOrder | null} [sortOrder]
     * @param {MaterialSearchSortBy | null} [sortBy]
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint registers new custom building product to the database or updates an existing one.
     * @summary Upsert Retool Building Product
     * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig) {
        return BuildingProductEditorApiFp(this.configuration).buildingProductsApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuildingsApi - axios parameter creator
 */
export const BuildingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * As an admin or member user can create a new building within the organisation.
         * @summary Create Org Building
         * @param {BuildingIN} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsCreateOrgBuilding: async (buildingIN: BuildingIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsCreateOrgBuilding', 'buildingIN', buildingIN)
            const localVarPath = `/api/v1/concular/buildings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a building.
         * @summary Delete Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsDeleteBuilding: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsDeleteBuilding', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove images from the building.
         * @summary Delete Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsDeleteImgBuilding: async (buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsDeleteImgBuilding', 'buildingId', buildingId)
            // verify required parameter 'buildingImageAddRemoveIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsDeleteImgBuilding', 'buildingImageAddRemoveIN', buildingImageAddRemoveIN)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/image`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingImageAddRemoveIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Export Certification
         * @param {string} buildingId
         * @param {ExportCertificationIN} exportCertificationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsExportCertification: async (buildingId: string, exportCertificationIN: ExportCertificationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsExportCertification', 'buildingId', buildingId)
            // verify required parameter 'exportCertificationIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsExportCertification', 'exportCertificationIN', exportCertificationIN)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/export_certification`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportCertificationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the building types. Building type is required to create a building.
         * @summary Get All Building Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllBuildingTypes: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/buildings/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available states for the building. For example, Planned or Existing building.
         * @summary Get All Current State
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllCurrentState: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/buildings/current_state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of IFC, CSV and Audit files of the building.
         * @summary Get All Material Resources
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllMaterialResources: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsGetAllMaterialResources', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/material_resources`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all buildings for the organisation. It will return list of all the buildings that belongs to organisation.
         * @summary Get All Org Buildings
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllOrgBuildings: async (organisationId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsGetAllOrgBuildings', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/buildings/{organisation_id}/all`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the all the details for a specific building.
         * @summary Get Org Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetOrgBuilding: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsGetOrgBuilding', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/buildings/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the status of the building
         * @summary Mapping Status
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsMappingStatus: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsMappingStatus', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/mapping_status`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add/attach images with building.
         * @summary Update Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUpdateImgBuilding: async (buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsUpdateImgBuilding', 'buildingId', buildingId)
            // verify required parameter 'buildingImageAddRemoveIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsUpdateImgBuilding', 'buildingImageAddRemoveIN', buildingImageAddRemoveIN)
            const localVarPath = `/api/v1/concular/buildings/{building_id}/image`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingImageAddRemoveIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User or admin can update the building details.
         * @summary Update Org Building
         * @param {string} buildingId
         * @param {BuildingUpdateIN} buildingUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUpdateOrgBuilding: async (buildingId: string, buildingUpdateIN: BuildingUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsUpdateOrgBuilding', 'buildingId', buildingId)
            // verify required parameter 'buildingUpdateIN' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsUpdateOrgBuilding', 'buildingUpdateIN', buildingUpdateIN)
            const localVarPath = `/api/v1/concular/buildings/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building image uploader. Single or multiple images can be uploaded.
         * @summary Upload Building Images
         * @param {Array<File>} images
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUploadBuildingImages: async (images: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'images' is not null or undefined
            assertParamExists('concularApiV1RoutersBuildingsUploadBuildingImages', 'images', images)
            const localVarPath = `/api/v1/concular/buildings/upload/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (images) {
                images.forEach((element) => {
                    localVarFormParams.append('images', element as any);
                })
            }



            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildingsApi - functional programming interface
 */
export const BuildingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuildingsApiAxiosParamCreator(configuration)
    return {
        /**
         * As an admin or member user can create a new building within the organisation.
         * @summary Create Org Building
         * @param {BuildingIN} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN: BuildingIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsCreateOrgBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a building.
         * @summary Delete Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsDeleteBuilding(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsDeleteBuilding(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsDeleteBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove images from the building.
         * @summary Delete Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId, buildingImageAddRemoveIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsDeleteImgBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Export Certification
         * @param {string} buildingId
         * @param {ExportCertificationIN} exportCertificationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsExportCertification(buildingId: string, exportCertificationIN: ExportCertificationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsExportCertification(buildingId, exportCertificationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsExportCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all the building types. Building type is required to create a building.
         * @summary Get All Building Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsGetAllBuildingTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBuildingTypeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsGetAllBuildingTypes(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsGetAllBuildingTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available states for the building. For example, Planned or Existing building.
         * @summary Get All Current State
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsGetAllCurrentState(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsGetAllCurrentState(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsGetAllCurrentState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of IFC, CSV and Audit files of the building.
         * @summary Get All Material Resources
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaterialResourceOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsGetAllMaterialResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all buildings for the organisation. It will return list of all the buildings that belongs to organisation.
         * @summary Get All Org Buildings
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsGetAllOrgBuildings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the all the details for a specific building.
         * @summary Get Org Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsGetOrgBuilding(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsGetOrgBuilding(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsGetOrgBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the status of the building
         * @summary Mapping Status
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsMappingStatus(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingMappingStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsMappingStatus(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsMappingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add/attach images with building.
         * @summary Update Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId, buildingImageAddRemoveIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsUpdateImgBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User or admin can update the building details.
         * @summary Update Org Building
         * @param {string} buildingId
         * @param {BuildingUpdateIN} buildingUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId: string, buildingUpdateIN: BuildingUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId, buildingUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsUpdateOrgBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building image uploader. Single or multiple images can be uploaded.
         * @summary Upload Building Images
         * @param {Array<File>} images
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersBuildingsUploadBuildingImages(images: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingImageOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersBuildingsUploadBuildingImages(images, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingsApi.concularApiV1RoutersBuildingsUploadBuildingImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuildingsApi - factory interface
 */
export const BuildingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuildingsApiFp(configuration)
    return {
        /**
         * As an admin or member user can create a new building within the organisation.
         * @summary Create Org Building
         * @param {BuildingIN} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN: BuildingIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a building.
         * @summary Delete Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsDeleteBuilding(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersBuildingsDeleteBuilding(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove images from the building.
         * @summary Delete Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId, buildingImageAddRemoveIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export Certification
         * @param {string} buildingId
         * @param {ExportCertificationIN} exportCertificationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsExportCertification(buildingId: string, exportCertificationIN: ExportCertificationIN, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersBuildingsExportCertification(buildingId, exportCertificationIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the building types. Building type is required to create a building.
         * @summary Get All Building Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllBuildingTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedBuildingTypeOUT> {
            return localVarFp.concularApiV1RoutersBuildingsGetAllBuildingTypes(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available states for the building. For example, Planned or Existing building.
         * @summary Get All Current State
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllCurrentState(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.concularApiV1RoutersBuildingsGetAllCurrentState(options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of IFC, CSV and Audit files of the building.
         * @summary Get All Material Resources
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MaterialResourceOUT>> {
            return localVarFp.concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all buildings for the organisation. It will return list of all the buildings that belongs to organisation.
         * @summary Get All Org Buildings
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedBuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the all the details for a specific building.
         * @summary Get Org Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsGetOrgBuilding(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsGetOrgBuilding(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the status of the building
         * @summary Mapping Status
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsMappingStatus(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingMappingStatus> {
            return localVarFp.concularApiV1RoutersBuildingsMappingStatus(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add/attach images with building.
         * @summary Update Img Building
         * @param {string} buildingId
         * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId, buildingImageAddRemoveIN, options).then((request) => request(axios, basePath));
        },
        /**
         * User or admin can update the building details.
         * @summary Update Org Building
         * @param {string} buildingId
         * @param {BuildingUpdateIN} buildingUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId: string, buildingUpdateIN: BuildingUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId, buildingUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Building image uploader. Single or multiple images can be uploaded.
         * @summary Upload Building Images
         * @param {Array<File>} images
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersBuildingsUploadBuildingImages(images: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildingImageOUT>> {
            return localVarFp.concularApiV1RoutersBuildingsUploadBuildingImages(images, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuildingsApi - object-oriented interface
 */
export class BuildingsApi extends BaseAPI {
    /**
     * As an admin or member user can create a new building within the organisation.
     * @summary Create Org Building
     * @param {BuildingIN} buildingIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN: BuildingIN, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsCreateOrgBuilding(buildingIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a building.
     * @summary Delete Building
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsDeleteBuilding(buildingId: string, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsDeleteBuilding(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove images from the building.
     * @summary Delete Img Building
     * @param {string} buildingId
     * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsDeleteImgBuilding(buildingId, buildingImageAddRemoveIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Export Certification
     * @param {string} buildingId
     * @param {ExportCertificationIN} exportCertificationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsExportCertification(buildingId: string, exportCertificationIN: ExportCertificationIN, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsExportCertification(buildingId, exportCertificationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the building types. Building type is required to create a building.
     * @summary Get All Building Types
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsGetAllBuildingTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsGetAllBuildingTypes(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available states for the building. For example, Planned or Existing building.
     * @summary Get All Current State
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsGetAllCurrentState(options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsGetAllCurrentState(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of IFC, CSV and Audit files of the building.
     * @summary Get All Material Resources
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId: string, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsGetAllMaterialResources(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all buildings for the organisation. It will return list of all the buildings that belongs to organisation.
     * @summary Get All Org Buildings
     * @param {string} organisationId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsGetAllOrgBuildings(organisationId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the all the details for a specific building.
     * @summary Get Org Building
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsGetOrgBuilding(buildingId: string, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsGetOrgBuilding(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the status of the building
     * @summary Mapping Status
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsMappingStatus(buildingId: string, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsMappingStatus(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add/attach images with building.
     * @summary Update Img Building
     * @param {string} buildingId
     * @param {BuildingImageAddRemoveIN} buildingImageAddRemoveIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId: string, buildingImageAddRemoveIN: BuildingImageAddRemoveIN, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsUpdateImgBuilding(buildingId, buildingImageAddRemoveIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User or admin can update the building details.
     * @summary Update Org Building
     * @param {string} buildingId
     * @param {BuildingUpdateIN} buildingUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId: string, buildingUpdateIN: BuildingUpdateIN, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsUpdateOrgBuilding(buildingId, buildingUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building image uploader. Single or multiple images can be uploaded.
     * @summary Upload Building Images
     * @param {Array<File>} images
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersBuildingsUploadBuildingImages(images: Array<File>, options?: RawAxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).concularApiV1RoutersBuildingsUploadBuildingImages(images, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CadastreApi - axios parameter creator
 */
export const CadastreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return detailed information about the building.
         * @summary Ioer Building Details
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cadastreApiRouterIoerIoerBuildingDetails: async (gmlBuildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gmlBuildingId' is not null or undefined
            assertParamExists('cadastreApiRouterIoerIoerBuildingDetails', 'gmlBuildingId', gmlBuildingId)
            const localVarPath = `/api/v1/cadastre/ioer/{gml_building_id}/details`
                .replace(`{${"gml_building_id"}}`, encodeURIComponent(String(gmlBuildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return summarized information about the building.
         * @summary Ioer Building Groups
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cadastreApiRouterIoerIoerBuildingGroups: async (gmlBuildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gmlBuildingId' is not null or undefined
            assertParamExists('cadastreApiRouterIoerIoerBuildingGroups', 'gmlBuildingId', gmlBuildingId)
            const localVarPath = `/api/v1/cadastre/ioer/{gml_building_id}/groups`
                .replace(`{${"gml_building_id"}}`, encodeURIComponent(String(gmlBuildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CadastreApi - functional programming interface
 */
export const CadastreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CadastreApiAxiosParamCreator(configuration)
    return {
        /**
         * Return detailed information about the building.
         * @summary Ioer Building Details
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IOERDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CadastreApi.cadastreApiRouterIoerIoerBuildingDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return summarized information about the building.
         * @summary Ioer Building Groups
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IOERGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CadastreApi.cadastreApiRouterIoerIoerBuildingGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CadastreApi - factory interface
 */
export const CadastreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CadastreApiFp(configuration)
    return {
        /**
         * Return detailed information about the building.
         * @summary Ioer Building Details
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<IOERDetail> {
            return localVarFp.cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return summarized information about the building.
         * @summary Ioer Building Groups
         * @param {string} gmlBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<IOERGroup> {
            return localVarFp.cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CadastreApi - object-oriented interface
 */
export class CadastreApi extends BaseAPI {
    /**
     * Return detailed information about the building.
     * @summary Ioer Building Details
     * @param {string} gmlBuildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId: string, options?: RawAxiosRequestConfig) {
        return CadastreApiFp(this.configuration).cadastreApiRouterIoerIoerBuildingDetails(gmlBuildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return summarized information about the building.
     * @summary Ioer Building Groups
     * @param {string} gmlBuildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId: string, options?: RawAxiosRequestConfig) {
        return CadastreApiFp(this.configuration).cadastreApiRouterIoerIoerBuildingGroups(gmlBuildingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalculationTransparencyApi - axios parameter creator
 */
export const CalculationTransparencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Calculation Transparency
         * @param {string} objectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency', 'objectId', objectId)
            const localVarPath = `/api/v1/inventory/calculation_transparency/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationTransparencyApi - functional programming interface
 */
export const CalculationTransparencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationTransparencyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Calculation Transparency
         * @param {string} objectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculationTransparency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationTransparencyApi.inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationTransparencyApi - factory interface
 */
export const CalculationTransparencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationTransparencyApiFp(configuration)
    return {
        /**
         *
         * @summary Get Calculation Transparency
         * @param {string} objectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<CalculationTransparency> {
            return localVarFp.inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationTransparencyApi - object-oriented interface
 */
export class CalculationTransparencyApi extends BaseAPI {
    /**
     *
     * @summary Get Calculation Transparency
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId: string, options?: RawAxiosRequestConfig) {
        return CalculationTransparencyApiFp(this.configuration).inventoryApiV1RoutersCalculationTransparencyGetCalculationTransparency(objectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalculationsApi - axios parameter creator
 */
export const CalculationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the status of the calculations for a building or a file.
         * @summary Get Calculations Status
         * @param {ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersCalculationsGetCalculationsStatus: async (entityType: ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum, entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('concularApiV1RoutersCalculationsGetCalculationsStatus', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('concularApiV1RoutersCalculationsGetCalculationsStatus', 'entityId', entityId)
            const localVarPath = `/api/v1/concular/calculations/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationsApi - functional programming interface
 */
export const CalculationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the status of the calculations for a building or a file.
         * @summary Get Calculations Status
         * @param {ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersCalculationsGetCalculationsStatus(entityType: ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum, entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculationStatusOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersCalculationsGetCalculationsStatus(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationsApi.concularApiV1RoutersCalculationsGetCalculationsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationsApi - factory interface
 */
export const CalculationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationsApiFp(configuration)
    return {
        /**
         * Get the status of the calculations for a building or a file.
         * @summary Get Calculations Status
         * @param {ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum} entityType
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersCalculationsGetCalculationsStatus(entityType: ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum, entityId: string, options?: RawAxiosRequestConfig): AxiosPromise<CalculationStatusOUT> {
            return localVarFp.concularApiV1RoutersCalculationsGetCalculationsStatus(entityType, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationsApi - object-oriented interface
 */
export class CalculationsApi extends BaseAPI {
    /**
     * Get the status of the calculations for a building or a file.
     * @summary Get Calculations Status
     * @param {ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersCalculationsGetCalculationsStatus(entityType: ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum, entityId: string, options?: RawAxiosRequestConfig) {
        return CalculationsApiFp(this.configuration).concularApiV1RoutersCalculationsGetCalculationsStatus(entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum = {
    File: 'file',
    Building: 'building'
} as const;
export type ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum = typeof ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum[keyof typeof ConcularApiV1RoutersCalculationsGetCalculationsStatusEntityTypeEnum];


/**
 * CategoriesApi - axios parameter creator
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of categories
         * @summary Categories
         * @param {string} categorySystem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCategoryCategories: async (categorySystem: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categorySystem' is not null or undefined
            assertParamExists('caApiV1RoutersCategoryCategories', 'categorySystem', categorySystem)
            const localVarPath = `/api/v1/ca/categories/categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (categorySystem !== undefined) {
                localVarQueryParameter['category_system'] = categorySystem;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of categories
         * @summary Categories
         * @param {string} categorySystem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCategoryCategories(categorySystem: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryFullOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCategoryCategories(categorySystem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.caApiV1RoutersCategoryCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoriesApi - factory interface
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * Returns a list of categories
         * @summary Categories
         * @param {string} categorySystem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCategoryCategories(categorySystem: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryFullOut>> {
            return localVarFp.caApiV1RoutersCategoryCategories(categorySystem, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 */
export class CategoriesApi extends BaseAPI {
    /**
     * Returns a list of categories
     * @summary Categories
     * @param {string} categorySystem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCategoryCategories(categorySystem: string, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).caApiV1RoutersCategoryCategories(categorySystem, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommonURLsForApplicationsApi - axios parameter creator
 */
export const CommonURLsForApplicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate the POST URL for s3 upload.
         * @summary Generate Presigned Url
         * @param {PresignedUrlIn} presignedUrlIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersCommonGeneratePresignedUrl: async (presignedUrlIn: PresignedUrlIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presignedUrlIn' is not null or undefined
            assertParamExists('concularApiV1RoutersCommonGeneratePresignedUrl', 'presignedUrlIn', presignedUrlIn)
            const localVarPath = `/api/v1/concular/common/get-presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presignedUrlIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonURLsForApplicationsApi - functional programming interface
 */
export const CommonURLsForApplicationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonURLsForApplicationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate the POST URL for s3 upload.
         * @summary Generate Presigned Url
         * @param {PresignedUrlIn} presignedUrlIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn: PresignedUrlIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommonURLsForApplicationsApi.concularApiV1RoutersCommonGeneratePresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommonURLsForApplicationsApi - factory interface
 */
export const CommonURLsForApplicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonURLsForApplicationsApiFp(configuration)
    return {
        /**
         * Generate the POST URL for s3 upload.
         * @summary Generate Presigned Url
         * @param {PresignedUrlIn} presignedUrlIn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn: PresignedUrlIn, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonURLsForApplicationsApi - object-oriented interface
 */
export class CommonURLsForApplicationsApi extends BaseAPI {
    /**
     * Generate the POST URL for s3 upload.
     * @summary Generate Presigned Url
     * @param {PresignedUrlIn} presignedUrlIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn: PresignedUrlIn, options?: RawAxiosRequestConfig) {
        return CommonURLsForApplicationsApiFp(this.configuration).concularApiV1RoutersCommonGeneratePresignedUrl(presignedUrlIn, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComponentInsightsApi - axios parameter creator
 */
export const ComponentInsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to calculate insights on the component for rendering the graphical representation of the component.
         * @summary Component Insights
         * @param {ComponentInsightsIN} componentInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentInsightsComponentInsights: async (componentInsightsIN: ComponentInsightsIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentInsightsIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersComponentInsightsComponentInsights', 'componentInsightsIN', componentInsightsIN)
            const localVarPath = `/api/v1/building_products/component_insights/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentInsightsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentInsightsApi - functional programming interface
 */
export const ComponentInsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentInsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to calculate insights on the component for rendering the graphical representation of the component.
         * @summary Component Insights
         * @param {ComponentInsightsIN} componentInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN: ComponentInsightsIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentInsightsOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentInsightsApi.buildingProductsApiV1RoutersComponentInsightsComponentInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComponentInsightsApi - factory interface
 */
export const ComponentInsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentInsightsApiFp(configuration)
    return {
        /**
         * Endpoint to calculate insights on the component for rendering the graphical representation of the component.
         * @summary Component Insights
         * @param {ComponentInsightsIN} componentInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN: ComponentInsightsIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentInsightsOUT> {
            return localVarFp.buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentInsightsApi - object-oriented interface
 */
export class ComponentInsightsApi extends BaseAPI {
    /**
     * Endpoint to calculate insights on the component for rendering the graphical representation of the component.
     * @summary Component Insights
     * @param {ComponentInsightsIN} componentInsightsIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN: ComponentInsightsIN, options?: RawAxiosRequestConfig) {
        return ComponentInsightsApiFp(this.configuration).buildingProductsApiV1RoutersComponentInsightsComponentInsights(componentInsightsIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComponentsApi - axios parameter creator
 */
export const ComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckComponentCompliance: async (componentComplianceIN: ComponentComplianceIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentComplianceIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsCheckComponentCompliance', 'componentComplianceIN', componentComplianceIN)
            const localVarPath = `/api/v1/inventory/components/compliance/component_compliance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentComplianceIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckComponentDinCategory: async (componentDINCategoryIN: ComponentDINCategoryIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDINCategoryIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsCheckComponentDinCategory', 'componentDINCategoryIN', componentDINCategoryIN)
            const localVarPath = `/api/v1/inventory/components/categories/din_category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentDINCategoryIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckProductCompliance: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsCheckProductCompliance', 'productId', productId)
            const localVarPath = `/api/v1/inventory/components/compliance/product_compliance/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCreateComponent: async (componentCreateIN: ComponentCreateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentCreateIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsCreateComponent', 'componentCreateIN', componentCreateIN)
            const localVarPath = `/api/v1/inventory/components/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentCreateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsDeleteComponent: async (componentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsDeleteComponent', 'componentId', componentId)
            const localVarPath = `/api/v1/inventory/components/{component_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsDetailsByFile: async (componentId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsDetailsByFile', 'componentId', componentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsDetailsByFile', 'fileId', fileId)
            const localVarPath = `/api/v1/inventory/components/details_by_file/{component_id}/{file_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsEditComponent: async (componentId: string, componentEditIN: ComponentEditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsEditComponent', 'componentId', componentId)
            // verify required parameter 'componentEditIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsEditComponent', 'componentEditIN', componentEditIN)
            const localVarPath = `/api/v1/inventory/components/{component_id}`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentEditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new version of a Custom component with the latest child products. Soft-deletes the current version and regenerates EPD data and the product graphic.
         * @summary Upgrade Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsUpgradeComponent: async (componentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersComponentsUpgradeComponent', 'componentId', componentId)
            const localVarPath = `/api/v1/inventory/components/{component_id}/upgrade`
                .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsApi - functional programming interface
 */
export const ComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentComplianceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsCheckComponentCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDINCategoryOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsCheckComponentDinCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductComplianceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsCheckProductCompliance(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsCheckProductCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentCreateOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsCreateComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsDeleteComponent(componentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsDeleteComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDetailsByFileOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsDetailsByFile(componentId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsDetailsByFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentEditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsEditComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new version of a Custom component with the latest child products. Soft-deletes the current version and regenerates EPD data and the product graphic.
         * @summary Upgrade Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersComponentsUpgradeComponent(componentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentEditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersComponentsUpgradeComponent(componentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComponentsApi.inventoryApiV1RoutersComponentsUpgradeComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComponentsApi - factory interface
 */
export const ComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsApiFp(configuration)
    return {
        /**
         *
         * @summary Check Component Compliance
         * @param {ComponentComplianceIN} componentComplianceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentComplianceOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check Component Din Category
         * @param {ComponentDINCategoryIN} componentDINCategoryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDINCategoryOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check Product Compliance
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductComplianceOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsCheckProductCompliance(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new component :param request: :param payload: :return:
         * @summary Create Component
         * @param {ComponentCreateIN} componentCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentCreateOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsDeleteComponent(componentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Details By File
         * @param {string} componentId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDetailsByFileOut> {
            return localVarFp.inventoryApiV1RoutersComponentsDetailsByFile(componentId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit Component
         * @param {string} componentId
         * @param {ComponentEditIN} componentEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig): AxiosPromise<ComponentEditOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new version of a Custom component with the latest child products. Soft-deletes the current version and regenerates EPD data and the product graphic.
         * @summary Upgrade Component
         * @param {string} componentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersComponentsUpgradeComponent(componentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ComponentEditOUT> {
            return localVarFp.inventoryApiV1RoutersComponentsUpgradeComponent(componentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsApi - object-oriented interface
 */
export class ComponentsApi extends BaseAPI {
    /**
     *
     * @summary Check Component Compliance
     * @param {ComponentComplianceIN} componentComplianceIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN: ComponentComplianceIN, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsCheckComponentCompliance(componentComplianceIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check Component Din Category
     * @param {ComponentDINCategoryIN} componentDINCategoryIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN: ComponentDINCategoryIN, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsCheckComponentDinCategory(componentDINCategoryIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Check Product Compliance
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsCheckProductCompliance(productId: string, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsCheckProductCompliance(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new component :param request: :param payload: :return:
     * @summary Create Component
     * @param {ComponentCreateIN} componentCreateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN: ComponentCreateIN, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsCreateComponent(componentCreateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Component
     * @param {string} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsDeleteComponent(componentId: string, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsDeleteComponent(componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Details By File
     * @param {string} componentId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsDetailsByFile(componentId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsDetailsByFile(componentId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit Component
     * @param {string} componentId
     * @param {ComponentEditIN} componentEditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsEditComponent(componentId: string, componentEditIN: ComponentEditIN, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsEditComponent(componentId, componentEditIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new version of a Custom component with the latest child products. Soft-deletes the current version and regenerates EPD data and the product graphic.
     * @summary Upgrade Component
     * @param {string} componentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersComponentsUpgradeComponent(componentId: string, options?: RawAxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).inventoryApiV1RoutersComponentsUpgradeComponent(componentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DGNBApi - axios parameter creator
 */
export const DGNBApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a resource passport and returns the file
         * @summary Passport Create
         * @param {string} buildingUuid
         * @param {ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum} outputType Output types
         * @param {DGNBPassportIN} dGNBPassportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbPassportCreate: async (buildingUuid: string, outputType: ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum, dGNBPassportIN: DGNBPassportIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingUuid' is not null or undefined
            assertParamExists('reportApiV1RoutersDgnbPassportCreate', 'buildingUuid', buildingUuid)
            // verify required parameter 'outputType' is not null or undefined
            assertParamExists('reportApiV1RoutersDgnbPassportCreate', 'outputType', outputType)
            // verify required parameter 'dGNBPassportIN' is not null or undefined
            assertParamExists('reportApiV1RoutersDgnbPassportCreate', 'dGNBPassportIN', dGNBPassportIN)
            const localVarPath = `/api/v1/report/dgnb/passport/{building_uuid}`
                .replace(`{${"building_uuid"}}`, encodeURIComponent(String(buildingUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (outputType !== undefined) {
                localVarQueryParameter['output_type'] = outputType;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dGNBPassportIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the latest dgnb passport for a specific building with all the info
         * @summary Passport Latest
         * @param {string} buildingUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbPassportLatest: async (buildingUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingUuid' is not null or undefined
            assertParamExists('reportApiV1RoutersDgnbPassportLatest', 'buildingUuid', buildingUuid)
            const localVarPath = `/api/v1/report/dgnb/passport/{building_uuid}/latest`
                .replace(`{${"building_uuid"}}`, encodeURIComponent(String(buildingUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DGNBApi - functional programming interface
 */
export const DGNBApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DGNBApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a resource passport and returns the file
         * @summary Passport Create
         * @param {string} buildingUuid
         * @param {ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum} outputType Output types
         * @param {DGNBPassportIN} dGNBPassportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDgnbPassportCreate(buildingUuid: string, outputType: ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum, dGNBPassportIN: DGNBPassportIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingReportOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDgnbPassportCreate(buildingUuid, outputType, dGNBPassportIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGNBApi.reportApiV1RoutersDgnbPassportCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the latest dgnb passport for a specific building with all the info
         * @summary Passport Latest
         * @param {string} buildingUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDgnbPassportLatest(buildingUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DGNBPassportFileOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDgnbPassportLatest(buildingUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGNBApi.reportApiV1RoutersDgnbPassportLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DGNBApi - factory interface
 */
export const DGNBApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DGNBApiFp(configuration)
    return {
        /**
         * Creates a resource passport and returns the file
         * @summary Passport Create
         * @param {string} buildingUuid
         * @param {ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum} outputType Output types
         * @param {DGNBPassportIN} dGNBPassportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbPassportCreate(buildingUuid: string, outputType: ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum, dGNBPassportIN: DGNBPassportIN, options?: RawAxiosRequestConfig): AxiosPromise<BuildingReportOUT> {
            return localVarFp.reportApiV1RoutersDgnbPassportCreate(buildingUuid, outputType, dGNBPassportIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest dgnb passport for a specific building with all the info
         * @summary Passport Latest
         * @param {string} buildingUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbPassportLatest(buildingUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DGNBPassportFileOUT>> {
            return localVarFp.reportApiV1RoutersDgnbPassportLatest(buildingUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DGNBApi - object-oriented interface
 */
export class DGNBApi extends BaseAPI {
    /**
     * Creates a resource passport and returns the file
     * @summary Passport Create
     * @param {string} buildingUuid
     * @param {ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum} outputType Output types
     * @param {DGNBPassportIN} dGNBPassportIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDgnbPassportCreate(buildingUuid: string, outputType: ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum, dGNBPassportIN: DGNBPassportIN, options?: RawAxiosRequestConfig) {
        return DGNBApiFp(this.configuration).reportApiV1RoutersDgnbPassportCreate(buildingUuid, outputType, dGNBPassportIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the latest dgnb passport for a specific building with all the info
     * @summary Passport Latest
     * @param {string} buildingUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDgnbPassportLatest(buildingUuid: string, options?: RawAxiosRequestConfig) {
        return DGNBApiFp(this.configuration).reportApiV1RoutersDgnbPassportLatest(buildingUuid, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum = {
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Txt: 'TXT',
    None: 'NONE'
} as const;
export type ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum = typeof ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum[keyof typeof ReportApiV1RoutersDgnbPassportCreateOutputTypeEnum];


/**
 * DGNBXMLApi - axios parameter creator
 */
export const DGNBXMLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Dgnb Xml
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbXmlCreateDgnbXml: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDgnbXmlCreateDgnbXml', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dgnb_xml/dgnb_xml/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DGNBXMLApi - functional programming interface
 */
export const DGNBXMLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DGNBXMLApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Dgnb Xml
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingReportOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DGNBXMLApi.reportApiV1RoutersDgnbXmlCreateDgnbXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DGNBXMLApi - factory interface
 */
export const DGNBXMLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DGNBXMLApiFp(configuration)
    return {
        /**
         *
         * @summary Create Dgnb Xml
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingReportOUT> {
            return localVarFp.reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DGNBXMLApi - object-oriented interface
 */
export class DGNBXMLApi extends BaseAPI {
    /**
     *
     * @summary Create Dgnb Xml
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId: string, options?: RawAxiosRequestConfig) {
        return DGNBXMLApiFp(this.configuration).reportApiV1RoutersDgnbXmlCreateDgnbXml(buildingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardApi - axios parameter creator
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CPX dashboard endpoint
         * @summary Building Cpx
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingCpx: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingCpx', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/cpx`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building Dynamic Chart
         * @param {string} buildingId
         * @param {DashboardDynamicChartInput} dashboardDynamicChartInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingDynamicChart: async (buildingId: string, dashboardDynamicChartInput: DashboardDynamicChartInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingDynamicChart', 'buildingId', buildingId)
            // verify required parameter 'dashboardDynamicChartInput' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingDynamicChart', 'dashboardDynamicChartInput', dashboardDynamicChartInput)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/dynamic_chart`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardDynamicChartInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Environmental dashboard endpoint
         * @summary Building Environmental
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingEnvironmental: async (buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingEnvironmental', 'buildingId', buildingId)
            // verify required parameter 'dashboardBuildingEnvironmentalIN' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingEnvironmental', 'dashboardBuildingEnvironmentalIN', dashboardBuildingEnvironmentalIN)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/environmental`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardBuildingEnvironmentalIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building General Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingGeneralEmissions: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingGeneralEmissions', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/general_emissions`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hotspot analysis dashboard endpoint: Top-N EPDs ranked by a chosen indicator (default GWP).
         * @summary Building Hotspots
         * @param {string} buildingId
         * @param {DashboardBuildingHotspotIN} dashboardBuildingHotspotIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingHotspots: async (buildingId: string, dashboardBuildingHotspotIN: DashboardBuildingHotspotIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingHotspots', 'buildingId', buildingId)
            // verify required parameter 'dashboardBuildingHotspotIN' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingHotspots', 'dashboardBuildingHotspotIN', dashboardBuildingHotspotIN)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/hotspots`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardBuildingHotspotIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building mass dashboard endpoint
         * @summary Building Mass
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingMass: async (buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingMass', 'buildingId', buildingId)
            // verify required parameter 'dashboardBuildingEnvironmentalIN' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingMass', 'dashboardBuildingEnvironmentalIN', dashboardBuildingEnvironmentalIN)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/mass`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardBuildingEnvironmentalIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building material value dashboard endpoint
         * @summary Building Material Value
         * @param {string} buildingId
         * @param {DashboardBuildingMaterialValueIN} dashboardBuildingMaterialValueIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingMaterialValue: async (buildingId: string, dashboardBuildingMaterialValueIN: DashboardBuildingMaterialValueIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingMaterialValue', 'buildingId', buildingId)
            // verify required parameter 'dashboardBuildingMaterialValueIN' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingMaterialValue', 'dashboardBuildingMaterialValueIN', dashboardBuildingMaterialValueIN)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/material_value`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardBuildingMaterialValueIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Building Operational Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingOperationalEmissions: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingOperationalEmissions', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/operational_emissions`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Building operational energy dashboard endpoint
         * @summary Building Operational Energy
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingOperationalEnergy: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardBuildingOperationalEnergy', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/operational_energy`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Basic dashboard endpoint
         * @summary Dashboard Building Basic
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardDashboardBuildingBasic: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersDashboardDashboardBuildingBasic', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/dashboard/{building_id}/basic`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * CPX dashboard endpoint
         * @summary Building Cpx
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingCpx(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingCPX>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingCpx(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingCpx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building Dynamic Chart
         * @param {string} buildingId
         * @param {DashboardDynamicChartInput} dashboardDynamicChartInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingDynamicChart(buildingId: string, dashboardDynamicChartInput: DashboardDynamicChartInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDynamicChart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingDynamicChart(buildingId, dashboardDynamicChartInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingDynamicChart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Environmental dashboard endpoint
         * @summary Building Environmental
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingEnvironmental(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingEnvironmental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingEnvironmental(buildingId, dashboardBuildingEnvironmentalIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingEnvironmental']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building General Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingGeneralEmissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingGeneralEmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hotspot analysis dashboard endpoint: Top-N EPDs ranked by a chosen indicator (default GWP).
         * @summary Building Hotspots
         * @param {string} buildingId
         * @param {DashboardBuildingHotspotIN} dashboardBuildingHotspotIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingHotspots(buildingId: string, dashboardBuildingHotspotIN: DashboardBuildingHotspotIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingHotspotOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingHotspots(buildingId, dashboardBuildingHotspotIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingHotspots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building mass dashboard endpoint
         * @summary Building Mass
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingMass(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingMass>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingMass(buildingId, dashboardBuildingEnvironmentalIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingMass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building material value dashboard endpoint
         * @summary Building Material Value
         * @param {string} buildingId
         * @param {DashboardBuildingMaterialValueIN} dashboardBuildingMaterialValueIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingMaterialValue(buildingId: string, dashboardBuildingMaterialValueIN: DashboardBuildingMaterialValueIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingMaterialValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingMaterialValue(buildingId, dashboardBuildingMaterialValueIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingMaterialValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Building Operational Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingOperationalEmissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingOperationalEmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Building operational energy dashboard endpoint
         * @summary Building Operational Energy
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingOperationalEnergy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardBuildingOperationalEnergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Basic dashboard endpoint
         * @summary Dashboard Building Basic
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBuildingBasic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportApiV1RoutersDashboardDashboardBuildingBasic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * CPX dashboard endpoint
         * @summary Building Cpx
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingCpx(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingCPX> {
            return localVarFp.reportApiV1RoutersDashboardBuildingCpx(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building Dynamic Chart
         * @param {string} buildingId
         * @param {DashboardDynamicChartInput} dashboardDynamicChartInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingDynamicChart(buildingId: string, dashboardDynamicChartInput: DashboardDynamicChartInput, options?: RawAxiosRequestConfig): AxiosPromise<DashboardDynamicChart> {
            return localVarFp.reportApiV1RoutersDashboardBuildingDynamicChart(buildingId, dashboardDynamicChartInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Environmental dashboard endpoint
         * @summary Building Environmental
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingEnvironmental(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingEnvironmental> {
            return localVarFp.reportApiV1RoutersDashboardBuildingEnvironmental(buildingId, dashboardBuildingEnvironmentalIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Building general emissions dashboard endpoint
         * @summary Building General Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingGeneralEmissions> {
            return localVarFp.reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Hotspot analysis dashboard endpoint: Top-N EPDs ranked by a chosen indicator (default GWP).
         * @summary Building Hotspots
         * @param {string} buildingId
         * @param {DashboardBuildingHotspotIN} dashboardBuildingHotspotIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingHotspots(buildingId: string, dashboardBuildingHotspotIN: DashboardBuildingHotspotIN, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingHotspotOUT> {
            return localVarFp.reportApiV1RoutersDashboardBuildingHotspots(buildingId, dashboardBuildingHotspotIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Building mass dashboard endpoint
         * @summary Building Mass
         * @param {string} buildingId
         * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingMass(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingMass> {
            return localVarFp.reportApiV1RoutersDashboardBuildingMass(buildingId, dashboardBuildingEnvironmentalIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Building material value dashboard endpoint
         * @summary Building Material Value
         * @param {string} buildingId
         * @param {DashboardBuildingMaterialValueIN} dashboardBuildingMaterialValueIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingMaterialValue(buildingId: string, dashboardBuildingMaterialValueIN: DashboardBuildingMaterialValueIN, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingMaterialValue> {
            return localVarFp.reportApiV1RoutersDashboardBuildingMaterialValue(buildingId, dashboardBuildingMaterialValueIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Building Operational Emissions
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingOperationalEmissions> {
            return localVarFp.reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Building operational energy dashboard endpoint
         * @summary Building Operational Energy
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingOperationalEnergy> {
            return localVarFp.reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Basic dashboard endpoint
         * @summary Dashboard Building Basic
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBuildingBasic> {
            return localVarFp.reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 */
export class DashboardApi extends BaseAPI {
    /**
     * CPX dashboard endpoint
     * @summary Building Cpx
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingCpx(buildingId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingCpx(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building general emissions dashboard endpoint
     * @summary Building Dynamic Chart
     * @param {string} buildingId
     * @param {DashboardDynamicChartInput} dashboardDynamicChartInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingDynamicChart(buildingId: string, dashboardDynamicChartInput: DashboardDynamicChartInput, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingDynamicChart(buildingId, dashboardDynamicChartInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Environmental dashboard endpoint
     * @summary Building Environmental
     * @param {string} buildingId
     * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingEnvironmental(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingEnvironmental(buildingId, dashboardBuildingEnvironmentalIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building general emissions dashboard endpoint
     * @summary Building General Emissions
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingGeneralEmissions(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hotspot analysis dashboard endpoint: Top-N EPDs ranked by a chosen indicator (default GWP).
     * @summary Building Hotspots
     * @param {string} buildingId
     * @param {DashboardBuildingHotspotIN} dashboardBuildingHotspotIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingHotspots(buildingId: string, dashboardBuildingHotspotIN: DashboardBuildingHotspotIN, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingHotspots(buildingId, dashboardBuildingHotspotIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building mass dashboard endpoint
     * @summary Building Mass
     * @param {string} buildingId
     * @param {DashboardBuildingEnvironmentalIN} dashboardBuildingEnvironmentalIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingMass(buildingId: string, dashboardBuildingEnvironmentalIN: DashboardBuildingEnvironmentalIN, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingMass(buildingId, dashboardBuildingEnvironmentalIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building material value dashboard endpoint
     * @summary Building Material Value
     * @param {string} buildingId
     * @param {DashboardBuildingMaterialValueIN} dashboardBuildingMaterialValueIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingMaterialValue(buildingId: string, dashboardBuildingMaterialValueIN: DashboardBuildingMaterialValueIN, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingMaterialValue(buildingId, dashboardBuildingMaterialValueIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Building Operational Emissions
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingOperationalEmissions(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Building operational energy dashboard endpoint
     * @summary Building Operational Energy
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardBuildingOperationalEnergy(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Basic dashboard endpoint
     * @summary Dashboard Building Basic
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId: string, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportApiV1RoutersDashboardDashboardBuildingBasic(buildingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatasetCheckerApi - axios parameter creator
 */
export const DatasetCheckerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns how many physical objects in an IFC file are compliant with the building\'s certification.
         * @summary Check Dataset Compliance
         * @param {DatasetCheckerIN} datasetCheckerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance: async (datasetCheckerIN: DatasetCheckerIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetCheckerIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance', 'datasetCheckerIN', datasetCheckerIN)
            const localVarPath = `/api/v1/inventory/dataset_checker/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetCheckerIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetCheckerApi - functional programming interface
 */
export const DatasetCheckerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetCheckerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns how many physical objects in an IFC file are compliant with the building\'s certification.
         * @summary Check Dataset Compliance
         * @param {DatasetCheckerIN} datasetCheckerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN: DatasetCheckerIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetCheckerOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetCheckerApi.inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetCheckerApi - factory interface
 */
export const DatasetCheckerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetCheckerApiFp(configuration)
    return {
        /**
         * Returns how many physical objects in an IFC file are compliant with the building\'s certification.
         * @summary Check Dataset Compliance
         * @param {DatasetCheckerIN} datasetCheckerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN: DatasetCheckerIN, options?: RawAxiosRequestConfig): AxiosPromise<DatasetCheckerOUT> {
            return localVarFp.inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetCheckerApi - object-oriented interface
 */
export class DatasetCheckerApi extends BaseAPI {
    /**
     * Returns how many physical objects in an IFC file are compliant with the building\'s certification.
     * @summary Check Dataset Compliance
     * @param {DatasetCheckerIN} datasetCheckerIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN: DatasetCheckerIN, options?: RawAxiosRequestConfig) {
        return DatasetCheckerApiFp(this.configuration).inventoryApiV1RoutersDatasetCheckerCheckDatasetCompliance(datasetCheckerIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DetailReportTileApi - axios parameter creator
 */
export const DetailReportTileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch report tile data by report key.
         * @summary Fetch Report Tile
         * @param {FetchReportTileIN} fetchReportTileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersDetailReportTileFetchReportTile: async (fetchReportTileIN: FetchReportTileIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchReportTileIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersDetailReportTileFetchReportTile', 'fetchReportTileIN', fetchReportTileIN)
            const localVarPath = `/api/v1/inventory/detail_report_tile/fetch_report_tile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchReportTileIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetailReportTileApi - functional programming interface
 */
export const DetailReportTileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DetailReportTileApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch report tile data by report key.
         * @summary Fetch Report Tile
         * @param {FetchReportTileIN} fetchReportTileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN: FetchReportTileIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReportTileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DetailReportTileApi.inventoryApiV1RoutersDetailReportTileFetchReportTile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DetailReportTileApi - factory interface
 */
export const DetailReportTileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DetailReportTileApiFp(configuration)
    return {
        /**
         * Fetch report tile data by report key.
         * @summary Fetch Report Tile
         * @param {FetchReportTileIN} fetchReportTileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN: FetchReportTileIN, options?: RawAxiosRequestConfig): AxiosPromise<FetchReportTileOUT> {
            return localVarFp.inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DetailReportTileApi - object-oriented interface
 */
export class DetailReportTileApi extends BaseAPI {
    /**
     * Fetch report tile data by report key.
     * @summary Fetch Report Tile
     * @param {FetchReportTileIN} fetchReportTileIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN: FetchReportTileIN, options?: RawAxiosRequestConfig) {
        return DetailReportTileApiFp(this.configuration).inventoryApiV1RoutersDetailReportTileFetchReportTile(fetchReportTileIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DynamicMappingEditorApi - axios parameter creator
 */
export const DynamicMappingEditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns objects by file_id that matches the filter
         * @summary Filtered Object Ids
         * @param {string} fileId
         * @param {ObjectsFilterIN} objectsFilterIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterFilteredObjectIds: async (fileId: string, objectsFilterIN: ObjectsFilterIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterFilteredObjectIds', 'fileId', fileId)
            // verify required parameter 'objectsFilterIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterFilteredObjectIds', 'objectsFilterIN', objectsFilterIN)
            const localVarPath = `/api/v1/mapping_editor/filtering/{file_id}/index_filter`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectsFilterIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Building
         * @param {string} buildingId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding: async (buildingId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding', 'buildingId', buildingId)
            const localVarPath = `/api/v1/mapping_editor/filtering/property_browser_building/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Full
         * @param {string} fileId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull: async (fileId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull', 'fileId', fileId)
            const localVarPath = `/api/v1/mapping_editor/filtering/{file_id}/property_browser_full`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of possible values for a given dynamic column
         * @summary Retrieve Column Suggestions
         * @param {string} fileId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions: async (fileId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions', 'fileId', fileId)
            // verify required parameter 'columnSuggestionsIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions', 'columnSuggestionsIN', columnSuggestionsIN)
            const localVarPath = `/api/v1/mapping_editor/filtering/{file_id}/column_suggestions`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnSuggestionsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve Column Suggestions For Building
         * @param {string} buildingId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding: async (buildingId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding', 'buildingId', buildingId)
            // verify required parameter 'columnSuggestionsIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding', 'columnSuggestionsIN', columnSuggestionsIN)
            const localVarPath = `/api/v1/mapping_editor/filtering/column_suggestions_building/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnSuggestionsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DynamicMappingEditorApi - functional programming interface
 */
export const DynamicMappingEditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DynamicMappingEditorApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns objects by file_id that matches the filter
         * @summary Filtered Object Ids
         * @param {string} fileId
         * @param {ObjectsFilterIN} objectsFilterIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId: string, objectsFilterIN: ObjectsFilterIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectsFilterOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId, objectsFilterIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicMappingEditorApi.mappingEditorApiV1RoutersIndexFilterFilteredObjectIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Building
         * @param {string} buildingId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyBrowserTreeNode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId, viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicMappingEditorApi.mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Full
         * @param {string} fileId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyBrowserTreeNode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId, viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicMappingEditorApi.mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the list of possible values for a given dynamic column
         * @summary Retrieve Column Suggestions
         * @param {string} fileId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ColumnSuggestionsOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId, columnSuggestionsIN, searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicMappingEditorApi.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve Column Suggestions For Building
         * @param {string} buildingId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ColumnSuggestionsOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId, columnSuggestionsIN, searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicMappingEditorApi.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DynamicMappingEditorApi - factory interface
 */
export const DynamicMappingEditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DynamicMappingEditorApiFp(configuration)
    return {
        /**
         * Returns objects by file_id that matches the filter
         * @summary Filtered Object Ids
         * @param {string} fileId
         * @param {ObjectsFilterIN} objectsFilterIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId: string, objectsFilterIN: ObjectsFilterIN, options?: RawAxiosRequestConfig): AxiosPromise<ObjectsFilterOUT> {
            return localVarFp.mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId, objectsFilterIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Building
         * @param {string} buildingId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<PropertyBrowserTreeNode>> {
            return localVarFp.mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId, viewName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the properties that can be filtered per file
         * @summary Property Browser Full
         * @param {string} fileId
         * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<PropertyBrowserTreeNode>> {
            return localVarFp.mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId, viewName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of possible values for a given dynamic column
         * @summary Retrieve Column Suggestions
         * @param {string} fileId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ColumnSuggestionsOUT>> {
            return localVarFp.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId, columnSuggestionsIN, searchTerm, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Column Suggestions For Building
         * @param {string} buildingId
         * @param {ColumnSuggestionsIN} columnSuggestionsIN
         * @param {string} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ColumnSuggestionsOUT>> {
            return localVarFp.mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId, columnSuggestionsIN, searchTerm, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DynamicMappingEditorApi - object-oriented interface
 */
export class DynamicMappingEditorApi extends BaseAPI {
    /**
     * Returns objects by file_id that matches the filter
     * @summary Filtered Object Ids
     * @param {string} fileId
     * @param {ObjectsFilterIN} objectsFilterIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId: string, objectsFilterIN: ObjectsFilterIN, options?: RawAxiosRequestConfig) {
        return DynamicMappingEditorApiFp(this.configuration).mappingEditorApiV1RoutersIndexFilterFilteredObjectIds(fileId, objectsFilterIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the properties that can be filtered per file
     * @summary Property Browser Building
     * @param {string} buildingId
     * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum} [viewName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum, options?: RawAxiosRequestConfig) {
        return DynamicMappingEditorApiFp(this.configuration).mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(buildingId, viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the properties that can be filtered per file
     * @summary Property Browser Full
     * @param {string} fileId
     * @param {MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum} [viewName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId: string, viewName?: MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum, options?: RawAxiosRequestConfig) {
        return DynamicMappingEditorApiFp(this.configuration).mappingEditorApiV1RoutersIndexFilterPropertyBrowserFull(fileId, viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of possible values for a given dynamic column
     * @summary Retrieve Column Suggestions
     * @param {string} fileId
     * @param {ColumnSuggestionsIN} columnSuggestionsIN
     * @param {string} [searchTerm]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DynamicMappingEditorApiFp(this.configuration).mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestions(fileId, columnSuggestionsIN, searchTerm, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Retrieve Column Suggestions For Building
     * @param {string} buildingId
     * @param {ColumnSuggestionsIN} columnSuggestionsIN
     * @param {string} [searchTerm]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId: string, columnSuggestionsIN: ColumnSuggestionsIN, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DynamicMappingEditorApiFp(this.configuration).mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(buildingId, columnSuggestionsIN, searchTerm, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

export const MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum = typeof MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum[keyof typeof MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum];
export const MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum = typeof MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum[keyof typeof MappingEditorApiV1RoutersIndexFilterPropertyBrowserFullViewNameEnum];


/**
 * EPDInsightsApi - axios parameter creator
 */
export const EPDInsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculate EPD group insights including ratios and graphics data.
         * @summary Get Epd Group Insights
         * @param {EPDGroupInsightsIN} ePDGroupInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights: async (ePDGroupInsightsIN: EPDGroupInsightsIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDGroupInsightsIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights', 'ePDGroupInsightsIN', ePDGroupInsightsIN)
            const localVarPath = `/api/v1/building_products/epd_insights/epd_group_insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDGroupInsightsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EPDInsightsApi - functional programming interface
 */
export const EPDInsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EPDInsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculate EPD group insights including ratios and graphics data.
         * @summary Get Epd Group Insights
         * @param {EPDGroupInsightsIN} ePDGroupInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN: EPDGroupInsightsIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDGroupInsightsOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EPDInsightsApi.buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EPDInsightsApi - factory interface
 */
export const EPDInsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EPDInsightsApiFp(configuration)
    return {
        /**
         * Calculate EPD group insights including ratios and graphics data.
         * @summary Get Epd Group Insights
         * @param {EPDGroupInsightsIN} ePDGroupInsightsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN: EPDGroupInsightsIN, options?: RawAxiosRequestConfig): AxiosPromise<EPDGroupInsightsOUT> {
            return localVarFp.buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EPDInsightsApi - object-oriented interface
 */
export class EPDInsightsApi extends BaseAPI {
    /**
     * Calculate EPD group insights including ratios and graphics data.
     * @summary Get Epd Group Insights
     * @param {EPDGroupInsightsIN} ePDGroupInsightsIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN: EPDGroupInsightsIN, options?: RawAxiosRequestConfig) {
        return EPDInsightsApiFp(this.configuration).buildingProductsApiV1RoutersEpdInsightsGetEpdGroupInsights(ePDGroupInsightsIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExportsApi - axios parameter creator
 */
export const ExportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Export Status
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersExportsGetExportStatus: async (exportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('reportApiV1RoutersExportsGetExportStatus', 'exportId', exportId)
            const localVarPath = `/api/v1/report/exports/{export_id}/status`
                .replace(`{${"export_id"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportsApi - functional programming interface
 */
export const ExportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Export Status
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersExportsGetExportStatus(exportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingReportOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersExportsGetExportStatus(exportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.reportApiV1RoutersExportsGetExportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportsApi - factory interface
 */
export const ExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportsApiFp(configuration)
    return {
        /**
         *
         * @summary Get Export Status
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersExportsGetExportStatus(exportId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingReportOUT> {
            return localVarFp.reportApiV1RoutersExportsGetExportStatus(exportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportsApi - object-oriented interface
 */
export class ExportsApi extends BaseAPI {
    /**
     *
     * @summary Get Export Status
     * @param {string} exportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersExportsGetExportStatus(exportId: string, options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).reportApiV1RoutersExportsGetExportStatus(exportId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileOperationsApi - axios parameter creator
 */
export const FileOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Run File Operations
         * @param {string} fileId
         * @param {FileOperationIN} fileOperationIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersFileOperationsRunFileOperations: async (fileId: string, fileOperationIN: FileOperationIN, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersFileOperationsRunFileOperations', 'fileId', fileId)
            // verify required parameter 'fileOperationIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersFileOperationsRunFileOperations', 'fileOperationIN', fileOperationIN)
            const localVarPath = `/api/v1/mapping_editor/file_operations/file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileOperationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileOperationsApi - functional programming interface
 */
export const FileOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Run File Operations
         * @param {string} fileId
         * @param {FileOperationIN} fileOperationIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId: string, fileOperationIN: FileOperationIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId, fileOperationIN, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileOperationsApi.mappingEditorApiV1RoutersFileOperationsRunFileOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileOperationsApi - factory interface
 */
export const FileOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileOperationsApiFp(configuration)
    return {
        /**
         *
         * @summary Run File Operations
         * @param {string} fileId
         * @param {FileOperationIN} fileOperationIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId: string, fileOperationIN: FileOperationIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ObjectListOUT> {
            return localVarFp.mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId, fileOperationIN, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileOperationsApi - object-oriented interface
 */
export class FileOperationsApi extends BaseAPI {
    /**
     *
     * @summary Run File Operations
     * @param {string} fileId
     * @param {FileOperationIN} fileOperationIN
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId: string, fileOperationIN: FileOperationIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return FileOperationsApiFp(this.configuration).mappingEditorApiV1RoutersFileOperationsRunFileOperations(fileId, fileOperationIN, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileUploadApi - axios parameter creator
 */
export const FileUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Delete User File
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsDeleteUserFile: async (organisationId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsDeleteUserFile', 'organisationId', organisationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsDeleteUserFile', 'fileId', fileId)
            const localVarPath = `/api/v1/files/{organisation_id}/{file_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data For Download
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsGetDataForDownload: async (organisationId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsGetDataForDownload', 'organisationId', organisationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsGetDataForDownload', 'fileId', fileId)
            const localVarPath = `/api/v1/files/{organisation_id}/{file_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Uploaded Files
         * @param {string} organisationId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsListUploadedFiles: async (organisationId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsListUploadedFiles', 'organisationId', organisationId)
            const localVarPath = `/api/v1/files/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Manage File To Target Assignment
         * @param {string} organisationId
         * @param {string} fileId
         * @param {string} targetId
         * @param {string} targetModel
         * @param {UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsManageFileToTargetAssignment: async (organisationId: string, fileId: string, targetId: string, targetModel: string, action: UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsManageFileToTargetAssignment', 'organisationId', organisationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsManageFileToTargetAssignment', 'fileId', fileId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsManageFileToTargetAssignment', 'targetId', targetId)
            // verify required parameter 'targetModel' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsManageFileToTargetAssignment', 'targetModel', targetModel)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsManageFileToTargetAssignment', 'action', action)
            const localVarPath = `/api/v1/files/{organisation_id}/{file_id}/assignment`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }

            if (targetModel !== undefined) {
                localVarQueryParameter['target_model'] = targetModel;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk upload of files
         * @summary Upload Files
         * @param {string} organisationId
         * @param {FileUploadIN} fileUploadIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsUploadFiles: async (organisationId: string, fileUploadIN: FileUploadIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsUploadFiles', 'organisationId', organisationId)
            // verify required parameter 'fileUploadIN' is not null or undefined
            assertParamExists('uploadApiV1RoutersFileUploadsUploadFiles', 'fileUploadIN', fileUploadIN)
            const localVarPath = `/api/v1/files/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUploadIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileUploadApi - functional programming interface
 */
export const FileUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileUploadApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Delete User File
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.uploadApiV1RoutersFileUploadsDeleteUserFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Data For Download
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserFileDownloadOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.uploadApiV1RoutersFileUploadsGetDataForDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Uploaded Files
         * @param {string} organisationId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserFilesOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.uploadApiV1RoutersFileUploadsListUploadedFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Manage File To Target Assignment
         * @param {string} organisationId
         * @param {string} fileId
         * @param {string} targetId
         * @param {string} targetModel
         * @param {UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId: string, fileId: string, targetId: string, targetModel: string, action: UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId, fileId, targetId, targetModel, action, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.uploadApiV1RoutersFileUploadsManageFileToTargetAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk upload of files
         * @summary Upload Files
         * @param {string} organisationId
         * @param {FileUploadIN} fileUploadIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadApiV1RoutersFileUploadsUploadFiles(organisationId: string, fileUploadIN: FileUploadIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<S3PostData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadApiV1RoutersFileUploadsUploadFiles(organisationId, fileUploadIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.uploadApiV1RoutersFileUploadsUploadFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileUploadApi - factory interface
 */
export const FileUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileUploadApiFp(configuration)
    return {
        /**
         *
         * @summary Delete User File
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data For Download
         * @param {string} organisationId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserFileDownloadOUT> {
            return localVarFp.uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Uploaded Files
         * @param {string} organisationId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListUserFilesOUT> {
            return localVarFp.uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Manage File To Target Assignment
         * @param {string} organisationId
         * @param {string} fileId
         * @param {string} targetId
         * @param {string} targetModel
         * @param {UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId: string, fileId: string, targetId: string, targetModel: string, action: UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId, fileId, targetId, targetModel, action, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk upload of files
         * @summary Upload Files
         * @param {string} organisationId
         * @param {FileUploadIN} fileUploadIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApiV1RoutersFileUploadsUploadFiles(organisationId: string, fileUploadIN: FileUploadIN, options?: RawAxiosRequestConfig): AxiosPromise<Array<S3PostData>> {
            return localVarFp.uploadApiV1RoutersFileUploadsUploadFiles(organisationId, fileUploadIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileUploadApi - object-oriented interface
 */
export class FileUploadApi extends BaseAPI {
    /**
     *
     * @summary Delete User File
     * @param {string} organisationId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).uploadApiV1RoutersFileUploadsDeleteUserFile(organisationId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Data For Download
     * @param {string} organisationId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).uploadApiV1RoutersFileUploadsGetDataForDownload(organisationId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Uploaded Files
     * @param {string} organisationId
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).uploadApiV1RoutersFileUploadsListUploadedFiles(organisationId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Manage File To Target Assignment
     * @param {string} organisationId
     * @param {string} fileId
     * @param {string} targetId
     * @param {string} targetModel
     * @param {UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum} action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId: string, fileId: string, targetId: string, targetModel: string, action: UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).uploadApiV1RoutersFileUploadsManageFileToTargetAssignment(organisationId, fileId, targetId, targetModel, action, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk upload of files
     * @summary Upload Files
     * @param {string} organisationId
     * @param {FileUploadIN} fileUploadIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApiV1RoutersFileUploadsUploadFiles(organisationId: string, fileUploadIN: FileUploadIN, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).uploadApiV1RoutersFileUploadsUploadFiles(organisationId, fileUploadIN, options).then((request) => request(this.axios, this.basePath));
    }
}

export const UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum = {
    Assign: 'assign',
    Unassign: 'unassign'
} as const;
export type UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum = typeof UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum[keyof typeof UploadApiV1RoutersFileUploadsManageFileToTargetAssignmentActionEnum];


/**
 * IFCFileApi - axios parameter creator
 */
export const IFCFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an IFC file. It will take a while to clean up all the stuffs related to file.
         * @summary Delete Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDeleteIfcFile: async (ifcFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileDeleteIfcFile', 'ifcFileId', ifcFileId)
            const localVarPath = `/api/v1/ifc/files/{ifc_file_id}`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDownloadIfcFile: async (ifcFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileDownloadIfcFile', 'ifcFileId', ifcFileId)
            const localVarPath = `/api/v1/ifc/files/{ifc_file_id}/download`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File With Mappings
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings: async (ifcFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings', 'ifcFileId', ifcFileId)
            const localVarPath = `/api/v1/ifc/files/{ifc_file_id}/download_with_mappings`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthGetParamBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of IFC files of the building.
         * @summary Get All Ifc Files
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileGetAllIfcFiles: async (buildingId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileGetAllIfcFiles', 'buildingId', buildingId)
            const localVarPath = `/api/v1/ifc/files/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve processing report of ifc file.
         * @summary Get Processing Report
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileGetProcessingReport: async (ifcFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileGetProcessingReport', 'ifcFileId', ifcFileId)
            const localVarPath = `/api/v1/ifc/files/{ifc_file_id}/processing_report`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update reporting status of ifc file.
         * @summary Update Reporting Status
         * @param {string} ifcFileId
         * @param {string} reportingStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileUpdateReportingStatus: async (ifcFileId: string, reportingStatus: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileUpdateReportingStatus', 'ifcFileId', ifcFileId)
            // verify required parameter 'reportingStatus' is not null or undefined
            assertParamExists('ifcApiV1RoutersIfcFileUpdateReportingStatus', 'reportingStatus', reportingStatus)
            const localVarPath = `/api/v1/ifc/files/{ifc_file_id}/reporting_status`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (reportingStatus !== undefined) {
                localVarQueryParameter['reporting_status'] = reportingStatus;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IFCFileApi - functional programming interface
 */
export const IFCFileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IFCFileApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an IFC file. It will take a while to clean up all the stuffs related to file.
         * @summary Delete Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileDeleteIfcFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IFCFileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileDownloadIfcFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File With Mappings
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of IFC files of the building.
         * @summary Get All Ifc Files
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedIFCFileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileGetAllIfcFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve processing report of ifc file.
         * @summary Get Processing Report
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileProcessingReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileGetProcessingReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update reporting status of ifc file.
         * @summary Update Reporting Status
         * @param {string} ifcFileId
         * @param {string} reportingStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId: string, reportingStatus: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IFCFileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId, reportingStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IFCFileApi.ifcApiV1RoutersIfcFileUpdateReportingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IFCFileApi - factory interface
 */
export const IFCFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IFCFileApiFp(configuration)
    return {
        /**
         * Delete an IFC file. It will take a while to clean up all the stuffs related to file.
         * @summary Delete Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<IFCFileOUT> {
            return localVarFp.ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download ifc file that user uploaded.
         * @summary Download Ifc File With Mappings
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of IFC files of the building.
         * @summary Get All Ifc Files
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedIFCFileOUT> {
            return localVarFp.ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve processing report of ifc file.
         * @summary Get Processing Report
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileProcessingReport> {
            return localVarFp.ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update reporting status of ifc file.
         * @summary Update Reporting Status
         * @param {string} ifcFileId
         * @param {string} reportingStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId: string, reportingStatus: string, options?: RawAxiosRequestConfig): AxiosPromise<IFCFileOUT> {
            return localVarFp.ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId, reportingStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IFCFileApi - object-oriented interface
 */
export class IFCFileApi extends BaseAPI {
    /**
     * Delete an IFC file. It will take a while to clean up all the stuffs related to file.
     * @summary Delete Ifc File
     * @param {string} ifcFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileDeleteIfcFile(ifcFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download ifc file that user uploaded.
     * @summary Download Ifc File
     * @param {string} ifcFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId: string, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileDownloadIfcFile(ifcFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download ifc file that user uploaded.
     * @summary Download Ifc File With Mappings
     * @param {string} ifcFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId: string, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileDownloadIfcFileWithMappings(ifcFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of IFC files of the building.
     * @summary Get All Ifc Files
     * @param {string} buildingId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileGetAllIfcFiles(buildingId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve processing report of ifc file.
     * @summary Get Processing Report
     * @param {string} ifcFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId: string, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileGetProcessingReport(ifcFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update reporting status of ifc file.
     * @summary Update Reporting Status
     * @param {string} ifcFileId
     * @param {string} reportingStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId: string, reportingStatus: string, options?: RawAxiosRequestConfig) {
        return IFCFileApiFp(this.configuration).ifcApiV1RoutersIfcFileUpdateReportingStatus(ifcFileId, reportingStatus, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImagesApi - axios parameter creator
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add an image to a blueprint album.
         * @summary Add Existing Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddExistingImageToBlueprintAlbum: async (blueprintId: string, albumId: string, order: number, keyFile: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToBlueprintAlbum', 'blueprintId', blueprintId)
            // verify required parameter 'albumId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToBlueprintAlbum', 'albumId', albumId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToBlueprintAlbum', 'order', order)
            // verify required parameter 'keyFile' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToBlueprintAlbum', 'keyFile', keyFile)
            const localVarPath = `/api/v1/ca/images/blueprint/{blueprint_id}/albums/{album_id}/existing_images`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)))
                .replace(`{${"album_id"}}`, encodeURIComponent(String(albumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (keyFile !== undefined) {
                localVarQueryParameter['key_file'] = keyFile;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an image to an instance album.
         * @summary Add Existing Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddExistingImageToInstanceAlbum: async (instanceId: string, albumId: string, order: number, keyFile: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToInstanceAlbum', 'instanceId', instanceId)
            // verify required parameter 'albumId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToInstanceAlbum', 'albumId', albumId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToInstanceAlbum', 'order', order)
            // verify required parameter 'keyFile' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddExistingImageToInstanceAlbum', 'keyFile', keyFile)
            const localVarPath = `/api/v1/ca/images/instance/{instance_id}/albums/{album_id}/existing_images`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)))
                .replace(`{${"album_id"}}`, encodeURIComponent(String(albumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (keyFile !== undefined) {
                localVarQueryParameter['key_file'] = keyFile;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an image to a blueprint album.
         * @summary Add Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddImageToBlueprintAlbum: async (blueprintId: string, albumId: string, order: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToBlueprintAlbum', 'blueprintId', blueprintId)
            // verify required parameter 'albumId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToBlueprintAlbum', 'albumId', albumId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToBlueprintAlbum', 'order', order)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToBlueprintAlbum', 'file', file)
            const localVarPath = `/api/v1/ca/images/blueprint/{blueprint_id}/albums/{album_id}/images`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)))
                .replace(`{${"album_id"}}`, encodeURIComponent(String(albumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an image to an instance album.
         * @summary Add Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddImageToInstanceAlbum: async (instanceId: string, albumId: string, order: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToInstanceAlbum', 'instanceId', instanceId)
            // verify required parameter 'albumId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToInstanceAlbum', 'albumId', albumId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToInstanceAlbum', 'order', order)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('caApiV1RoutersImagesAddImageToInstanceAlbum', 'file', file)
            const localVarPath = `/api/v1/ca/images/instance/{instance_id}/albums/{album_id}/images`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)))
                .replace(`{${"album_id"}}`, encodeURIComponent(String(albumId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a blueprint album.
         * @summary Create Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesCreateBlueprintAlbum: async (blueprintId: string, albumName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesCreateBlueprintAlbum', 'blueprintId', blueprintId)
            // verify required parameter 'albumName' is not null or undefined
            assertParamExists('caApiV1RoutersImagesCreateBlueprintAlbum', 'albumName', albumName)
            const localVarPath = `/api/v1/ca/images/blueprint/{blueprint_id}/albums/{album_name}`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)))
                .replace(`{${"album_name"}}`, encodeURIComponent(String(albumName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an instance album.
         * @summary Create Instance Album
         * @param {string} instanceId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesCreateInstanceAlbum: async (instanceId: string, albumName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesCreateInstanceAlbum', 'instanceId', instanceId)
            // verify required parameter 'albumName' is not null or undefined
            assertParamExists('caApiV1RoutersImagesCreateInstanceAlbum', 'albumName', albumName)
            const localVarPath = `/api/v1/ca/images/instance/{instance_id}/albums/{album_name}`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)))
                .replace(`{${"album_name"}}`, encodeURIComponent(String(albumName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an image from a blueprint album.
         * @summary Delete Image From Blueprint Album
         * @param {string} imageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesDeleteImageFromBlueprintAlbum: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesDeleteImageFromBlueprintAlbum', 'imageId', imageId)
            const localVarPath = `/api/v1/ca/images/{image_id}`
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all blueprint albums.
         * @summary Get Blueprint Albums
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesGetBlueprintAlbums: async (blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesGetBlueprintAlbums', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/images/blueprint/{blueprint_id}/albums`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all instance albums.
         * @summary Get Instance Albums
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesGetInstanceAlbums: async (instanceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesGetInstanceAlbums', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/images/instance/{instance_id}/albums`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers an image to a blueprint album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Blueprint
         * @param {string} blueprintId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesRegisterImageToBlueprint: async (blueprintId: string, imageFilename: string, order?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesRegisterImageToBlueprint', 'blueprintId', blueprintId)
            // verify required parameter 'imageFilename' is not null or undefined
            assertParamExists('caApiV1RoutersImagesRegisterImageToBlueprint', 'imageFilename', imageFilename)
            const localVarPath = `/api/v1/ca/images/blueprint/{blueprint_id}/register_image`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (imageFilename !== undefined) {
                localVarQueryParameter['image_filename'] = imageFilename;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers an image to an instance album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Instance
         * @param {string} instanceId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesRegisterImageToInstance: async (instanceId: string, imageFilename: string, order?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesRegisterImageToInstance', 'instanceId', instanceId)
            // verify required parameter 'imageFilename' is not null or undefined
            assertParamExists('caApiV1RoutersImagesRegisterImageToInstance', 'imageFilename', imageFilename)
            const localVarPath = `/api/v1/ca/images/instance/{instance_id}/register_image`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (imageFilename !== undefined) {
                localVarQueryParameter['image_filename'] = imageFilename;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder an image in a blueprint or instance album.
         * @summary Reorder Image
         * @param {string} imageId
         * @param {number} order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesReorderImage: async (imageId: string, order: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('caApiV1RoutersImagesReorderImage', 'imageId', imageId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('caApiV1RoutersImagesReorderImage', 'order', order)
            const localVarPath = `/api/v1/ca/images/update/{image_id}`
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Add an image to a blueprint album.
         * @summary Add Existing Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId, albumId, order, keyFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesAddExistingImageToBlueprintAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an image to an instance album.
         * @summary Add Existing Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId, albumId, order, keyFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesAddExistingImageToInstanceAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an image to a blueprint album.
         * @summary Add Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId, albumId, order, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesAddImageToBlueprintAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an image to an instance album.
         * @summary Add Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId, albumId, order, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesAddImageToInstanceAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a blueprint album.
         * @summary Create Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId: string, albumName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageAlbumOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId, albumName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesCreateBlueprintAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an instance album.
         * @summary Create Instance Album
         * @param {string} instanceId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesCreateInstanceAlbum(instanceId: string, albumName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageAlbumOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesCreateInstanceAlbum(instanceId, albumName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesCreateInstanceAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an image from a blueprint album.
         * @summary Delete Image From Blueprint Album
         * @param {string} imageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesDeleteImageFromBlueprintAlbum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all blueprint albums.
         * @summary Get Blueprint Albums
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesGetBlueprintAlbums(blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageAlbumOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesGetBlueprintAlbums(blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesGetBlueprintAlbums']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all instance albums.
         * @summary Get Instance Albums
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesGetInstanceAlbums(instanceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageAlbumOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesGetInstanceAlbums(instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesGetInstanceAlbums']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers an image to a blueprint album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Blueprint
         * @param {string} blueprintId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageUploadOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId, imageFilename, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesRegisterImageToBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers an image to an instance album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Instance
         * @param {string} instanceId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesRegisterImageToInstance(instanceId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageUploadOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesRegisterImageToInstance(instanceId, imageFilename, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesRegisterImageToInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reorder an image in a blueprint or instance album.
         * @summary Reorder Image
         * @param {string} imageId
         * @param {number} order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersImagesReorderImage(imageId: string, order: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersImagesReorderImage(imageId, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImagesApi.caApiV1RoutersImagesReorderImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImagesApi - factory interface
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImagesApiFp(configuration)
    return {
        /**
         * Add an image to a blueprint album.
         * @summary Add Existing Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig): AxiosPromise<ImageOUT> {
            return localVarFp.caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId, albumId, order, keyFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an image to an instance album.
         * @summary Add Existing Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {string} keyFile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig): AxiosPromise<ImageOUT> {
            return localVarFp.caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId, albumId, order, keyFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an image to a blueprint album.
         * @summary Add Image To Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImageOUT> {
            return localVarFp.caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId, albumId, order, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an image to an instance album.
         * @summary Add Image To Instance Album
         * @param {string} instanceId
         * @param {string} albumId
         * @param {number} order
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ImageOUT> {
            return localVarFp.caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId, albumId, order, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a blueprint album.
         * @summary Create Blueprint Album
         * @param {string} blueprintId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId: string, albumName: string, options?: RawAxiosRequestConfig): AxiosPromise<ImageAlbumOUT> {
            return localVarFp.caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId, albumName, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an instance album.
         * @summary Create Instance Album
         * @param {string} instanceId
         * @param {string} albumName
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesCreateInstanceAlbum(instanceId: string, albumName: string, options?: RawAxiosRequestConfig): AxiosPromise<ImageAlbumOUT> {
            return localVarFp.caApiV1RoutersImagesCreateInstanceAlbum(instanceId, albumName, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an image from a blueprint album.
         * @summary Delete Image From Blueprint Album
         * @param {string} imageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all blueprint albums.
         * @summary Get Blueprint Albums
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesGetBlueprintAlbums(blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ImageAlbumOUT>> {
            return localVarFp.caApiV1RoutersImagesGetBlueprintAlbums(blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all instance albums.
         * @summary Get Instance Albums
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesGetInstanceAlbums(instanceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ImageAlbumOUT>> {
            return localVarFp.caApiV1RoutersImagesGetInstanceAlbums(instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers an image to a blueprint album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Blueprint
         * @param {string} blueprintId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig): AxiosPromise<ImageUploadOUT> {
            return localVarFp.caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId, imageFilename, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers an image to an instance album. It will return a presigned url where the frontend must upload the asset to.
         * @summary Register Image To Instance
         * @param {string} instanceId
         * @param {string} imageFilename
         * @param {number} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesRegisterImageToInstance(instanceId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig): AxiosPromise<ImageUploadOUT> {
            return localVarFp.caApiV1RoutersImagesRegisterImageToInstance(instanceId, imageFilename, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorder an image in a blueprint or instance album.
         * @summary Reorder Image
         * @param {string} imageId
         * @param {number} order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersImagesReorderImage(imageId: string, order: number, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersImagesReorderImage(imageId, order, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImagesApi - object-oriented interface
 */
export class ImagesApi extends BaseAPI {
    /**
     * Add an image to a blueprint album.
     * @summary Add Existing Image To Blueprint Album
     * @param {string} blueprintId
     * @param {string} albumId
     * @param {number} order
     * @param {string} keyFile
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesAddExistingImageToBlueprintAlbum(blueprintId, albumId, order, keyFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an image to an instance album.
     * @summary Add Existing Image To Instance Album
     * @param {string} instanceId
     * @param {string} albumId
     * @param {number} order
     * @param {string} keyFile
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId: string, albumId: string, order: number, keyFile: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesAddExistingImageToInstanceAlbum(instanceId, albumId, order, keyFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an image to a blueprint album.
     * @summary Add Image To Blueprint Album
     * @param {string} blueprintId
     * @param {string} albumId
     * @param {number} order
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesAddImageToBlueprintAlbum(blueprintId, albumId, order, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an image to an instance album.
     * @summary Add Image To Instance Album
     * @param {string} instanceId
     * @param {string} albumId
     * @param {number} order
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId: string, albumId: string, order: number, file: File, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesAddImageToInstanceAlbum(instanceId, albumId, order, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a blueprint album.
     * @summary Create Blueprint Album
     * @param {string} blueprintId
     * @param {string} albumName
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId: string, albumName: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesCreateBlueprintAlbum(blueprintId, albumName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an instance album.
     * @summary Create Instance Album
     * @param {string} instanceId
     * @param {string} albumName
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesCreateInstanceAlbum(instanceId: string, albumName: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesCreateInstanceAlbum(instanceId, albumName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an image from a blueprint album.
     * @summary Delete Image From Blueprint Album
     * @param {string} imageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesDeleteImageFromBlueprintAlbum(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all blueprint albums.
     * @summary Get Blueprint Albums
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesGetBlueprintAlbums(blueprintId: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesGetBlueprintAlbums(blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all instance albums.
     * @summary Get Instance Albums
     * @param {string} instanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesGetInstanceAlbums(instanceId: string, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesGetInstanceAlbums(instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers an image to a blueprint album. It will return a presigned url where the frontend must upload the asset to.
     * @summary Register Image To Blueprint
     * @param {string} blueprintId
     * @param {string} imageFilename
     * @param {number} [order]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesRegisterImageToBlueprint(blueprintId, imageFilename, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers an image to an instance album. It will return a presigned url where the frontend must upload the asset to.
     * @summary Register Image To Instance
     * @param {string} instanceId
     * @param {string} imageFilename
     * @param {number} [order]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesRegisterImageToInstance(instanceId: string, imageFilename: string, order?: number, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesRegisterImageToInstance(instanceId, imageFilename, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorder an image in a blueprint or instance album.
     * @summary Reorder Image
     * @param {string} imageId
     * @param {number} order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersImagesReorderImage(imageId: string, order: number, options?: RawAxiosRequestConfig) {
        return ImagesApiFp(this.configuration).caApiV1RoutersImagesReorderImage(imageId, order, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryApi - axios parameter creator
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Export Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersInventoryExportInventoryData: async (buildingId: string, objectListIN: ObjectListIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersInventoryExportInventoryData', 'buildingId', buildingId)
            // verify required parameter 'objectListIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersInventoryExportInventoryData', 'objectListIN', objectListIN)
            const localVarPath = `/api/v1/mapping_editor/inventory/{building_id}/export`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectListIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersInventoryGetInventoryData: async (buildingId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersInventoryGetInventoryData', 'buildingId', buildingId)
            // verify required parameter 'objectListIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersInventoryGetInventoryData', 'objectListIN', objectListIN)
            const localVarPath = `/api/v1/mapping_editor/inventory/{building_id}/list`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectListIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Export Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId: string, objectListIN: ObjectListIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId, objectListIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.mappingEditorApiV1RoutersInventoryExportInventoryData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId, objectListIN, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.mappingEditorApiV1RoutersInventoryGetInventoryData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryApi - factory interface
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         *
         * @summary Export Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId: string, objectListIN: ObjectListIN, options?: RawAxiosRequestConfig): AxiosPromise<ExportResultOUT> {
            return localVarFp.mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId, objectListIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Inventory Data
         * @param {string} buildingId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ObjectListOUT> {
            return localVarFp.mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId, objectListIN, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 */
export class InventoryApi extends BaseAPI {
    /**
     *
     * @summary Export Inventory Data
     * @param {string} buildingId
     * @param {ObjectListIN} objectListIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId: string, objectListIN: ObjectListIN, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).mappingEditorApiV1RoutersInventoryExportInventoryData(buildingId, objectListIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Inventory Data
     * @param {string} buildingId
     * @param {ObjectListIN} objectListIN
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).mappingEditorApiV1RoutersInventoryGetInventoryData(buildingId, objectListIN, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryEPDsApi - axios parameter creator
 */
export const InventoryEPDsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return all certification data and its conformity.
         * @summary Certification Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdCertificationData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/epds/certification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new EPD and allows to overwrite existing ones by hiding the existing one:  If a source_uuid is given, the existing one will be hidden and a new one that is not hidden will be created. If the source_uuid is not given, a fresh one will be created.  Users are only permitted to manage EPDs related to the organisation.
         * @summary Create Epd
         * @param {string} organisationId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdCreateEpd: async (organisationId: string, ePDDetailIN: EPDDetailIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdCreateEpd', 'organisationId', organisationId)
            // verify required parameter 'ePDDetailIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdCreateEpd', 'ePDDetailIN', ePDDetailIN)
            const localVarPath = `/api/v1/inventory/epds/{organisation_id}/create_epd`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDDetailIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Epd
         * @param {string} epdId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdDeleteEpd: async (epdId: string, organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epdId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdDeleteEpd', 'epdId', epdId)
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdDeleteEpd', 'organisationId', organisationId)
            const localVarPath = `/api/v1/inventory/epds/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (epdId !== undefined) {
                localVarQueryParameter['epd_id'] = epdId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit Epd
         * @param {string} organisationId
         * @param {string} epdId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdEditEpd: async (organisationId: string, epdId: string, ePDDetailIN: EPDDetailIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdEditEpd', 'organisationId', organisationId)
            // verify required parameter 'epdId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdEditEpd', 'epdId', epdId)
            // verify required parameter 'ePDDetailIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdEditEpd', 'ePDDetailIN', ePDDetailIN)
            const localVarPath = `/api/v1/inventory/epds/{organisation_id}/edit_epd/{epd_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"epd_id"}}`, encodeURIComponent(String(epdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDDetailIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all EPD conformity data.
         * @summary Epd Conformity Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdEpdConformityData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/epds/epd_conformity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Indicators For Conformity
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity: async (conformityName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conformityName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity', 'conformityName', conformityName)
            const localVarPath = `/api/v1/inventory/epds/epd_indicators/{conformity_name}`
                .replace(`{${"conformity_name"}}`, encodeURIComponent(String(conformityName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Upload Csv Template
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate: async (conformityName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conformityName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate', 'conformityName', conformityName)
            const localVarPath = `/api/v1/inventory/epds/epd_upload_csv_template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (conformityName !== undefined) {
                localVarQueryParameter['conformity_name'] = conformityName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Indicators From File
         * @param {string} conformityName
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetIndicatorsFromFile: async (conformityName: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conformityName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdGetIndicatorsFromFile', 'conformityName', conformityName)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdGetIndicatorsFromFile', 'file', file)
            const localVarPath = `/api/v1/inventory/epds/epd_indicators/from_file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (conformityName !== undefined) {
                localVarQueryParameter['conformity_name'] = conformityName;
            }


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Parse Indicators With Ai
         * @param {string} conformityName
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdParseIndicatorsWithAi: async (conformityName: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conformityName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdParseIndicatorsWithAi', 'conformityName', conformityName)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdParseIndicatorsWithAi', 'files', files)
            const localVarPath = `/api/v1/inventory/epds/parse_with_ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (conformityName !== undefined) {
                localVarQueryParameter['conformity_name'] = conformityName;
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }



            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for EPD entry data by name of EPD entry.
         * @summary Search Epd Data
         * @param {string} term
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdSearchEpdData: async (term: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdSearchEpdData', 'term', term)
            const localVarPath = `/api/v1/inventory/epds/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a custom EPD creation request.
         * @summary Submit Custom Epd Creation Request
         * @param {CustomEPDSubmissionIN} customEPDSubmissionIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest: async (customEPDSubmissionIN: CustomEPDSubmissionIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customEPDSubmissionIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest', 'customEPDSubmissionIN', customEPDSubmissionIN)
            const localVarPath = `/api/v1/inventory/epds/custom_epd_submission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customEPDSubmissionIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryEPDsApi - functional programming interface
 */
export const InventoryEPDsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryEPDsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return all certification data and its conformity.
         * @summary Certification Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdCertificationData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificationOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdCertificationData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdCertificationData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new EPD and allows to overwrite existing ones by hiding the existing one:  If a source_uuid is given, the existing one will be hidden and a new one that is not hidden will be created. If the source_uuid is not given, a fresh one will be created.  Users are only permitted to manage EPDs related to the organisation.
         * @summary Create Epd
         * @param {string} organisationId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdCreateEpd(organisationId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDDetailOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdCreateEpd(organisationId, ePDDetailIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdCreateEpd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Epd
         * @param {string} epdId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdDeleteEpd(epdId: string, organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdDeleteEpd(epdId, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdDeleteEpd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edit Epd
         * @param {string} organisationId
         * @param {string} epdId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdEditEpd(organisationId: string, epdId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDDetailOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdEditEpd(organisationId, epdId, ePDDetailIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdEditEpd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all EPD conformity data.
         * @summary Epd Conformity Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdEpdConformityData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EPDConformityOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdEpdConformityData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdEpdConformityData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Indicators For Conformity
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EPDIndicatorOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Upload Csv Template
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Indicators From File
         * @param {string} conformityName
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParsedIndicators>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdGetIndicatorsFromFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Parse Indicators With Ai
         * @param {string} conformityName
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParsedIndicators>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdParseIndicatorsWithAi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for EPD entry data by name of EPD entry.
         * @summary Search Epd Data
         * @param {string} term
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdSearchEpdData(term: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInventoryEPDOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdSearchEpdData(term, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdSearchEpdData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit a custom EPD creation request.
         * @summary Submit Custom Epd Creation Request
         * @param {CustomEPDSubmissionIN} customEPDSubmissionIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN: CustomEPDSubmissionIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryEPDsApi.inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryEPDsApi - factory interface
 */
export const InventoryEPDsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryEPDsApiFp(configuration)
    return {
        /**
         * Return all certification data and its conformity.
         * @summary Certification Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdCertificationData(options?: RawAxiosRequestConfig): AxiosPromise<Array<CertificationOut>> {
            return localVarFp.inventoryApiV1RoutersEpdCertificationData(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new EPD and allows to overwrite existing ones by hiding the existing one:  If a source_uuid is given, the existing one will be hidden and a new one that is not hidden will be created. If the source_uuid is not given, a fresh one will be created.  Users are only permitted to manage EPDs related to the organisation.
         * @summary Create Epd
         * @param {string} organisationId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdCreateEpd(organisationId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig): AxiosPromise<EPDDetailOUT> {
            return localVarFp.inventoryApiV1RoutersEpdCreateEpd(organisationId, ePDDetailIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Epd
         * @param {string} epdId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdDeleteEpd(epdId: string, organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.inventoryApiV1RoutersEpdDeleteEpd(epdId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit Epd
         * @param {string} organisationId
         * @param {string} epdId
         * @param {EPDDetailIN} ePDDetailIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdEditEpd(organisationId: string, epdId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig): AxiosPromise<EPDDetailOUT> {
            return localVarFp.inventoryApiV1RoutersEpdEditEpd(organisationId, epdId, ePDDetailIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all EPD conformity data.
         * @summary Epd Conformity Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdEpdConformityData(options?: RawAxiosRequestConfig): AxiosPromise<Array<EPDConformityOut>> {
            return localVarFp.inventoryApiV1RoutersEpdEpdConformityData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Indicators For Conformity
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EPDIndicatorOUT>> {
            return localVarFp.inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Upload Csv Template
         * @param {string} conformityName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Indicators From File
         * @param {string} conformityName
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ParsedIndicators> {
            return localVarFp.inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Parse Indicators With Ai
         * @param {string} conformityName
         * @param {Array<File>} files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<ParsedIndicators> {
            return localVarFp.inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName, files, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for EPD entry data by name of EPD entry.
         * @summary Search Epd Data
         * @param {string} term
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdSearchEpdData(term: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedInventoryEPDOut> {
            return localVarFp.inventoryApiV1RoutersEpdSearchEpdData(term, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a custom EPD creation request.
         * @summary Submit Custom Epd Creation Request
         * @param {CustomEPDSubmissionIN} customEPDSubmissionIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN: CustomEPDSubmissionIN, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryEPDsApi - object-oriented interface
 */
export class InventoryEPDsApi extends BaseAPI {
    /**
     * Return all certification data and its conformity.
     * @summary Certification Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdCertificationData(options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdCertificationData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new EPD and allows to overwrite existing ones by hiding the existing one:  If a source_uuid is given, the existing one will be hidden and a new one that is not hidden will be created. If the source_uuid is not given, a fresh one will be created.  Users are only permitted to manage EPDs related to the organisation.
     * @summary Create Epd
     * @param {string} organisationId
     * @param {EPDDetailIN} ePDDetailIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdCreateEpd(organisationId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdCreateEpd(organisationId, ePDDetailIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Epd
     * @param {string} epdId
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdDeleteEpd(epdId: string, organisationId: string, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdDeleteEpd(epdId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit Epd
     * @param {string} organisationId
     * @param {string} epdId
     * @param {EPDDetailIN} ePDDetailIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdEditEpd(organisationId: string, epdId: string, ePDDetailIN: EPDDetailIN, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdEditEpd(organisationId, epdId, ePDDetailIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all EPD conformity data.
     * @summary Epd Conformity Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdEpdConformityData(options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdEpdConformityData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Indicators For Conformity
     * @param {string} conformityName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName: string, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdGetEpdIndicatorsForConformity(conformityName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Upload Csv Template
     * @param {string} conformityName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName: string, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdGetEpdUploadCsvTemplate(conformityName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Indicators From File
     * @param {string} conformityName
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName: string, file: File, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdGetIndicatorsFromFile(conformityName, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Parse Indicators With Ai
     * @param {string} conformityName
     * @param {Array<File>} files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdParseIndicatorsWithAi(conformityName, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for EPD entry data by name of EPD entry.
     * @summary Search Epd Data
     * @param {string} term
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdSearchEpdData(term: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdSearchEpdData(term, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a custom EPD creation request.
     * @summary Submit Custom Epd Creation Request
     * @param {CustomEPDSubmissionIN} customEPDSubmissionIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN: CustomEPDSubmissionIN, options?: RawAxiosRequestConfig) {
        return InventoryEPDsApiFp(this.configuration).inventoryApiV1RoutersEpdSubmitCustomEpdCreationRequest(customEPDSubmissionIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryFileApi - axios parameter creator
 */
export const InventoryFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Uploads and processes inventory file .csv and .xlsx
         * @summary Upload And Process Inventory File
         * @param {string} buildingId
         * @param {File} file
         * @param {boolean} [splitQuantityIntoObjects] Create as many distinct objects as the quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile: async (buildingId: string, file: File, splitQuantityIntoObjects?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile', 'buildingId', buildingId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile', 'file', file)
            const localVarPath = `/api/v1/inventory/files/upload_file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }


            if (splitQuantityIntoObjects !== undefined) {
                localVarFormParams.append('split_quantity_into_objects', String(splitQuantityIntoObjects) as any);
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads and processes inventory file .ifc
         * @summary Upload And Process Inventory Ifc Csv File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile: async (buildingId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile', 'buildingId', buildingId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile', 'file', file)
            const localVarPath = `/api/v1/inventory/files/upload_ifc_csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryFileApi - functional programming interface
 */
export const InventoryFileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryFileApiAxiosParamCreator(configuration)
    return {
        /**
         * Uploads and processes inventory file .csv and .xlsx
         * @summary Upload And Process Inventory File
         * @param {string} buildingId
         * @param {File} file
         * @param {boolean} [splitQuantityIntoObjects] Create as many distinct objects as the quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId: string, file: File, splitQuantityIntoObjects?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryFileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId, file, splitQuantityIntoObjects, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryFileApi.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads and processes inventory file .ifc
         * @summary Upload And Process Inventory Ifc Csv File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryFileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryFileApi.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryFileApi - factory interface
 */
export const InventoryFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryFileApiFp(configuration)
    return {
        /**
         * Uploads and processes inventory file .csv and .xlsx
         * @summary Upload And Process Inventory File
         * @param {string} buildingId
         * @param {File} file
         * @param {boolean} [splitQuantityIntoObjects] Create as many distinct objects as the quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId: string, file: File, splitQuantityIntoObjects?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<InventoryFileOUT> {
            return localVarFp.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId, file, splitQuantityIntoObjects, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads and processes inventory file .ifc
         * @summary Upload And Process Inventory Ifc Csv File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<InventoryFileOUT> {
            return localVarFp.inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryFileApi - object-oriented interface
 */
export class InventoryFileApi extends BaseAPI {
    /**
     * Uploads and processes inventory file .csv and .xlsx
     * @summary Upload And Process Inventory File
     * @param {string} buildingId
     * @param {File} file
     * @param {boolean} [splitQuantityIntoObjects] Create as many distinct objects as the quantity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId: string, file: File, splitQuantityIntoObjects?: boolean, options?: RawAxiosRequestConfig) {
        return InventoryFileApiFp(this.configuration).inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryFile(buildingId, file, splitQuantityIntoObjects, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads and processes inventory file .ifc
     * @summary Upload And Process Inventory Ifc Csv File
     * @param {string} buildingId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId: string, file: File, options?: RawAxiosRequestConfig) {
        return InventoryFileApiFp(this.configuration).inventoryApiV1RoutersInventoryFileUploadAndProcessInventoryIfcCsvFile(buildingId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryMappingEditorApi - axios parameter creator
 */
export const InventoryMappingEditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get mapping status of an IFC file
         * @summary Get File Status
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMappingEditorGetFileStatus: async (ifcFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMappingEditorGetFileStatus', 'ifcFileId', ifcFileId)
            const localVarPath = `/api/v1/inventory/editor/file/{ifc_file_id}/status`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the details of multiple inventory components by guid.
         * @summary Get Physical Object Details With Guid
         * @param {string} ifcFileId
         * @param {string} objectGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid: async (ifcFileId: string, objectGuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ifcFileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid', 'ifcFileId', ifcFileId)
            // verify required parameter 'objectGuid' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid', 'objectGuid', objectGuid)
            const localVarPath = `/api/v1/inventory/editor/file/{ifc_file_id}/object/{object_guid}/`
                .replace(`{${"ifc_file_id"}}`, encodeURIComponent(String(ifcFileId)))
                .replace(`{${"object_guid"}}`, encodeURIComponent(String(objectGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryMappingEditorApi - functional programming interface
 */
export const InventoryMappingEditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryMappingEditorApiAxiosParamCreator(configuration)
    return {
        /**
         * Get mapping status of an IFC file
         * @summary Get File Status
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryMappingEditorApi.inventoryApiV1RoutersMappingEditorGetFileStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the details of multiple inventory components by guid.
         * @summary Get Physical Object Details With Guid
         * @param {string} ifcFileId
         * @param {string} objectGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId: string, objectGuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryPhysicalObjectDetailOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId, objectGuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryMappingEditorApi.inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryMappingEditorApi - factory interface
 */
export const InventoryMappingEditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryMappingEditorApiFp(configuration)
    return {
        /**
         * Get mapping status of an IFC file
         * @summary Get File Status
         * @param {string} ifcFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the details of multiple inventory components by guid.
         * @summary Get Physical Object Details With Guid
         * @param {string} ifcFileId
         * @param {string} objectGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId: string, objectGuid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InventoryPhysicalObjectDetailOut>> {
            return localVarFp.inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId, objectGuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryMappingEditorApi - object-oriented interface
 */
export class InventoryMappingEditorApi extends BaseAPI {
    /**
     * Get mapping status of an IFC file
     * @summary Get File Status
     * @param {string} ifcFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId: string, options?: RawAxiosRequestConfig) {
        return InventoryMappingEditorApiFp(this.configuration).inventoryApiV1RoutersMappingEditorGetFileStatus(ifcFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the details of multiple inventory components by guid.
     * @summary Get Physical Object Details With Guid
     * @param {string} ifcFileId
     * @param {string} objectGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId: string, objectGuid: string, options?: RawAxiosRequestConfig) {
        return InventoryMappingEditorApiFp(this.configuration).inventoryApiV1RoutersMappingEditorGetPhysicalObjectDetailsWithGuid(ifcFileId, objectGuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryProductsApi - axios parameter creator
 */
export const InventoryProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductsDetailsByFile: async (productId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductsDetailsByFile', 'productId', productId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductsDetailsByFile', 'fileId', fileId)
            const localVarPath = `/api/v1/inventory/product/details_by_file/{product_id}/{file_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductsGetProductSearchDetails: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductsGetProductSearchDetails', 'productId', productId)
            const localVarPath = `/api/v1/inventory/product/search_details/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryProductsApi - functional programming interface
 */
export const InventoryProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryProductsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryProductDetailsByFileOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductsDetailsByFile(productId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryProductsApi.inventoryApiV1RoutersProductsDetailsByFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductsGetProductSearchDetails(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryProductsApi.inventoryApiV1RoutersProductsGetProductSearchDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryProductsApi - factory interface
 */
export const InventoryProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryProductsApiFp(configuration)
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<InventoryProductDetailsByFileOut> {
            return localVarFp.inventoryApiV1RoutersProductsDetailsByFile(productId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<InternalProductSearchOutput> {
            return localVarFp.inventoryApiV1RoutersProductsGetProductSearchDetails(productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryProductsApi - object-oriented interface
 */
export class InventoryProductsApi extends BaseAPI {
    /**
     *
     * @summary Details By File
     * @param {string} productId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return InventoryProductsApiFp(this.configuration).inventoryApiV1RoutersProductsDetailsByFile(productId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Details of a single product including EPD Groups
     * @summary Get Product Search Details
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig) {
        return InventoryProductsApiFp(this.configuration).inventoryApiV1RoutersProductsGetProductSearchDetails(productId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LCCApi - axios parameter creator
 */
export const LCCApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a paginated list of per-product LCC results for a building.  Uses the inventory pipeline for DB-level grouping and pagination.
         * @summary Lcc Components
         * @param {string} buildingId
         * @param {LCCComponentListIN} lCCComponentListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccLccComponents: async (buildingId: string, lCCComponentListIN: LCCComponentListIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersLccLccComponents', 'buildingId', buildingId)
            // verify required parameter 'lCCComponentListIN' is not null or undefined
            assertParamExists('reportApiV1RoutersLccLccComponents', 'lCCComponentListIN', lCCComponentListIN)
            const localVarPath = `/api/v1/report/lcc/{building_id}/components`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lCCComponentListIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get LCC totals and KG summaries for a building.  This endpoint always returns data for the **entire building** (no pagination). Use ``/{building_id}/components`` for the paginated component list.
         * @summary Lcc Summary
         * @param {string} buildingId
         * @param {LCCSummaryIN} lCCSummaryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccLccSummary: async (buildingId: string, lCCSummaryIN: LCCSummaryIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersLccLccSummary', 'buildingId', buildingId)
            // verify required parameter 'lCCSummaryIN' is not null or undefined
            assertParamExists('reportApiV1RoutersLccLccSummary', 'lCCSummaryIN', lCCSummaryIN)
            const localVarPath = `/api/v1/report/lcc/{building_id}/summary`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lCCSummaryIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all convention defaults keyed by name (dgnb23, bnb, qng).
         * @summary List Conventions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccListConventions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/report/lcc/conventions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LCCApi - functional programming interface
 */
export const LCCApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LCCApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a paginated list of per-product LCC results for a building.  Uses the inventory pipeline for DB-level grouping and pagination.
         * @summary Lcc Components
         * @param {string} buildingId
         * @param {LCCComponentListIN} lCCComponentListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersLccLccComponents(buildingId: string, lCCComponentListIN: LCCComponentListIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LCCComponentListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersLccLccComponents(buildingId, lCCComponentListIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LCCApi.reportApiV1RoutersLccLccComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get LCC totals and KG summaries for a building.  This endpoint always returns data for the **entire building** (no pagination). Use ``/{building_id}/components`` for the paginated component list.
         * @summary Lcc Summary
         * @param {string} buildingId
         * @param {LCCSummaryIN} lCCSummaryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersLccLccSummary(buildingId: string, lCCSummaryIN: LCCSummaryIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LCCSummaryOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersLccLccSummary(buildingId, lCCSummaryIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LCCApi.reportApiV1RoutersLccLccSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all convention defaults keyed by name (dgnb23, bnb, qng).
         * @summary List Conventions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersLccListConventions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: LCCConventionInfo; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersLccListConventions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LCCApi.reportApiV1RoutersLccListConventions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LCCApi - factory interface
 */
export const LCCApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LCCApiFp(configuration)
    return {
        /**
         * Get a paginated list of per-product LCC results for a building.  Uses the inventory pipeline for DB-level grouping and pagination.
         * @summary Lcc Components
         * @param {string} buildingId
         * @param {LCCComponentListIN} lCCComponentListIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccLccComponents(buildingId: string, lCCComponentListIN: LCCComponentListIN, options?: RawAxiosRequestConfig): AxiosPromise<LCCComponentListOUT> {
            return localVarFp.reportApiV1RoutersLccLccComponents(buildingId, lCCComponentListIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Get LCC totals and KG summaries for a building.  This endpoint always returns data for the **entire building** (no pagination). Use ``/{building_id}/components`` for the paginated component list.
         * @summary Lcc Summary
         * @param {string} buildingId
         * @param {LCCSummaryIN} lCCSummaryIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccLccSummary(buildingId: string, lCCSummaryIN: LCCSummaryIN, options?: RawAxiosRequestConfig): AxiosPromise<LCCSummaryOUT> {
            return localVarFp.reportApiV1RoutersLccLccSummary(buildingId, lCCSummaryIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all convention defaults keyed by name (dgnb23, bnb, qng).
         * @summary List Conventions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersLccListConventions(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: LCCConventionInfo; }> {
            return localVarFp.reportApiV1RoutersLccListConventions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LCCApi - object-oriented interface
 */
export class LCCApi extends BaseAPI {
    /**
     * Get a paginated list of per-product LCC results for a building.  Uses the inventory pipeline for DB-level grouping and pagination.
     * @summary Lcc Components
     * @param {string} buildingId
     * @param {LCCComponentListIN} lCCComponentListIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersLccLccComponents(buildingId: string, lCCComponentListIN: LCCComponentListIN, options?: RawAxiosRequestConfig) {
        return LCCApiFp(this.configuration).reportApiV1RoutersLccLccComponents(buildingId, lCCComponentListIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get LCC totals and KG summaries for a building.  This endpoint always returns data for the **entire building** (no pagination). Use ``/{building_id}/components`` for the paginated component list.
     * @summary Lcc Summary
     * @param {string} buildingId
     * @param {LCCSummaryIN} lCCSummaryIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersLccLccSummary(buildingId: string, lCCSummaryIN: LCCSummaryIN, options?: RawAxiosRequestConfig) {
        return LCCApiFp(this.configuration).reportApiV1RoutersLccLccSummary(buildingId, lCCSummaryIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all convention defaults keyed by name (dgnb23, bnb, qng).
     * @summary List Conventions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersLccListConventions(options?: RawAxiosRequestConfig) {
        return LCCApiFp(this.configuration).reportApiV1RoutersLccListConventions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LicensesApi - axios parameter creator
 */
export const LicensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive a building by ending its building-level licences and assigning the read-only building licence. The building becomes view-only; org-level licences are untouched. One-way — reversal is staff-only via the admin.
         * @summary Archive Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesArchiveBuilding: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('licenseApiV1RoutersLicensesArchiveBuilding', 'buildingId', buildingId)
            const localVarPath = `/api/v1/licenses/buildings/{building_id}/archive`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Change License
         * @param {string} licenseId
         * @param {LicenseUpdateIN} licenseUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesChangeLicense: async (licenseId: string, licenseUpdateIN: LicenseUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenseId' is not null or undefined
            assertParamExists('licenseApiV1RoutersLicensesChangeLicense', 'licenseId', licenseId)
            // verify required parameter 'licenseUpdateIN' is not null or undefined
            assertParamExists('licenseApiV1RoutersLicensesChangeLicense', 'licenseUpdateIN', licenseUpdateIN)
            const localVarPath = `/api/v1/licenses/{license_id}`
                .replace(`{${"license_id"}}`, encodeURIComponent(String(licenseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licenseUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all the features in the system. Needed to generate the LicenseFeatureEnum for the frontend
         * @summary Get All License Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesGetAllLicenseFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/licenses/all_features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the licenses belonging to a building or an organisation
         * @summary Get Licenses
         * @param {LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum} ownerType
         * @param {string} ownerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesGetLicenses: async (ownerType: LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum, ownerUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('licenseApiV1RoutersLicensesGetLicenses', 'ownerType', ownerType)
            // verify required parameter 'ownerUuid' is not null or undefined
            assertParamExists('licenseApiV1RoutersLicensesGetLicenses', 'ownerUuid', ownerUuid)
            const localVarPath = `/api/v1/licenses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (ownerType !== undefined) {
                localVarQueryParameter['owner_type'] = ownerType;
            }

            if (ownerUuid !== undefined) {
                localVarQueryParameter['owner_uuid'] = ownerUuid;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicensesApi - functional programming interface
 */
export const LicensesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicensesApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive a building by ending its building-level licences and assigning the read-only building licence. The building becomes view-only; org-level licences are untouched. One-way — reversal is staff-only via the admin.
         * @summary Archive Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licenseApiV1RoutersLicensesArchiveBuilding(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licenseApiV1RoutersLicensesArchiveBuilding(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licenseApiV1RoutersLicensesArchiveBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Change License
         * @param {string} licenseId
         * @param {LicenseUpdateIN} licenseUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licenseApiV1RoutersLicensesChangeLicense(licenseId: string, licenseUpdateIN: LicenseUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licenseApiV1RoutersLicensesChangeLicense(licenseId, licenseUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licenseApiV1RoutersLicensesChangeLicense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of all the features in the system. Needed to generate the LicenseFeatureEnum for the frontend
         * @summary Get All License Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licenseApiV1RoutersLicensesGetAllLicenseFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LicenseFeatureEnum>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licenseApiV1RoutersLicensesGetAllLicenseFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licenseApiV1RoutersLicensesGetAllLicenseFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the licenses belonging to a building or an organisation
         * @summary Get Licenses
         * @param {LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum} ownerType
         * @param {string} ownerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licenseApiV1RoutersLicensesGetLicenses(ownerType: LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum, ownerUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LicenseOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licenseApiV1RoutersLicensesGetLicenses(ownerType, ownerUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicensesApi.licenseApiV1RoutersLicensesGetLicenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LicensesApi - factory interface
 */
export const LicensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicensesApiFp(configuration)
    return {
        /**
         * Archive a building by ending its building-level licences and assigning the read-only building licence. The building becomes view-only; org-level licences are untouched. One-way — reversal is staff-only via the admin.
         * @summary Archive Building
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesArchiveBuilding(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<LicenseOUT> {
            return localVarFp.licenseApiV1RoutersLicensesArchiveBuilding(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change License
         * @param {string} licenseId
         * @param {LicenseUpdateIN} licenseUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesChangeLicense(licenseId: string, licenseUpdateIN: LicenseUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<LicenseOUT> {
            return localVarFp.licenseApiV1RoutersLicensesChangeLicense(licenseId, licenseUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of all the features in the system. Needed to generate the LicenseFeatureEnum for the frontend
         * @summary Get All License Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesGetAllLicenseFeatures(options?: RawAxiosRequestConfig): AxiosPromise<Array<LicenseFeatureEnum>> {
            return localVarFp.licenseApiV1RoutersLicensesGetAllLicenseFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the licenses belonging to a building or an organisation
         * @summary Get Licenses
         * @param {LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum} ownerType
         * @param {string} ownerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseApiV1RoutersLicensesGetLicenses(ownerType: LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum, ownerUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LicenseOUT>> {
            return localVarFp.licenseApiV1RoutersLicensesGetLicenses(ownerType, ownerUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LicensesApi - object-oriented interface
 */
export class LicensesApi extends BaseAPI {
    /**
     * Archive a building by ending its building-level licences and assigning the read-only building licence. The building becomes view-only; org-level licences are untouched. One-way — reversal is staff-only via the admin.
     * @summary Archive Building
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public licenseApiV1RoutersLicensesArchiveBuilding(buildingId: string, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licenseApiV1RoutersLicensesArchiveBuilding(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Change License
     * @param {string} licenseId
     * @param {LicenseUpdateIN} licenseUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public licenseApiV1RoutersLicensesChangeLicense(licenseId: string, licenseUpdateIN: LicenseUpdateIN, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licenseApiV1RoutersLicensesChangeLicense(licenseId, licenseUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of all the features in the system. Needed to generate the LicenseFeatureEnum for the frontend
     * @summary Get All License Features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public licenseApiV1RoutersLicensesGetAllLicenseFeatures(options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licenseApiV1RoutersLicensesGetAllLicenseFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the licenses belonging to a building or an organisation
     * @summary Get Licenses
     * @param {LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum} ownerType
     * @param {string} ownerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public licenseApiV1RoutersLicensesGetLicenses(ownerType: LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum, ownerUuid: string, options?: RawAxiosRequestConfig) {
        return LicensesApiFp(this.configuration).licenseApiV1RoutersLicensesGetLicenses(ownerType, ownerUuid, options).then((request) => request(this.axios, this.basePath));
    }
}

export const LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum = {
    Building: 'BUILDING',
    Organisation: 'ORGANISATION'
} as const;
export type LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum = typeof LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum[keyof typeof LicenseApiV1RoutersLicensesGetLicensesOwnerTypeEnum];


/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the place details from the place_id.
         * @summary Place Details
         * @param {string} placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsPlaceDetails: async (placeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeId' is not null or undefined
            assertParamExists('concularApiV1RoutersLocationsPlaceDetails', 'placeId', placeId)
            const localVarPath = `/api/v1/concular/locations/{place_id}/place`
                .replace(`{${"place_id"}}`, encodeURIComponent(String(placeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search a locations from the AWS location
         * @summary Search Locations
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsSearchLocations: async (locationQuery: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationQuery' is not null or undefined
            assertParamExists('concularApiV1RoutersLocationsSearchLocations', 'locationQuery', locationQuery)
            const localVarPath = `/api/v1/concular/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (locationQuery !== undefined) {
                localVarQueryParameter['location_query'] = locationQuery;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place predictions based on user search.
         * @summary Suggest Places
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsSuggestPlaces: async (locationQuery: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationQuery' is not null or undefined
            assertParamExists('concularApiV1RoutersLocationsSuggestPlaces', 'locationQuery', locationQuery)
            const localVarPath = `/api/v1/concular/locations/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (locationQuery !== undefined) {
                localVarQueryParameter['location_query'] = locationQuery;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the place details from the place_id.
         * @summary Place Details
         * @param {string} placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersLocationsPlaceDetails(placeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceDetailsOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersLocationsPlaceDetails(placeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.concularApiV1RoutersLocationsPlaceDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search a locations from the AWS location
         * @summary Search Locations
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersLocationsSearchLocations(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAWSLocationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersLocationsSearchLocations(locationQuery, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.concularApiV1RoutersLocationsSearchLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Place predictions based on user search.
         * @summary Suggest Places
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersLocationsSuggestPlaces(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSuggestOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersLocationsSuggestPlaces(locationQuery, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.concularApiV1RoutersLocationsSuggestPlaces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Get the place details from the place_id.
         * @summary Place Details
         * @param {string} placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsPlaceDetails(placeId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlaceDetailsOUT> {
            return localVarFp.concularApiV1RoutersLocationsPlaceDetails(placeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search a locations from the AWS location
         * @summary Search Locations
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsSearchLocations(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedAWSLocationOUT> {
            return localVarFp.concularApiV1RoutersLocationsSearchLocations(locationQuery, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Place predictions based on user search.
         * @summary Suggest Places
         * @param {string} locationQuery
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersLocationsSuggestPlaces(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedSuggestOUT> {
            return localVarFp.concularApiV1RoutersLocationsSuggestPlaces(locationQuery, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     * Get the place details from the place_id.
     * @summary Place Details
     * @param {string} placeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersLocationsPlaceDetails(placeId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).concularApiV1RoutersLocationsPlaceDetails(placeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search a locations from the AWS location
     * @summary Search Locations
     * @param {string} locationQuery
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersLocationsSearchLocations(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).concularApiV1RoutersLocationsSearchLocations(locationQuery, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place predictions based on user search.
     * @summary Suggest Places
     * @param {string} locationQuery
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersLocationsSuggestPlaces(locationQuery: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).concularApiV1RoutersLocationsSuggestPlaces(locationQuery, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManufacturerApi - axios parameter creator
 */
export const ManufacturerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Manufacturer
         * @param {ManufacturerIN} manufacturerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersManufacturerCreateManufacturer: async (manufacturerIN: ManufacturerIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'manufacturerIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersManufacturerCreateManufacturer', 'manufacturerIN', manufacturerIN)
            const localVarPath = `/api/v1/building_products/manufacturers/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manufacturerIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Manufacturer
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersManufacturerSearchManufacturer: async (searchTerm?: string | null, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/manufacturers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManufacturerApi - functional programming interface
 */
export const ManufacturerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManufacturerApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Manufacturer
         * @param {ManufacturerIN} manufacturerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN: ManufacturerIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManufacturerOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturerApi.buildingProductsApiV1RoutersManufacturerCreateManufacturer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Manufacturer
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm?: string | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedManufacturerOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturerApi.buildingProductsApiV1RoutersManufacturerSearchManufacturer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManufacturerApi - factory interface
 */
export const ManufacturerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManufacturerApiFp(configuration)
    return {
        /**
         *
         * @summary Create Manufacturer
         * @param {ManufacturerIN} manufacturerIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN: ManufacturerIN, options?: RawAxiosRequestConfig): AxiosPromise<ManufacturerOUT> {
            return localVarFp.buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Manufacturer
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm?: string | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedManufacturerOUT> {
            return localVarFp.buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManufacturerApi - object-oriented interface
 */
export class ManufacturerApi extends BaseAPI {
    /**
     *
     * @summary Create Manufacturer
     * @param {ManufacturerIN} manufacturerIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN: ManufacturerIN, options?: RawAxiosRequestConfig) {
        return ManufacturerApiFp(this.configuration).buildingProductsApiV1RoutersManufacturerCreateManufacturer(manufacturerIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Manufacturer
     * @param {string | null} [searchTerm]
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm?: string | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return ManufacturerApiFp(this.configuration).buildingProductsApiV1RoutersManufacturerSearchManufacturer(searchTerm, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MappingEditorDynamicColumnsApi - axios parameter creator
 */
export const MappingEditorDynamicColumnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all the columns available for a given file
         * @summary Get Dynamic Columns
         * @param {string} [fileId]
         * @param {string} [buildingId]
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns: async (fileId?: string, buildingId?: string, viewName?: MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/mapping_editor/dynamic_columns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['file_id'] = fileId;
            }

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum} viewName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsGetUserColumns: async (viewName: MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewName' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersDynamicColumnsGetUserColumns', 'viewName', viewName)
            const localVarPath = `/api/v1/mapping_editor/dynamic_columns/user_columns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Save User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum} viewName
         * @param {SaveUserDynamicColumnsIN} saveUserDynamicColumnsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns: async (viewName: MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum, saveUserDynamicColumnsIN: SaveUserDynamicColumnsIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewName' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns', 'viewName', viewName)
            // verify required parameter 'saveUserDynamicColumnsIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns', 'saveUserDynamicColumnsIN', saveUserDynamicColumnsIN)
            const localVarPath = `/api/v1/mapping_editor/dynamic_columns/user_columns/save/{view_name}`
                .replace(`{${"view_name"}}`, encodeURIComponent(String(viewName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveUserDynamicColumnsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MappingEditorDynamicColumnsApi - functional programming interface
 */
export const MappingEditorDynamicColumnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MappingEditorDynamicColumnsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all the columns available for a given file
         * @summary Get Dynamic Columns
         * @param {string} [fileId]
         * @param {string} [buildingId]
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId?: string, buildingId?: string, viewName?: MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DynamicColumnOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId, buildingId, viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorDynamicColumnsApi.mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum} viewName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorDynamicColumnsApi.mappingEditorApiV1RoutersDynamicColumnsGetUserColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Save User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum} viewName
         * @param {SaveUserDynamicColumnsIN} saveUserDynamicColumnsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum, saveUserDynamicColumnsIN: SaveUserDynamicColumnsIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName, saveUserDynamicColumnsIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorDynamicColumnsApi.mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MappingEditorDynamicColumnsApi - factory interface
 */
export const MappingEditorDynamicColumnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MappingEditorDynamicColumnsApiFp(configuration)
    return {
        /**
         * Returns all the columns available for a given file
         * @summary Get Dynamic Columns
         * @param {string} [fileId]
         * @param {string} [buildingId]
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId?: string, buildingId?: string, viewName?: MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<DynamicColumnOUT>> {
            return localVarFp.mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId, buildingId, viewName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum} viewName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save User Columns
         * @param {MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum} viewName
         * @param {SaveUserDynamicColumnsIN} saveUserDynamicColumnsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum, saveUserDynamicColumnsIN: SaveUserDynamicColumnsIN, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName, saveUserDynamicColumnsIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MappingEditorDynamicColumnsApi - object-oriented interface
 */
export class MappingEditorDynamicColumnsApi extends BaseAPI {
    /**
     * Returns all the columns available for a given file
     * @summary Get Dynamic Columns
     * @param {string} [fileId]
     * @param {string} [buildingId]
     * @param {MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum} [viewName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId?: string, buildingId?: string, viewName?: MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum, options?: RawAxiosRequestConfig) {
        return MappingEditorDynamicColumnsApiFp(this.configuration).mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(fileId, buildingId, viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get User Columns
     * @param {MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum} viewName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum, options?: RawAxiosRequestConfig) {
        return MappingEditorDynamicColumnsApiFp(this.configuration).mappingEditorApiV1RoutersDynamicColumnsGetUserColumns(viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Save User Columns
     * @param {MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum} viewName
     * @param {SaveUserDynamicColumnsIN} saveUserDynamicColumnsIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName: MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum, saveUserDynamicColumnsIN: SaveUserDynamicColumnsIN, options?: RawAxiosRequestConfig) {
        return MappingEditorDynamicColumnsApiFp(this.configuration).mappingEditorApiV1RoutersDynamicColumnsSaveUserColumns(viewName, saveUserDynamicColumnsIN, options).then((request) => request(this.axios, this.basePath));
    }
}

export const MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum = typeof MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum[keyof typeof MappingEditorApiV1RoutersDynamicColumnsGetDynamicColumnsViewNameEnum];
export const MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum = typeof MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum[keyof typeof MappingEditorApiV1RoutersDynamicColumnsGetUserColumnsViewNameEnum];
export const MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum = typeof MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum[keyof typeof MappingEditorApiV1RoutersDynamicColumnsSaveUserColumnsViewNameEnum];


/**
 * MappingEditorObjectsApi - axios parameter creator
 */
export const MappingEditorObjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Fetch Global Ifc Ids From Groups
         * @param {string} fileId
         * @param {GlobalIFCIdsFromGroupsIN} globalIFCIdsFromGroupsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups: async (fileId: string, globalIFCIdsFromGroupsIN: GlobalIFCIdsFromGroupsIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups', 'fileId', fileId)
            // verify required parameter 'globalIFCIdsFromGroupsIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups', 'globalIFCIdsFromGroupsIN', globalIFCIdsFromGroupsIN)
            const localVarPath = `/api/v1/mapping_editor/objects/{file_id}/group_global_ids`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalIFCIdsFromGroupsIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all objects by file_id regardless of filtering and pagination.
         * @summary Get All Objects
         * @param {string} fileId
         * @param {ObjectListNoPaginationIN} objectListNoPaginationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsGetAllObjects: async (fileId: string, objectListNoPaginationIN: ObjectListNoPaginationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsGetAllObjects', 'fileId', fileId)
            // verify required parameter 'objectListNoPaginationIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsGetAllObjects', 'objectListNoPaginationIN', objectListNoPaginationIN)
            const localVarPath = `/api/v1/mapping_editor/objects/{file_id}/all`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectListNoPaginationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns objects by file_id.
         * @summary List Objects By File Id
         * @param {string} fileId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsListObjectsByFileId: async (fileId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsListObjectsByFileId', 'fileId', fileId)
            // verify required parameter 'objectListIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectsListObjectsByFileId', 'objectListIN', objectListIN)
            const localVarPath = `/api/v1/mapping_editor/objects/{file_id}/list`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectListIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MappingEditorObjectsApi - functional programming interface
 */
export const MappingEditorObjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MappingEditorObjectsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Fetch Global Ifc Ids From Groups
         * @param {string} fileId
         * @param {GlobalIFCIdsFromGroupsIN} globalIFCIdsFromGroupsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId: string, globalIFCIdsFromGroupsIN: GlobalIFCIdsFromGroupsIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObjectListNoPaginationOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId, globalIFCIdsFromGroupsIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorObjectsApi.mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all objects by file_id regardless of filtering and pagination.
         * @summary Get All Objects
         * @param {string} fileId
         * @param {ObjectListNoPaginationIN} objectListNoPaginationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersObjectsGetAllObjects(fileId: string, objectListNoPaginationIN: ObjectListNoPaginationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObjectListNoPaginationOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersObjectsGetAllObjects(fileId, objectListNoPaginationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorObjectsApi.mappingEditorApiV1RoutersObjectsGetAllObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns objects by file_id.
         * @summary List Objects By File Id
         * @param {string} fileId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId, objectListIN, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MappingEditorObjectsApi.mappingEditorApiV1RoutersObjectsListObjectsByFileId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MappingEditorObjectsApi - factory interface
 */
export const MappingEditorObjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MappingEditorObjectsApiFp(configuration)
    return {
        /**
         *
         * @summary Fetch Global Ifc Ids From Groups
         * @param {string} fileId
         * @param {GlobalIFCIdsFromGroupsIN} globalIFCIdsFromGroupsIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId: string, globalIFCIdsFromGroupsIN: GlobalIFCIdsFromGroupsIN, options?: RawAxiosRequestConfig): AxiosPromise<Array<ObjectListNoPaginationOUT>> {
            return localVarFp.mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId, globalIFCIdsFromGroupsIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all objects by file_id regardless of filtering and pagination.
         * @summary Get All Objects
         * @param {string} fileId
         * @param {ObjectListNoPaginationIN} objectListNoPaginationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsGetAllObjects(fileId: string, objectListNoPaginationIN: ObjectListNoPaginationIN, options?: RawAxiosRequestConfig): AxiosPromise<Array<ObjectListNoPaginationOUT>> {
            return localVarFp.mappingEditorApiV1RoutersObjectsGetAllObjects(fileId, objectListNoPaginationIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns objects by file_id.
         * @summary List Objects By File Id
         * @param {string} fileId
         * @param {ObjectListIN} objectListIN
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ObjectListOUT> {
            return localVarFp.mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId, objectListIN, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MappingEditorObjectsApi - object-oriented interface
 */
export class MappingEditorObjectsApi extends BaseAPI {
    /**
     *
     * @summary Fetch Global Ifc Ids From Groups
     * @param {string} fileId
     * @param {GlobalIFCIdsFromGroupsIN} globalIFCIdsFromGroupsIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId: string, globalIFCIdsFromGroupsIN: GlobalIFCIdsFromGroupsIN, options?: RawAxiosRequestConfig) {
        return MappingEditorObjectsApiFp(this.configuration).mappingEditorApiV1RoutersObjectsFetchGlobalIfcIdsFromGroups(fileId, globalIFCIdsFromGroupsIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all objects by file_id regardless of filtering and pagination.
     * @summary Get All Objects
     * @param {string} fileId
     * @param {ObjectListNoPaginationIN} objectListNoPaginationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersObjectsGetAllObjects(fileId: string, objectListNoPaginationIN: ObjectListNoPaginationIN, options?: RawAxiosRequestConfig) {
        return MappingEditorObjectsApiFp(this.configuration).mappingEditorApiV1RoutersObjectsGetAllObjects(fileId, objectListNoPaginationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns objects by file_id.
     * @summary List Objects By File Id
     * @param {string} fileId
     * @param {ObjectListIN} objectListIN
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId: string, objectListIN: ObjectListIN, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MappingEditorObjectsApiFp(this.configuration).mappingEditorApiV1RoutersObjectsListObjectsByFileId(fileId, objectListIN, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MatchSnapshotsApi - axios parameter creator
 */
export const MatchSnapshotsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a selected snapshot.
         * @summary Delete Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot: async (fileId: string, snapshotId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot', 'fileId', fileId)
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot', 'snapshotId', snapshotId)
            const localVarPath = `/api/v1/inventory/match_snapshots/{file_id}/{snapshot_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"snapshot_id"}}`, encodeURIComponent(String(snapshotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of snapshots. - mapping: Returns standard snapshots (excludes Full, Nightly, Admin) - full: Returns only Full and Nightly snapshots - all: Returns everything except Admin
         * @summary List Snapshots
         * @param {string} fileId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsListSnapshots: async (fileId: string, page?: number, pageSize?: number, category?: InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsListSnapshots', 'fileId', fileId)
            const localVarPath = `/api/v1/inventory/match_snapshots/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore matches from a selected snapshot. When restoring, we have to restore them in chronological order. The exception are Full snapshots, which we can jump between at any time.
         * @summary Recalculate Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {boolean} [asTask]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot: async (fileId: string, snapshotId: number, asTask?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot', 'fileId', fileId)
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot', 'snapshotId', snapshotId)
            const localVarPath = `/api/v1/inventory/match_snapshots/restore/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (snapshotId !== undefined) {
                localVarQueryParameter['snapshot_id'] = snapshotId;
            }

            if (asTask !== undefined) {
                localVarQueryParameter['as_task'] = asTask;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freeze all matches currently made for a given file ID in a snapshot.
         * @summary Take Snapshot
         * @param {string} fileId
         * @param {string} snapshotName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsTakeSnapshot: async (fileId: string, snapshotName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsTakeSnapshot', 'fileId', fileId)
            // verify required parameter 'snapshotName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersMatchSnapshotsTakeSnapshot', 'snapshotName', snapshotName)
            const localVarPath = `/api/v1/inventory/match_snapshots/create/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (snapshotName !== undefined) {
                localVarQueryParameter['snapshot_name'] = snapshotName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchSnapshotsApi - functional programming interface
 */
export const MatchSnapshotsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchSnapshotsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a selected snapshot.
         * @summary Delete Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId: string, snapshotId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId, snapshotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchSnapshotsApi.inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of snapshots. - mapping: Returns standard snapshots (excludes Full, Nightly, Admin) - full: Returns only Full and Nightly snapshots - all: Returns everything except Admin
         * @summary List Snapshots
         * @param {string} fileId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId: string, page?: number, pageSize?: number, category?: InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId, page, pageSize, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchSnapshotsApi.inventoryApiV1RoutersMatchSnapshotsListSnapshots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restore matches from a selected snapshot. When restoring, we have to restore them in chronological order. The exception are Full snapshots, which we can jump between at any time.
         * @summary Recalculate Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {boolean} [asTask]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId: string, snapshotId: number, asTask?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId, snapshotId, asTask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchSnapshotsApi.inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Freeze all matches currently made for a given file ID in a snapshot.
         * @summary Take Snapshot
         * @param {string} fileId
         * @param {string} snapshotName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId: string, snapshotName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapshotOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId, snapshotName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchSnapshotsApi.inventoryApiV1RoutersMatchSnapshotsTakeSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatchSnapshotsApi - factory interface
 */
export const MatchSnapshotsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchSnapshotsApiFp(configuration)
    return {
        /**
         * Delete a selected snapshot.
         * @summary Delete Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId: string, snapshotId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId, snapshotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of snapshots. - mapping: Returns standard snapshots (excludes Full, Nightly, Admin) - full: Returns only Full and Nightly snapshots - all: Returns everything except Admin
         * @summary List Snapshots
         * @param {string} fileId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId: string, page?: number, pageSize?: number, category?: InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotListOUT> {
            return localVarFp.inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId, page, pageSize, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore matches from a selected snapshot. When restoring, we have to restore them in chronological order. The exception are Full snapshots, which we can jump between at any time.
         * @summary Recalculate Snapshot
         * @param {string} fileId
         * @param {number} snapshotId
         * @param {boolean} [asTask]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId: string, snapshotId: number, asTask?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId, snapshotId, asTask, options).then((request) => request(axios, basePath));
        },
        /**
         * Freeze all matches currently made for a given file ID in a snapshot.
         * @summary Take Snapshot
         * @param {string} fileId
         * @param {string} snapshotName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId: string, snapshotName: string, options?: RawAxiosRequestConfig): AxiosPromise<SnapshotOUT> {
            return localVarFp.inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId, snapshotName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatchSnapshotsApi - object-oriented interface
 */
export class MatchSnapshotsApi extends BaseAPI {
    /**
     * Delete a selected snapshot.
     * @summary Delete Snapshot
     * @param {string} fileId
     * @param {number} snapshotId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId: string, snapshotId: number, options?: RawAxiosRequestConfig) {
        return MatchSnapshotsApiFp(this.configuration).inventoryApiV1RoutersMatchSnapshotsDeleteSnapshot(fileId, snapshotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of snapshots. - mapping: Returns standard snapshots (excludes Full, Nightly, Admin) - full: Returns only Full and Nightly snapshots - all: Returns everything except Admin
     * @summary List Snapshots
     * @param {string} fileId
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId: string, page?: number, pageSize?: number, category?: InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum, options?: RawAxiosRequestConfig) {
        return MatchSnapshotsApiFp(this.configuration).inventoryApiV1RoutersMatchSnapshotsListSnapshots(fileId, page, pageSize, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restore matches from a selected snapshot. When restoring, we have to restore them in chronological order. The exception are Full snapshots, which we can jump between at any time.
     * @summary Recalculate Snapshot
     * @param {string} fileId
     * @param {number} snapshotId
     * @param {boolean} [asTask]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId: string, snapshotId: number, asTask?: boolean, options?: RawAxiosRequestConfig) {
        return MatchSnapshotsApiFp(this.configuration).inventoryApiV1RoutersMatchSnapshotsRecalculateSnapshot(fileId, snapshotId, asTask, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freeze all matches currently made for a given file ID in a snapshot.
     * @summary Take Snapshot
     * @param {string} fileId
     * @param {string} snapshotName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId: string, snapshotName: string, options?: RawAxiosRequestConfig) {
        return MatchSnapshotsApiFp(this.configuration).inventoryApiV1RoutersMatchSnapshotsTakeSnapshot(fileId, snapshotName, options).then((request) => request(this.axios, this.basePath));
    }
}

export const InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum = {
    Mapping: 'mapping',
    Full: 'full',
    All: 'all'
} as const;
export type InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum = typeof InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum[keyof typeof InventoryApiV1RoutersMatchSnapshotsListSnapshotsCategoryEnum];


/**
 * MaterialApi - axios parameter creator
 */
export const MaterialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Material
         * @param {string} organisationId
         * @param {MaterialIN} materialIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersMaterialCreateMaterial: async (organisationId: string, materialIN: MaterialIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersMaterialCreateMaterial', 'organisationId', organisationId)
            // verify required parameter 'materialIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersMaterialCreateMaterial', 'materialIN', materialIN)
            const localVarPath = `/api/v1/building_products/materials/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(materialIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Material
         * @param {string | null} [searchTerm]
         * @param {string | null} [categoryName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersMaterialSearchMaterial: async (searchTerm?: string | null, categoryName?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/materials/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (categoryName !== undefined) {
                localVarQueryParameter['category_name'] = categoryName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialApi - functional programming interface
 */
export const MaterialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Material
         * @param {string} organisationId
         * @param {MaterialIN} materialIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId: string, materialIN: MaterialIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaterialOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId, materialIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialApi.buildingProductsApiV1RoutersMaterialCreateMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Material
         * @param {string | null} [searchTerm]
         * @param {string | null} [categoryName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm?: string | null, categoryName?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StructuredMaterialOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm, categoryName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaterialApi.buildingProductsApiV1RoutersMaterialSearchMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaterialApi - factory interface
 */
export const MaterialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialApiFp(configuration)
    return {
        /**
         *
         * @summary Create Material
         * @param {string} organisationId
         * @param {MaterialIN} materialIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId: string, materialIN: MaterialIN, options?: RawAxiosRequestConfig): AxiosPromise<MaterialOUT> {
            return localVarFp.buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId, materialIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Material
         * @param {string | null} [searchTerm]
         * @param {string | null} [categoryName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm?: string | null, categoryName?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<StructuredMaterialOut>> {
            return localVarFp.buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm, categoryName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialApi - object-oriented interface
 */
export class MaterialApi extends BaseAPI {
    /**
     *
     * @summary Create Material
     * @param {string} organisationId
     * @param {MaterialIN} materialIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId: string, materialIN: MaterialIN, options?: RawAxiosRequestConfig) {
        return MaterialApiFp(this.configuration).buildingProductsApiV1RoutersMaterialCreateMaterial(organisationId, materialIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Material
     * @param {string | null} [searchTerm]
     * @param {string | null} [categoryName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm?: string | null, categoryName?: string | null, options?: RawAxiosRequestConfig) {
        return MaterialApiFp(this.configuration).buildingProductsApiV1RoutersMaterialSearchMaterial(searchTerm, categoryName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * Materials2050Api - axios parameter creator
 */
export const Materials2050ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Materials 2050 Epd Details
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails: async (epdId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epdId' is not null or undefined
            assertParamExists('importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails', 'epdId', epdId)
            const localVarPath = `/api/v1/importer/m50/epds/{epd_id}`
                .replace(`{${"epd_id"}}`, encodeURIComponent(String(epdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Import Epd
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050ImportEpd: async (epdId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epdId' is not null or undefined
            assertParamExists('importerApiV1RoutersMaterials2050ImportEpd', 'epdId', epdId)
            const localVarPath = `/api/v1/importer/m50/epds/{epd_id}/import`
                .replace(`{${"epd_id"}}`, encodeURIComponent(String(epdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return all filter categories that have at least one option
         * @summary List Filter Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050ListFilterCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/importer/m50/filter-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Filter Options
         * @param {string} categoryId
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050SearchFilterOptions: async (categoryId: string, searchTerm?: string | null, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('importerApiV1RoutersMaterials2050SearchFilterOptions', 'categoryId', categoryId)
            const localVarPath = `/api/v1/importer/m50/filter-options/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Material 2050 Epds
         * @param {Material2050SearchInput} material2050SearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050SearchMaterial2050Epds: async (material2050SearchInput: Material2050SearchInput, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'material2050SearchInput' is not null or undefined
            assertParamExists('importerApiV1RoutersMaterials2050SearchMaterial2050Epds', 'material2050SearchInput', material2050SearchInput)
            const localVarPath = `/api/v1/importer/m50/search-epds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(material2050SearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Materials2050Api - functional programming interface
 */
export const Materials2050ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Materials2050ApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Materials 2050 Epd Details
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Materials2050EPDDetailOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Materials2050Api.importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Import Epd
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importerApiV1RoutersMaterials2050ImportEpd(epdId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDSearchOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importerApiV1RoutersMaterials2050ImportEpd(epdId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Materials2050Api.importerApiV1RoutersMaterials2050ImportEpd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * return all filter categories that have at least one option
         * @summary List Filter Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importerApiV1RoutersMaterials2050ListFilterCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterCategoryOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importerApiV1RoutersMaterials2050ListFilterCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Materials2050Api.importerApiV1RoutersMaterials2050ListFilterCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Filter Options
         * @param {string} categoryId
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId: string, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFilterOptionsOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId, searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Materials2050Api.importerApiV1RoutersMaterials2050SearchFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Material 2050 Epds
         * @param {Material2050SearchInput} material2050SearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput: Material2050SearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMaterial2050SearchOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Materials2050Api.importerApiV1RoutersMaterials2050SearchMaterial2050Epds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Materials2050Api - factory interface
 */
export const Materials2050ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Materials2050ApiFp(configuration)
    return {
        /**
         *
         * @summary Get Materials 2050 Epd Details
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId: string, options?: RawAxiosRequestConfig): AxiosPromise<Materials2050EPDDetailOUT> {
            return localVarFp.importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import Epd
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050ImportEpd(epdId: string, options?: RawAxiosRequestConfig): AxiosPromise<EPDSearchOUT> {
            return localVarFp.importerApiV1RoutersMaterials2050ImportEpd(epdId, options).then((request) => request(axios, basePath));
        },
        /**
         * return all filter categories that have at least one option
         * @summary List Filter Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050ListFilterCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<FilterCategoryOUT>> {
            return localVarFp.importerApiV1RoutersMaterials2050ListFilterCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Filter Options
         * @param {string} categoryId
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId: string, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFilterOptionsOUT> {
            return localVarFp.importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId, searchTerm, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Material 2050 Epds
         * @param {Material2050SearchInput} material2050SearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput: Material2050SearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedMaterial2050SearchOUT> {
            return localVarFp.importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Materials2050Api - object-oriented interface
 */
export class Materials2050Api extends BaseAPI {
    /**
     *
     * @summary Get Materials 2050 Epd Details
     * @param {string} epdId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId: string, options?: RawAxiosRequestConfig) {
        return Materials2050ApiFp(this.configuration).importerApiV1RoutersMaterials2050GetMaterials2050EpdDetails(epdId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Import Epd
     * @param {string} epdId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importerApiV1RoutersMaterials2050ImportEpd(epdId: string, options?: RawAxiosRequestConfig) {
        return Materials2050ApiFp(this.configuration).importerApiV1RoutersMaterials2050ImportEpd(epdId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * return all filter categories that have at least one option
     * @summary List Filter Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importerApiV1RoutersMaterials2050ListFilterCategories(options?: RawAxiosRequestConfig) {
        return Materials2050ApiFp(this.configuration).importerApiV1RoutersMaterials2050ListFilterCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Filter Options
     * @param {string} categoryId
     * @param {string | null} [searchTerm]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId: string, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return Materials2050ApiFp(this.configuration).importerApiV1RoutersMaterials2050SearchFilterOptions(categoryId, searchTerm, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Material 2050 Epds
     * @param {Material2050SearchInput} material2050SearchInput
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput: Material2050SearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return Materials2050ApiFp(this.configuration).importerApiV1RoutersMaterials2050SearchMaterial2050Epds(material2050SearchInput, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectOperationsApi - axios parameter creator
 */
export const ObjectOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to map a single physical object to a product and fetch the data for the detail view
         * @summary Detail View Mapping
         * @param {string} objectId
         * @param {DetailViewMappingIN} detailViewMappingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectOperationsDetailViewMapping: async (objectId: string, detailViewMappingIN: DetailViewMappingIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectOperationsDetailViewMapping', 'objectId', objectId)
            // verify required parameter 'detailViewMappingIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectOperationsDetailViewMapping', 'detailViewMappingIN', detailViewMappingIN)
            const localVarPath = `/api/v1/mapping_editor/object_operations/object/{object_id}/detail_view_mapping`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detailViewMappingIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Operations for selected objects or groups
         * @summary Run File Object Operations
         * @param {string} fileId
         * @param {ObjectOperationIN} objectOperationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations: async (fileId: string, objectOperationIN: ObjectOperationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations', 'fileId', fileId)
            // verify required parameter 'objectOperationIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations', 'objectOperationIN', objectOperationIN)
            const localVarPath = `/api/v1/mapping_editor/object_operations/file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectOperationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectOperationsApi - functional programming interface
 */
export const ObjectOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to map a single physical object to a product and fetch the data for the detail view
         * @summary Detail View Mapping
         * @param {string} objectId
         * @param {DetailViewMappingIN} detailViewMappingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId: string, detailViewMappingIN: DetailViewMappingIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailViewMappingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId, detailViewMappingIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectOperationsApi.mappingEditorApiV1RoutersObjectOperationsDetailViewMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Operations for selected objects or groups
         * @summary Run File Object Operations
         * @param {string} fileId
         * @param {ObjectOperationIN} objectOperationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId: string, objectOperationIN: ObjectOperationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectListOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId, objectOperationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectOperationsApi.mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectOperationsApi - factory interface
 */
export const ObjectOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectOperationsApiFp(configuration)
    return {
        /**
         * Endpoint to map a single physical object to a product and fetch the data for the detail view
         * @summary Detail View Mapping
         * @param {string} objectId
         * @param {DetailViewMappingIN} detailViewMappingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId: string, detailViewMappingIN: DetailViewMappingIN, options?: RawAxiosRequestConfig): AxiosPromise<DetailViewMappingOUT> {
            return localVarFp.mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId, detailViewMappingIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Operations for selected objects or groups
         * @summary Run File Object Operations
         * @param {string} fileId
         * @param {ObjectOperationIN} objectOperationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId: string, objectOperationIN: ObjectOperationIN, options?: RawAxiosRequestConfig): AxiosPromise<ObjectListOUT> {
            return localVarFp.mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId, objectOperationIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectOperationsApi - object-oriented interface
 */
export class ObjectOperationsApi extends BaseAPI {
    /**
     * Endpoint to map a single physical object to a product and fetch the data for the detail view
     * @summary Detail View Mapping
     * @param {string} objectId
     * @param {DetailViewMappingIN} detailViewMappingIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId: string, detailViewMappingIN: DetailViewMappingIN, options?: RawAxiosRequestConfig) {
        return ObjectOperationsApiFp(this.configuration).mappingEditorApiV1RoutersObjectOperationsDetailViewMapping(objectId, detailViewMappingIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Operations for selected objects or groups
     * @summary Run File Object Operations
     * @param {string} fileId
     * @param {ObjectOperationIN} objectOperationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId: string, objectOperationIN: ObjectOperationIN, options?: RawAxiosRequestConfig) {
        return ObjectOperationsApiFp(this.configuration).mappingEditorApiV1RoutersObjectOperationsRunFileObjectOperations(fileId, objectOperationIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OfflineApi - axios parameter creator
 */
export const OfflineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all fields
         * @summary Get Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetFields: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/offline/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetFieldsets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/offline/fieldsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetManufacturers: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/offline/manufacturers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetProductGroups: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/offline/product_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfflineApi - functional programming interface
 */
export const OfflineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfflineApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all fields
         * @summary Get Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersOfflineGetFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedFieldOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersOfflineGetFields(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineApi.caApiV1RoutersOfflineGetFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersOfflineGetFieldsets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlimFieldSetOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersOfflineGetFieldsets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineApi.caApiV1RoutersOfflineGetFieldsets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersOfflineGetManufacturers(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedManufacturerOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersOfflineGetManufacturers(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineApi.caApiV1RoutersOfflineGetManufacturers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersOfflineGetProductGroups(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProductGroupOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersOfflineGetProductGroups(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineApi.caApiV1RoutersOfflineGetProductGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OfflineApi - factory interface
 */
export const OfflineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfflineApiFp(configuration)
    return {
        /**
         * Get all fields
         * @summary Get Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedFieldOUT> {
            return localVarFp.caApiV1RoutersOfflineGetFields(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetFieldsets(options?: RawAxiosRequestConfig): AxiosPromise<Array<SlimFieldSetOUT>> {
            return localVarFp.caApiV1RoutersOfflineGetFieldsets(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetManufacturers(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedManufacturerOUT> {
            return localVarFp.caApiV1RoutersOfflineGetManufacturers(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersOfflineGetProductGroups(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedProductGroupOUT> {
            return localVarFp.caApiV1RoutersOfflineGetProductGroups(limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OfflineApi - object-oriented interface
 */
export class OfflineApi extends BaseAPI {
    /**
     * Get all fields
     * @summary Get Fields
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersOfflineGetFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OfflineApiFp(this.configuration).caApiV1RoutersOfflineGetFields(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all active fieldsets
     * @summary Get Fieldsets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersOfflineGetFieldsets(options?: RawAxiosRequestConfig) {
        return OfflineApiFp(this.configuration).caApiV1RoutersOfflineGetFieldsets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all manufacturers.
     * @summary Get Manufacturers
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersOfflineGetManufacturers(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OfflineApiFp(this.configuration).caApiV1RoutersOfflineGetManufacturers(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all product groups
     * @summary Get Product Groups
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersOfflineGetProductGroups(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OfflineApiFp(this.configuration).caApiV1RoutersOfflineGetProductGroups(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnlineApi - axios parameter creator
 */
export const OnlineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditCreateAudit: async (auditIN: AuditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditCreateAudit', 'auditIN', auditIN)
            const localVarPath = `/api/v1/ca/online/audit/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditDeleteAudit: async (auditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditDeleteAudit', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/online/audit/{audit_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditGetAudit: async (auditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditGetAudit', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/online/audit/{audit_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Audits
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListAudits: async (buildingId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditListAudits', 'buildingId', buildingId)
            const localVarPath = `/api/v1/ca/online/audit/buildings/<building_id>/audits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Floors
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListFloors: async (auditId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditListFloors', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/online/audit/{audit_id}/floors`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Rooms
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListRooms: async (auditId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineAuditListRooms', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/online/audit/{audit_id}/rooms`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Blueprint
         * @param {string} auditId
         * @param {BlueprintIN} blueprintIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintCreateBlueprint: async (auditId: string, blueprintIN: BlueprintIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintCreateBlueprint', 'auditId', auditId)
            // verify required parameter 'blueprintIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintCreateBlueprint', 'blueprintIN', blueprintIN)
            const localVarPath = `/api/v1/ca/online/blueprint/{audit_id}/blueprints/create`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blueprintIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Blueprint
         * @param {string} auditId
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintDeleteBlueprint: async (auditId: string, blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintDeleteBlueprint', 'auditId', auditId)
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintDeleteBlueprint', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/blueprint/{blueprint_id}/delete`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (auditId !== undefined) {
                localVarQueryParameter['audit_id'] = auditId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Duplicate Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint: async (blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/blueprint/{blueprint_id}/duplicate`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Blueprint Details
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails: async (blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/blueprint/{blueprint_id}/details`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Blueprint Images
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintGetBlueprintImages: async (blueprintId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintGetBlueprintImages', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/blueprint/online/blueprint/{blueprint_id}/images`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Blueprint Properties
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintListBlueprintProperties: async (blueprintId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintListBlueprintProperties', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/blueprint/{blueprint_id}/properties`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Blueprints
         * @param {string} auditId
         * @param {SortOrder | null} [sortOrder]
         * @param {BlueprintListSortBy | null} [sortBy]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintListBlueprints: async (auditId: string, sortOrder?: SortOrder | null, sortBy?: BlueprintListSortBy | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintListBlueprints', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/online/blueprint/{audit_id}/blueprints`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Blueprint Property
         * @param {BlueprintPropertyIN} blueprintPropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty: async (blueprintPropertyIN: BlueprintPropertyIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintPropertyIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty', 'blueprintPropertyIN', blueprintPropertyIN)
            const localVarPath = `/api/v1/ca/online/blueprint_property/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blueprintPropertyIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty: async (blueprintPropertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintPropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty', 'blueprintPropertyId', blueprintPropertyId)
            const localVarPath = `/api/v1/ca/online/blueprint_property/{blueprint_property_id}`
                .replace(`{${"blueprint_property_id"}}`, encodeURIComponent(String(blueprintPropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty: async (blueprintPropertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintPropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty', 'blueprintPropertyId', blueprintPropertyId)
            const localVarPath = `/api/v1/ca/online/blueprint_property/{blueprint_property_id}`
                .replace(`{${"blueprint_property_id"}}`, encodeURIComponent(String(blueprintPropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {BlueprintPropertyUpdateIN} blueprintPropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty: async (blueprintPropertyId: string, blueprintPropertyUpdateIN: BlueprintPropertyUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintPropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty', 'blueprintPropertyId', blueprintPropertyId)
            // verify required parameter 'blueprintPropertyUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty', 'blueprintPropertyUpdateIN', blueprintPropertyUpdateIN)
            const localVarPath = `/api/v1/ca/online/blueprint_property/{blueprint_property_id}`
                .replace(`{${"blueprint_property_id"}}`, encodeURIComponent(String(blueprintPropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blueprintPropertyUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Blueprints
         * @param {string} auditId
         * @param {string} searchTerm
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintSearchBlueprints: async (auditId: string, searchTerm: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintSearchBlueprints', 'auditId', auditId)
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintSearchBlueprints', 'searchTerm', searchTerm)
            const localVarPath = `/api/v1/ca/online/blueprint/{audit_id}/blueprints/search`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Blueprint
         * @param {string} blueprintId
         * @param {BlueprintUpdateIN} blueprintUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintUpdateBlueprint: async (blueprintId: string, blueprintUpdateIN: BlueprintUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintUpdateBlueprint', 'blueprintId', blueprintId)
            // verify required parameter 'blueprintUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineBlueprintUpdateBlueprint', 'blueprintUpdateIN', blueprintUpdateIN)
            const localVarPath = `/api/v1/ca/online/blueprint/{blueprint_id}/update`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blueprintUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Field
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldCreateField: async (fieldIN: FieldIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFieldCreateField', 'fieldIN', fieldIN)
            const localVarPath = `/api/v1/ca/online/field/fields/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fieldIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldDeleteField: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFieldDeleteField', 'fieldId', fieldId)
            const localVarPath = `/api/v1/ca/online/field/fields/{field_id}`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldGetField: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFieldGetField', 'fieldId', fieldId)
            const localVarPath = `/api/v1/ca/online/field/fields/{field_id}`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldListFields: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/online/field/fields/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Field
         * @param {string} fieldId
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldUpdateField: async (fieldId: string, fieldIN: FieldIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFieldUpdateField', 'fieldId', fieldId)
            // verify required parameter 'fieldIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFieldUpdateField', 'fieldIN', fieldIN)
            const localVarPath = `/api/v1/ca/online/field/fields/{field_id}/update`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fieldIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Floor
         * @param {FloorCreateIN} floorCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorCreateFloor: async (floorCreateIN: FloorCreateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'floorCreateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFloorCreateFloor', 'floorCreateIN', floorCreateIN)
            const localVarPath = `/api/v1/ca/online/floor/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(floorCreateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorDeleteFloor: async (floorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'floorId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFloorDeleteFloor', 'floorId', floorId)
            const localVarPath = `/api/v1/ca/online/floor/{floor_id}`
                .replace(`{${"floor_id"}}`, encodeURIComponent(String(floorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorGetFloor: async (floorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'floorId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFloorGetFloor', 'floorId', floorId)
            const localVarPath = `/api/v1/ca/online/floor/{floor_id}`
                .replace(`{${"floor_id"}}`, encodeURIComponent(String(floorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Floor
         * @param {string} floorId
         * @param {FloorUpdateIN} floorUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorUpdateFloor: async (floorId: string, floorUpdateIN: FloorUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'floorId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFloorUpdateFloor', 'floorId', floorId)
            // verify required parameter 'floorUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineFloorUpdateFloor', 'floorUpdateIN', floorUpdateIN)
            const localVarPath = `/api/v1/ca/online/floor/{floor_id}`
                .replace(`{${"floor_id"}}`, encodeURIComponent(String(floorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(floorUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Instance
         * @param {InstanceIN} instanceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceCreateInstance: async (instanceIN: InstanceIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceCreateInstance', 'instanceIN', instanceIN)
            const localVarPath = `/api/v1/ca/online/instance/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instanceIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceDeleteInstance: async (auditId: string, instanceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceDeleteInstance', 'auditId', auditId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceDeleteInstance', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/online/instance/{audit_id}/instances/{instance_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)))
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Duplicate Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceDuplicateInstance: async (instanceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceDuplicateInstance', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/online/instance/{instance_id}/duplicate`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceGetInstance: async (auditId: string, instanceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceGetInstance', 'auditId', auditId)
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceGetInstance', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/online/instance/{audit_id}/instances/{instance_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)))
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Instance Properties
         * @param {string} instanceId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceListInstanceProperties: async (instanceId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceListInstanceProperties', 'instanceId', instanceId)
            const localVarPath = `/api/v1/ca/online/instance/{instance_id}/properties`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Instances
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceListInstances: async (blueprintId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blueprintId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceListInstances', 'blueprintId', blueprintId)
            const localVarPath = `/api/v1/ca/online/instance/{blueprint_id}/instances`
                .replace(`{${"blueprint_id"}}`, encodeURIComponent(String(blueprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Instance Property
         * @param {InstancePropertyIN} instancePropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty: async (instancePropertyIN: InstancePropertyIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instancePropertyIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty', 'instancePropertyIN', instancePropertyIN)
            const localVarPath = `/api/v1/ca/online/instance_property/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instancePropertyIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty: async (instancePropertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instancePropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty', 'instancePropertyId', instancePropertyId)
            const localVarPath = `/api/v1/ca/online/instance_property/{instance_property_id}`
                .replace(`{${"instance_property_id"}}`, encodeURIComponent(String(instancePropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Single Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty: async (instancePropertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instancePropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty', 'instancePropertyId', instancePropertyId)
            const localVarPath = `/api/v1/ca/online/instance_property/{instance_property_id}`
                .replace(`{${"instance_property_id"}}`, encodeURIComponent(String(instancePropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Instance Property
         * @param {string} instancePropertyId
         * @param {InstancePropertyUpdateIN} instancePropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty: async (instancePropertyId: string, instancePropertyUpdateIN: InstancePropertyUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instancePropertyId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty', 'instancePropertyId', instancePropertyId)
            // verify required parameter 'instancePropertyUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty', 'instancePropertyUpdateIN', instancePropertyUpdateIN)
            const localVarPath = `/api/v1/ca/online/instance_property/{instance_property_id}`
                .replace(`{${"instance_property_id"}}`, encodeURIComponent(String(instancePropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instancePropertyUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Instance
         * @param {string} instanceId
         * @param {InstanceUpdateIN} instanceUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceUpdateInstance: async (instanceId: string, instanceUpdateIN: InstanceUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceUpdateInstance', 'instanceId', instanceId)
            // verify required parameter 'instanceUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineInstanceUpdateInstance', 'instanceUpdateIN', instanceUpdateIN)
            const localVarPath = `/api/v1/ca/online/instance/{instance_id}/update`
                .replace(`{${"instance_id"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instanceUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Room
         * @param {RoomCreateIN} roomCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomCreateRoom: async (roomCreateIN: RoomCreateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomCreateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineRoomCreateRoom', 'roomCreateIN', roomCreateIN)
            const localVarPath = `/api/v1/ca/online/room/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomCreateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomDeleteRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineRoomDeleteRoom', 'roomId', roomId)
            const localVarPath = `/api/v1/ca/online/room/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomGetRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineRoomGetRoom', 'roomId', roomId)
            const localVarPath = `/api/v1/ca/online/room/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Room
         * @param {string} roomId
         * @param {RoomUpdateIN} roomUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomUpdateRoom: async (roomId: string, roomUpdateIN: RoomUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineRoomUpdateRoom', 'roomId', roomId)
            // verify required parameter 'roomUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersCaOnlineRoomUpdateRoom', 'roomUpdateIN', roomUpdateIN)
            const localVarPath = `/api/v1/ca/online/room/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnlineApi - functional programming interface
 */
export const OnlineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnlineApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditCreateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlimAuditOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditCreateAudit(auditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditCreateAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditDeleteAudit(auditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditDeleteAudit(auditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditDeleteAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlimAuditOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditGetAudit(auditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditGetAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Audits
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditListAudits(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSlimAuditOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditListAudits(buildingId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditListAudits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Floors
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditListFloors(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedFloorOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditListFloors(auditId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditListFloors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Rooms
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineAuditListRooms(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedRoomOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineAuditListRooms(auditId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineAuditListRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Blueprint
         * @param {string} auditId
         * @param {BlueprintIN} blueprintIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId: string, blueprintIN: BlueprintIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlimBlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId, blueprintIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintCreateBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Blueprint
         * @param {string} auditId
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId: string, blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId, blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintDeleteBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Duplicate Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlimBlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Blueprint Details
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Blueprint Images
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintGetBlueprintImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Blueprint Properties
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBlueprintPropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintListBlueprintProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Blueprints
         * @param {string} auditId
         * @param {SortOrder | null} [sortOrder]
         * @param {BlueprintListSortBy | null} [sortBy]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId: string, sortOrder?: SortOrder | null, sortBy?: BlueprintListSortBy | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSlimBlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId, sortOrder, sortBy, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintListBlueprints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Blueprint Property
         * @param {BlueprintPropertyIN} blueprintPropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN: BlueprintPropertyIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlueprintPropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlueprintPropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {BlueprintPropertyUpdateIN} blueprintPropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId: string, blueprintPropertyUpdateIN: BlueprintPropertyUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlueprintPropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId, blueprintPropertyUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Blueprints
         * @param {string} auditId
         * @param {string} searchTerm
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId: string, searchTerm: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSlimBlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId, searchTerm, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintSearchBlueprints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Blueprint
         * @param {string} blueprintId
         * @param {BlueprintUpdateIN} blueprintUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId: string, blueprintUpdateIN: BlueprintUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlimBlueprintOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId, blueprintUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineBlueprintUpdateBlueprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Field
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFieldCreateField(fieldIN: FieldIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFieldCreateField(fieldIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFieldCreateField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFieldDeleteField(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFieldDeleteField(fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFieldDeleteField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFieldGetField(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFieldGetField(fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFieldGetField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFieldListFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedFieldOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFieldListFields(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFieldListFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Field
         * @param {string} fieldId
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFieldUpdateField(fieldId: string, fieldIN: FieldIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFieldUpdateField(fieldId, fieldIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFieldUpdateField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Floor
         * @param {FloorCreateIN} floorCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN: FloorCreateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFloorCreateFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFloorDeleteFloor(floorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFloorDeleteFloor(floorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFloorDeleteFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFloorGetFloor(floorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFloorGetFloor(floorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFloorGetFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Floor
         * @param {string} floorId
         * @param {FloorUpdateIN} floorUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineFloorUpdateFloor(floorId: string, floorUpdateIN: FloorUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineFloorUpdateFloor(floorId, floorUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineFloorUpdateFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Instance
         * @param {InstanceIN} instanceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN: InstanceIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstanceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceCreateInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId, instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceDeleteInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Duplicate Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstanceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceDuplicateInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceGetInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstanceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceGetInstance(auditId, instanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceGetInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Instance Properties
         * @param {string} instanceId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInstancePropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceListInstanceProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Instances
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceListInstances(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInstanceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceListInstances(blueprintId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceListInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Instance Property
         * @param {InstancePropertyIN} instancePropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN: InstancePropertyIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstancePropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Single Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstancePropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Instance Property
         * @param {string} instancePropertyId
         * @param {InstancePropertyUpdateIN} instancePropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId: string, instancePropertyUpdateIN: InstancePropertyUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstancePropertyOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId, instancePropertyUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Instance
         * @param {string} instanceId
         * @param {InstanceUpdateIN} instanceUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId: string, instanceUpdateIN: InstanceUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstanceOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId, instanceUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineInstanceUpdateInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Room
         * @param {RoomCreateIN} roomCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN: RoomCreateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineRoomCreateRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineRoomDeleteRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineRoomDeleteRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineRoomDeleteRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineRoomGetRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineRoomGetRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineRoomGetRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Room
         * @param {string} roomId
         * @param {RoomUpdateIN} roomUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersCaOnlineRoomUpdateRoom(roomId: string, roomUpdateIN: RoomUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersCaOnlineRoomUpdateRoom(roomId, roomUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineApi.caApiV1RoutersCaOnlineRoomUpdateRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnlineApi - factory interface
 */
export const OnlineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnlineApiFp(configuration)
    return {
        /**
         *
         * @summary Create Audit
         * @param {AuditIN} auditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditCreateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig): AxiosPromise<SlimAuditOut> {
            return localVarFp.caApiV1RoutersCaOnlineAuditCreateAudit(auditIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditDeleteAudit(auditId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersCaOnlineAuditDeleteAudit(auditId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Audit
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig): AxiosPromise<SlimAuditOut> {
            return localVarFp.caApiV1RoutersCaOnlineAuditGetAudit(auditId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Audits
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListAudits(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedSlimAuditOut> {
            return localVarFp.caApiV1RoutersCaOnlineAuditListAudits(buildingId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Floors
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListFloors(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedFloorOUT> {
            return localVarFp.caApiV1RoutersCaOnlineAuditListFloors(auditId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Rooms
         * @param {string} auditId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineAuditListRooms(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedRoomOUT> {
            return localVarFp.caApiV1RoutersCaOnlineAuditListRooms(auditId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Blueprint
         * @param {string} auditId
         * @param {BlueprintIN} blueprintIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId: string, blueprintIN: BlueprintIN, options?: RawAxiosRequestConfig): AxiosPromise<SlimBlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId, blueprintIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Blueprint
         * @param {string} auditId
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId: string, blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId, blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Duplicate Blueprint
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<SlimBlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Blueprint Details
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<BlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Blueprint Images
         * @param {string} blueprintId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ImageOUT>> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Blueprint Properties
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedBlueprintPropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Blueprints
         * @param {string} auditId
         * @param {SortOrder | null} [sortOrder]
         * @param {BlueprintListSortBy | null} [sortBy]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId: string, sortOrder?: SortOrder | null, sortBy?: BlueprintListSortBy | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedSlimBlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId, sortOrder, sortBy, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Blueprint Property
         * @param {BlueprintPropertyIN} blueprintPropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN: BlueprintPropertyIN, options?: RawAxiosRequestConfig): AxiosPromise<BlueprintPropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig): AxiosPromise<BlueprintPropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Blueprint Property
         * @param {string} blueprintPropertyId
         * @param {BlueprintPropertyUpdateIN} blueprintPropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId: string, blueprintPropertyUpdateIN: BlueprintPropertyUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<BlueprintPropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId, blueprintPropertyUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Blueprints
         * @param {string} auditId
         * @param {string} searchTerm
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId: string, searchTerm: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedSlimBlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId, searchTerm, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Blueprint
         * @param {string} blueprintId
         * @param {BlueprintUpdateIN} blueprintUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId: string, blueprintUpdateIN: BlueprintUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<SlimBlueprintOUT> {
            return localVarFp.caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId, blueprintUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Field
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldCreateField(fieldIN: FieldIN, options?: RawAxiosRequestConfig): AxiosPromise<FieldOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFieldCreateField(fieldIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldDeleteField(fieldId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersCaOnlineFieldDeleteField(fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Field
         * @param {string} fieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldGetField(fieldId: string, options?: RawAxiosRequestConfig): AxiosPromise<FieldOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFieldGetField(fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Fields
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldListFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedFieldOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFieldListFields(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Field
         * @param {string} fieldId
         * @param {FieldIN} fieldIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFieldUpdateField(fieldId: string, fieldIN: FieldIN, options?: RawAxiosRequestConfig): AxiosPromise<FieldOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFieldUpdateField(fieldId, fieldIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Floor
         * @param {FloorCreateIN} floorCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN: FloorCreateIN, options?: RawAxiosRequestConfig): AxiosPromise<FloorOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorDeleteFloor(floorId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFloorDeleteFloor(floorId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Floor
         * @param {string} floorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorGetFloor(floorId: string, options?: RawAxiosRequestConfig): AxiosPromise<FloorOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFloorGetFloor(floorId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Floor
         * @param {string} floorId
         * @param {FloorUpdateIN} floorUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineFloorUpdateFloor(floorId: string, floorUpdateIN: FloorUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<FloorOUT> {
            return localVarFp.caApiV1RoutersCaOnlineFloorUpdateFloor(floorId, floorUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Instance
         * @param {InstanceIN} instanceIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN: InstanceIN, options?: RawAxiosRequestConfig): AxiosPromise<InstanceOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId, instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Duplicate Instance
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId: string, options?: RawAxiosRequestConfig): AxiosPromise<InstanceOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Instance
         * @param {string} auditId
         * @param {string} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceGetInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig): AxiosPromise<InstanceOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceGetInstance(auditId, instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Instance Properties
         * @param {string} instanceId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedInstancePropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Instances
         * @param {string} blueprintId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceListInstances(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedInstanceOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceListInstances(blueprintId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Instance Property
         * @param {InstancePropertyIN} instancePropertyIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN: InstancePropertyIN, options?: RawAxiosRequestConfig): AxiosPromise<InstancePropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Single Instance Property
         * @param {string} instancePropertyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig): AxiosPromise<InstancePropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Instance Property
         * @param {string} instancePropertyId
         * @param {InstancePropertyUpdateIN} instancePropertyUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId: string, instancePropertyUpdateIN: InstancePropertyUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<InstancePropertyOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId, instancePropertyUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Instance
         * @param {string} instanceId
         * @param {InstanceUpdateIN} instanceUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId: string, instanceUpdateIN: InstanceUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<InstanceOUT> {
            return localVarFp.caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId, instanceUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Room
         * @param {RoomCreateIN} roomCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN: RoomCreateIN, options?: RawAxiosRequestConfig): AxiosPromise<RoomOUT> {
            return localVarFp.caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomDeleteRoom(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersCaOnlineRoomDeleteRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomGetRoom(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomOUT> {
            return localVarFp.caApiV1RoutersCaOnlineRoomGetRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Room
         * @param {string} roomId
         * @param {RoomUpdateIN} roomUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersCaOnlineRoomUpdateRoom(roomId: string, roomUpdateIN: RoomUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<RoomOUT> {
            return localVarFp.caApiV1RoutersCaOnlineRoomUpdateRoom(roomId, roomUpdateIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnlineApi - object-oriented interface
 */
export class OnlineApi extends BaseAPI {
    /**
     *
     * @summary Create Audit
     * @param {AuditIN} auditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditCreateAudit(auditIN: AuditIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditCreateAudit(auditIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Audit
     * @param {string} auditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditDeleteAudit(auditId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditDeleteAudit(auditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Audit
     * @param {string} auditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditGetAudit(auditId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditGetAudit(auditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Audits
     * @param {string} buildingId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditListAudits(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditListAudits(buildingId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Floors
     * @param {string} auditId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditListFloors(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditListFloors(auditId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Rooms
     * @param {string} auditId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineAuditListRooms(auditId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineAuditListRooms(auditId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Blueprint
     * @param {string} auditId
     * @param {BlueprintIN} blueprintIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId: string, blueprintIN: BlueprintIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintCreateBlueprint(auditId, blueprintIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Blueprint
     * @param {string} auditId
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId: string, blueprintId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintDeleteBlueprint(auditId, blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Duplicate Blueprint
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintDuplicateBlueprint(blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Blueprint Details
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintGetBlueprintDetails(blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Blueprint Images
     * @param {string} blueprintId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintGetBlueprintImages(blueprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Blueprint Properties
     * @param {string} blueprintId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintListBlueprintProperties(blueprintId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Blueprints
     * @param {string} auditId
     * @param {SortOrder | null} [sortOrder]
     * @param {BlueprintListSortBy | null} [sortBy]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId: string, sortOrder?: SortOrder | null, sortBy?: BlueprintListSortBy | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintListBlueprints(auditId, sortOrder, sortBy, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Blueprint Property
     * @param {BlueprintPropertyIN} blueprintPropertyIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN: BlueprintPropertyIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintPropertyCreateBlueprintProperty(blueprintPropertyIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Blueprint Property
     * @param {string} blueprintPropertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintPropertyDeleteBlueprintProperty(blueprintPropertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Blueprint Property
     * @param {string} blueprintPropertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintPropertyGetBlueprintProperty(blueprintPropertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Blueprint Property
     * @param {string} blueprintPropertyId
     * @param {BlueprintPropertyUpdateIN} blueprintPropertyUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId: string, blueprintPropertyUpdateIN: BlueprintPropertyUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintPropertyUpdateBlueprintProperty(blueprintPropertyId, blueprintPropertyUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Blueprints
     * @param {string} auditId
     * @param {string} searchTerm
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId: string, searchTerm: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintSearchBlueprints(auditId, searchTerm, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Blueprint
     * @param {string} blueprintId
     * @param {BlueprintUpdateIN} blueprintUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId: string, blueprintUpdateIN: BlueprintUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineBlueprintUpdateBlueprint(blueprintId, blueprintUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Field
     * @param {FieldIN} fieldIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFieldCreateField(fieldIN: FieldIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFieldCreateField(fieldIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Field
     * @param {string} fieldId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFieldDeleteField(fieldId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFieldDeleteField(fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Field
     * @param {string} fieldId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFieldGetField(fieldId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFieldGetField(fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Fields
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFieldListFields(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFieldListFields(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Field
     * @param {string} fieldId
     * @param {FieldIN} fieldIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFieldUpdateField(fieldId: string, fieldIN: FieldIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFieldUpdateField(fieldId, fieldIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Floor
     * @param {FloorCreateIN} floorCreateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN: FloorCreateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFloorCreateFloor(floorCreateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Floor
     * @param {string} floorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFloorDeleteFloor(floorId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFloorDeleteFloor(floorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Floor
     * @param {string} floorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFloorGetFloor(floorId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFloorGetFloor(floorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Floor
     * @param {string} floorId
     * @param {FloorUpdateIN} floorUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineFloorUpdateFloor(floorId: string, floorUpdateIN: FloorUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineFloorUpdateFloor(floorId, floorUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Instance
     * @param {InstanceIN} instanceIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN: InstanceIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceCreateInstance(instanceIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Instance
     * @param {string} auditId
     * @param {string} instanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceDeleteInstance(auditId, instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Duplicate Instance
     * @param {string} instanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceDuplicateInstance(instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Instance
     * @param {string} auditId
     * @param {string} instanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceGetInstance(auditId: string, instanceId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceGetInstance(auditId, instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Instance Properties
     * @param {string} instanceId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceListInstanceProperties(instanceId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Instances
     * @param {string} blueprintId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceListInstances(blueprintId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceListInstances(blueprintId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Instance Property
     * @param {InstancePropertyIN} instancePropertyIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN: InstancePropertyIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstancePropertyCreateInstanceProperty(instancePropertyIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Instance Property
     * @param {string} instancePropertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstancePropertyDeleteInstanceProperty(instancePropertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Single Instance Property
     * @param {string} instancePropertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstancePropertyGetSingleInstanceProperty(instancePropertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Instance Property
     * @param {string} instancePropertyId
     * @param {InstancePropertyUpdateIN} instancePropertyUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId: string, instancePropertyUpdateIN: InstancePropertyUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstancePropertyUpdateInstanceProperty(instancePropertyId, instancePropertyUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Instance
     * @param {string} instanceId
     * @param {InstanceUpdateIN} instanceUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId: string, instanceUpdateIN: InstanceUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineInstanceUpdateInstance(instanceId, instanceUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Room
     * @param {RoomCreateIN} roomCreateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN: RoomCreateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineRoomCreateRoom(roomCreateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Room
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineRoomDeleteRoom(roomId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineRoomDeleteRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Room
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineRoomGetRoom(roomId: string, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineRoomGetRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Room
     * @param {string} roomId
     * @param {RoomUpdateIN} roomUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersCaOnlineRoomUpdateRoom(roomId: string, roomUpdateIN: RoomUpdateIN, options?: RawAxiosRequestConfig) {
        return OnlineApiFp(this.configuration).caApiV1RoutersCaOnlineRoomUpdateRoom(roomId, roomUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperationalEnergyApi - axios parameter creator
 */
export const OperationalEnergyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Check Operational Energy
         * @param {string} buildingId
         * @param {string | null} [certificationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergyCheckOperationalEnergy: async (buildingId: string, certificationId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersOperationalEnergyCheckOperationalEnergy', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/operational_energy/{building_id}/check_operational_energy`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (certificationId !== undefined) {
                localVarQueryParameter['certification_id'] = certificationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Operational Energy All Certifications
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/operational_energy/{building_id}/operational_energy`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sync B6
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergySyncB6: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersOperationalEnergySyncB6', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/operational_energy/sync_b6_from_retool/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm the report
         * @summary Confirm Report
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergyConfirmReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportApiV1RoutersOperationalEnergyConfirmReport', 'reportId', reportId)
            const localVarPath = `/api/v1/report/operational_energy/{report_id}/confirm`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the latest CONFIRMED report if report_id is not provided. Otherwise, get the report by report_id
         * @summary Get Latest Report
         * @param {string} buildingId
         * @param {string | null} [reportId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergyGetLatestReport: async (buildingId: string, reportId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersOperationalEnergyGetLatestReport', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/operational_energy/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (reportId !== undefined) {
                localVarQueryParameter['report_id'] = reportId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a file
         * @summary Submit File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergySubmitFile: async (buildingId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersOperationalEnergySubmitFile', 'buildingId', buildingId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('reportApiV1RoutersOperationalEnergySubmitFile', 'file', file)
            const localVarPath = `/api/v1/report/operational_energy/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationalEnergyApi - functional programming interface
 */
export const OperationalEnergyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationalEnergyApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Check Operational Energy
         * @param {string} buildingId
         * @param {string | null} [certificationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId: string, certificationId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckOperationalEnergy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId, certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.concularApiV1RoutersOperationalEnergyCheckOperationalEnergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Operational Energy All Certifications
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationalEnergyTable>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Sync B6
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOperationalEnergySyncB6(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOperationalEnergySyncB6(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.concularApiV1RoutersOperationalEnergySyncB6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm the report
         * @summary Confirm Report
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersOperationalEnergyConfirmReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersOperationalEnergyConfirmReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.reportApiV1RoutersOperationalEnergyConfirmReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the latest CONFIRMED report if report_id is not provided. Otherwise, get the report by report_id
         * @summary Get Latest Report
         * @param {string} buildingId
         * @param {string | null} [reportId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId: string, reportId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestReportOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.reportApiV1RoutersOperationalEnergyGetLatestReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit a file
         * @summary Submit File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersOperationalEnergySubmitFile(buildingId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationalEnergyReportSubmitOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersOperationalEnergySubmitFile(buildingId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationalEnergyApi.reportApiV1RoutersOperationalEnergySubmitFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperationalEnergyApi - factory interface
 */
export const OperationalEnergyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationalEnergyApiFp(configuration)
    return {
        /**
         *
         * @summary Check Operational Energy
         * @param {string} buildingId
         * @param {string | null} [certificationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId: string, certificationId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CheckOperationalEnergy> {
            return localVarFp.concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId, certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Operational Energy All Certifications
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<OperationalEnergyTable> {
            return localVarFp.concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync B6
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOperationalEnergySyncB6(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersOperationalEnergySyncB6(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm the report
         * @summary Confirm Report
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergyConfirmReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.reportApiV1RoutersOperationalEnergyConfirmReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the latest CONFIRMED report if report_id is not provided. Otherwise, get the report by report_id
         * @summary Get Latest Report
         * @param {string} buildingId
         * @param {string | null} [reportId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId: string, reportId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LatestReportOUT> {
            return localVarFp.reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a file
         * @summary Submit File
         * @param {string} buildingId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersOperationalEnergySubmitFile(buildingId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OperationalEnergyReportSubmitOUT> {
            return localVarFp.reportApiV1RoutersOperationalEnergySubmitFile(buildingId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationalEnergyApi - object-oriented interface
 */
export class OperationalEnergyApi extends BaseAPI {
    /**
     *
     * @summary Check Operational Energy
     * @param {string} buildingId
     * @param {string | null} [certificationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId: string, certificationId?: string | null, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).concularApiV1RoutersOperationalEnergyCheckOperationalEnergy(buildingId, certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Operational Energy All Certifications
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId: string, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).concularApiV1RoutersOperationalEnergyOperationalEnergyAllCertifications(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Sync B6
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOperationalEnergySyncB6(buildingId: string, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).concularApiV1RoutersOperationalEnergySyncB6(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm the report
     * @summary Confirm Report
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersOperationalEnergyConfirmReport(reportId: string, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).reportApiV1RoutersOperationalEnergyConfirmReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the latest CONFIRMED report if report_id is not provided. Otherwise, get the report by report_id
     * @summary Get Latest Report
     * @param {string} buildingId
     * @param {string | null} [reportId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId: string, reportId?: string | null, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).reportApiV1RoutersOperationalEnergyGetLatestReport(buildingId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a file
     * @summary Submit File
     * @param {string} buildingId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersOperationalEnergySubmitFile(buildingId: string, file: File, options?: RawAxiosRequestConfig) {
        return OperationalEnergyApiFp(this.configuration).reportApiV1RoutersOperationalEnergySubmitFile(buildingId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationAccessRequestsApi - axios parameter creator
 */
export const OrganisationAccessRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get latest status of user organisation request.
         * @summary Check Org Access Request Status
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/organisation_requests/{organisation_id}/status`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation admin can decline the user request to join the organisation.
         * @summary Decline User Request For Organisation
         * @param {string} orgAccessReqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation: async (orgAccessReqId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccessReqId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation', 'orgAccessReqId', orgAccessReqId)
            const localVarPath = `/api/v1/concular/organisation_requests/{org_access_req_id}`
                .replace(`{${"org_access_req_id"}}`, encodeURIComponent(String(orgAccessReqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation admin can get all the pending invites and request for an organisation.
         * @summary Get All Requests
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestGetAllRequests: async (organisationId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestGetAllRequests', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/organisation_requests/{organisation_id}/all`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation admin can invite new users (as an admin or a member) to join the organisation. User will be notified by email.
         * @summary Invite User Or Admin For Org
         * @param {string} organisationId
         * @param {OrganisationInviteeIN} organisationInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg: async (organisationId: string, organisationInviteeIN: OrganisationInviteeIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg', 'organisationId', organisationId)
            // verify required parameter 'organisationInviteeIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg', 'organisationInviteeIN', organisationInviteeIN)
            const localVarPath = `/api/v1/concular/organisation_requests/{organisation_id}/invite`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationInviteeIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organisation admin can accept request of user to join the organisation.
         * @summary Request Accept
         * @param {OrganisationRequestAcceptIN} organisationRequestAcceptIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestRequestAccept: async (organisationRequestAcceptIN: OrganisationRequestAcceptIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationRequestAcceptIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestRequestAccept', 'organisationRequestAcceptIN', organisationRequestAcceptIN)
            const localVarPath = `/api/v1/concular/organisation_requests/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationRequestAcceptIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User can request to join organisation. But organisation must have to configure domain. If organisation domain and user\'s email domain match then it will display organisations that user can request to join. Organisation admins will be notified by email.
         * @summary Request To Join Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/organisation_requests/{organisation_id}/join`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationAccessRequestsApi - functional programming interface
 */
export const OrganisationAccessRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationAccessRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get latest status of user organisation request.
         * @summary Check Org Access Request Status
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAccessRequestOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation admin can decline the user request to join the organisation.
         * @summary Decline User Request For Organisation
         * @param {string} orgAccessReqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation admin can get all the pending invites and request for an organisation.
         * @summary Get All Requests
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrganisationRequestAllOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestGetAllRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation admin can invite new users (as an admin or a member) to join the organisation. User will be notified by email.
         * @summary Invite User Or Admin For Org
         * @param {string} organisationId
         * @param {OrganisationInviteeIN} organisationInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId: string, organisationInviteeIN: OrganisationInviteeIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationInviteeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId, organisationInviteeIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organisation admin can accept request of user to join the organisation.
         * @summary Request Accept
         * @param {OrganisationRequestAcceptIN} organisationRequestAcceptIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN: OrganisationRequestAcceptIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestRequestAccept']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User can request to join organisation. But organisation must have to configure domain. If organisation domain and user\'s email domain match then it will display organisations that user can request to join. Organisation admins will be notified by email.
         * @summary Request To Join Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationAccessRequestOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationAccessRequestsApi.concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationAccessRequestsApi - factory interface
 */
export const OrganisationAccessRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationAccessRequestsApiFp(configuration)
    return {
        /**
         * Get latest status of user organisation request.
         * @summary Check Org Access Request Status
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationAccessRequestOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation admin can decline the user request to join the organisation.
         * @summary Decline User Request For Organisation
         * @param {string} orgAccessReqId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation admin can get all the pending invites and request for an organisation.
         * @summary Get All Requests
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOrganisationRequestAllOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation admin can invite new users (as an admin or a member) to join the organisation. User will be notified by email.
         * @summary Invite User Or Admin For Org
         * @param {string} organisationId
         * @param {OrganisationInviteeIN} organisationInviteeIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId: string, organisationInviteeIN: OrganisationInviteeIN, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationInviteeOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId, organisationInviteeIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Organisation admin can accept request of user to join the organisation.
         * @summary Request Accept
         * @param {OrganisationRequestAcceptIN} organisationRequestAcceptIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN: OrganisationRequestAcceptIN, options?: RawAxiosRequestConfig): AxiosPromise<UserOrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN, options).then((request) => request(axios, basePath));
        },
        /**
         * User can request to join organisation. But organisation must have to configure domain. If organisation domain and user\'s email domain match then it will display organisations that user can request to join. Organisation admins will be notified by email.
         * @summary Request To Join Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationAccessRequestOUT> {
            return localVarFp.concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationAccessRequestsApi - object-oriented interface
 */
export class OrganisationAccessRequestsApi extends BaseAPI {
    /**
     * Get latest status of user organisation request.
     * @summary Check Org Access Request Status
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId: string, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestCheckOrgAccessRequestStatus(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation admin can decline the user request to join the organisation.
     * @summary Decline User Request For Organisation
     * @param {string} orgAccessReqId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId: string, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestDeclineUserRequestForOrganisation(orgAccessReqId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation admin can get all the pending invites and request for an organisation.
     * @summary Get All Requests
     * @param {string} organisationId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestGetAllRequests(organisationId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation admin can invite new users (as an admin or a member) to join the organisation. User will be notified by email.
     * @summary Invite User Or Admin For Org
     * @param {string} organisationId
     * @param {OrganisationInviteeIN} organisationInviteeIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId: string, organisationInviteeIN: OrganisationInviteeIN, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestInviteUserOrAdminForOrg(organisationId, organisationInviteeIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organisation admin can accept request of user to join the organisation.
     * @summary Request Accept
     * @param {OrganisationRequestAcceptIN} organisationRequestAcceptIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN: OrganisationRequestAcceptIN, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestRequestAccept(organisationRequestAcceptIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User can request to join organisation. But organisation must have to configure domain. If organisation domain and user\'s email domain match then it will display organisations that user can request to join. Organisation admins will be notified by email.
     * @summary Request To Join Organisation
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId: string, options?: RawAxiosRequestConfig) {
        return OrganisationAccessRequestsApiFp(this.configuration).concularApiV1RoutersOrganisationAccessRequestRequestToJoinOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationDomainsApi - axios parameter creator
 */
export const OrganisationDomainsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create and attach domain with organisation. Domains can be used to suggest organisation to the user based on their email domain.
         * @summary Create Org Domain
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainCreateOrgDomain: async (organisationDomainIN: OrganisationDomainIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationDomainIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationDomainCreateOrgDomain', 'organisationDomainIN', organisationDomainIN)
            const localVarPath = `/api/v1/concular/org_domains/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationDomainIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove domain from the organisation.
         * @summary Delete Org Domain
         * @param {string} orgDomainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainDeleteOrgDomain: async (orgDomainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgDomainId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationDomainDeleteOrgDomain', 'orgDomainId', orgDomainId)
            const localVarPath = `/api/v1/concular/org_domains/{org_domain_id}`
                .replace(`{${"org_domain_id"}}`, encodeURIComponent(String(orgDomainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the domains that are associated with organisation.
         * @summary Get All Org Domain
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainGetAllOrgDomain: async (organisationId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationDomainGetAllOrgDomain', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/org_domains/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the organisation domain.
         * @summary Update Org Domain
         * @param {string} orgDomainId
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainUpdateOrgDomain: async (orgDomainId: string, organisationDomainIN: OrganisationDomainIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgDomainId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationDomainUpdateOrgDomain', 'orgDomainId', orgDomainId)
            // verify required parameter 'organisationDomainIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationDomainUpdateOrgDomain', 'organisationDomainIN', organisationDomainIN)
            const localVarPath = `/api/v1/concular/org_domains/{org_domain_id}`
                .replace(`{${"org_domain_id"}}`, encodeURIComponent(String(orgDomainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationDomainIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationDomainsApi - functional programming interface
 */
export const OrganisationDomainsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationDomainsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create and attach domain with organisation. Domains can be used to suggest organisation to the user based on their email domain.
         * @summary Create Org Domain
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDomainOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationDomainsApi.concularApiV1RoutersOrganisationDomainCreateOrgDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove domain from the organisation.
         * @summary Delete Org Domain
         * @param {string} orgDomainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationDomainsApi.concularApiV1RoutersOrganisationDomainDeleteOrgDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all the domains that are associated with organisation.
         * @summary Get All Org Domain
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrganisationDomainOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationDomainsApi.concularApiV1RoutersOrganisationDomainGetAllOrgDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the organisation domain.
         * @summary Update Org Domain
         * @param {string} orgDomainId
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId: string, organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDomainOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId, organisationDomainIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationDomainsApi.concularApiV1RoutersOrganisationDomainUpdateOrgDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationDomainsApi - factory interface
 */
export const OrganisationDomainsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationDomainsApiFp(configuration)
    return {
        /**
         * Create and attach domain with organisation. Domains can be used to suggest organisation to the user based on their email domain.
         * @summary Create Org Domain
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDomainOUT> {
            return localVarFp.concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove domain from the organisation.
         * @summary Delete Org Domain
         * @param {string} orgDomainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the domains that are associated with organisation.
         * @summary Get All Org Domain
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOrganisationDomainOUT> {
            return localVarFp.concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the organisation domain.
         * @summary Update Org Domain
         * @param {string} orgDomainId
         * @param {OrganisationDomainIN} organisationDomainIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId: string, organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDomainOUT> {
            return localVarFp.concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId, organisationDomainIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationDomainsApi - object-oriented interface
 */
export class OrganisationDomainsApi extends BaseAPI {
    /**
     * Create and attach domain with organisation. Domains can be used to suggest organisation to the user based on their email domain.
     * @summary Create Org Domain
     * @param {OrganisationDomainIN} organisationDomainIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig) {
        return OrganisationDomainsApiFp(this.configuration).concularApiV1RoutersOrganisationDomainCreateOrgDomain(organisationDomainIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove domain from the organisation.
     * @summary Delete Org Domain
     * @param {string} orgDomainId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId: string, options?: RawAxiosRequestConfig) {
        return OrganisationDomainsApiFp(this.configuration).concularApiV1RoutersOrganisationDomainDeleteOrgDomain(orgDomainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the domains that are associated with organisation.
     * @summary Get All Org Domain
     * @param {string} organisationId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganisationDomainsApiFp(this.configuration).concularApiV1RoutersOrganisationDomainGetAllOrgDomain(organisationId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the organisation domain.
     * @summary Update Org Domain
     * @param {string} orgDomainId
     * @param {OrganisationDomainIN} organisationDomainIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId: string, organisationDomainIN: OrganisationDomainIN, options?: RawAxiosRequestConfig) {
        return OrganisationDomainsApiFp(this.configuration).concularApiV1RoutersOrganisationDomainUpdateOrgDomain(orgDomainId, organisationDomainIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationTypesApi - axios parameter creator
 */
export const OrganisationTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all organisation types
         * @summary Get Organisation Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsTypeGetOrganisationTypes: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/organisation_types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationTypesApi - functional programming interface
 */
export const OrganisationTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all organisation types
         * @summary Get Organisation Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrganisationTypeOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationTypesApi.concularApiV1RoutersOrganisationsTypeGetOrganisationTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationTypesApi - factory interface
 */
export const OrganisationTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationTypesApiFp(configuration)
    return {
        /**
         * Get all organisation types
         * @summary Get Organisation Types
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOrganisationTypeOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationTypesApi - object-oriented interface
 */
export class OrganisationTypesApi extends BaseAPI {
    /**
     * Get all organisation types
     * @summary Get Organisation Types
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganisationTypesApiFp(this.configuration).concularApiV1RoutersOrganisationsTypeGetOrganisationTypes(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationsApi - axios parameter creator
 */
export const OrganisationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds the demo building to the organisation.
         * @summary Add Demo Building
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsAddDemoBuilding: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsAddDemoBuilding', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}/add_demo_building`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an organisation. Creator will be an organisation admin.
         * @summary Create Organisation
         * @param {OrganisationIN} organisationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsCreateOrganisation: async (organisationIN: OrganisationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsCreateOrganisation', 'organisationIN', organisationIN)
            const localVarPath = `/api/v1/concular/organisations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organisation.
         * @summary Delete Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsDeleteOrganisation: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsDeleteOrganisation', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API will return all the organisations of the user.
         * @summary Get All Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetAllOrganisations: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/organisations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Available user roles for an organisation.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/organisations/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * It will return a list of the organisations that related to a user\'s email domain. Organisation should have domain configured.
         * @summary Get User Domain Related Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/organisations/related/domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation
         * @param {string} organisationId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsOrgBulkBuildingCreation: async (organisationId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsOrgBulkBuildingCreation', 'organisationId', organisationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsOrgBulkBuildingCreation', 'file', file)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}/bulk_building_creation`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation Json
         * @param {string} organisationId
         * @param {Array<BuildingIN>} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson: async (organisationId: string, buildingIN: Array<BuildingIN>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson', 'organisationId', organisationId)
            // verify required parameter 'buildingIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson', 'buildingIN', buildingIN)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}/bulk_building_creation_json`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organisation. You can only pass the fields that you want to update.
         * @summary Update Organisation
         * @param {string} organisationId
         * @param {OrganisationUpdateIN} organisationUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsUpdateOrganisation: async (organisationId: string, organisationUpdateIN: OrganisationUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsUpdateOrganisation', 'organisationId', organisationId)
            // verify required parameter 'organisationUpdateIN' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsUpdateOrganisation', 'organisationUpdateIN', organisationUpdateIN)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisationUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload logo for the organisation.
         * @summary Upload Organisation Logo
         * @param {string} organisationId
         * @param {File} logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsUploadOrganisationLogo: async (organisationId: string, logo: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsUploadOrganisationLogo', 'organisationId', organisationId)
            // verify required parameter 'logo' is not null or undefined
            assertParamExists('concularApiV1RoutersOrganisationsUploadOrganisationLogo', 'logo', logo)
            const localVarPath = `/api/v1/concular/organisations/{organisation_id}/logo`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


            if (logo !== undefined) {
                localVarFormParams.append('logo', logo as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationsApi - functional programming interface
 */
export const OrganisationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds the demo building to the organisation.
         * @summary Add Demo Building
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsAddDemoBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an organisation. Creator will be an organisation admin.
         * @summary Create Organisation
         * @param {OrganisationIN} organisationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN: OrganisationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsCreateOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organisation.
         * @summary Delete Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsDeleteOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This API will return all the organisations of the user.
         * @summary Get All Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsGetAllOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsGetAllOrganisations(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsGetAllOrganisations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Available user roles for an organisation.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsGetAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRoleOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsGetAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsGetAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * It will return a list of the organisations that related to a user\'s email domain. Organisation should have domain configured.
         * @summary Get User Domain Related Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation
         * @param {string} organisationId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsOrgBulkBuildingCreation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation Json
         * @param {string} organisationId
         * @param {Array<BuildingIN>} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId: string, buildingIN: Array<BuildingIN>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId, buildingIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organisation. You can only pass the fields that you want to update.
         * @summary Update Organisation
         * @param {string} organisationId
         * @param {OrganisationUpdateIN} organisationUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId: string, organisationUpdateIN: OrganisationUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId, organisationUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsUpdateOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload logo for the organisation.
         * @summary Upload Organisation Logo
         * @param {string} organisationId
         * @param {File} logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId: string, logo: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId, logo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationsApi.concularApiV1RoutersOrganisationsUploadOrganisationLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationsApi - factory interface
 */
export const OrganisationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationsApiFp(configuration)
    return {
        /**
         * Adds the demo building to the organisation.
         * @summary Add Demo Building
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuildingOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an organisation. Creator will be an organisation admin.
         * @summary Create Organisation
         * @param {OrganisationIN} organisationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN: OrganisationIN, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organisation.
         * @summary Delete Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * This API will return all the organisations of the user.
         * @summary Get All Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetAllOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsGetAllOrganisations(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Available user roles for an organisation.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleOUT>> {
            return localVarFp.concularApiV1RoutersOrganisationsGetAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * It will return a list of the organisations that related to a user\'s email domain. Organisation should have domain configured.
         * @summary Get User Domain Related Organisations
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation
         * @param {string} organisationId
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildingOUT>> {
            return localVarFp.concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Special case for bulk building creation.
         * @summary Org Bulk Building Creation Json
         * @param {string} organisationId
         * @param {Array<BuildingIN>} buildingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId: string, buildingIN: Array<BuildingIN>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildingOUT>> {
            return localVarFp.concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId, buildingIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organisation. You can only pass the fields that you want to update.
         * @summary Update Organisation
         * @param {string} organisationId
         * @param {OrganisationUpdateIN} organisationUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId: string, organisationUpdateIN: OrganisationUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId, organisationUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload logo for the organisation.
         * @summary Upload Organisation Logo
         * @param {string} organisationId
         * @param {File} logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId: string, logo: File, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationOUT> {
            return localVarFp.concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId, logo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationsApi - object-oriented interface
 */
export class OrganisationsApi extends BaseAPI {
    /**
     * Adds the demo building to the organisation.
     * @summary Add Demo Building
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId: string, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsAddDemoBuilding(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an organisation. Creator will be an organisation admin.
     * @summary Create Organisation
     * @param {OrganisationIN} organisationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN: OrganisationIN, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsCreateOrganisation(organisationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organisation.
     * @summary Delete Organisation
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId: string, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsDeleteOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API will return all the organisations of the user.
     * @summary Get All Organisations
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsGetAllOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsGetAllOrganisations(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Available user roles for an organisation.
     * @summary Get All Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsGetAllRoles(options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsGetAllRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * It will return a list of the organisations that related to a user\'s email domain. Organisation should have domain configured.
     * @summary Get User Domain Related Organisations
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsGetUserDomainRelatedOrganisations(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Special case for bulk building creation.
     * @summary Org Bulk Building Creation
     * @param {string} organisationId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId: string, file: File, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsOrgBulkBuildingCreation(organisationId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Special case for bulk building creation.
     * @summary Org Bulk Building Creation Json
     * @param {string} organisationId
     * @param {Array<BuildingIN>} buildingIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId: string, buildingIN: Array<BuildingIN>, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsOrgBulkBuildingCreationJson(organisationId, buildingIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organisation. You can only pass the fields that you want to update.
     * @summary Update Organisation
     * @param {string} organisationId
     * @param {OrganisationUpdateIN} organisationUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId: string, organisationUpdateIN: OrganisationUpdateIN, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsUpdateOrganisation(organisationId, organisationUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload logo for the organisation.
     * @summary Upload Organisation Logo
     * @param {string} organisationId
     * @param {File} logo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId: string, logo: File, options?: RawAxiosRequestConfig) {
        return OrganisationsApiFp(this.configuration).concularApiV1RoutersOrganisationsUploadOrganisationLogo(organisationId, logo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PowerBIApi - axios parameter creator
 */
export const PowerBIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Embed Params
         * @param {string} reportId
         * @param {string} [additionalDatasetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersPowerbiGetEmbedParams: async (reportId: string, additionalDatasetId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportApiV1RoutersPowerbiGetEmbedParams', 'reportId', reportId)
            const localVarPath = `/api/v1/report/powerbi/embed-params/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (additionalDatasetId !== undefined) {
                localVarQueryParameter['additional_dataset_id'] = additionalDatasetId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PowerBIApi - functional programming interface
 */
export const PowerBIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PowerBIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Embed Params
         * @param {string} reportId
         * @param {string} [additionalDatasetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersPowerbiGetEmbedParams(reportId: string, additionalDatasetId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersPowerbiGetEmbedParams(reportId, additionalDatasetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PowerBIApi.reportApiV1RoutersPowerbiGetEmbedParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PowerBIApi - factory interface
 */
export const PowerBIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PowerBIApiFp(configuration)
    return {
        /**
         *
         * @summary Get Embed Params
         * @param {string} reportId
         * @param {string} [additionalDatasetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersPowerbiGetEmbedParams(reportId: string, additionalDatasetId?: string, options?: RawAxiosRequestConfig): AxiosPromise<EmbedConfig> {
            return localVarFp.reportApiV1RoutersPowerbiGetEmbedParams(reportId, additionalDatasetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PowerBIApi - object-oriented interface
 */
export class PowerBIApi extends BaseAPI {
    /**
     *
     * @summary Get Embed Params
     * @param {string} reportId
     * @param {string} [additionalDatasetId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersPowerbiGetEmbedParams(reportId: string, additionalDatasetId?: string, options?: RawAxiosRequestConfig) {
        return PowerBIApiFp(this.configuration).reportApiV1RoutersPowerbiGetEmbedParams(reportId, additionalDatasetId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessingRulesApi - axios parameter creator
 */
export const ProcessingRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Check Broken Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules', 'organisationId', organisationId)
            const localVarPath = `/api/v1/mapping_editor/processing_rules/broken_rules/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create A Processing Rule
         * @param {ProcessingRulesCreateIN} processingRulesCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule: async (processingRulesCreateIN: ProcessingRulesCreateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processingRulesCreateIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule', 'processingRulesCreateIN', processingRulesCreateIN)
            const localVarPath = `/api/v1/mapping_editor/processing_rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processingRulesCreateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Processing Rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule: async (ruleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule', 'ruleId', ruleId)
            const localVarPath = `/api/v1/mapping_editor/processing_rules/{rule_id}`
                .replace(`{${"rule_id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Processing Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesListProcessingRules: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesListProcessingRules', 'organisationId', organisationId)
            const localVarPath = `/api/v1/mapping_editor/processing_rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Organisational Property Browser
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser', 'organisationId', organisationId)
            const localVarPath = `/api/v1/mapping_editor/processing_rules/organisational_property_browser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Processing Rule
         * @param {number} ruleId
         * @param {ProcessingRuleUpdateIN} processingRuleUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule: async (ruleId: number, processingRuleUpdateIN: ProcessingRuleUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule', 'ruleId', ruleId)
            // verify required parameter 'processingRuleUpdateIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule', 'processingRuleUpdateIN', processingRuleUpdateIN)
            const localVarPath = `/api/v1/mapping_editor/processing_rules/{rule_id}`
                .replace(`{${"rule_id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processingRuleUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Processing Rule Orders
         * @param {Array<ProcessingRulesUpdateOrdersIN>} processingRulesUpdateOrdersIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders: async (processingRulesUpdateOrdersIN: Array<ProcessingRulesUpdateOrdersIN>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processingRulesUpdateOrdersIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders', 'processingRulesUpdateOrdersIN', processingRulesUpdateOrdersIN)
            const localVarPath = `/api/v1/mapping_editor/processing_rules/orders/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processingRulesUpdateOrdersIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingRulesApi - functional programming interface
 */
export const ProcessingRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessingRulesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Check Broken Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokenRulesOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create A Processing Rule
         * @param {ProcessingRulesCreateIN} processingRulesCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN: ProcessingRulesCreateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingRuleOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Processing Rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Processing Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessingRuleOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesListProcessingRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Organisational Property Browser
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyBrowserTreeNode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Processing Rule
         * @param {number} ruleId
         * @param {ProcessingRuleUpdateIN} processingRuleUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId: number, processingRuleUpdateIN: ProcessingRuleUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingRuleOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId, processingRuleUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Processing Rule Orders
         * @param {Array<ProcessingRulesUpdateOrdersIN>} processingRulesUpdateOrdersIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN: Array<ProcessingRulesUpdateOrdersIN>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessingRuleOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessingRulesApi.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessingRulesApi - factory interface
 */
export const ProcessingRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessingRulesApiFp(configuration)
    return {
        /**
         *
         * @summary Check Broken Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrokenRulesOUT> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create A Processing Rule
         * @param {ProcessingRulesCreateIN} processingRulesCreateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN: ProcessingRulesCreateIN, options?: RawAxiosRequestConfig): AxiosPromise<ProcessingRuleOUT> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Processing Rule
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Processing Rules
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessingRuleOUT>> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Organisational Property Browser
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PropertyBrowserTreeNode>> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Processing Rule
         * @param {number} ruleId
         * @param {ProcessingRuleUpdateIN} processingRuleUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId: number, processingRuleUpdateIN: ProcessingRuleUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<ProcessingRuleOUT> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId, processingRuleUpdateIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Processing Rule Orders
         * @param {Array<ProcessingRulesUpdateOrdersIN>} processingRulesUpdateOrdersIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN: Array<ProcessingRulesUpdateOrdersIN>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessingRuleOUT>> {
            return localVarFp.mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingRulesApi - object-oriented interface
 */
export class ProcessingRulesApi extends BaseAPI {
    /**
     *
     * @summary Check Broken Rules
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId: string, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesCheckBrokenRules(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create A Processing Rule
     * @param {ProcessingRulesCreateIN} processingRulesCreateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN: ProcessingRulesCreateIN, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesCreateAProcessingRule(processingRulesCreateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Processing Rule
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId: number, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesDeleteProcessingRule(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Processing Rules
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId: string, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesListProcessingRules(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Organisational Property Browser
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId: string, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesOrganisationalPropertyBrowser(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Processing Rule
     * @param {number} ruleId
     * @param {ProcessingRuleUpdateIN} processingRuleUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId: number, processingRuleUpdateIN: ProcessingRuleUpdateIN, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRule(ruleId, processingRuleUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Processing Rule Orders
     * @param {Array<ProcessingRulesUpdateOrdersIN>} processingRulesUpdateOrdersIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN: Array<ProcessingRulesUpdateOrdersIN>, options?: RawAxiosRequestConfig) {
        return ProcessingRulesApiFp(this.configuration).mappingEditorApiV1RoutersProcessingRulesUpdateProcessingRuleOrders(processingRulesUpdateOrdersIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductClassesApi - axios parameter creator
 */
export const ProductClassesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Product Classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductClassesGetProductClasses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/product_classes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductClassesApi - functional programming interface
 */
export const ProductClassesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductClassesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Product Classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductClassesGetProductClasses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductClassWithConfigsOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductClassesGetProductClasses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductClassesApi.buildingProductsApiV1RoutersProductClassesGetProductClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductClassesApi - factory interface
 */
export const ProductClassesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductClassesApiFp(configuration)
    return {
        /**
         *
         * @summary Get Product Classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductClassesGetProductClasses(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductClassWithConfigsOUT>> {
            return localVarFp.buildingProductsApiV1RoutersProductClassesGetProductClasses(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductClassesApi - object-oriented interface
 */
export class ProductClassesApi extends BaseAPI {
    /**
     *
     * @summary Get Product Classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductClassesGetProductClasses(options?: RawAxiosRequestConfig) {
        return ProductClassesApiFp(this.configuration).buildingProductsApiV1RoutersProductClassesGetProductClasses(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductEditorApi - axios parameter creator
 */
export const ProductEditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorCheckEpdGroups: async (ePDGroupsCheckIN: EPDGroupsCheckIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDGroupsCheckIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorCheckEpdGroups', 'ePDGroupsCheckIN', ePDGroupsCheckIN)
            const localVarPath = `/api/v1/inventory/product_editor/check_epd_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDGroupsCheckIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorCheckEpdSpecifications: async (ePDSpecificationCheckIN: EPDSpecificationCheckIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDSpecificationCheckIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorCheckEpdSpecifications', 'ePDSpecificationCheckIN', ePDSpecificationCheckIN)
            const localVarPath = `/api/v1/inventory/product_editor/check_epd_specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDSpecificationCheckIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct', 'productId', productId)
            const localVarPath = `/api/v1/inventory/product_editor/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorEditCustomBuildingProduct: async (productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorEditCustomBuildingProduct', 'productId', productId)
            // verify required parameter 'customBuildingProductEditIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorEditCustomBuildingProduct', 'customBuildingProductEditIN', customBuildingProductEditIN)
            const localVarPath = `/api/v1/inventory/product_editor/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customBuildingProductEditIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetCategories: async (categorySystem?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/product_editor/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (categorySystem !== undefined) {
                localVarQueryParameter['category_system'] = categorySystem;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetCpxValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/product_editor/cpx_values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Databases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdDatabases: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/product_editor/epd_databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Detail
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdDetail: async (epdId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epdId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorGetEpdDetail', 'epdId', epdId)
            const localVarPath = `/api/v1/inventory/product_editor/epds/{epd_id}`
                .replace(`{${"epd_id"}}`, encodeURIComponent(String(epdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Filter Options
         * @param {InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum} fieldName
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdFilterOptions: async (fieldName: InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum, searchTerm?: string | null, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldName' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorGetEpdFilterOptions', 'fieldName', fieldName)
            const localVarPath = `/api/v1/inventory/product_editor/epds/filters/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (fieldName !== undefined) {
                localVarQueryParameter['field_name'] = fieldName;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Epd Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/product_editor/epd_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct: async (customBuildingProductIN: CustomBuildingProductIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customBuildingProductIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct', 'customBuildingProductIN', customBuildingProductIN)
            const localVarPath = `/api/v1/inventory/product_editor/building_products/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customBuildingProductIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Epds
         * @param {EPDSearchIN} ePDSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {EPDSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorSearchEpds: async (ePDSearchIN: EPDSearchIN, sortOrder?: SortOrder | null, sortBy?: EPDSearchSortBy | null, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ePDSearchIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorSearchEpds', 'ePDSearchIN', ePDSearchIN)
            const localVarPath = `/api/v1/inventory/product_editor/search/epds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ePDSearchIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorSearchMaterials: async (materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialSearchIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorSearchMaterials', 'materialSearchIN', materialSearchIN)
            const localVarPath = `/api/v1/inventory/product_editor/search/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(materialSearchIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct: async (retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retoolBuildingProductUpsertIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct', 'retoolBuildingProductUpsertIN', retoolBuildingProductUpsertIN)
            const localVarPath = `/api/v1/inventory/product_editor/retool/upsert_building_product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retoolBuildingProductUpsertIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductEditorApi - functional programming interface
 */
export const ProductEditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductEditorApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDGroupsCheckOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorCheckEpdGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpdSpecificationCheckOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorCheckEpdSpecifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomBuildingProductEditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorEditCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetCategories(categorySystem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CPXValueOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetCpxValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetCpxValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Databases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetEpdDatabases(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetEpdDatabases(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetEpdDatabases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Detail
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetEpdDetail(epdId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EPDDetailOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetEpdDetail(epdId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetEpdDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Filter Options
         * @param {InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum} fieldName
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName: InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEPDFilterOptionsOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName, searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetEpdFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Epd Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorGetEpdTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorGetEpdTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorGetEpdTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomBuildingProductOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Epds
         * @param {EPDSearchIN} ePDSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {EPDSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN: EPDSearchIN, sortOrder?: SortOrder | null, sortBy?: EPDSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedEPDSearchOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN, sortOrder, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorSearchEpds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMaterialSearchOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorSearchMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetoolBuildingProductUpsertOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductEditorApi.inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductEditorApi - factory interface
 */
export const ProductEditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductEditorApiFp(configuration)
    return {
        /**
         * This endpoint checks the combination of the compliance of multiple epd groups.
         * @summary Check Epd Groups
         * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig): AxiosPromise<EPDGroupsCheckOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
         * @summary Check Epd Specifications
         * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig): AxiosPromise<EpdSpecificationCheckOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Custom Building Product
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit Custom Building Product
         * @param {string} productId
         * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig): AxiosPromise<CustomBuildingProductEditOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Categories
         * @param {string | null} [categorySystem]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryOUT>> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetCategories(categorySystem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Cpx Values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<CPXValueOUT>> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetCpxValues(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Databases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdDatabases(options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetEpdDatabases(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Detail
         * @param {string} epdId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdDetail(epdId: string, options?: RawAxiosRequestConfig): AxiosPromise<EPDDetailOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetEpdDetail(epdId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Filter Options
         * @param {InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum} fieldName
         * @param {string | null} [searchTerm]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName: InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEPDFilterOptionsOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName, searchTerm, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Epd Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorGetEpdTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.inventoryApiV1RoutersProductEditorGetEpdTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint registers a custom building product to the database.
         * @summary Register Custom Building Product
         * @param {CustomBuildingProductIN} customBuildingProductIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig): AxiosPromise<CustomBuildingProductOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Epds
         * @param {EPDSearchIN} ePDSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {EPDSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN: EPDSearchIN, sortOrder?: SortOrder | null, sortBy?: EPDSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedEPDSearchOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Materials
         * @param {MaterialSearchIN} materialSearchIN
         * @param {SortOrder | null} [sortOrder]
         * @param {MaterialSearchSortBy | null} [sortBy]
         * @param {number} [page]
         * @param {number | null} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PagedMaterialSearchOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint registers new custom building product to the database or updates an existing one.
         * @summary Upsert Retool Building Product
         * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig): AxiosPromise<RetoolBuildingProductUpsertOUT> {
            return localVarFp.inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductEditorApi - object-oriented interface
 */
export class ProductEditorApi extends BaseAPI {
    /**
     * This endpoint checks the combination of the compliance of multiple epd groups.
     * @summary Check Epd Groups
     * @param {EPDGroupsCheckIN} ePDGroupsCheckIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN: EPDGroupsCheckIN, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorCheckEpdGroups(ePDGroupsCheckIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint checks if the given epd specifications have the same dataset_source and conformity. Also, it returns a list of certifications that are compliant for this epd group.
     * @summary Check Epd Specifications
     * @param {EPDSpecificationCheckIN} ePDSpecificationCheckIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN: EPDSpecificationCheckIN, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorCheckEpdSpecifications(ePDSpecificationCheckIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Custom Building Product
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId: string, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorDeleteCustomBuildingProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit Custom Building Product
     * @param {string} productId
     * @param {CustomBuildingProductEditIN} customBuildingProductEditIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId: string, customBuildingProductEditIN: CustomBuildingProductEditIN, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorEditCustomBuildingProduct(productId, customBuildingProductEditIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Categories
     * @param {string | null} [categorySystem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetCategories(categorySystem?: string | null, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetCategories(categorySystem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Cpx Values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetCpxValues(options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetCpxValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Databases
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetEpdDatabases(options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetEpdDatabases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Detail
     * @param {string} epdId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetEpdDetail(epdId: string, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetEpdDetail(epdId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Filter Options
     * @param {InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum} fieldName
     * @param {string | null} [searchTerm]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName: InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum, searchTerm?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetEpdFilterOptions(fieldName, searchTerm, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Epd Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorGetEpdTypes(options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorGetEpdTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint registers a custom building product to the database.
     * @summary Register Custom Building Product
     * @param {CustomBuildingProductIN} customBuildingProductIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN: CustomBuildingProductIN, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorRegisterCustomBuildingProduct(customBuildingProductIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Epds
     * @param {EPDSearchIN} ePDSearchIN
     * @param {SortOrder | null} [sortOrder]
     * @param {EPDSearchSortBy | null} [sortBy]
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN: EPDSearchIN, sortOrder?: SortOrder | null, sortBy?: EPDSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorSearchEpds(ePDSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Materials
     * @param {MaterialSearchIN} materialSearchIN
     * @param {SortOrder | null} [sortOrder]
     * @param {MaterialSearchSortBy | null} [sortBy]
     * @param {number} [page]
     * @param {number | null} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN: MaterialSearchIN, sortOrder?: SortOrder | null, sortBy?: MaterialSearchSortBy | null, page?: number, pageSize?: number | null, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorSearchMaterials(materialSearchIN, sortOrder, sortBy, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint registers new custom building product to the database or updates an existing one.
     * @summary Upsert Retool Building Product
     * @param {RetoolBuildingProductUpsertIN} retoolBuildingProductUpsertIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN: RetoolBuildingProductUpsertIN, options?: RawAxiosRequestConfig) {
        return ProductEditorApiFp(this.configuration).inventoryApiV1RoutersProductEditorUpsertRetoolBuildingProduct(retoolBuildingProductUpsertIN, options).then((request) => request(this.axios, this.basePath));
    }
}

export const InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum = {
    Database: 'database',
    ReferenceUnit: 'reference_unit',
    ConformityName: 'conformity__name',
    DataType: 'data_type'
} as const;
export type InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum = typeof InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum[keyof typeof InventoryApiV1RoutersProductEditorGetEpdFilterOptionsFieldNameEnum];


/**
 * ProductPropertyConfigurationApi - axios parameter creator
 */
export const ProductPropertyConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Property Configuration
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration: async (propertyConfigurationIN: PropertyConfigurationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyConfigurationIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration', 'propertyConfigurationIN', propertyConfigurationIN)
            const localVarPath = `/api/v1/building_products/property_configuration/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(propertyConfigurationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All Property Configs
         * @param {string} organisationId
         * @param {PropertyTypeChoices | null} [propertyType]
         * @param {string | null} [productClassId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs: async (organisationId: string, propertyType?: PropertyTypeChoices | null, productClassId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs', 'organisationId', organisationId)
            const localVarPath = `/api/v1/building_products/property_configuration/all/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (propertyType !== undefined) {
                localVarQueryParameter['property_type'] = propertyType;
            }

            if (productClassId !== undefined) {
                localVarQueryParameter['product_class_id'] = productClassId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Property Value In Use
         * @param {string} propertySlug
         * @param {string} organisationId
         * @param {string} propertyValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse: async (propertySlug: string, organisationId: string, propertyValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertySlug' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse', 'propertySlug', propertySlug)
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse', 'organisationId', organisationId)
            // verify required parameter 'propertyValue' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse', 'propertyValue', propertyValue)
            const localVarPath = `/api/v1/building_products/property_configuration/property_value_in_use/{property_slug}`
                .replace(`{${"property_slug"}}`, encodeURIComponent(String(propertySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }

            if (propertyValue !== undefined) {
                localVarQueryParameter['property_value'] = propertyValue;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Single Property Config
         * @param {string} slug
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig: async (slug: string, organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig', 'slug', slug)
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig', 'organisationId', organisationId)
            const localVarPath = `/api/v1/building_products/property_configuration/single/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove Property Configuration
         * @param {string} organisationId
         * @param {string} propertySlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration: async (organisationId: string, propertySlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration', 'organisationId', organisationId)
            // verify required parameter 'propertySlug' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration', 'propertySlug', propertySlug)
            const localVarPath = `/api/v1/building_products/property_configuration/{organisation_id}/{property_slug}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"property_slug"}}`, encodeURIComponent(String(propertySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Ordering
         * @param {string} organisationId
         * @param {PropertyOrderingIN} propertyOrderingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering: async (organisationId: string, propertyOrderingIN: PropertyOrderingIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering', 'organisationId', organisationId)
            // verify required parameter 'propertyOrderingIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering', 'propertyOrderingIN', propertyOrderingIN)
            const localVarPath = `/api/v1/building_products/property_configuration/order_properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(propertyOrderingIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Property Configuration
         * @param {string} propertySlug
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration: async (propertySlug: string, propertyConfigurationIN: PropertyConfigurationIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertySlug' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration', 'propertySlug', propertySlug)
            // verify required parameter 'propertyConfigurationIN' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration', 'propertyConfigurationIN', propertyConfigurationIN)
            const localVarPath = `/api/v1/building_products/property_configuration/{property_slug}`
                .replace(`{${"property_slug"}}`, encodeURIComponent(String(propertySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(propertyConfigurationIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPropertyConfigurationApi - functional programming interface
 */
export const ProductPropertyConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPropertyConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Property Configuration
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyConfigurationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get All Property Configs
         * @param {string} organisationId
         * @param {PropertyTypeChoices | null} [propertyType]
         * @param {string | null} [productClassId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId: string, propertyType?: PropertyTypeChoices | null, productClassId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyConfigurationOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId, propertyType, productClassId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Property Value In Use
         * @param {string} propertySlug
         * @param {string} organisationId
         * @param {string} propertyValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug: string, organisationId: string, propertyValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsedPropertiesOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug, organisationId, propertyValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Single Property Config
         * @param {string} slug
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug: string, organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyConfigurationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove Property Configuration
         * @param {string} organisationId
         * @param {string} propertySlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId: string, propertySlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId, propertySlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Ordering
         * @param {string} organisationId
         * @param {PropertyOrderingIN} propertyOrderingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId: string, propertyOrderingIN: PropertyOrderingIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId, propertyOrderingIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Property Configuration
         * @param {string} propertySlug
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug: string, propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyConfigurationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug, propertyConfigurationIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductPropertyConfigurationApi.buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductPropertyConfigurationApi - factory interface
 */
export const ProductPropertyConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPropertyConfigurationApiFp(configuration)
    return {
        /**
         *
         * @summary Create Property Configuration
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig): AxiosPromise<PropertyConfigurationOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All Property Configs
         * @param {string} organisationId
         * @param {PropertyTypeChoices | null} [propertyType]
         * @param {string | null} [productClassId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId: string, propertyType?: PropertyTypeChoices | null, productClassId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PropertyConfigurationOUT>> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId, propertyType, productClassId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Property Value In Use
         * @param {string} propertySlug
         * @param {string} organisationId
         * @param {string} propertyValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug: string, organisationId: string, propertyValue: string, options?: RawAxiosRequestConfig): AxiosPromise<UsedPropertiesOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug, organisationId, propertyValue, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Single Property Config
         * @param {string} slug
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug: string, organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<PropertyConfigurationOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove Property Configuration
         * @param {string} organisationId
         * @param {string} propertySlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId: string, propertySlug: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId, propertySlug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Ordering
         * @param {string} organisationId
         * @param {PropertyOrderingIN} propertyOrderingIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId: string, propertyOrderingIN: PropertyOrderingIN, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId, propertyOrderingIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Property Configuration
         * @param {string} propertySlug
         * @param {PropertyConfigurationIN} propertyConfigurationIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug: string, propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig): AxiosPromise<PropertyConfigurationOUT> {
            return localVarFp.buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug, propertyConfigurationIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductPropertyConfigurationApi - object-oriented interface
 */
export class ProductPropertyConfigurationApi extends BaseAPI {
    /**
     *
     * @summary Create Property Configuration
     * @param {PropertyConfigurationIN} propertyConfigurationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationCreatePropertyConfiguration(propertyConfigurationIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get All Property Configs
     * @param {string} organisationId
     * @param {PropertyTypeChoices | null} [propertyType]
     * @param {string | null} [productClassId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId: string, propertyType?: PropertyTypeChoices | null, productClassId?: string | null, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationGetAllPropertyConfigs(organisationId, propertyType, productClassId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Property Value In Use
     * @param {string} propertySlug
     * @param {string} organisationId
     * @param {string} propertyValue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug: string, organisationId: string, propertyValue: string, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationGetPropertyValueInUse(propertySlug, organisationId, propertyValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Single Property Config
     * @param {string} slug
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug: string, organisationId: string, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationGetSinglePropertyConfig(slug, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Remove Property Configuration
     * @param {string} organisationId
     * @param {string} propertySlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId: string, propertySlug: string, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationRemovePropertyConfiguration(organisationId, propertySlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Ordering
     * @param {string} organisationId
     * @param {PropertyOrderingIN} propertyOrderingIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId: string, propertyOrderingIN: PropertyOrderingIN, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationUpdateOrdering(organisationId, propertyOrderingIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Property Configuration
     * @param {string} propertySlug
     * @param {PropertyConfigurationIN} propertyConfigurationIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug: string, propertyConfigurationIN: PropertyConfigurationIN, options?: RawAxiosRequestConfig) {
        return ProductPropertyConfigurationApiFp(this.configuration).buildingProductsApiV1RoutersPropertyConfigurationUpdatePropertyConfiguration(propertySlug, propertyConfigurationIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductSearchApi - axios parameter creator
 */
export const ProductSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineMaterials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/search_engine/search/materials/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Product Din Categories
         * @param {BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductDinCategories: async (level?: BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/search_engine/search/product-din-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Product Din Categories By Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/building_products/search_engine/search/product-din-categories-by-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Product Search Ai Query
         * @param {string} objectId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery: async (objectId: string, organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery', 'objectId', objectId)
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery', 'organisationId', organisationId)
            const localVarPath = `/api/v1/building_products/search_engine/search/ai_search_query/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineSearchProducts: async (productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productSearchInput' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersSearchEngineSearchProducts', 'productSearchInput', productSearchInput)
            const localVarPath = `/api/v1/building_products/search_engine/search/products/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineSearchUsedProducts: async (organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersSearchEngineSearchUsedProducts', 'organisationId', organisationId)
            const localVarPath = `/api/v1/building_products/search_engine/search/used_products/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSearchApi - functional programming interface
 */
export const ProductSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSearchApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleMaterialOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineMaterials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Product Din Categories
         * @param {BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineProductDinCategories(level?: BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchEngineCategoryOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineProductDinCategories(level, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineProductDinCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Product Din Categories By Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDinCategoryByLevelOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Product Search Ai Query
         * @param {string} objectId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId: string, organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GermanSearchQuery>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalPaginatedProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineSearchProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalPaginatedProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSearchApi.buildingProductsApiV1RoutersSearchEngineSearchUsedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductSearchApi - factory interface
 */
export const ProductSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSearchApiFp(configuration)
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleMaterialOut>> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineMaterials(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Product Din Categories
         * @param {BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductDinCategories(level?: BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchEngineCategoryOUT>> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineProductDinCategories(level, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Product Din Categories By Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options?: RawAxiosRequestConfig): AxiosPromise<ProductDinCategoryByLevelOUT> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Product Search Ai Query
         * @param {string} objectId
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId: string, organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GermanSearchQuery> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<InternalPaginatedProductSearchOutput> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<InternalPaginatedProductSearchOutput> {
            return localVarFp.buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductSearchApi - object-oriented interface
 */
export class ProductSearchApi extends BaseAPI {
    /**
     *
     * @summary Materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineMaterials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Product Din Categories
     * @param {BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineProductDinCategories(level?: BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineProductDinCategories(level, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Product Din Categories By Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineProductDinCategoriesByLevel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Product Search Ai Query
     * @param {string} objectId
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId: string, organisationId: string, options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineProductSearchAiQuery(objectId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Products
     * @param {ProductSearchInput} productSearchInput
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Used Products
     * @param {string} organisationId
     * @param {string | null} [buildingId]
     * @param {string | null} [searchQuery]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).buildingProductsApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

export const BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum = {
    Level1: 'level_1',
    Level2: 'level_2',
    Level3: 'level_3'
} as const;
export type BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum = typeof BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum[keyof typeof BuildingProductsApiV1RoutersSearchEngineProductDinCategoriesLevelEnum];


/**
 * ProductsAndComponentsApi - axios parameter creator
 */
export const ProductsAndComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsDetailsByFile: async (productId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsDetailsByFile', 'productId', productId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsDetailsByFile', 'fileId', fileId)
            const localVarPath = `/api/v1/building_products/product/details_by_file/{product_id}/{file_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsGetProductSearchDetails: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsGetProductSearchDetails', 'productId', productId)
            const localVarPath = `/api/v1/building_products/product/search_details/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Products
         * @param {string} organisationId
         * @param {string | null} [search]
         * @param {string | null} [dinCategoryNumber]
         * @param {boolean | null} [isPublished]
         * @param {boolean} [paginate]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsListProducts: async (organisationId: string, search?: string | null, dinCategoryNumber?: string | null, isPublished?: boolean | null, paginate?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsListProducts', 'organisationId', organisationId)
            const localVarPath = `/api/v1/building_products/product/list/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (dinCategoryNumber !== undefined) {
                localVarQueryParameter['din_category_number'] = dinCategoryNumber;
            }

            if (isPublished !== undefined) {
                localVarQueryParameter['is_published'] = isPublished;
            }

            if (paginate !== undefined) {
                localVarQueryParameter['paginate'] = paginate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Publish Product
         * @param {string} productId
         * @param {string} organisationId
         * @param {BuildingProductsApiV1RoutersProductsPublishProductActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsPublishProduct: async (productId: string, organisationId: string, action: BuildingProductsApiV1RoutersProductsPublishProductActionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsPublishProduct', 'productId', productId)
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsPublishProduct', 'organisationId', organisationId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('buildingProductsApiV1RoutersProductsPublishProduct', 'action', action)
            const localVarPath = `/api/v1/building_products/product/publish_product/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisation_id'] = organisationId;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsAndComponentsApi - functional programming interface
 */
export const ProductsAndComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsAndComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryProductDetailsByFileOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductsDetailsByFile(productId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsAndComponentsApi.buildingProductsApiV1RoutersProductsDetailsByFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsAndComponentsApi.buildingProductsApiV1RoutersProductsGetProductSearchDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List Products
         * @param {string} organisationId
         * @param {string | null} [search]
         * @param {string | null} [dinCategoryNumber]
         * @param {boolean | null} [isPublished]
         * @param {boolean} [paginate]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductsListProducts(organisationId: string, search?: string | null, dinCategoryNumber?: string | null, isPublished?: boolean | null, paginate?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListPaginatedOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductsListProducts(organisationId, search, dinCategoryNumber, isPublished, paginate, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsAndComponentsApi.buildingProductsApiV1RoutersProductsListProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Publish Product
         * @param {string} productId
         * @param {string} organisationId
         * @param {BuildingProductsApiV1RoutersProductsPublishProductActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildingProductsApiV1RoutersProductsPublishProduct(productId: string, organisationId: string, action: BuildingProductsApiV1RoutersProductsPublishProductActionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildingProductsApiV1RoutersProductsPublishProduct(productId, organisationId, action, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsAndComponentsApi.buildingProductsApiV1RoutersProductsPublishProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsAndComponentsApi - factory interface
 */
export const ProductsAndComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsAndComponentsApiFp(configuration)
    return {
        /**
         *
         * @summary Details By File
         * @param {string} productId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<InventoryProductDetailsByFileOut> {
            return localVarFp.buildingProductsApiV1RoutersProductsDetailsByFile(productId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Details of a single product including EPD Groups
         * @summary Get Product Search Details
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<InternalProductSearchOutput> {
            return localVarFp.buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Products
         * @param {string} organisationId
         * @param {string | null} [search]
         * @param {string | null} [dinCategoryNumber]
         * @param {boolean | null} [isPublished]
         * @param {boolean} [paginate]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsListProducts(organisationId: string, search?: string | null, dinCategoryNumber?: string | null, isPublished?: boolean | null, paginate?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductListPaginatedOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductsListProducts(organisationId, search, dinCategoryNumber, isPublished, paginate, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Publish Product
         * @param {string} productId
         * @param {string} organisationId
         * @param {BuildingProductsApiV1RoutersProductsPublishProductActionEnum} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingProductsApiV1RoutersProductsPublishProduct(productId: string, organisationId: string, action: BuildingProductsApiV1RoutersProductsPublishProductActionEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.buildingProductsApiV1RoutersProductsPublishProduct(productId, organisationId, action, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsAndComponentsApi - object-oriented interface
 */
export class ProductsAndComponentsApi extends BaseAPI {
    /**
     *
     * @summary Details By File
     * @param {string} productId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductsDetailsByFile(productId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return ProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersProductsDetailsByFile(productId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Details of a single product including EPD Groups
     * @summary Get Product Search Details
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId: string, options?: RawAxiosRequestConfig) {
        return ProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersProductsGetProductSearchDetails(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Products
     * @param {string} organisationId
     * @param {string | null} [search]
     * @param {string | null} [dinCategoryNumber]
     * @param {boolean | null} [isPublished]
     * @param {boolean} [paginate]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductsListProducts(organisationId: string, search?: string | null, dinCategoryNumber?: string | null, isPublished?: boolean | null, paginate?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersProductsListProducts(organisationId, search, dinCategoryNumber, isPublished, paginate, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Publish Product
     * @param {string} productId
     * @param {string} organisationId
     * @param {BuildingProductsApiV1RoutersProductsPublishProductActionEnum} action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildingProductsApiV1RoutersProductsPublishProduct(productId: string, organisationId: string, action: BuildingProductsApiV1RoutersProductsPublishProductActionEnum, options?: RawAxiosRequestConfig) {
        return ProductsAndComponentsApiFp(this.configuration).buildingProductsApiV1RoutersProductsPublishProduct(productId, organisationId, action, options).then((request) => request(this.axios, this.basePath));
    }
}

export const BuildingProductsApiV1RoutersProductsPublishProductActionEnum = {
    Publish: 'publish',
    Unpublish: 'unpublish'
} as const;
export type BuildingProductsApiV1RoutersProductsPublishProductActionEnum = typeof BuildingProductsApiV1RoutersProductsPublishProductActionEnum[keyof typeof BuildingProductsApiV1RoutersProductsPublishProductActionEnum];


/**
 * PropertyBrowserApi - axios parameter creator
 */
export const PropertyBrowserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Building Scope Nodes
         * @param {string} buildingId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes: async (buildingId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes', 'buildingId', buildingId)
            const localVarPath = `/api/v1/mapping_editor/property_browser/building/{building_id}/nodes`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (parentNodeId !== undefined) {
                localVarQueryParameter['parent_node_id'] = parentNodeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary File Scope Nodes
         * @param {string} fileId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes: async (fileId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes', 'fileId', fileId)
            const localVarPath = `/api/v1/mapping_editor/property_browser/file/{file_id}/nodes`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (parentNodeId !== undefined) {
                localVarQueryParameter['parent_node_id'] = parentNodeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (viewName !== undefined) {
                localVarQueryParameter['view_name'] = viewName;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a list of (column_key, column_source) pairs to browser leaf nodes.  Returns a dict keyed by f\"{column_source}:{column_key}\". Unrecognised pairs are silently omitted. Scoped to the same \"Object properties\" subtree as `organisation_scope_nodes`.
         * @summary Organisation Resolve Nodes
         * @param {string} organisationId
         * @param {ResolveNodesIN} resolveNodesIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes: async (organisationId: string, resolveNodesIN: ResolveNodesIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes', 'organisationId', organisationId)
            // verify required parameter 'resolveNodesIN' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes', 'resolveNodesIN', resolveNodesIN)
            const localVarPath = `/api/v1/mapping_editor/property_browser/organisation/{organisation_id}/resolve-nodes`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveNodesIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Organisation Scope Nodes
         * @param {string} organisationId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes: async (organisationId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes', 'organisationId', organisationId)
            const localVarPath = `/api/v1/mapping_editor/property_browser/organisation/{organisation_id}/nodes`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (parentNodeId !== undefined) {
                localVarQueryParameter['parent_node_id'] = parentNodeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertyBrowserApi - functional programming interface
 */
export const PropertyBrowserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertyBrowserApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Building Scope Nodes
         * @param {string} buildingId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBrowserNodesPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId, parentNodeId, search, page, pageSize, viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertyBrowserApi.mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary File Scope Nodes
         * @param {string} fileId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBrowserNodesPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId, parentNodeId, search, page, pageSize, viewName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertyBrowserApi.mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a list of (column_key, column_source) pairs to browser leaf nodes.  Returns a dict keyed by f\"{column_source}:{column_key}\". Unrecognised pairs are silently omitted. Scoped to the same \"Object properties\" subtree as `organisation_scope_nodes`.
         * @summary Organisation Resolve Nodes
         * @param {string} organisationId
         * @param {ResolveNodesIN} resolveNodesIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId: string, resolveNodesIN: ResolveNodesIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: PropertyBrowserNodeOUT; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId, resolveNodesIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertyBrowserApi.mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Organisation Scope Nodes
         * @param {string} organisationId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBrowserNodesPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId, parentNodeId, search, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertyBrowserApi.mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropertyBrowserApi - factory interface
 */
export const PropertyBrowserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertyBrowserApiFp(configuration)
    return {
        /**
         *
         * @summary Building Scope Nodes
         * @param {string} buildingId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<PropertyBrowserNodesPage> {
            return localVarFp.mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId, parentNodeId, search, page, pageSize, viewName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary File Scope Nodes
         * @param {string} fileId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum} [viewName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum, options?: RawAxiosRequestConfig): AxiosPromise<PropertyBrowserNodesPage> {
            return localVarFp.mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId, parentNodeId, search, page, pageSize, viewName, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a list of (column_key, column_source) pairs to browser leaf nodes.  Returns a dict keyed by f\"{column_source}:{column_key}\". Unrecognised pairs are silently omitted. Scoped to the same \"Object properties\" subtree as `organisation_scope_nodes`.
         * @summary Organisation Resolve Nodes
         * @param {string} organisationId
         * @param {ResolveNodesIN} resolveNodesIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId: string, resolveNodesIN: ResolveNodesIN, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: PropertyBrowserNodeOUT; }> {
            return localVarFp.mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId, resolveNodesIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Organisation Scope Nodes
         * @param {string} organisationId
         * @param {string | null} [parentNodeId]
         * @param {string | null} [search]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PropertyBrowserNodesPage> {
            return localVarFp.mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId, parentNodeId, search, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertyBrowserApi - object-oriented interface
 */
export class PropertyBrowserApi extends BaseAPI {
    /**
     *
     * @summary Building Scope Nodes
     * @param {string} buildingId
     * @param {string | null} [parentNodeId]
     * @param {string | null} [search]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum} [viewName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum, options?: RawAxiosRequestConfig) {
        return PropertyBrowserApiFp(this.configuration).mappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodes(buildingId, parentNodeId, search, page, pageSize, viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary File Scope Nodes
     * @param {string} fileId
     * @param {string | null} [parentNodeId]
     * @param {string | null} [search]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum} [viewName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, viewName?: MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum, options?: RawAxiosRequestConfig) {
        return PropertyBrowserApiFp(this.configuration).mappingEditorApiV1RoutersPropertyBrowserFileScopeNodes(fileId, parentNodeId, search, page, pageSize, viewName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a list of (column_key, column_source) pairs to browser leaf nodes.  Returns a dict keyed by f\"{column_source}:{column_key}\". Unrecognised pairs are silently omitted. Scoped to the same \"Object properties\" subtree as `organisation_scope_nodes`.
     * @summary Organisation Resolve Nodes
     * @param {string} organisationId
     * @param {ResolveNodesIN} resolveNodesIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId: string, resolveNodesIN: ResolveNodesIN, options?: RawAxiosRequestConfig) {
        return PropertyBrowserApiFp(this.configuration).mappingEditorApiV1RoutersPropertyBrowserOrganisationResolveNodes(organisationId, resolveNodesIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Organisation Scope Nodes
     * @param {string} organisationId
     * @param {string | null} [parentNodeId]
     * @param {string | null} [search]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId: string, parentNodeId?: string | null, search?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return PropertyBrowserApiFp(this.configuration).mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(organisationId, parentNodeId, search, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

export const MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum = typeof MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum[keyof typeof MappingEditorApiV1RoutersPropertyBrowserBuildingScopeNodesViewNameEnum];
export const MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum = {
    Dme: 'DME',
    Exports: 'EXPORTS',
    Inventory: 'INVENTORY',
    Rbm: 'RBM',
    DetailView: 'DETAIL_VIEW',
    Dashboard: 'DASHBOARD',
    HotspotAnalysis: 'HOTSPOT_ANALYSIS'
} as const;
export type MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum = typeof MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum[keyof typeof MappingEditorApiV1RoutersPropertyBrowserFileScopeNodesViewNameEnum];


/**
 * ReportBuildingsApi - axios parameter creator
 */
export const ReportBuildingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Delete Building Exported Certification
         * @param {string} buildingId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingDeleteBuildingExportedCertification: async (buildingId: string, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingDeleteBuildingExportedCertification', 'buildingId', buildingId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingDeleteBuildingExportedCertification', 'reportId', reportId)
            const localVarPath = `/api/v1/report/buildings/{building_id}/reports/{report_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Embed Url
         * @param {RetoolEmbedIN} retoolEmbedIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingEmbedUrl: async (retoolEmbedIN: RetoolEmbedIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retoolEmbedIN' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingEmbedUrl', 'retoolEmbedIN', retoolEmbedIN)
            const localVarPath = `/api/v1/report/buildings/retool/embed_url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retoolEmbedIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Export Master Tool Like
         * @param {string} buildingId
         * @param {MasterToolExportIN} masterToolExportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingExportMasterToolLike: async (buildingId: string, masterToolExportIN: MasterToolExportIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingExportMasterToolLike', 'buildingId', buildingId)
            // verify required parameter 'masterToolExportIN' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingExportMasterToolLike', 'masterToolExportIN', masterToolExportIN)
            const localVarPath = `/api/v1/report/buildings/{building_id}/export_master_tool_like`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(masterToolExportIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Building Exported Certifications
         * @param {string} buildingId
         * @param {ExportStatusEnum | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingExportedCertifications: async (buildingId: string, status?: ExportStatusEnum | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingGetBuildingExportedCertifications', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/buildings/{building_id}/reports`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Building Pdf Report
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingPdfReport: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingGetBuildingPdfReport', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/buildings/{building_id}/pdf_report`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Building Report Content
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingReportContent: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('reportApiV1RoutersBuildingGetBuildingReportContent', 'buildingId', buildingId)
            const localVarPath = `/api/v1/report/buildings/{building_id}/report_content`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportBuildingsApi - functional programming interface
 */
export const ReportBuildingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportBuildingsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Delete Building Exported Certification
         * @param {string} buildingId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId: string, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingDeleteBuildingExportedCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Embed Url
         * @param {RetoolEmbedIN} retoolEmbedIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN: RetoolEmbedIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetoolEmbedOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingEmbedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Export Master Tool Like
         * @param {string} buildingId
         * @param {MasterToolExportIN} masterToolExportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingExportMasterToolLike(buildingId: string, masterToolExportIN: MasterToolExportIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingExportMasterToolLike(buildingId, masterToolExportIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingExportMasterToolLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Building Exported Certifications
         * @param {string} buildingId
         * @param {ExportStatusEnum | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId: string, status?: ExportStatusEnum | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingReportOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingGetBuildingExportedCertifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Building Pdf Report
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingGetBuildingPdfReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Building Report Content
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportApiV1RoutersBuildingGetBuildingReportContent(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportApiV1RoutersBuildingGetBuildingReportContent(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportBuildingsApi.reportApiV1RoutersBuildingGetBuildingReportContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportBuildingsApi - factory interface
 */
export const ReportBuildingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportBuildingsApiFp(configuration)
    return {
        /**
         *
         * @summary Delete Building Exported Certification
         * @param {string} buildingId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId: string, reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Embed Url
         * @param {RetoolEmbedIN} retoolEmbedIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN: RetoolEmbedIN, options?: RawAxiosRequestConfig): AxiosPromise<RetoolEmbedOUT> {
            return localVarFp.reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export Master Tool Like
         * @param {string} buildingId
         * @param {MasterToolExportIN} masterToolExportIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingExportMasterToolLike(buildingId: string, masterToolExportIN: MasterToolExportIN, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.reportApiV1RoutersBuildingExportMasterToolLike(buildingId, masterToolExportIN, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Building Exported Certifications
         * @param {string} buildingId
         * @param {ExportStatusEnum | null} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId: string, status?: ExportStatusEnum | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<BuildingReportOUT>> {
            return localVarFp.reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Building Pdf Report
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Building Report Content
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportApiV1RoutersBuildingGetBuildingReportContent(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reportApiV1RoutersBuildingGetBuildingReportContent(buildingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportBuildingsApi - object-oriented interface
 */
export class ReportBuildingsApi extends BaseAPI {
    /**
     *
     * @summary Delete Building Exported Certification
     * @param {string} buildingId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId: string, reportId: string, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingDeleteBuildingExportedCertification(buildingId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Embed Url
     * @param {RetoolEmbedIN} retoolEmbedIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN: RetoolEmbedIN, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingEmbedUrl(retoolEmbedIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Export Master Tool Like
     * @param {string} buildingId
     * @param {MasterToolExportIN} masterToolExportIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingExportMasterToolLike(buildingId: string, masterToolExportIN: MasterToolExportIN, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingExportMasterToolLike(buildingId, masterToolExportIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Building Exported Certifications
     * @param {string} buildingId
     * @param {ExportStatusEnum | null} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId: string, status?: ExportStatusEnum | null, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingGetBuildingExportedCertifications(buildingId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Building Pdf Report
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId: string, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingGetBuildingPdfReport(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Building Report Content
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportApiV1RoutersBuildingGetBuildingReportContent(buildingId: string, options?: RawAxiosRequestConfig) {
        return ReportBuildingsApiFp(this.configuration).reportApiV1RoutersBuildingGetBuildingReportContent(buildingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepositoriesApi - axios parameter creator
 */
export const RepositoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Audits By Building Id
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetAuditsByBuildingId: async (buildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('caApiV1RoutersRepositoryGetAuditsByBuildingId', 'buildingId', buildingId)
            const localVarPath = `/api/v1/ca/repositories/building/{building_id}/audits`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all fields
         * @summary Get Fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetFields: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/repositories/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetFieldsets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/repositories/fieldsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetManufacturers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/repositories/manufacturers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetProductGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/repositories/product_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetSlimProductGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/repositories/product_groups/slim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups Id
         * @param {string} productGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetSlimProductGroupsId: async (productGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productGroupId' is not null or undefined
            assertParamExists('caApiV1RoutersRepositoryGetSlimProductGroupsId', 'productGroupId', productGroupId)
            const localVarPath = `/api/v1/ca/repositories/product_groups/slim/{product_group_id}`
                .replace(`{${"product_group_id"}}`, encodeURIComponent(String(productGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepositoriesApi - functional programming interface
 */
export const RepositoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepositoriesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Audits By Building Id
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetAuditsByBuildingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all fields
         * @summary Get Fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetFields(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetFields(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetFieldsets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlimFieldSetOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetFieldsets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetFieldsets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetManufacturers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManufacturerOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetManufacturers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetManufacturers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetProductGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductGroupOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetProductGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetProductGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetSlimProductGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlimProductGroupOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetSlimProductGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetSlimProductGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups Id
         * @param {string} productGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlimProductGroupOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoriesApi.caApiV1RoutersRepositoryGetSlimProductGroupsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepositoriesApi - factory interface
 */
export const RepositoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepositoriesApiFp(configuration)
    return {
        /**
         *
         * @summary Get Audits By Building Id
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all fields
         * @summary Get Fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetFields(options?: RawAxiosRequestConfig): AxiosPromise<Array<FieldOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetFields(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all active fieldsets
         * @summary Get Fieldsets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetFieldsets(options?: RawAxiosRequestConfig): AxiosPromise<Array<SlimFieldSetOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetFieldsets(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all manufacturers.
         * @summary Get Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetManufacturers(options?: RawAxiosRequestConfig): AxiosPromise<Array<ManufacturerOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetManufacturers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all product groups
         * @summary Get Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetProductGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductGroupOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetProductGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetSlimProductGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<SlimProductGroupOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetSlimProductGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all product groups without field options
         * @summary Get Slim Product Groups Id
         * @param {string} productGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlimProductGroupOUT>> {
            return localVarFp.caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepositoriesApi - object-oriented interface
 */
export class RepositoriesApi extends BaseAPI {
    /**
     *
     * @summary Get Audits By Building Id
     * @param {string} buildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId: string, options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetAuditsByBuildingId(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all fields
     * @summary Get Fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetFields(options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetFields(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all active fieldsets
     * @summary Get Fieldsets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetFieldsets(options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetFieldsets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all manufacturers.
     * @summary Get Manufacturers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetManufacturers(options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetManufacturers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all product groups
     * @summary Get Product Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetProductGroups(options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetProductGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all product groups without field options
     * @summary Get Slim Product Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetSlimProductGroups(options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetSlimProductGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all product groups without field options
     * @summary Get Slim Product Groups Id
     * @param {string} productGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId: string, options?: RawAxiosRequestConfig) {
        return RepositoriesApiFp(this.configuration).caApiV1RoutersRepositoryGetSlimProductGroupsId(productGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RetoolWorkflowsApi - axios parameter creator
 */
export const RetoolWorkflowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all building types
         * @summary Trigger Workflow
         * @param {WorkflowTriggerInput} workflowTriggerInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retoolApiRouterWorkflowsTriggerWorkflow: async (workflowTriggerInput: WorkflowTriggerInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowTriggerInput' is not null or undefined
            assertParamExists('retoolApiRouterWorkflowsTriggerWorkflow', 'workflowTriggerInput', workflowTriggerInput)
            const localVarPath = `/api/v1/retool_workflows/workflow_trigger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowTriggerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetoolWorkflowsApi - functional programming interface
 */
export const RetoolWorkflowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RetoolWorkflowsApiAxiosParamCreator(configuration)
    return {
        /**
         * List all building types
         * @summary Trigger Workflow
         * @param {WorkflowTriggerInput} workflowTriggerInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput: WorkflowTriggerInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetoolWorkflowsApi.retoolApiRouterWorkflowsTriggerWorkflow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RetoolWorkflowsApi - factory interface
 */
export const RetoolWorkflowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RetoolWorkflowsApiFp(configuration)
    return {
        /**
         * List all building types
         * @summary Trigger Workflow
         * @param {WorkflowTriggerInput} workflowTriggerInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput: WorkflowTriggerInput, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseSchema> {
            return localVarFp.retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RetoolWorkflowsApi - object-oriented interface
 */
export class RetoolWorkflowsApi extends BaseAPI {
    /**
     * List all building types
     * @summary Trigger Workflow
     * @param {WorkflowTriggerInput} workflowTriggerInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput: WorkflowTriggerInput, options?: RawAxiosRequestConfig) {
        return RetoolWorkflowsApiFp(this.configuration).retoolApiRouterWorkflowsTriggerWorkflow(workflowTriggerInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineMaterials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/search_engine/search/materials/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Product Din Categories
         * @param {InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineProductDinCategories: async (level?: InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/search_engine/search/product-din-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineSearchProducts: async (productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productSearchInput' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSearchEngineSearchProducts', 'productSearchInput', productSearchInput)
            const localVarPath = `/api/v1/inventory/search_engine/search/products/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineSearchUsedProducts: async (organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSearchEngineSearchUsedProducts', 'organisationId', organisationId)
            const localVarPath = `/api/v1/inventory/search_engine/search/used_products/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['building_id'] = buildingId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleMaterialOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSearchEngineMaterials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.inventoryApiV1RoutersSearchEngineMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Product Din Categories
         * @param {InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSearchEngineProductDinCategories(level?: InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchEngineCategoryOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSearchEngineProductDinCategories(level, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.inventoryApiV1RoutersSearchEngineProductDinCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalPaginatedProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.inventoryApiV1RoutersSearchEngineSearchProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalPaginatedProductSearchOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.inventoryApiV1RoutersSearchEngineSearchUsedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         *
         * @summary Materials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleMaterialOut>> {
            return localVarFp.inventoryApiV1RoutersSearchEngineMaterials(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Product Din Categories
         * @param {InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineProductDinCategories(level?: InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchEngineCategoryOUT>> {
            return localVarFp.inventoryApiV1RoutersSearchEngineProductDinCategories(level, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Products
         * @param {ProductSearchInput} productSearchInput
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<InternalPaginatedProductSearchOutput> {
            return localVarFp.inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Used Products
         * @param {string} organisationId
         * @param {string | null} [buildingId]
         * @param {string | null} [searchQuery]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<InternalPaginatedProductSearchOutput> {
            return localVarFp.inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     *
     * @summary Materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSearchEngineMaterials(options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).inventoryApiV1RoutersSearchEngineMaterials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Product Din Categories
     * @param {InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum} [level]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSearchEngineProductDinCategories(level?: InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).inventoryApiV1RoutersSearchEngineProductDinCategories(level, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Products
     * @param {ProductSearchInput} productSearchInput
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput: ProductSearchInput, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).inventoryApiV1RoutersSearchEngineSearchProducts(productSearchInput, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Search Used Products
     * @param {string} organisationId
     * @param {string | null} [buildingId]
     * @param {string | null} [searchQuery]
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId: string, buildingId?: string | null, searchQuery?: string | null, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).inventoryApiV1RoutersSearchEngineSearchUsedProducts(organisationId, buildingId, searchQuery, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

export const InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum = {
    Level1: 'level_1',
    Level2: 'level_2',
    Level3: 'level_3'
} as const;
export type InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum = typeof InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum[keyof typeof InventoryApiV1RoutersSearchEngineProductDinCategoriesLevelEnum];


/**
 * SummaryApi - axios parameter creator
 */
export const SummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CSV Exporter for summary table
         * @summary Export Object Calculation Csv
         * @param {string} fileType
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryExportObjectCalculationCsv: async (fileType: string, columnValueSchemaIN: ColumnValueSchemaIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileType' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSummaryExportObjectCalculationCsv', 'fileType', fileType)
            // verify required parameter 'columnValueSchemaIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSummaryExportObjectCalculationCsv', 'columnValueSchemaIN', columnValueSchemaIN)
            const localVarPath = `/api/v1/inventory/summary/{file_type}/export`
                .replace(`{${"file_type"}}`, encodeURIComponent(String(fileType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnValueSchemaIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the available columns to display
         * @summary Get Available Columns
         * @param {ColumnConfiguration | null} [config]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetAvailableColumns: async (config?: ColumnConfiguration | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/summary/available_columns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (config !== undefined) {
                localVarQueryParameter['config'] = config;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the distinct values for the given columns
         * @summary Get Column Value Distinct
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetColumnValueDistinct: async (columnValueSchemaIN: ColumnValueSchemaIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnValueSchemaIN' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSummaryGetColumnValueDistinct', 'columnValueSchemaIN', columnValueSchemaIN)
            const localVarPath = `/api/v1/inventory/summary/distinct_values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(columnValueSchemaIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the groups to display
         * @summary Get Friendly Name Groups
         * @param {string | null} [conformityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetFriendlyNameGroups: async (conformityId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inventory/summary/friendly_name_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (conformityId !== undefined) {
                localVarQueryParameter['conformity_id'] = conformityId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the information inside the summary table.
         * @summary Get Info Table
         * @param {SummaryTableDataSchemaIn} summaryTableDataSchemaIn
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetInfoTable: async (summaryTableDataSchemaIn: SummaryTableDataSchemaIn, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'summaryTableDataSchemaIn' is not null or undefined
            assertParamExists('inventoryApiV1RoutersSummaryGetInfoTable', 'summaryTableDataSchemaIn', summaryTableDataSchemaIn)
            const localVarPath = `/api/v1/inventory/summary/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(summaryTableDataSchemaIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryApi - functional programming interface
 */
export const SummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * CSV Exporter for summary table
         * @summary Export Object Calculation Csv
         * @param {string} fileType
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType: string, columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType, columnValueSchemaIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryApi.inventoryApiV1RoutersSummaryExportObjectCalculationCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the available columns to display
         * @summary Get Available Columns
         * @param {ColumnConfiguration | null} [config]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSummaryGetAvailableColumns(config?: ColumnConfiguration | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableColumnsOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSummaryGetAvailableColumns(config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryApi.inventoryApiV1RoutersSummaryGetAvailableColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the distinct values for the given columns
         * @summary Get Column Value Distinct
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryApi.inventoryApiV1RoutersSummaryGetColumnValueDistinct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the groups to display
         * @summary Get Friendly Name Groups
         * @param {string | null} [conformityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FriendlyNameGroupOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryApi.inventoryApiV1RoutersSummaryGetFriendlyNameGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the information inside the summary table.
         * @summary Get Info Table
         * @param {SummaryTableDataSchemaIn} summaryTableDataSchemaIn
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn: SummaryTableDataSchemaIn, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pageddict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryApi.inventoryApiV1RoutersSummaryGetInfoTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SummaryApi - factory interface
 */
export const SummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SummaryApiFp(configuration)
    return {
        /**
         * CSV Exporter for summary table
         * @summary Export Object Calculation Csv
         * @param {string} fileType
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType: string, columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType, columnValueSchemaIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the available columns to display
         * @summary Get Available Columns
         * @param {ColumnConfiguration | null} [config]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetAvailableColumns(config?: ColumnConfiguration | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableColumnsOUT>> {
            return localVarFp.inventoryApiV1RoutersSummaryGetAvailableColumns(config, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the distinct values for the given columns
         * @summary Get Column Value Distinct
         * @param {ColumnValueSchemaIN} columnValueSchemaIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the groups to display
         * @summary Get Friendly Name Groups
         * @param {string | null} [conformityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<FriendlyNameGroupOUT>> {
            return localVarFp.inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the information inside the summary table.
         * @summary Get Info Table
         * @param {SummaryTableDataSchemaIn} summaryTableDataSchemaIn
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn: SummaryTableDataSchemaIn, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Pageddict> {
            return localVarFp.inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SummaryApi - object-oriented interface
 */
export class SummaryApi extends BaseAPI {
    /**
     * CSV Exporter for summary table
     * @summary Export Object Calculation Csv
     * @param {string} fileType
     * @param {ColumnValueSchemaIN} columnValueSchemaIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType: string, columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig) {
        return SummaryApiFp(this.configuration).inventoryApiV1RoutersSummaryExportObjectCalculationCsv(fileType, columnValueSchemaIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the available columns to display
     * @summary Get Available Columns
     * @param {ColumnConfiguration | null} [config]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSummaryGetAvailableColumns(config?: ColumnConfiguration | null, options?: RawAxiosRequestConfig) {
        return SummaryApiFp(this.configuration).inventoryApiV1RoutersSummaryGetAvailableColumns(config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the distinct values for the given columns
     * @summary Get Column Value Distinct
     * @param {ColumnValueSchemaIN} columnValueSchemaIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN: ColumnValueSchemaIN, options?: RawAxiosRequestConfig) {
        return SummaryApiFp(this.configuration).inventoryApiV1RoutersSummaryGetColumnValueDistinct(columnValueSchemaIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the groups to display
     * @summary Get Friendly Name Groups
     * @param {string | null} [conformityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId?: string | null, options?: RawAxiosRequestConfig) {
        return SummaryApiFp(this.configuration).inventoryApiV1RoutersSummaryGetFriendlyNameGroups(conformityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the information inside the summary table.
     * @summary Get Info Table
     * @param {SummaryTableDataSchemaIn} summaryTableDataSchemaIn
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn: SummaryTableDataSchemaIn, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return SummaryApiFp(this.configuration).inventoryApiV1RoutersSummaryGetInfoTable(summaryTableDataSchemaIn, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get user profile related information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserGetUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user sso token for userback. So that user do not need to add credentials on userback
         * @summary Get User Sso Token For Userback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserGetUserSsoTokenForUserback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/user/userback/sso-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend verification email to user
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserResendVerificationEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/user/verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearerUnverifiedEmail required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user profile information like, first name, last name and term of service.
         * @summary Update User Profile
         * @param {UserProfileIN} userProfileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserUpdateUserProfile: async (userProfileIN: UserProfileIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userProfileIN' is not null or undefined
            assertParamExists('concularApiV1RoutersUserUpdateUserProfile', 'userProfileIN', userProfileIN)
            const localVarPath = `/api/v1/concular/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userProfileIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Get user profile related information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserGetUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserGetUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.concularApiV1RoutersUserGetUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user sso token for userback. So that user do not need to add credentials on userback
         * @summary Get User Sso Token For Userback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserGetUserSsoTokenForUserback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserBackTokenOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserGetUserSsoTokenForUserback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.concularApiV1RoutersUserGetUserSsoTokenForUserback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend verification email to user
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserResendVerificationEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserResendVerificationEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.concularApiV1RoutersUserResendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user profile information like, first name, last name and term of service.
         * @summary Update User Profile
         * @param {UserProfileIN} userProfileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserUpdateUserProfile(userProfileIN: UserProfileIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserUpdateUserProfile(userProfileIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.concularApiV1RoutersUserUpdateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Get user profile related information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserGetUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileOUT> {
            return localVarFp.concularApiV1RoutersUserGetUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user sso token for userback. So that user do not need to add credentials on userback
         * @summary Get User Sso Token For Userback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserGetUserSsoTokenForUserback(options?: RawAxiosRequestConfig): AxiosPromise<UserBackTokenOUT> {
            return localVarFp.concularApiV1RoutersUserGetUserSsoTokenForUserback(options).then((request) => request(axios, basePath));
        },
        /**
         * Resend verification email to user
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserResendVerificationEmail(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.concularApiV1RoutersUserResendVerificationEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * Update user profile information like, first name, last name and term of service.
         * @summary Update User Profile
         * @param {UserProfileIN} userProfileIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserUpdateUserProfile(userProfileIN: UserProfileIN, options?: RawAxiosRequestConfig): AxiosPromise<UserProfileOUT> {
            return localVarFp.concularApiV1RoutersUserUpdateUserProfile(userProfileIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Get user profile related information.
     * @summary Get User Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserGetUserProfile(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).concularApiV1RoutersUserGetUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user sso token for userback. So that user do not need to add credentials on userback
     * @summary Get User Sso Token For Userback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserGetUserSsoTokenForUserback(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).concularApiV1RoutersUserGetUserSsoTokenForUserback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend verification email to user
     * @summary Resend Verification Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserResendVerificationEmail(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).concularApiV1RoutersUserResendVerificationEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user profile information like, first name, last name and term of service.
     * @summary Update User Profile
     * @param {UserProfileIN} userProfileIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserUpdateUserProfile(userProfileIN: UserProfileIN, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).concularApiV1RoutersUserUpdateUserProfile(userProfileIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserAuditsApi - axios parameter creator
 */
export const UserAuditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all the available roles for the UserAudit model.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditGetAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/user_audits/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the members of a specific audit.
         * @summary Get Audit Members
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditGetAuditMembers: async (auditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditGetAuditMembers', 'auditId', auditId)
            const localVarPath = `/api/v1/ca/user_audits/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (auditId !== undefined) {
                localVarQueryParameter['audit_id'] = auditId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the audits that the user is a member of for online usage.
         * @summary List User Audits For Online Usage
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditListUserAuditsForOnlineUsage: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ca/user_audits/online`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a user from a specific audit. This endpoint can be used by both an audit manager and the member itself.
         * @summary Remove Member From Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditRemoveMemberFromAudit: async (auditId: string, memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditRemoveMemberFromAudit', 'auditId', auditId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditRemoveMemberFromAudit', 'memberId', memberId)
            const localVarPath = `/api/v1/ca/user_audits/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (auditId !== undefined) {
                localVarQueryParameter['audit_id'] = auditId;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user audit instance. Written for updating the role of a user in an audit.
         * @summary Update User Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {UserAuditUpdateIN} userAuditUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditUpdateUserAudit: async (auditId: string, memberId: number, userAuditUpdateIN: UserAuditUpdateIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditUpdateUserAudit', 'auditId', auditId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditUpdateUserAudit', 'memberId', memberId)
            // verify required parameter 'userAuditUpdateIN' is not null or undefined
            assertParamExists('caApiV1RoutersUserAuditUpdateUserAudit', 'userAuditUpdateIN', userAuditUpdateIN)
            const localVarPath = `/api/v1/ca/user_audits/audits/{audit_id}/members/{member_id}`
                .replace(`{${"audit_id"}}`, encodeURIComponent(String(auditId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAuditUpdateIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAuditsApi - functional programming interface
 */
export const UserAuditsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAuditsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all the available roles for the UserAudit model.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersUserAuditGetAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAuditRoleOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersUserAuditGetAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAuditsApi.caApiV1RoutersUserAuditGetAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the members of a specific audit.
         * @summary Get Audit Members
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersUserAuditGetAuditMembers(auditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditMemberOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersUserAuditGetAuditMembers(auditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAuditsApi.caApiV1RoutersUserAuditGetAuditMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the audits that the user is a member of for online usage.
         * @summary List User Audits For Online Usage
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSlimUserAuditOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAuditsApi.caApiV1RoutersUserAuditListUserAuditsForOnlineUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a user from a specific audit. This endpoint can be used by both an audit manager and the member itself.
         * @summary Remove Member From Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId: string, memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAuditsApi.caApiV1RoutersUserAuditRemoveMemberFromAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a user audit instance. Written for updating the role of a user in an audit.
         * @summary Update User Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {UserAuditUpdateIN} userAuditUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiV1RoutersUserAuditUpdateUserAudit(auditId: string, memberId: number, userAuditUpdateIN: UserAuditUpdateIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditMemberOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiV1RoutersUserAuditUpdateUserAudit(auditId, memberId, userAuditUpdateIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAuditsApi.caApiV1RoutersUserAuditUpdateUserAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserAuditsApi - factory interface
 */
export const UserAuditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAuditsApiFp(configuration)
    return {
        /**
         * Returns all the available roles for the UserAudit model.
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditGetAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserAuditRoleOUT>> {
            return localVarFp.caApiV1RoutersUserAuditGetAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the members of a specific audit.
         * @summary Get Audit Members
         * @param {string} auditId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditGetAuditMembers(auditId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditMemberOUT>> {
            return localVarFp.caApiV1RoutersUserAuditGetAuditMembers(auditId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the audits that the user is a member of for online usage.
         * @summary List User Audits For Online Usage
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedSlimUserAuditOUT> {
            return localVarFp.caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a user from a specific audit. This endpoint can be used by both an audit manager and the member itself.
         * @summary Remove Member From Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId: string, memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a user audit instance. Written for updating the role of a user in an audit.
         * @summary Update User Audit
         * @param {string} auditId
         * @param {number} memberId
         * @param {UserAuditUpdateIN} userAuditUpdateIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiV1RoutersUserAuditUpdateUserAudit(auditId: string, memberId: number, userAuditUpdateIN: UserAuditUpdateIN, options?: RawAxiosRequestConfig): AxiosPromise<AuditMemberOUT> {
            return localVarFp.caApiV1RoutersUserAuditUpdateUserAudit(auditId, memberId, userAuditUpdateIN, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAuditsApi - object-oriented interface
 */
export class UserAuditsApi extends BaseAPI {
    /**
     * Returns all the available roles for the UserAudit model.
     * @summary Get All Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersUserAuditGetAllRoles(options?: RawAxiosRequestConfig) {
        return UserAuditsApiFp(this.configuration).caApiV1RoutersUserAuditGetAllRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the members of a specific audit.
     * @summary Get Audit Members
     * @param {string} auditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersUserAuditGetAuditMembers(auditId: string, options?: RawAxiosRequestConfig) {
        return UserAuditsApiFp(this.configuration).caApiV1RoutersUserAuditGetAuditMembers(auditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the audits that the user is a member of for online usage.
     * @summary List User Audits For Online Usage
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserAuditsApiFp(this.configuration).caApiV1RoutersUserAuditListUserAuditsForOnlineUsage(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a user from a specific audit. This endpoint can be used by both an audit manager and the member itself.
     * @summary Remove Member From Audit
     * @param {string} auditId
     * @param {number} memberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId: string, memberId: number, options?: RawAxiosRequestConfig) {
        return UserAuditsApiFp(this.configuration).caApiV1RoutersUserAuditRemoveMemberFromAudit(auditId, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a user audit instance. Written for updating the role of a user in an audit.
     * @summary Update User Audit
     * @param {string} auditId
     * @param {number} memberId
     * @param {UserAuditUpdateIN} userAuditUpdateIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiV1RoutersUserAuditUpdateUserAudit(auditId: string, memberId: number, userAuditUpdateIN: UserAuditUpdateIN, options?: RawAxiosRequestConfig) {
        return UserAuditsApiFp(this.configuration).caApiV1RoutersUserAuditUpdateUserAudit(auditId, memberId, userAuditUpdateIN, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserBuildingsApi - axios parameter creator
 */
export const UserBuildingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all the roles for the user building. For example [{1: \"Guest\"}]
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/user_buildings/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * As a building member, you can see list of all the users in the building.
         * @summary Get Building Users
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetBuildingUsers: async (buildingId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserBuildingsGetBuildingUsers', 'buildingId', buildingId)
            const localVarPath = `/api/v1/concular/user_buildings/{building_id}/members`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the buildings of the user.
         * @summary Get User Buildings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetUserBuildings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/concular/user_buildings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User can leave the building.
         * @summary Leave Building
         * @param {string} userBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsLeaveBuilding: async (userBuildingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userBuildingId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserBuildingsLeaveBuilding', 'userBuildingId', userBuildingId)
            const localVarPath = `/api/v1/concular/user_buildings/{user_building_id}`
                .replace(`{${"user_building_id"}}`, encodeURIComponent(String(userBuildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserBuildingsApi - functional programming interface
 */
export const UserBuildingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserBuildingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all the roles for the user building. For example [{1: \"Guest\"}]
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserBuildingsGetAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRoleOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserBuildingsGetAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserBuildingsApi.concularApiV1RoutersUserBuildingsGetAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * As a building member, you can see list of all the users in the building.
         * @summary Get Building Users
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBuildingMemberOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserBuildingsApi.concularApiV1RoutersUserBuildingsGetBuildingUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all the buildings of the user.
         * @summary Get User Buildings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserBuildingsGetUserBuildings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserBuildingOUT>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserBuildingsGetUserBuildings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserBuildingsApi.concularApiV1RoutersUserBuildingsGetUserBuildings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User can leave the building.
         * @summary Leave Building
         * @param {string} userBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserBuildingsApi.concularApiV1RoutersUserBuildingsLeaveBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserBuildingsApi - factory interface
 */
export const UserBuildingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserBuildingsApiFp(configuration)
    return {
        /**
         * Get all the roles for the user building. For example [{1: \"Guest\"}]
         * @summary Get All Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleOUT>> {
            return localVarFp.concularApiV1RoutersUserBuildingsGetAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * As a building member, you can see list of all the users in the building.
         * @summary Get Building Users
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedBuildingMemberOUT> {
            return localVarFp.concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the buildings of the user.
         * @summary Get User Buildings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsGetUserBuildings(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserBuildingOUT>> {
            return localVarFp.concularApiV1RoutersUserBuildingsGetUserBuildings(options).then((request) => request(axios, basePath));
        },
        /**
         * User can leave the building.
         * @summary Leave Building
         * @param {string} userBuildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserBuildingsApi - object-oriented interface
 */
export class UserBuildingsApi extends BaseAPI {
    /**
     * Get all the roles for the user building. For example [{1: \"Guest\"}]
     * @summary Get All Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserBuildingsGetAllRoles(options?: RawAxiosRequestConfig) {
        return UserBuildingsApiFp(this.configuration).concularApiV1RoutersUserBuildingsGetAllRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * As a building member, you can see list of all the users in the building.
     * @summary Get Building Users
     * @param {string} buildingId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserBuildingsApiFp(this.configuration).concularApiV1RoutersUserBuildingsGetBuildingUsers(buildingId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the buildings of the user.
     * @summary Get User Buildings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserBuildingsGetUserBuildings(options?: RawAxiosRequestConfig) {
        return UserBuildingsApiFp(this.configuration).concularApiV1RoutersUserBuildingsGetUserBuildings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User can leave the building.
     * @summary Leave Building
     * @param {string} userBuildingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId: string, options?: RawAxiosRequestConfig) {
        return UserBuildingsApiFp(this.configuration).concularApiV1RoutersUserBuildingsLeaveBuilding(userBuildingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserOrganisationsApi - axios parameter creator
 */
export const UserOrganisationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admin can change role of existing user for an organisation.
         * @summary Change User Role
         * @param {string} organisationId
         * @param {UserOrganisationRoleIN} userOrganisationRoleIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsChangeUserRole: async (organisationId: string, userOrganisationRoleIN: UserOrganisationRoleIN, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsChangeUserRole', 'organisationId', organisationId)
            // verify required parameter 'userOrganisationRoleIN' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsChangeUserRole', 'userOrganisationRoleIN', userOrganisationRoleIN)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userOrganisationRoleIN, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get number of admins withing the organisation. Organisation require at least on admin. If there is a only admin then it can\'t change the role to user.
         * @summary Get Num Of Admins For Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}/counts/admin`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * As an organisation admin, you can see list of all the users (admin/member) in the organisation.
         * @summary Get Organisation Users
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetOrganisationUsers: async (organisationId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsGetOrganisationUsers', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}/members`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the details of an organisation.
         * @summary Get User Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetUserOrganisation: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsGetUserOrganisation', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}/user`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Member can leave the organisation.
         * @summary Leave Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsLeaveOrganisation: async (organisationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsLeaveOrganisation', 'organisationId', organisationId)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}/`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * As an org admin I want to remove user from organisation.
         * @summary Remove User From Organisation
         * @param {string} organisationId
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation: async (organisationId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation', 'organisationId', organisationId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation', 'username', username)
            const localVarPath = `/api/v1/concular/user_organisation/{organisation_id}/{username}`
                .replace(`{${"organisation_id"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AuthBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication AuthAPIKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserOrganisationsApi - functional programming interface
 */
export const UserOrganisationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserOrganisationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Admin can change role of existing user for an organisation.
         * @summary Change User Role
         * @param {string} organisationId
         * @param {UserOrganisationRoleIN} userOrganisationRoleIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId: string, userOrganisationRoleIN: UserOrganisationRoleIN, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOrganisationMemberOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId, userOrganisationRoleIN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsChangeUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get number of admins withing the organisation. Organisation require at least on admin. If there is a only admin then it can\'t change the role to user.
         * @summary Get Num Of Admins For Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * As an organisation admin, you can see list of all the users (admin/member) in the organisation.
         * @summary Get Organisation Users
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedUserOrganisationMemberOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsGetOrganisationUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all the details of an organisation.
         * @summary Get User Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOrganisationOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsGetUserOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Member can leave the organisation.
         * @summary Leave Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsLeaveOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * As an org admin I want to remove user from organisation.
         * @summary Remove User From Organisation
         * @param {string} organisationId
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOUT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrganisationsApi.concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserOrganisationsApi - factory interface
 */
export const UserOrganisationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserOrganisationsApiFp(configuration)
    return {
        /**
         * Admin can change role of existing user for an organisation.
         * @summary Change User Role
         * @param {string} organisationId
         * @param {UserOrganisationRoleIN} userOrganisationRoleIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId: string, userOrganisationRoleIN: UserOrganisationRoleIN, options?: RawAxiosRequestConfig): AxiosPromise<UserOrganisationMemberOUT> {
            return localVarFp.concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId, userOrganisationRoleIN, options).then((request) => request(axios, basePath));
        },
        /**
         * Get number of admins withing the organisation. Organisation require at least on admin. If there is a only admin then it can\'t change the role to user.
         * @summary Get Num Of Admins For Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * As an organisation admin, you can see list of all the users (admin/member) in the organisation.
         * @summary Get Organisation Users
         * @param {string} organisationId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedUserOrganisationMemberOUT> {
            return localVarFp.concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the details of an organisation.
         * @summary Get User Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserOrganisationOUT> {
            return localVarFp.concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Member can leave the organisation.
         * @summary Leave Organisation
         * @param {string} organisationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * As an org admin I want to remove user from organisation.
         * @summary Remove User From Organisation
         * @param {string} organisationId
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultOUT> {
            return localVarFp.concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId, username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserOrganisationsApi - object-oriented interface
 */
export class UserOrganisationsApi extends BaseAPI {
    /**
     * Admin can change role of existing user for an organisation.
     * @summary Change User Role
     * @param {string} organisationId
     * @param {UserOrganisationRoleIN} userOrganisationRoleIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId: string, userOrganisationRoleIN: UserOrganisationRoleIN, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsChangeUserRole(organisationId, userOrganisationRoleIN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get number of admins withing the organisation. Organisation require at least on admin. If there is a only admin then it can\'t change the role to user.
     * @summary Get Num Of Admins For Organisation
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId: string, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsGetNumOfAdminsForOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * As an organisation admin, you can see list of all the users (admin/member) in the organisation.
     * @summary Get Organisation Users
     * @param {string} organisationId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsGetOrganisationUsers(organisationId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the details of an organisation.
     * @summary Get User Organisation
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId: string, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsGetUserOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Member can leave the organisation.
     * @summary Leave Organisation
     * @param {string} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId: string, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsLeaveOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * As an org admin I want to remove user from organisation.
     * @summary Remove User From Organisation
     * @param {string} organisationId
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId: string, username: string, options?: RawAxiosRequestConfig) {
        return UserOrganisationsApiFp(this.configuration).concularApiV1RoutersUserOrganisationsRemoveUserFromOrganisation(organisationId, username, options).then((request) => request(this.axios, this.basePath));
    }
}
